(function() {
  'use strict';

  angular
    .module('tnsp', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'angular-ladda',
      'checklist-model',
      'bsLoadingOverlay',
      'angularMoment',
      'oitozero.ngSweetAlert',
      'mgo-angular-wizard',
      'ui.utils.masks',
      'angular-md5',
      'credit-cards',
      'ngIdle'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('CashRegistersController', CashRegistersController);

  /** @ngInject */
  function CashRegistersController(rTerminal, $rootScope, SweetAlert, toastr, rCashRegister, $state, $log, PAGINATION_CONFIG, bsLoadingOverlayService) {
    var vm = this,
      cashRegistersRefresh,
      terminalId = $state.params.terminalId;

    vm.selectedCashRegister = {};

    vm.query = {terminalId:terminalId};
    vm.cashRegistersList = [];
    vm.terminalId = terminalId;
    vm.terminalName = '';

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createCashRegister = createCashRegister;
    vm.searchCashRegisters = searchCashRegisters;
    vm.editCashRegister = editCashRegister;
    vm.deleteCashRegister = deleteCashRegister;

    function init () {
      loadTerminal();
      loadCashRegisters();
    }
    init();

    function loadTerminal(){
      rTerminal.query({id:terminalId}, function(result){
        vm.terminalName = result.name;
      });
    }

    function loadCashRegisters(){
      bsLoadingOverlayService.start({referenceId: 'cashRegisters-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rCashRegister.query(vm.query, function(result){
        vm.cashRegistersList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'cashRegisters-overlay'});
      });
    }


    function createCashRegister(){
      vm.selectedCashRegister = null;
      angular.element('#modalCashRegisterForm').modal({backdrop: 'static', keyboard: false});
    }

    function editCashRegister(cashRegister){
      angular.copy(cashRegister, vm.selectedCashRegister);
      angular.element('#modalCashRegisterForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteCashRegister(cashRegister){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar esta Caja Registradora?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rCashRegister.delete({id:cashRegister.id, terminalId: terminalId}, function(){
              toastr.success('Caja Registradora Eliminada correctamente');
              loadCashRegisters();
            }, function(error){
              toastr.error('Error al Eliminar Caja Registradora', error.data.messages);
            });
          }
        }
      );
    }

    function searchCashRegisters (){
      vm.pagination.pageNum = 1;
      vm.query.name = vm.filter;
      vm.query.description = vm.filter;
      vm.query.inclusive = false;
      loadCashRegisters();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadCashRegisters();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadCashRegisters();
    }

    function range (n) {
      return new Array(n);
    }

    cashRegistersRefresh = $rootScope.$on('cashRegistersRefresh', function() {
      loadCashRegisters();
    });

    $rootScope.$on('$destroy', cashRegistersRefresh);
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller("ManageTripsController", ManageTripsController);

  /** @ngInject */
  function ManageTripsController(
    rRoute,
    rBus,
    rUser,
    rTrip,
    toastr,
    moment,
    $rootScope
  ) {
    var vm = this;
    vm.routesList = [];
    vm.busClasses = [];
    vm.buses = [];
    vm.busDrivers = [];
    vm.schedulesAvailable = [];

    vm.openOriginDate = openOriginDate;
    vm.loadSchedulesAvailable = loadSchedulesAvailable;
    vm.updateTrip = updateTrip;
    vm.busSelected = busSelected;
    vm.tripSelected = tripSelected;
    vm.canLockTrip = canLockTrip;
    vm.canUnLockTrip = canUnLockTrip;

    vm.lock = lock;
    vm.unlock = unlock;

    vm.query = {};
    vm.filter = {};
    vm.selectedTicket = {};

    init();

    function loadRoutes() {
      rRoute.query({ pagesize: 120, onlyActiveSchedules: true, publicRoute: true }, function (result) {
        vm.routesList = result.records;
      });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function (result) {
        vm.busClasses = result.records;
      });
    }

    function loadBuses() {
      rBus.query({ pagesize: 500 }, function (result) {
        vm.buses = result.records;
      });
    }

    function loadBusDrivers() {
      rUser.query({ role: 11, pagesize: 500 }, function (result) {
        vm.busDrivers = result.records;
      });
    }

    function openOriginDate() {
      vm.showOriginCalendar = true;
    }

    function loadSchedulesAvailable() {
      if (vm.filter.route && vm.filter.originDateUI && vm.filter.busType) {
        rTrip.query(
          {
            routeid: vm.filter.route,
            busclassid: vm.filter.busType,
            date: moment(vm.filter.originDateUI).format("YYYY-MM-DD"),
            inclusive: true
          },
          function (result) {
            vm.schedulesAvailable = result.records.filter(function (item) {
              return (
                item.schedule.visible === true &&
                item.schedule.isDisplayable === true
              );
            });

            vm.bus = result.records[0].bus;
          }
        );
      } else {
        vm.schedulesAvailable = [];
      }
    }

    function updateTrip(form) {
      vm.loading = true;
      if (!form.$valid) {
        vm.loading = false;
        vm.submitAttempt = true;
        return;
      }

      rTrip.patchTrip(
        {
          id: vm.filter.selectedTrip.id,
          seats: vm.filter.selectedTrip.seats,
          busId: vm.filter.selectedTrip.bus.id,
          driverId: vm.filter.selectedTrip.driver.id
        },
        function () {
          toastr.success("Viaje actualizado Correctamente");
          vm.loading = false;
        },
        function (error) {
          toastr.error(error.data.message, "Error al actualizar viaje");
          vm.loading = false;
        }
      );
    }

    function tripSelected() {
      if (!vm.filter.selectedTrip.bus) {
        vm.filter.selectedTrip.bus = {};
      }
      if (!vm.filter.selectedTrip.driver) {
        vm.filter.selectedTrip.driver = {};
      }
    }

    function canLockTrip(trip) {
      return trip && trip.locked === false && $rootScope.hasPermissionsFor("LOCK_TRIP");
    }

    function canUnLockTrip(trip) {
      return trip && trip.locked && $rootScope.hasPermissionsFor("UNLOCK_TRIP");
    }

    function lock() {
      rTrip.lock(
        {
          id: vm.filter.selectedTrip.id
        },
        function () {
          toastr.success("Viaje bloqueado Correctamente");
          vm.filter.selectedTrip.locked = true;
        },
        function (error) {
          toastr.error(error.data.message, "Error al bloquear el viaje");
        }
      );
    }

    function unlock() {
      rTrip.unlock(
        {
          id: vm.filter.selectedTrip.id
        },
        function () {
          toastr.success("Viaje Desbloqueado Correctamente");
          vm.filter.selectedTrip.locked = false;
        },
        function (error) {
          toastr.error(error.data.message, "Error al desbloquear el viaje");
        }
      );
    }

    function init() {
      loadRoutes();
      loadBusClasses();
      loadBuses();
      loadBusDrivers();
    }

    function busSelected(bus) {
      var selectedBus = null;
      angular.forEach(vm.buses, function (b) {
        if (b.id == bus) {
          selectedBus = b;
        }
      });

      vm.max = selectedBus.capacity;
      vm.filter.selectedTrip.seats = selectedBus.capacity;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('TillController', TillController);

  /** @ngInject */
  function TillController(authenticationService, $rootScope, $timeout, $log) {
    var vm = this,
      tillRefresh;

    vm.openCashRegister = openCashRegister;
    vm.closeCashRegister = closeCashRegister;
    vm.addMovement = addMovement;
    vm.ticketRegistration = ticketRegistration;
    vm.addCancellation = addCancellation;
    vm.showMovement = showMovement;
    vm.buyDollars = buyDollars;

    loadUserInformation();

    function loadUserInformation(){
      var allAuthInfo = authenticationService.getAllAuthInfo();
      vm.userInfo = allAuthInfo.userInfo;
    }

    function openCashRegister(){
      if (vm.userInfo.openCash == null){
        angular.element('#modalOpenCashRegisterForm').modal({backdrop: 'static', keyboard: false});
      }
    }

    function buyDollars(){
      if (vm.userInfo.openCash) {
        angular.element('#modalBuyDollarsForm').modal({backdrop: 'static', keyboard: false});
      }
    }

    function closeCashRegister(){
      if (vm.userInfo.openCash){
        angular.element('#modalCloseCashRegisterForm').modal({backdrop: 'static', keyboard: false});
      }
    }

    function addMovement(){
      if (vm.userInfo.openCash) {
        angular.element('#modalAddMovementForm').modal({backdrop: 'static', keyboard: false});
      }
    }

    function ticketRegistration(){
      angular.element('#modalTicketRegistrationForm').modal({backdrop: 'static', keyboard: false});
    }

    function addCancellation(){
      angular.element('#modalAddCancellationForm').modal({backdrop: 'static', keyboard: false});
    }

    function showMovement(){
      if (vm.userInfo.openCash != null){
        angular.element('#modalCashRegisterBalance').modal({backdrop: 'static', keyboard: false});
      }
    }

    tillRefresh = $rootScope.$on('tillRefresh', function() {
      $timeout(function(){
        loadUserInformation();
      },400);
    });

    $rootScope.$on('$destroy', tillRefresh);
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller("SearchTicketsController", SearchTicketsController);

  /** @ngInject */
  function SearchTicketsController(
    DATE_FORMAT,
    $window,
    $timeout,
    rRoute,
    rTicketInvoice,
    rBus,
    utilsService,
    rTicket,
    rTrip,
    rBoarding,
    rSchedule,
    toastr,
    WizardHandler,
    moment,
    authenticationService,
    SweetAlert,
    $rootScope
  ) {
    var vm = this,
      minDate = new Date(),
      maxDate = moment().add(3, "month"),
      loggedUser = authenticationService.getUserInfo(),
      restartTicketsEvent;

    vm.dateFormat = DATE_FORMAT;
    vm.dateConfig = { minDate: minDate, maxDate: maxDate };
    vm.routesList = [];

    initVariables();

    vm.editTicket = editTicket;

    vm.searchTicket = searchTicket;

    vm.loadSchedulesAvailable = loadSchedulesAvailable;

    vm.generateSeats = generateSeats;
    vm.openOriginDate = openOriginDate;

    vm.goToSelectClients = goToSelectClients;
    vm.toggleSeatSelection = toggleSeatSelection;

    vm.canRemoveChecks = $rootScope.hasPermissionsFor('CLEAR_CHECKS') || vm.isSysAdmin;

    /*Step 2*/
    vm.editClient = editClient;
    vm.goToSelectSeats = goToSelectSeats;
    vm.reserveTickets = reserveTickets;
    vm.refreshSeats = refreshSeats;

    vm.goToConfirmation = goToConfirmation;
    vm.editClient = editClient;

    vm.restartTickets = restartTickets;
    vm.cancelReservation = cancelReservation;

    vm.printInvoice = printInvoice;

    vm.clearChecks = clearChecks;
    vm.canPutOnHold = canPutOnHold;
    vm.putOnHold = putOnHold;
    vm.disableOnHold = false;


    vm.isSysAdmin = $rootScope.isAdmin();

    function initVariables() {
      if (vm.ticket) {
        //WizardHandler.wizard('edit-ticket-wizard').reset();
      }

      vm.submitAttemptStep1 = false;
      vm.submitAttemptStep2 = false;
      vm.submitAttemptStep3 = false;
      vm.originDateUI = null;

      vm.disableReturnRoute = true;
      vm.loading = false;

      vm.ticket = null;
      vm.originalTicket = null;
      vm.invoice = null;

      vm.busesTypes = [];

      vm.schedulesAvailable = [];

      vm.allSeats = [];

      vm.selectedSeat = [];

      vm.selectedClient = {};

      vm.boardingList = [];

      vm.finalTicketList = { tickets: [] };
    }

    vm.selectedInvoice = [];

    function printInvoice(invoice) {
      angular.copy([invoice], vm.selectedInvoice);
      angular
        .element("#modalTicketInvoice")
        .modal({ backdrop: "static", keyboard: false });
    }

    /*Step 1*/

    function clearChecks() {
      rTicket.clearChecks(
        { id: vm.originalTicket.invoiceNumber },
        function () {
          toastr.success("Chequeos limpiados");
        },
        function () {
          toastr.error("Error al limpiar chequeos");
        }
      );
    }

    function canPutOnHold() {
      if (vm.ticket) {
        return (
          (vm.isSysAdmin ||
            $rootScope.hasPermissionsFor("TICKET_EDIT_STATUS")) &&
          !vm.ticket.hasChecks
        );
      }
      return false;
    }

    function putOnHold() {
      rTicket.putOnHold(
        {
          id: vm.originalTicket.invoiceNumber,
          isOnHold: vm.originalTicket.status === "ACTIVE"
        },
        function () {
          toastr.success("Estado de revisión actualizado");
          vm.disableOnHold = true;
        },
        function () {
          toastr.error("Error al poner ticket en revisión");
        }
      );
    }

    function searchTicket(form) {
      initVariables();

      if (!form.$valid) {
        return;
      }

      rTicketInvoice.query(
        { id: vm.ticketToSearch },
        function (result) {
          vm.invoice = result;

          rTicket.query(
            { id: vm.ticketToSearch },
            function (result) {
              vm.originalTicket = result;

              if (vm.originalTicket.status !== "RELEASED") {
                vm.originalTicket.tripSeat.trip.schedule.departureTimeUI =
                  utilsService.mapToAMPM(
                    vm.originalTicket.tripSeat.trip.schedule.departureTime
                  );
                vm.ticket = {};

                angular.forEach(vm.routesList, function (route) {
                  if (route.id == vm.originalTicket.routeRate.route.id) {
                    vm.ticket.route = route;
                  }
                });

                // vm.ticket.route = vm.originalTicket.routeRate.route;
                vm.ticket.clients = [vm.originalTicket.client];
                vm.ticket.hasChecks =
                  vm.originalTicket.check1 ||
                  vm.originalTicket.check2 ||
                  vm.originalTicket.check3;

                if (vm.ticket.hasChecks) {
                  toastr.error("Este Ticket ya tiene chequeos");
                }

                loadSchedulesAvailable();
              } else {
                toastr.error("Este Boleto fue INACTIVADO");
              }
            },
            function () {
              toastr.error("Ocurrio un Error");
              vm.ticket = null;
              vm.originalTicket = null;
              vm.invoice = null;
            }
          );
        },
        function () {
          toastr.error("Este Tiquete no existe");
          vm.ticket = null;
          vm.originalTicket = null;
          vm.invoice = null;
        }
      );
    }

    function loadRoutes() {
      rRoute.query({ pagesize: 150 }, function (result) {
        vm.routesList = result.records;
      });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function (result) {
        vm.busClasses = result.records;
      });
    }

    function loadSchedulesAvailable() {
      if (vm.ticket.route.id && vm.originDateUI && vm.ticket.busType) {
        rTrip.query(
          {
            routeid: vm.ticket.route.id,
            busclassid: vm.ticket.busType,
            date: moment(vm.originDateUI).format("YYYY-MM-DD"),
            inclusive: true
          },
          function (result) {
            vm.schedulesAvailable = result.records.filter(function (item) {
              return (
                item.schedule.visible === true &&
                item.schedule.isDisplayable === true
              );
            });
          }
        );
      }
    }

    function generateSeats() {
      $timeout(function () {
        if (vm.ticket.selectedTrip) {
          for (var i = 1; i <= vm.ticket.selectedTrip.seats; i++) {
            vm.allSeats.push({ seatNumber: i, isOccupied: false });
          }
          checkOccupiedSeats();
        } else {
          vm.allSeats = [];
        }
      }, 1000);
    }

    function checkOccupiedSeats() {
      if (!vm.ticket.selectedTrip.tripSeats) {
        vm.ticket.selectedTrip.tripSeats = [];
      }
      vm.ticket.selectedTrip.availableSeats =
        vm.ticket.selectedTrip.seats - vm.ticket.selectedTrip.tripSeats.length;

      angular.forEach(vm.ticket.selectedTrip.seats, function (occupiedSeat) {
        angular.forEach(vm.allSeats, function (availableSeat) {
          if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
            availableSeat.isOccupied = true;
            availableSeat.selected = false;
            vm.ticket.selectedTrip.availableSeats--;
          }
        });
      });
    }

    function openOriginDate() {
      vm.showOriginCalendar = true;
    }

    function goToSelectClients(form) {
      vm.submitAttemptStep1 = true;
      if (!form.$valid) {
        return;
      }
      loadBoardings(vm.ticket.route, vm.ticket.selectedTrip.schedule);

      WizardHandler.wizard("edit-ticket-wizard").next();
    }

    /*Step 2*/

    function goToSelectSeats(form) {
      vm.submitAttemptStep2 = true;
      if (!form.$valid || !vm.ticket.clients.length > 0) {
        return;
      }
      refreshSeats();
      WizardHandler.wizard("edit-ticket-wizard").next();
    }

    function loadBoardings(route, schedule) {
      var routeId;
      if (!route.transfer) {
        routeId = route.id;
      } else {
        routeId = route.subRoutes[0].id;
      }

      rBoarding.query({ pagesize: 100, routeId: routeId }, function (result) {
        vm.boardingList = result.records;
        loadInvalidBoardings(schedule, routeId);
      });
    }

    function loadInvalidBoardings(schedule, routeId) {
      rSchedule.query({ id: schedule.id, routeId: routeId }, function (result) {
        var schedule = result;
        updateList(vm.boardingList, schedule.invalidBoardings);

        var tempBoardings = [];
        angular.forEach(vm.boardingList, function (boarding) {
          if (!boarding.hide) {
            tempBoardings.push(boarding);
          }
        });

        angular.copy(tempBoardings, vm.boardingList);
      });
    }

    function updateList(list, list2) {
      angular.forEach(list, function (item) {
        angular.forEach(list2, function (item2) {
          if (item.id === item2.id) {
            item.hide = true;
            //list.splice(index, 1);
          }
        });
      });
    }

    function editClient(client) {
      angular.copy(client, vm.selectedClient);
      angular
        .element("#modalClientForm")
        .modal({ backdrop: "static", keyboard: false });
    }

    /*Step 3*/

    function refreshSeats() {
      rTrip.getOccupiedSeats(
        { id: vm.ticket.selectedTrip.id },
        function (result) {
          var occupiedSeats = result;
          angular.forEach(occupiedSeats, function (occupiedSeat) {
            angular.forEach(vm.allSeats, function (availableSeat) {
              if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
                availableSeat.isOccupied = true;
                availableSeat.selected = false;
                removeSeat(occupiedSeat);
              }
            });
          });
        }
      );
    }

    function toggleSeatSelection(seat) {
      if (!seat.selected) {
        seat.selected = true;
        vm.selectedSeat.push(seat);
      } else {
        seat.selected = false;
        removeSeat(seat);
      }
    }

    function getSeatsToReserve() {
      var list = vm.selectedSeat;
      var seats = [];

      angular.forEach(vm.ticket.clients, function (client, index) {
        seats.push({ clientId: client.id, seatNumber: list[index].seatNumber });
      });

      return seats;
    }

    function reserveTickets() {
      var seats = getSeatsToReserve();
      var tripId = vm.ticket.selectedTrip.id;
      rTicket.reserve(
        { tripId: tripId, seats: seats },
        function () {
          vm.ticket.total =
            vm.ticket.selectedTrip.schedule.routeRate.billingRate *
            vm.ticket.clients.length;

          toastr.success("Reservación Satisfactoria");
          WizardHandler.wizard("edit-ticket-wizard").next();
        },
        function (error) {
          toastr.error(error.data.message, "Error de reservación");
          refreshSeats();
        }
      );
    }

    function removeSeat(_seat) {
      var index = -1;
      angular.forEach(vm.selectedSeat, function (seat, _index) {
        if (seat.id === _seat.id) {
          index = _index;
        }
      });
      vm.selectedSeat.splice(index, 1);
    }

    function goToConfirmation(form) {
      vm.submitAttemptStep3 = true;
      if (!form.$valid || vm.selectedSeat.length !== vm.ticket.clients.length) {
        return;
      }

      vm.submitAttemptStep3 = false;
      reserveTickets();
    }

    /*Step 4*/

    function restartTickets() {
      $window.location.reload();
    }

    function cancelReservation() {
      var clientIds = [];
      angular.forEach(vm.ticket.clients, function (client) {
        clientIds.push(client.id);
      });

      rTicket.cancelReserve(
        { tripId: vm.ticket.selectedTrip.id, clientIds: clientIds },
        function () {
          rTicket.cancelReserve(
            { tripId: vm.ticket.selectedTrip.id, clientIds: clientIds },
            function () {
              toastr.info("Reservación cancelada");
              $timeout(function () {
                $window.location.reload();
              }, 1500);
            }
          );
        }
      );
    }

    function editTicket() {
      var ticketToUpdate = {
        id: vm.originalTicket.invoiceNumber,
        trip: {
          id: vm.ticket.selectedTrip.id
        },
        seatNumber: vm.selectedSeat[0].seatNumber
      };
      rTicket.update(
        ticketToUpdate,
        function () {
          toastr.info("Ticket Editado Satisfactoriamente");
          $timeout(function () {
            $window.location.reload();
          }, 2000);
        },
        function (error) {
          toastr.error(error.data.message, "Error al editar");
        }
      );
    }

    /*TODO: SORT*/

    function hasCashierOpen() {
      if (!loggedUser.openCash && !loggedUser.reseller) {
        SweetAlert.swal({
          title: "",
          text: "Para Vender debe tener una caja abierta",
          confirmButtonText: "Aceptar",
          closeOnConfirm: true,
          closeOnCancel: true
        });
      }
    }

    function init() {
      hasCashierOpen();

      loadRoutes();
      loadBusClasses();
    }

    init();

    restartTicketsEvent = $rootScope.$on("restartTicketsEvent", function () {
      restartTickets();
    });

    $rootScope.$on("$destroy", restartTicketsEvent);
  }
})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('EditTicketsBoardingController', EditTicketsBoardingController);

  /** @ngInject */
  function EditTicketsBoardingController(rTicket, rSchedule, rTicketInvoice, DATE_FORMAT, $window, rBoarding, toastr, utilsService) {
    var vm = this;

    vm.submitAttempt = false;

    vm.dateFormat = DATE_FORMAT;
    vm.ticket = null;
    vm.originalTicket = null;

    vm.newTicket = {};


    vm.boardingList = [];
    vm.invalidBoardingList = [];

    vm.searchTicket = searchTicket;
    vm.changeBoarding = changeBoarding;

    function searchTicket(form) {
      vm.loading = false;
      vm.submitAttempt = true;

      if (!form.$valid) {
        return
      }

      rTicketInvoice.query({ id: vm.ticketToSearch }, function (result) {
        vm.ticket = result;

        vm.ticket.timeUI = utilsService.mapToAMPM(vm.ticket.time)

        rTicket.query({ id: vm.ticketToSearch }, function (result) {
          vm.originalTicket = result;
          loadBoardings(vm.originalTicket.routeRate.route, vm.originalTicket.tripSeat.trip.schedule);

        }, function () {
          toastr.error('Ocurrio un Error');
          vm.originalTicket = null
        });
      }, function () {
        toastr.error('Este Tiquete no existe');
        vm.ticket = null;
      });
    }

    function changeBoarding(form) {
      vm.loading = true;
      vm.submitAttempt = true;

      if (!form.$valid) {
        vm.loading = false;
        return;
      }


      rTicket.partialUpdate({ id:vm.ticket.invoiceNumber,  boarding: vm.newBoarding }, function () {
        toastr.success('Abordaje actualizado satisfactoriametne');
        vm.loading = false;
      }, function () {
        toastr.error('Hubo un error al actualizar el abordaje');
      });
    }


    function loadBoardings(route, schedule) {
      rBoarding.query({ pagesize: 100, routeId: route.id }, function (result) {
        vm.boardingList = result.records;
        loadInvalidBoardings(schedule, route.id);
      });
    }

    function loadInvalidBoardings(schedule, routeId) {
      rSchedule.query({ id: schedule.id, routeId: routeId }, function (result) {
        var schedule = result;
        updateList(vm.boardingList, schedule.invalidBoardings);


        var tempBoardings = [];
        angular.forEach(vm.boardingList, function (boarding) {
          if (!boarding.hide) {
            tempBoardings.push(boarding);
          }
        });

        angular.copy(tempBoardings, vm.boardingList);

        markPreselectedBoarding();

      });
    }

    function updateList(list, list2) {
      angular.forEach(list, function (item) {
        angular.forEach(list2, function (item2) {
          if (item.id === item2.id) {
            item.hide = true;
          }
        });
      });
    }

    function markPreselectedBoarding() {
      angular.forEach(vm.boardingList, function (boarding) {
        if (boarding.name === vm.ticket.boarding) {
          vm.newBoarding = boarding;
        }
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller("EditTicketsController", EditTicketsController);

  /** @ngInject */
  function EditTicketsController(
    DATE_FORMAT,
    DISCOUNT,
    $window,
    $timeout,
    utilsService,
    rRoute,
    rTicketInvoice,
    rBus,
    rTicket,
    rTrip,
    rBoarding,
    rSchedule,
    toastr,
    WizardHandler,
    moment,
    authenticationService,
    SweetAlert,
    $rootScope,
    SALE_PAYMENT_TYPES,
    SALES_TIME_AFTER_DETARTURE,
    SALES_TIME_AFTER_DETARTURE_RESELLER
  ) {
    var vm = this,
      minDate = new Date(),
      maxDate = moment().add(3, "month"),
      loggedUser = authenticationService.getUserInfo(),
      restartTicketsEvent,
      ticketContactUpdatedEvent;

    vm.dateFormat = DATE_FORMAT;
    vm.dateConfig = { minDate: minDate, maxDate: maxDate };
    vm.routesList = [];
    vm.paymentMethods = SALE_PAYMENT_TYPES;

    vm.isSysAdmin = $rootScope.isAdmin();
    vm.canRemoveChecks = $rootScope.hasPermissionsFor('CLEAR_CHECKS') || vm.isSysAdmin;
    vm.canEditContact = $rootScope.hasPermissionsFor('TICKET_EDIT_SPECIAL') || vm.isSysAdmin;

    initVariables();

    vm.editTicket = editTicket;
    vm.searchTicket = searchTicket;
    vm.loadSchedulesAvailable = loadSchedulesAvailable;
    vm.openOriginDate = openOriginDate;
    vm.goToSelectClients = goToSelectClients;

    vm.getSeatLabel = getSeatLabel;
    vm.getAvailableSeats = getAvailableSeats;
    vm.handleSelectedSeats = handleSelectedSeats;

    /*Step 2*/
    vm.editClient = editClient;
    vm.openContactForm = openContactForm;
    vm.goToSelectSeats = goToSelectSeats;
    vm.reserveTickets = reserveTickets;
    vm.refreshSeats = refreshSeats;

    vm.goBackToStepOne = goBackToStepOne;
    vm.clearSeatSelection = clearSeatSelection;
    vm.goToConfirmation = goToConfirmation;
    vm.editClient = editClient;

    vm.restartTickets = restartTickets;
    vm.goBackToStepThree = goBackToStepThree;
    vm.cancelReservation = cancelReservation;

    vm.calcDifference = calcDifference;
    vm.isCoveredTotal = isCoveredTotal;
    vm.totalCash = totalCash;
    vm.paymentMethodChange = paymentMethodChange;

    vm.clearChecks = clearChecks;

    vm.isSysAdmin = $rootScope.isAdmin();

    function initVariables() {
      if (vm.ticket) {
        WizardHandler.wizard("edit-ticket-wizard").reset();
      }

      vm.submitAttemptStep1 = false;
      vm.submitAttemptStep2 = false;
      vm.submitAttemptStep3 = false;
      vm.submitAttemptStep4 = false;
      vm.originDateUI = null;

      vm.hasToPay = false;
      vm.differenceToPay = 0;
      vm.totalPaidAmount = 0;
      vm.paymentMethod = null;
      clearPaymentFields();

      vm.disableReturnRoute = true;
      vm.loading = false;

      vm.ticket = null;
      vm.originalTicket = null;
      vm.invoice = null;
      vm.paidBreakdown = null;
      vm.invoices = [];
      vm.editInvoiceInfo = null;

      vm.busesTypes = [];

      vm.schedulesAvailable = [];

      vm.occupiedSeats = [];
      vm.selectedSeat = [];
      vm.reservedSeats = [];

      /* Al buscar otro tiquete hay que rehacer el mapa de asientos: si no, la
         directiva conserva la seleccion del tiquete anterior. */
      vm.showBusLayout = false;
      $timeout(function () {
        vm.showBusLayout = true;
      });

      vm.selectedClient = {};

      vm.boardingList = [];

      vm.finalTicketList = { tickets: [] };
    }

    /*Step 1*/

    function clearChecks() {
      rTicket.clearChecks(
        { id: vm.originalTicket.invoiceNumber },
        function () {
          toastr.success("Chequeos limpiados");
          searchTicketProcess();
        },
        function () {
          toastr.error("Error al limpiar chequeos");
        }
      );
    }

    function searchTicket(form) {
      initVariables();

      if (!form.$valid) {
        return;
      }

      searchTicketProcess();
    }

    function searchTicketProcess() {
      rTicketInvoice.query(
        { id: vm.ticketToSearch },
        function (result) {
          vm.invoice = result;
          vm.paidBreakdown = buildPaidBreakdown(result);

          rTicket.query(
            { id: vm.ticketToSearch },
            function (result) {
              vm.originalTicket = result;
              vm.originalTicket.tripSeat.trip.schedule.departureTimeUI = utilsService.mapToAMPM(vm.originalTicket.tripSeat.trip.schedule.departureTime);
              vm.ticket = {};

              angular.forEach(vm.routesList, function (route) {
                if (route.id == vm.originalTicket.routeRate.route.id) {
                  vm.ticket.route = route;
                }
              });

              // vm.ticket.route = vm.originalTicket.routeRate.route;
              vm.ticket.clients = [vm.originalTicket.client];
              vm.ticket.hasChecks = vm.originalTicket.check1 || vm.originalTicket.check2 || vm.originalTicket.check3;

              if (vm.ticket.hasChecks) { toastr.error("Este Ticket ya tiene chequeos"); }

              loadSchedulesAvailable();
            },
            function () {
              toastr.error("Ocurrio un Error");
              vm.ticket = null;
              vm.originalTicket = null;
              vm.invoice = null;
              vm.paidBreakdown = null;
            }
          );
        },
        function () {
          toastr.error("Este Tiquete no existe");
          vm.ticket = null;
          vm.originalTicket = null;
          vm.invoice = null;
          vm.paidBreakdown = null;
        }
      );
    }

    function loadRoutes() {
      rRoute.query({ pagesize: 150, onlyActiveSchedules: true, publicRoute: true }, function (result) {
        vm.routesList = result.records;
      });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function (result) {
        vm.busClasses = result.records;
      });
    }

    function loadSchedulesAvailable() {
      vm.ticket.busType = vm.busClasses[0].id;
      if (vm.ticket.route.id && vm.originDateUI && vm.ticket.busType) {
        rTrip.query(
          {
            routeid: vm.ticket.route.id,
            busclassid: vm.ticket.busType,
            date: moment(vm.originDateUI).format("YYYY-MM-DD"),
            inclusive: true
          },
          function (result) {
            vm.schedulesAvailable = result.records.filter(function (item) {
              var scheduleDateTime = item.date + "T" + item.schedule.departureTime + ":00.000-0600";
              var terminalAllowed = (vm.isSysAdmin || $rootScope.hasPermissionsFor('EDIT_TICKETS_EXTENDED_TIME')) || (!loggedUser.reseller && moment() < moment(scheduleDateTime).add(SALES_TIME_AFTER_DETARTURE, "m"));
              var resellerAllowed = loggedUser.reseller && moment() < moment(scheduleDateTime).add(SALES_TIME_AFTER_DETARTURE_RESELLER, "m");

              return (item.schedule.visible === true && item.schedule.isDisplayable === true && (terminalAllowed || resellerAllowed));
            });
            vm.schedulesAvailable.map(function (trip) { trip.schedule.departureTimeUI = utilsService.mapToAMPM(trip.schedule.departureTime); });
          }
        );
      }
    }

    function getSeatLabel(layoutType, seatNumber) {
      return utilsService.getSeatLabel(layoutType, seatNumber);
    }

    function getAvailableSeats() {
      $timeout(function () {
        var trip = vm.ticket.selectedTrip;
        if (!trip) return;
        trip.availableSeats = utilsService.getAvailableSeats(trip).available;
        refreshSeats();
      }, 1000);
    }

    /* Se copia: el arreglo que emite tnsp-bus-layout es el suyo, y si se guarda
       la referencia el padre termina apuntando a un arreglo que ya no le
       corresponde (o que la directiva sigue modificando). */
    function handleSelectedSeats(selectedSeats) {
      vm.selectedSeat = (selectedSeats || []).slice();
    }

    function openOriginDate() {
      vm.showOriginCalendar = true;
    }

    function goToSelectClients(form) {
      vm.submitAttemptStep1 = true;
      if (!form.$valid) {
        return;
      }

      refreshSeats();
      WizardHandler.wizard("edit-ticket-wizard").next();
    }

    /*Step 2*/
    function goToSelectSeats(form) {
      vm.submitAttemptStep2 = true;
      if (!form.$valid || !vm.ticket.clients.length > 0) {
        return;
      }
      refreshSeats();
      WizardHandler.wizard("edit-ticket-wizard").next();
    }

    function loadBoardings(route, schedule) {
      var routeId;
      if (!route.transfer) {
        routeId = route.id;
      } else {
        routeId = route.subRoutes[0].id;
      }

      rBoarding.query({ pagesize: 100, routeId: routeId }, function (result) {
        vm.boardingList = result.records;
        loadInvalidBoardings(schedule, routeId);
      });
    }

    function loadInvalidBoardings(schedule, routeId) {
      rSchedule.query({ id: schedule.id, routeId: routeId }, function (result) {
        var schedule = result;
        updateList(vm.boardingList, schedule.invalidBoardings);

        var tempBoardings = [];
        angular.forEach(vm.boardingList, function (boarding) {
          if (!boarding.hide) {
            tempBoardings.push(boarding);
          }
        });

        angular.copy(tempBoardings, vm.boardingList);
      });
    }

    function updateList(list, list2) {
      angular.forEach(list, function (item) {
        angular.forEach(list2, function (item2) {
          if (item.id === item2.id) {
            item.hide = true;
            //list.splice(index, 1);
          }
        });
      });
    }

    function editClient(client) {
      angular.copy(client, vm.selectedClient);
      angular.element("#modalClientForm").modal({ backdrop: "static", keyboard: false });
    }

    function openContactForm() {
      angular
        .element("#modalTicketContactForm")
        .modal({ backdrop: "static", keyboard: false });
    }

    function refreshSeats() {
      rTrip.getOccupiedSeats(
        { id: vm.ticket.selectedTrip.id },
        function (result) {
          vm.occupiedSeats = result;
        }
      );
    }

    function getSeatsToReserve() {
      var list = vm.selectedSeat;
      var seats = [];

      angular.forEach(vm.ticket.clients, function (client, index) {
        if (list[index] && list[index].seatNumber) {
          seats.push({
            clientId: client.id,
            seatNumber: list[index].seatNumber
          });
        }
      });

      vm.ticket.clients.length = seats.length;

      return seats;
    }

    function reserveTickets() {
      var seats = getSeatsToReserve();
      var tripId = vm.ticket.selectedTrip.id;
      rTicket.reserve(
        { tripId: tripId, seats: seats },
        function () {
          /* El PUT debe mover el tiquete al asiento que se acaba de reservar,
             no a lo que quede en la seleccion cuando el cajero confirme. */
          vm.reservedSeats = seats;
          vm.ticket.total = getNewTicketPrice();
          updateDifference();

          toastr.success("Reservación Satisfactoria");
          WizardHandler.wizard("edit-ticket-wizard").next();
        },
        function (error) {
          toastr.error(error.data.message, "Error de reservación");
          refreshSeats();
        }
      );
    }


    function goBackToStepOne() {
      vm.ticket.selectedTrip = null;
      vm.submitAttemptStep1 = false;
      vm.clearSeatSelection();
    }

    function clearSeatSelection() {
      vm.selectedSeat = [];
      vm.reservedSeats = [];
      vm.showBusLayout = false;
      $timeout(function () {
        vm.showBusLayout = true;
      });
    }

    function goToConfirmation(form) {
      vm.submitAttemptStep3 = true;
      if (!form.$valid || vm.selectedSeat.length !== vm.ticket.clients.length) {
        return;
      }

      loadBoardings(vm.ticket.route, vm.ticket.selectedTrip.schedule);
      vm.submitAttemptStep3 = false;
      reserveTickets();
    }

    /*Step 4*/

    function restartTickets() {
      $window.location.reload();
    }

    function goBackToStepThree() {
      vm.cancelReservation(false);
      vm.clearSeatSelection();
    }

    function cancelReservation(reloadAfterCancel) {
      var seats = [];
      /* Se libera lo reservado, no lo que este seleccionado en pantalla. */
      angular.forEach(vm.reservedSeats, function (seat) {
        seats.push(seat.seatNumber);
      });

      rTicket.cancelReserve(
        { tripId: vm.ticket.selectedTrip.id, seats: seats },
        function () {
          if (reloadAfterCancel) {
            toastr.info("Reservación cancelada");
            $timeout(function () {
              $window.location.reload();
            }, 1500);
          }
        }
      );
    }

    /* El servidor conserva el descuento del tiquete original al recalcular el
       precio, por eso se replica aquí en lugar de leer el check de la vista. */
    function originalHasDiscount() {
      return !!(vm.originalTicket.hasDiscount || vm.originalTicket.discount);
    }

    function getNewTicketPrice() {
      var rate = vm.ticket.selectedTrip.schedule.routeRate.billingRate;

      if (!originalHasDiscount()) {
        return rate;
      }

      return utilsService.roundNearest10(rate - (rate / 100) * vm.discountToApply);
    }

    /* Lo ya pagado por el tiquete, incluyendo ajustes previos. Si el tiquete
       se cambio antes por uno mas caro, ese monto ya cubre el nuevo precio y no
       se debe volver a cobrar contra la tarifa original. */
    function getTotalPaidAmount() {
      var totalPaid = vm.originalTicket.totalPaidAmount;

      if (totalPaid === null || totalPaid === undefined || totalPaid === "") {
        return parseFloat(vm.originalTicket.rate || 0);
      }

      return parseFloat(totalPaid);
    }

    /* Lo pagado puede incluir ajustes de ediciones previas. Se desglosa contra
       la tarifa original para que el cajero lo vea apenas busca el tiquete. */
    function buildPaidBreakdown(invoice) {
      var originalRate = parseFloat(invoice.originalRate);
      var totalPaid = parseFloat(invoice.totalPaidAmount);

      if (isNaN(originalRate) || isNaN(totalPaid)) {
        return null;
      }

      var difference = totalPaid - originalRate;

      return {
        originalRate: originalRate,
        difference: Math.abs(difference),
        sign: difference < 0 ? "-" : "+"
      };
    }

    function updateDifference() {
      var newPrice = parseFloat(vm.ticket.total || 0);
      var totalPaid = getTotalPaidAmount();

      vm.totalPaidAmount = totalPaid;
      vm.differenceToPay = Math.max(newPrice - totalPaid, 0);
      vm.hasToPay = vm.differenceToPay > 0;

      if (!vm.hasToPay) {
        clearPaymentFields();
      }

      calcDifference();
    }

    function clearPaymentFields() {
      vm.amount = null;
      vm.cardAmount = null;
      vm.sinpeAmount = null;
      vm.cashAmount = null;
      vm.cardConfirmation = null;
      vm.sinpeConfirmation = null;
      vm.difference = null;
    }

    function paymentMethodChange() {
      vm.difference = null;
      if (vm.paymentMethod.name != "Mixto") {
        vm.cardAmount = null;
        vm.sinpeAmount = null;
        vm.cashAmount = null;
      }
    }

    function calcDifference() {
      vm.difference = null;

      if (!vm.hasToPay) {
        return;
      }

      if (vm.amount && vm.amount > 0) {
        vm.difference = vm.differenceToPay - parseFloat(vm.amount);
        vm.difference = vm.difference * -1;
      }
      if (vm.cardAmount && vm.cardAmount > 0 || vm.sinpeAmount && vm.sinpeAmount > 0 || vm.cashAmount && vm.cashAmount > 0) {
        vm.difference = vm.differenceToPay - (parseFloat(vm.cardAmount || 0) + parseFloat(vm.sinpeAmount || 0) + parseFloat(vm.cashAmount || 0));
        vm.difference = vm.difference * -1;
      }
    }

    function isCoveredTotal() {
      return (parseFloat(vm.cardAmount || 0) + parseFloat(vm.sinpeAmount || 0) + parseFloat(vm.cashAmount || 0)) >= vm.differenceToPay;
    }

    function totalCash() {
      return parseFloat(vm.cashAmount || 0) - vm.difference;
    }

    function setError(message) {
      toastr.error(message);
      vm.loading = false;
      return false;
    }

    function isPaymentValid() {
      var totalAmount = parseFloat(vm.differenceToPay || 0);
      var enteredAmount = parseFloat(vm.amount || 0);

      switch (vm.paymentMethod.name) {
        case "Mixto":

          var card = parseFloat(vm.cardAmount || 0);
          var sinpe = parseFloat(vm.sinpeAmount || 0);
          var cash = parseFloat(vm.cashAmount || 0);

          if (card > totalAmount) {
            return setError("El monto de Tarjeta no puede ser mayor al total");
          }

          if (sinpe > totalAmount) {
            return setError("El monto de SINPE Móvil no puede ser mayor al total");
          }

          if (card + sinpe > totalAmount) {
            return setError("Tarjeta y SINPE Móvil sumados no pueden ser mayores al total");
          }

          if (card + sinpe + cash < totalAmount) {
            return setError("Montos deben sumar igual o mayor al total");
          }
          break;
        case "Tarjeta":
        case "SINPE Movil":
          if (enteredAmount !== totalAmount) {
            return setError("Monto debe ser igual al total");
          }
          break;
        default:
          if (enteredAmount < totalAmount) {
            return setError("Monto Insuficiente");
          }
          break;
      }
      return true;
    }

    /* La suma de los montos debe dar exactamente la diferencia cobrada, por eso
       el efectivo va neto de vuelto. */
    function buildPaymentMethods() {
      var paymentMethods = [];

      switch (vm.paymentMethod.name) {
        case "Efectivo":
          paymentMethods.push({
            paymentType: "Efectivo",
            amount: vm.amount - (vm.difference || 0)
          });
          break;
        case "Tarjeta":
        case "SINPE Movil":
          paymentMethods.push({
            paymentType: vm.paymentMethod.name,
            amount: parseFloat(vm.amount),
            cardConfirmation: vm.cardConfirmation
          });
          break;
        case "Mixto":
          if (vm.cardAmount > 0) {
            paymentMethods.push({
              paymentType: "Tarjeta",
              amount: parseFloat(vm.cardAmount),
              cardConfirmation: vm.cardConfirmation
            });
          }
          if (vm.sinpeAmount > 0) {
            paymentMethods.push({
              paymentType: "SINPE Movil",
              amount: parseFloat(vm.sinpeAmount),
              cardConfirmation: vm.sinpeConfirmation
            });
          }
          if (vm.cashAmount > 0) {
            paymentMethods.push({
              paymentType: "Efectivo",
              amount: totalCash()
            });
          }
          break;
      }

      return paymentMethods;
    }

    function buildAdjustmentReference() {
      return "ADJ-" + vm.originalTicket.invoiceNumber + "-" + moment().format("YYYYMMDDHHmmss");
    }

    function adjustErrorMessage(error) {
      var data = (error && error.data) || {};
      var message = data.message || "";

      if (data.errorType === "PAYED_AMMOUNT_MISSMATCH" || message.indexOf("PAYED_AMMOUNT_MISSMATCH") !== -1) {
        return "El monto de la diferencia no coincide con el calculado por el sistema. Vuelva a buscar el tiquete e intente de nuevo.";
      }

      return message;
    }

    function editTicket(form) {
      vm.submitAttemptStep4 = true;

      if (!form.$valid) {
        return;
      }

      if (vm.hasToPay && !isPaymentValid()) {
        return;
      }

      vm.loading = true;

      if (vm.hasToPay) {
        adjustThenUpdate();
      } else {
        updateTicket(null);
      }
    }

    /* El ajuste va primero: el servidor calcula la diferencia contra el viaje
       actual del tiquete, así que debe correr antes de moverlo con el PUT. */
    function adjustThenUpdate() {
      var reference = buildAdjustmentReference();

      var adjustment = {
        id: vm.originalTicket.invoiceNumber,
        tripId: vm.ticket.selectedTrip.id,
        amount: vm.differenceToPay,
        reference: reference,
        source: "terminal",
        paymentMethods: buildPaymentMethods()
      };

      rTicket.adjust(
        adjustment,
        function () {
          updateTicket(reference);
        },
        function (error) {
          vm.loading = false;
          toastr.error(adjustErrorMessage(error), "Error al cobrar la diferencia");
        }
      );
    }

    function updateTicket(paidReference) {
      var ticketToUpdate = {
        id: vm.originalTicket.invoiceNumber,
        trip: {
          id: vm.ticket.selectedTrip.id
        },
        seatNumber: vm.reservedSeats[0].seatNumber,
        boarding: { id: vm.ticket.clients[0].boarding.id }
      };
      rTicket.update(
        ticketToUpdate,
        function () {
          toastr.info("Ticket Editado Satisfactoriamente");

          /* Si se cobro diferencia el cajero necesita el comprobante; el modal
             recarga la pagina al cerrarse (restartTicketsEvent). */
          if (paidReference) {
            showEditInvoice();
            return;
          }

          $timeout(function () {
            $window.location.reload();
          }, 2000);
        },
        function (error) {
          vm.loading = false;

          /* La diferencia ya se cobró: el cajero necesita la referencia para
             que soporte pueda completar el cambio manualmente. */
          if (paidReference) {
            toastr.error(
              "La diferencia fue cobrada (ref. " + paidReference + ") pero no se pudo asignar el asiento/abordaje. Contacte a soporte.",
              "Error al editar",
              { timeOut: 0, extendedTimeOut: 0 }
            );
            return;
          }

          toastr.error(error.data.message, "Error al editar");
        }
      );
    }

    /* El precio original y la diferencia se toman de lo calculado en la pantalla:
       el invoice que devuelve el servidor ya trae el precio nuevo. */
    function showEditInvoice() {
      vm.editInvoiceInfo = {
        originalPrice: vm.totalPaidAmount,
        paidDifference: vm.differenceToPay
      };
      vm.invoices = [{ invoiceNumber: vm.originalTicket.invoiceNumber }];
      vm.loading = false;

      angular
        .element("#modalTicketInvoice")
        .modal({ backdrop: "static", keyboard: false });
    }

    /*TODO: SORT*/

    function hasCashierOpen() {
      if (!loggedUser.openCash && !loggedUser.reseller) {
        SweetAlert.swal({
          title: "",
          text: "Para Vender debe tener una caja abierta",
          confirmButtonText: "Aceptar",
          closeOnConfirm: true,
          closeOnCancel: true
        });
      }
    }

    function init() {
      hasCashierOpen();
      vm.discountToApply = DISCOUNT;

      loadRoutes();
      loadBusClasses();
    }

    init();

    restartTicketsEvent = $rootScope.$on("restartTicketsEvent", function () {
      restartTickets();
    });

    ticketContactUpdatedEvent = $rootScope.$on(
      "ticketContactUpdated",
      function (_, updatedTicket) {
        if (!vm.originalTicket || !updatedTicket) {
          return;
        }
        vm.originalTicket.email = updatedTicket.email;
        vm.originalTicket.customerPhone = updatedTicket.customerPhone;
      }
    );

    $rootScope.$on("$destroy", restartTicketsEvent);
    $rootScope.$on("$destroy", ticketContactUpdatedEvent);
  }
})();

(function () {
  "use strict";

  angular.module("tnsp").controller("TicketsController", TicketsController);

  /** @ngInject */
  function TicketsController(
    DISCOUNT,
    $window,
    $timeout,
    $scope,
    rRoute,
    rBus,
    rUser,
    rClient,
    rTicket,
    rTrip,
    rBoarding,
    rDropoff,
    rSchedule,
    toastr,
    utilsService,
    WizardHandler,
    moment,
    authenticationService,
    SweetAlert,
    $rootScope,
    SALE_PAYMENT_TYPES,
    SALES_TIME_AFTER_DETARTURE,
    SALES_TIME_AFTER_DETARTURE_RESELLER
  ) {
    var vm = this,
      minDate = new Date(),
      now = moment(),
      maxDate = moment().add(3, "month"),
      loggedUser = authenticationService.getUserInfo(),
      restartTicketsEvent,
      rawTotal = null;

    vm.isSysAdmin = $rootScope.isAdmin();

    vm.roundNearest10 = roundNearest10;
    vm.buyDollars = buyDollars;
    var paymentTimer = null;

    vm.disableReturnRoute = true;
    vm.loading = false;

    vm.paymentMethods = SALE_PAYMENT_TYPES;

    vm.years = [
      { value: 26, desc: "2026" },
      { value: 27, desc: "2027" },
      { value: 28, desc: "2028" },
      { value: 29, desc: "2029" },
      { value: 30, desc: "2030" },
      { value: 31, desc: "2031" },
      { value: 32, desc: "2032" },
    ];

    vm.months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

    vm.routesList = [];
    vm.busesTypes = [];
    vm.schedulesAvailable = [];

    vm.occupiedSeats = [];
    vm.selectedSeat = [];

    vm.newticket = {};
    vm.newticket.typeOfTrip = 1;

    vm.originalClientList = []
    vm.newticket.clients = [];
    vm.selectedClient = {};

    vm.showBusLayout = true;

    vm.boardingList = [];
    vm.dropoffList = [];

    vm.finalTicketList = { tickets: [] };

    vm.dateConfig = { minDate: minDate, maxDate: maxDate };

    vm.ticketsPaid = false;

    vm.discountToApply = 0;
    vm.totlaWithDiscount = 0;
    vm.syncBoardingValues = syncBoardingValues;
    vm.updateTotal = updateTotal;

    vm.selectedRoutePrefix = null;
    vm.selectRoute = selectRoute;

    vm.loadSchedulesAvailable = loadSchedulesAvailable;
    vm.openOriginDate = openOriginDate;
    vm.goToSelectClients = goToSelectClients;

    vm.getSeatLabel = getSeatLabel;
    vm.getAvailableSeats = getAvailableSeats;
    vm.handleSelectedSeats = handleSelectedSeats;


    /*Step 2*/
    vm.searchClient = searchClient;
    vm.addClientToTicket = addClientToTicket;
    vm.createClient = createClient;
    vm.editClient = editClient;
    vm.removeClient = removeClient;
    vm.goToSelectSeats = goToSelectSeats;
    vm.reserveTickets = reserveTickets;
    vm.refreshSeats = refreshSeats;

    /*Step3*/
    vm.goBackToStepOne = goBackToStepOne;
    vm.clearSeatSelection = clearSeatSelection;
    vm.goToConfirmation = goToConfirmation;
    vm.isSubmittingStep3 = false;

    /*Step 4*/
    vm.payTickets = payTickets;
    vm.calcDifference = calcDifference;
    vm.isCoveredTotal = isCoveredTotal;
    vm.totalCash = totalCash;

    vm.restartTickets = restartTickets;
    vm.goBackToStepThree = goBackToStepThree;
    vm.cancelReservation = cancelReservation;
    vm.paymentMethodChange = paymentMethodChange;

    var fullRouteList = [];

    init();

    function roundNearest10(num) {
      return utilsService.roundNearest10(num);
    }

    function selectRoute(route) {
      vm.selectedRoutePrefix = route;
      filterRoutes();
      WizardHandler.wizard("ticket-wizard").next();
    }

    /*Step 1*/
    function loadRoutes() {
      rRoute.query(
        { publicRoute: true, onlyActiveSchedule: true, pagesize: 150 },
        function (result) {
          fullRouteList = result.records;
          vm.routesList = angular.copy(fullRouteList);
        }
      );
    }

    function filterRoutes() {
      vm.routesList = fullRouteList.filter(function (route) {
        return route.invoiceCounterNumber.prefix === vm.selectedRoutePrefix;
      });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function (result) {
        vm.busClasses = result.records;
      });
    }

    function buyDollars() {
      if (loggedUser.openCash) {
        angular.element('#modalBuyDollarsForm').modal({ backdrop: 'static', keyboard: false });
      } else {
        SweetAlert.swal({
          title: "",
          text: "Para comprar dolares debe tener una caja abierta",
          confirmButtonText: "Aceptar",
          closeOnConfirm: true,
        });
      }
    }

    //TODO CLEAN UP THIS FUNCTION
    function loadSchedulesAvailable() {
      if (vm.newTicket) {
        vm.newTicket.busType = vm.busClasses[0].id;

        if (vm.newTicket.route.id && vm.originDateUI && vm.newTicket.busType) {
          rTrip.query({
            routeid: vm.newTicket.route.id,
            busclassid: vm.newTicket.busType,
            date: moment(vm.originDateUI).format("YYYY-MM-DD"),
            inclusive: true
          }, function (result) {
            vm.schedulesAvailable = result.records.filter(function (item) {
              var scheduleDateTime = item.date + "T" + item.schedule.departureTime + ":00.000-0600";
              var terminalAllowed = vm.isSysAdmin || (!loggedUser.reseller && moment() < moment(scheduleDateTime).add(SALES_TIME_AFTER_DETARTURE, "m"));
              var resellerAllowed = loggedUser.reseller && moment() < moment(scheduleDateTime).add(SALES_TIME_AFTER_DETARTURE_RESELLER, "m");
              return (item.schedule.visible === true && item.schedule.isDisplayable === true && (terminalAllowed || resellerAllowed));
            });
            vm.schedulesAvailable.map(function (trip) { trip.schedule.departureTimeUI = utilsService.mapToAMPM(trip.schedule.departureTime); });
          }
          );
        }
      }
    }

    function getSeatLabel(layoutType, seatNumber) {
      return utilsService.getSeatLabel(layoutType, seatNumber);
    }

    function getAvailableSeats() {
      $timeout(function () {
        var trip = vm.newTicket.selectedTrip;
        if (!trip) return;
        trip.availableSeats = utilsService.getAvailableSeats(trip).available;
        refreshSeats();
      }, 1000);
    }

    function handleSelectedSeats(selectedSeats) {
      vm.selectedSeat = selectedSeats;
    }

    function openOriginDate() {
      vm.showOriginCalendar = true;
    }

    function goToSelectClients(form) {
      vm.submitAttemptStep1 = true;
      if (!form.$valid) {
        return;
      }

      if (vm.newticket.typeOfTrip != 3) {
        loadBoardings(vm.newTicket.route, vm.newTicket.selectedTrip.schedule);
        // HOTFIX: Drop Off desactivado temporalmente
        // loadDropoffs(vm.newTicket.route, vm.newTicket.selectedTrip.schedule);
      }

      refreshSeats();
      searchClient("000");
      searchClient("111");
      searchClient("222");
      searchClient("333");
      searchClient("444");
      searchClient("555");
      searchClient("666");
      searchClient("777");
      searchClient("888");
      searchClient("999");

      WizardHandler.wizard("ticket-wizard").next();
    }

    /*Step 2*/

    function goToSelectSeats(form) {
      vm.submitAttemptStep2 = true;
      if (!form.$valid || !vm.originalClientList.length > 0) {
        return;
      }
      refreshSeats();
      //loadApprovers();
      WizardHandler.wizard("ticket-wizard").next();
    }

    function loadBoardings(route, schedule) {
      var routeId = route.id;

      rBoarding.query({ pagesize: 100, routeId: routeId }, function (result) {
        vm.boardingList = result.records;
        loadInvalidBoardings(schedule, routeId);
      });
    }

    function loadDropoffs(route, schedule) {
      var routeId = route.id;
      var scheduleId = schedule.id;

      rDropoff.query(
        { routeId: routeId, scheduleId: scheduleId },
        function (result) {
          vm.dropoffList = result;
        }
      );
    }

    function loadInvalidBoardings(schedule, routeId) {
      rSchedule.query({ id: schedule.id, routeId: routeId }, function (result) {
        var schedule = result;
        updateList(vm.boardingList, schedule.invalidBoardings);

        var tempBoardings = [];
        angular.forEach(vm.boardingList, function (boarding) {
          if (!boarding.hide) {
            tempBoardings.push(boarding);
          }
        });

        angular.copy(tempBoardings, vm.boardingList);
      });
    }

    function updateList(list, list2) {
      angular.forEach(list, function (item) {
        angular.forEach(list2, function (item2) {
          if (item.id === item2.id) {
            item.hide = true;
            //list.splice(index, 1);
          }
        });
      });
    }

    function getAge(dateString) {
      var today = new Date(),
        birthDate = new Date(dateString),
        age = today.getFullYear() - birthDate.getFullYear(),
        m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    }

    function searchClient(id) {
      if (id) {
        rClient.query({ identification: id }, function (result) {
          if (result.records.length > 0) {
            angular.forEach(result.records, function (item) {
              item.age = getAge(item.birthdate);
              item.hasDiscount = false;
            });
            vm.searchedClient = result.records[0];
            addClientToTicket();
          } else {
            vm.searchedClient = {};
            toastr.error("No se encontró un cliente con esa identificación");
          }
        });
      } else {
        angular.copy({}, vm.searchedClient);
      }
    }

    function addClientToTicket() {
      if (
        !angular.equals({}, vm.searchedClient) &&
        vm.searchedClient != undefined
      ) {
        vm.searchedClient.boarding = vm.searchedClientBoarding;
        vm.searchedClient.boardingT = vm.searchedClientBoardingT;
        vm.searchedClient.returnBoarding = vm.searchedClientReturnBoarding;

        vm.newticket.clients.push(vm.searchedClient);
        vm.originalClientList.push(vm.searchedClient);

        if (
          moment(vm.searchedClient.identificationExpiration).subtract(
            6,
            "months"
          ) < now
        ) {
          toastr.error(
            "El Pasaporte está vencido o por vencer en menos de 6 meses",
            "Vencimiento de Pasaporte"
          );
        }
        vm.searchedClient = {};
        vm.identificationToSearch = "";
        vm.searchedClientBoarding = "";
        vm.searchedClientReturnBoarding = "";
      } else {
        if (
          angular.equals({}, vm.searchedClient) ||
          vm.searchedClient == undefined
        ) {
          toastr.error("Debe buscar y seleccionar un cliente");
        } else {
          toastr.error("Debe seleccionar el abordaje");
        }
      }
    }

    function createClient() {
      vm.selectedClient = null;
      angular
        .element("#modalClientForm")
        .modal({ backdrop: "static", keyboard: false });
    }

    function editClient(client) {
      angular.copy(client, vm.selectedClient);
      angular
        .element("#modalClientForm")
        .modal({ backdrop: "static", keyboard: false });
    }

    function removeClient(index) {
      vm.newticket.clients.splice(index, 1);
    }

    /*Step 3*/
    function refreshSeats() {
      rTrip.getOccupiedSeats({ id: vm.newTicket.selectedTrip.id }, function (result) {
        vm.occupiedSeats = result;
      });
    }


    function getSeatsToReserve() {
      var list = vm.selectedSeat;
      var seats = [];

      angular.forEach(vm.originalClientList, function (client, index) {
        if (list[index] && list[index].seatNumber) {
          seats.push({
            clientId: client.id,
            seatNumber: list[index].seatNumber
          });
        }
      });
      angular.copy(vm.originalClientList, vm.newticket.clients);
      vm.newticket.clients.length = seats.length;

      return seats;
    }

    function reserveTickets() {
      var seats = getSeatsToReserve();
      var tripId = vm.newTicket.selectedTrip.id;
      rTicket.reserve(
        { tripId: tripId, seats: seats },
        function () {
          vm.newTicket.total =
            vm.newTicket.selectedTrip.schedule.routeRate.billingRate *
            vm.newticket.clients.length;

          toastr.success("Reservación Satisfactoria");
          WizardHandler.wizard("ticket-wizard").next();
        },
        function (error) {
          toastr.error(error.data.message, "Error de reservación");
          refreshSeats();
        }
      );
    }

    function goBackToStepOne() {
      vm.newTicket.selectedTrip = null;
      vm.submitAttemptStep1 = false;
      vm.clearSeatSelection();
    }

    function clearSeatSelection() {
      vm.selectedSeat.length = 0;
      vm.showBusLayout = false;
      $timeout(function () {
        vm.showBusLayout = true;
      });
    }

    function goToConfirmation(form) {

      if (vm.isSubmittingStep3) return;

      vm.isSubmittingStep3 = true;

      vm.submitAttemptStep3 = true;
      if (!form.$valid) {
        return;
      }

      vm.submitAttemptStep3 = false;

      reserveTickets();
      setPaymentTimer();
      loadApprovers();
    }

    /*Step 4*/
    function setPaymentTimer() {
      paymentTimer = $timeout(function () {
        SweetAlert.warning(
          {
            title: "",
            text: "Tu Reservación ha expirado, debe iniciar nuevamente la compra",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
            closeOnConfirm: true,
            closeOnCancel: true,
            allowEscapeKey: false
          },
          function () {
            restartTickets();
          }
        );
      }, 300000); // timer of 7 min  ( 1000 * 60 * 5 )
    }

    function syncBoardingValues(index, selectedBoarding) {
      if (index === 0 && selectedBoarding) {
        angular.forEach(vm.newticket.clients, function (client) {
          if (!client.boarding) {
            client.boarding = selectedBoarding;
          }
        });
      }
    }

    function updateTotal() {
      var clientRate = 0;
      if (!rawTotal) {
        rawTotal = vm.newTicket.total;
      } else {
        vm.newTicket.total = rawTotal;
        if (vm.amount || vm.cardAmount || vm.sinpeAmount || vm.cashAmount) {
          calcDifference();
        }
      }

      var newTotalCalculated = 0;

      angular.forEach(vm.newticket.clients, function (client) {
        if (client.dropoff && client.dropoff.rate) {
          clientRate = client.dropoff.rate;
        } else if (client.boarding && client.boarding.rate) {
          clientRate = client.boarding.rate;
        } else {
          clientRate = vm.newTicket.selectedTrip.schedule.routeRate.billingRate;
        }

        if (client.hasDiscount) {
          if (client.dropoff) {
            newTotalCalculated += client.dropoff.discountRate;
          } else {
            newTotalCalculated += roundNearest10(
              clientRate - (clientRate / 100) * vm.discountToApply
            );
          }
        } else {
          newTotalCalculated += clientRate;
        }
      });

      rawTotal = newTotalCalculated;
      vm.newTicket.total = rawTotal;

      if (vm.amount || vm.cardAmount || vm.sinpeAmount || vm.cashAmount) {
        calcDifference();
      }
    }

    function loadApprovers() {
      vm.approverList = [];
      rUser.query({ page: 0, pagesize: 200, role: 1 }, function (result) {
        vm.approverList = vm.approverList.concat(result.records);
      });

      rUser.query({ page: 0, pagesize: 200, role: 3 }, function (result) {
        vm.approverList = vm.approverList.concat(result.records);
      });
    }

    function calcDifference() {
      vm.difference = null;
      if (vm.amount && vm.amount > 0) {
        vm.difference = vm.newTicket.total - parseFloat(vm.amount);
        vm.difference = vm.difference * -1;
      }
      if (vm.cardAmount && vm.cardAmount > 0 || vm.sinpeAmount && vm.sinpeAmount > 0 || vm.cashAmount && vm.cashAmount > 0) {
        vm.difference = vm.newTicket.total - (parseFloat(vm.cardAmount || 0) + parseFloat(vm.sinpeAmount || 0) + parseFloat(vm.cashAmount || 0));
        vm.difference = vm.difference * -1;
      }
    }

    function isCoveredTotal() {
      return (parseFloat(vm.cardAmount || 0) + parseFloat(vm.sinpeAmount || 0) + parseFloat(vm.cashAmount || 0)) >= vm.newTicket.total;
    }

    function payTickets(form) {
      vm.submitAttemptStep4 = true;
      vm.loading = true;
      if (!form.$valid || !isPaymentValid()) {
        vm.loading = false;
        return;
      }
      paymentProcess();
    }

    function isPaymentValid() {
      var totalAmount = parseFloat(vm.newTicket.total || 0);
      var enteredAmount = parseFloat(vm.amount || 0);

      switch (vm.paymentMethod.name) {
        case "Mixto":

          var card = parseFloat(vm.cardAmount || 0);
          var sinpe = parseFloat(vm.sinpeAmount || 0);
          var cash = parseFloat(vm.cashAmount || 0);

          if (card > totalAmount) {
            return setError("El monto de Tarjeta no puede ser mayor al total");
          }

          if (sinpe > totalAmount) {
            return setError("El monto de SINPE Móvil no puede ser mayor al total");
          }

          if (card + sinpe > totalAmount) {
            return setError("Tarjeta y SINPE Móvil sumados no pueden ser mayores al total");
          }

          if (card + sinpe + cash < totalAmount) {
            return setError("Montos deben sumar igual o mayor al total");
          }
          break;
        case "Tarjeta":
        case "SINPE Movil":
          if (enteredAmount !== totalAmount) {
            return setError("Monto debe ser igual al total");
          }
          break;
        default:
          if (enteredAmount < totalAmount) {
            return setError("Monto Insuficiente");
          }
          break;
      }
      return true;
    }

    function setError(message) {
      toastr.error(message);
      vm.loading = false;
      return false;
    }

    function paymentProcess() {
      var payment = {
        source: "terminal"
      };
      if (vm.newTicket.customerPhone) {
        payment.customerPhone = vm.newTicket.customerPhone;
      }
      if (vm.newTicket.email) {
        payment.email = vm.newTicket.email;
      }
      payment.tickets = [];
      payment.paymentTypes = [];
      switch (vm.paymentMethod.name) {
        case "Efectivo":
          var finalAmount = vm.amount - vm.difference || 0;
          if (finalAmount === vm.newTicket.total) {
            payment.paymentTypes.push({
              paymentType: "Efectivo",
              amount: finalAmount
            });
          } else {
            toastr.error("Monto de pago incorrecto");
            return;
          }
          break;
        case "Tarjeta":
        case "SINPE Movil":
          payment.paymentTypes.push({
            paymentType: vm.paymentMethod.name,
            amount: vm.amount,
            cardConfirmation: vm.newTicket.cardConfirmation
          });
          break;
        case "Mixto":
          if (vm.cardAmount > 0) {
            payment.paymentTypes.push({
              paymentType: "Tarjeta",
              amount: parseFloat(vm.cardAmount),
              cardConfirmation: vm.newTicket.cardConfirmation
            });
          }
          if (vm.sinpeAmount > 0) {
            payment.paymentTypes.push({
              paymentType: "SINPE Movil",
              amount: parseFloat(vm.sinpeAmount),
              cardConfirmation: vm.newTicket.sinpeConfirmation
            });
          }
          if (vm.cashAmount > 0) {
            payment.paymentTypes.push({
              paymentType: "Efectivo",
              amount: totalCash()
            });
          }
          break;
      }
      angular.forEach(vm.newticket.clients, function (client, index) {
        var ticket = {};
        ticket.client = { id: client.id };
        ticket.hasDiscount = client.hasDiscount;

        ticket.tripSeat = {};
        ticket.tripSeat.trip = { id: vm.newTicket.selectedTrip.id };
        ticket.tripSeat.seatNumber = vm.selectedSeat[index].seatNumber;
        if (client.boarding) {
          ticket.boarding = {};
          ticket.boarding.id = client.boarding.id;
        }

        if (client.dropoff) {
          ticket.dropOff = {};
          ticket.dropOff.id = client.dropoff.id;
        }
        if (client.hasDiscount) {
          ticket.citizenId = "";
          ticket.citizenId = client.citizenId;
        }
        payment.tickets.push(ticket);
      });
      rTicket.save(
        payment,
        function (result) {
          toastr.success("Ticket vendido");
          vm.ticketsPaid = true;

          vm.invoices = result;

          angular
            .element("#modalTicketInvoice")
            .modal({ backdrop: "static", keyboard: false });
          vm.loading = false;
        },
        function (error) {
          toastr.error("Error al comprar", error.data.message);
          vm.loading = false;
        }
      );
    }

    function totalCash() {
      var totalCash = parseFloat(vm.cashAmount || 0) - vm.difference;
      return totalCash;
    }

    function restartTickets() {
      $window.location.reload();
    }

    function goBackToStepThree() {
      vm.cancelReservation(false);
      vm.clearSeatSelection();
    }

    function cancelReservation(reloadAfterCancel) {
      vm.isSubmittingStep3 = false;
      $timeout.cancel(paymentTimer);
      var seats = [];
      angular.forEach(vm.selectedSeat, function (seat) {
        seats.push(seat.seatNumber);
      });

      rTicket.cancelReserve(
        { tripId: vm.newTicket.selectedTrip.id, seats: seats },
        function () {
          if (reloadAfterCancel) {
            toastr.info("Reservación cancelada");
            $timeout(function () {
              $window.location.reload();
            }, 1500);
          }
        }
      );
    }

    function paymentMethodChange() {
      vm.difference = null;
      if (vm.paymentMethod.name != "Mixto") {
        vm.cardAmount = null;
        vm.sinpeAmount = null;
        vm.cashAmount = null;
      }
    }

    function hasCashierOpen() {
      if (!loggedUser.openCash && !loggedUser.reseller) {
        SweetAlert.swal({
          title: "",
          text: "Para Vender debe tener una caja abierta",
          confirmButtonText: "Aceptar",
          closeOnConfirm: true,
          closeOnCancel: true
        });
      }
    }

    function init() {
      hasCashierOpen();
      loadRoutes();
      loadBusClasses();
      vm.discountToApply = DISCOUNT;
    }

    restartTicketsEvent = $rootScope.$on("restartTicketsEvent", function () {
      restartTickets();
    });

    $scope.$on("wizard:stepChanged", function (_, args) {
      if (args.index === 1) {
        vm.newticket.clients = [];
      }
    });

    $rootScope.$on("$destroy", restartTicketsEvent);
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller("TicketHistoryController", TicketHistoryController);

  /** @ngInject */
  function TicketHistoryController(rTicket, toastr, $rootScope) {
    var vm = this;
    vm.searchTicket = searchTicket;
    vm.ticketToSearch = "";

    vm.history = null;

    vm.isSysAdmin = $rootScope.isAdmin();

    function searchTicket(form) {
      if (!form.$valid) {
        return;
      }

      rTicket.reportTicketHistory(
        { id: vm.ticketToSearch },
        function (result) {
          vm.history = result;
        },
        function () {
          toastr.error("Este Tiquete no existe");
          vm.history = [];
        }
      );
    }

    function init() {}

    init();
  }
})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('RedeemController', RedeemController);

  /** @ngInject */
  function RedeemController($log, $window, $timeout, rTicket, rTrip, toastr, REDEEM_PAYMENT_TYPES, SweetAlert, WizardHandler, moment, authenticationService, rCashRegister) {
    var vm = this,
      minDate = new Date(),
      loggedUser = authenticationService.getUserInfo();

    vm.dateConfig = { minDate: minDate };
    vm.schedulesAvailable = [];
    vm.allSeats = [];
    vm.selectedSeat = [];
    vm.boardingList = [];
    vm.paymentMethods = REDEEM_PAYMENT_TYPES;

    vm.searchTicket = searchTicket;
    vm.loadSchedulesAvailable = loadSchedulesAvailable;
    vm.generateSeats = generateSeats;
    vm.goToSeats = goToSeats;
    vm.toggleSeatSelection = toggleSeatSelection;

    vm.reserveTickets = reserveTickets;
    vm.refreshSeats = refreshSeats;

    vm.goToConfirmation = goToConfirmation;
    vm.cancelReservation = cancelReservation;


    vm.payTickets = payTickets;
    vm.simpleRedeem = simpleRedeem;

    function loadSchedulesAvailable() {
      if (vm.originDateUI) {
        rTrip.query({
          routeid: vm.ticket.routeRate.route.id,
          busclassid: vm.ticket.routeRate.busClass.id,
          date: moment(vm.originDateUI).format('YYYY-MM-DD'),
          inclusive: true
        }, function (result) {
          vm.schedulesAvailable = result.records.filter(function (item) {
            return item.schedule.visible === true && item.schedule.isDisplayable === true;
          });
        });
      } else {
        vm.schedulesAvailable = [];
      }
    }

    function generateSeats() {
      $timeout(function () {
        if (vm.selectedTrip) {
          for (var i = 1; i <= vm.selectedTrip.seats; i++) {
            vm.allSeats.push({ seatNumber: i, isOccupied: false });
          }
          checkOccupiedSeats();
        } else {
          vm.allSeats = [];
        }
      }, 1000);
    }

    function checkOccupiedSeats() {
      vm.selectedTrip.availableSeats = (vm.selectedTrip.seats - vm.selectedTrip.tripSeats.length);

      angular.forEach(vm.selectedTrip.seats, function (occupiedSeat) {
        angular.forEach(vm.allSeats, function (availableSeat) {
          if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
            availableSeat.isOccupied = true;
            availableSeat.selected = false;
            vm.selectedTrip.availableSeats--;
          }
        })
      });
    }

    function goToSeats(form) {
      vm.submitAttemptStep1 = true;
      if (!form.$valid) {
        return
      }
      refreshSeats();
      WizardHandler.wizard('redeem-wizard').next();
    }

    function refreshSeats() {
      rTrip.getOccupiedSeats({ id: vm.selectedTrip.id }, function (result) {
        var occupiedSeats = result;
        angular.forEach(occupiedSeats, function (occupiedSeat) {
          angular.forEach(vm.allSeats, function (availableSeat) {
            if (occupiedSeat.seatNumber === availableSeat.seatNumber) {
              availableSeat.isOccupied = true;
              availableSeat.selected = false;
              removeSeat(occupiedSeat);
            }
          })
        });

      })
    }

    function toggleSeatSelection(seat) {
      if (!seat.selected) {
        seat.selected = true;
        vm.selectedSeat.push(seat);
      } else {
        seat.selected = false;
        removeSeat(seat);
      }
    }

    function reserveTickets() {

      var seats = getSeatsToReserve();
      var tripId = vm.selectedTrip.id;
      rTicket.reserve({ tripId: tripId, seats: seats }, function () {
        toastr.success('Reservación Satisfactoria');
        vm.total = (vm.selectedTrip.schedule.routeRate.billingRate);
        prepareConfirm();
        WizardHandler.wizard('redeem-wizard').next();
      }, function (error) {
        toastr.error(error.data.message, 'Error de reservación');
        refreshSeats();
      });

    }

    function removeSeat(_seat) {
      var index = -1;
      angular.forEach(vm.selectedSeat, function (seat, _index) {
        if (seat.id === _seat.id) {
          index = _index;
        }
      });
      vm.selectedSeat.splice(index, 1);
    }

    function getSeatsToReserve() {
      var list = vm.selectedSeat;
      var seats = [{ clientId: vm.ticket.client.id, seatNumber: list[0].seatNumber }];
      return seats;
    }

    function searchTicket(form) {
      if (!form.$valid) {
        return
      }
      rTicket.query({ id: vm.ticketToSearch }, function (result) {
        if (result.status === 'RELEASED' || result.status === 'OPEN') {
          vm.ticket = result;
        } else {
          toastr.error('El tiquete ingresado ya fue utilizado');
          vm.ticket = null;
        }
      }, function () {
        toastr.error('Este Tiquete no existe');
        vm.ticket = null;
      });
    }

    function goToConfirmation(form) {
      vm.submitAttemptStep2 = true;
      if (!form.$valid || (vm.selectedSeat.length !== 1)) {
        return
      }
      vm.submitAttemptStep2 = false;
      reserveTickets();

    }

    function cancelReservation() {

      var clientIds = [vm.ticket.client.id];

      rTicket.cancelReserve({ tripId: vm.selectedTrip.id, clientIds: clientIds }, function () {
        toastr.info('Reservación cancelada');
        $timeout(function () {
          $window.location.reload();
        }, 1500);
      });
    }

    function prepareConfirm() {
      vm.hasToPay = false;

      if (vm.total > vm.ticket.rate) {
        vm.hasToPay = true;
        vm.differenceToPay = parseInt(vm.total) - parseInt(vm.ticket.rate);

        vm.total = vm.differenceToPay;
      }

    }

    function payTickets(form) {

      vm.submitAttemptStep3 = true;
      if (!form.$valid) {
        return
      }

      simpleRedeem(true);

    }

    function simpleRedeem(addMovement) {
      var ticketToRedeem = {};


      ticketToRedeem.id = vm.ticket.invoiceNumber;
      ticketToRedeem.tripSeat = {
        trip: { id: vm.selectedTrip.id },
        seatNumber: vm.selectedSeat[0].seatNumber
      };

      rTicket.redeem(ticketToRedeem, function () {
        if (addMovement){
          addCashierMovement();
        }else{
          toastr.success('Ticket Redimido');
          $timeout( function(){
            $window.location.reload();
          }, 1500);

        }
      }, function (error) {
        toastr.error(error.data.message, 'Error al redimir');
      });

      $log.info(vm.ticket);

    }

    function addCashierMovement() {
      vm.addMovement = {
        id: loggedUser.openCash.id,
        terminalId: loggedUser.terminal.id,
        detail: 'Redimir ticket ' + vm.ticket.invoiceNumber,
        rate: vm.total,
        type: { id: 8 }
      };

      rCashRegister.addMovement(vm.addMovement, function() {
        vm.loading = false;
        toastr.success('Ticket Redimido');
        $timeout( function(){
          $window.location.reload();
        }, 1500);
      }, function(error){
        vm.loading = false;
        toastr.error(error.data.message, 'Error al redimir');
      });
    }

    function hasCashierOpen() {
      if (!loggedUser.openCash && !loggedUser.reseller) {
        SweetAlert.swal({
            title: '',
            text: 'Para Redimir debe tener una caja abierta',
            confirmButtonText: 'Aceptar',
            closeOnConfirm: true,
            closeOnCancel: true
          }
        );
      }
    }

    function init() {
      hasCashierOpen();
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('SalesController', SalesController);

  /** @ngInject */
  function SalesController() {

  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ChecksController', ChecksController);

  /** @ngInject */
  function ChecksController($rootScope, $log, rRoute, rBus, rTrip, rTicket, bsLoadingOverlayService, toastr, utilsService, moment, SweetAlert) {
    var vm = this,
      checkTicketsRefresh;
    vm.routesList = [];
    vm.busClasses = [];
    vm.schedulesAvailable = [];

    vm.openOriginDate = openOriginDate;
    vm.openReturnDate = openReturnDate;
    vm.searchTickets = searchTickets;

    vm.addUngeragePersonInformation = addUngeragePersonInformation;
    vm.addChecksLoadInformation = addChecksLoadInformation;
    vm.saveTicketsChecks = saveTicketsChecks;
    vm.loadSchedulesAvailable = loadSchedulesAvailable;
    vm.updateChecks = updateChecks;
    vm.releaseTicket = releaseTicket;
    vm.releaseTripTickets = releaseTripTickets;

    vm.print = print;

    vm.editClient = editClient;
    vm.selectedClient = {};

    vm.query = {};
    vm.filter = {};
    vm.selectedTicket = {};

    init();

    function print() {
      /* eslint-disable */
      window.print();
      /* eslint-enable */
    }

    function loadRoutes(){
      rRoute.query({ pagesize: 150, onlyActiveSchedules: true, publicRoute: true }, function(result){
        vm.routesList = result.records;
      });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function(result){
        vm.busClasses = result.records;
      });
    }

    function openOriginDate() {
      vm.showOriginCalendar = true;
    }

    function openReturnDate() {
      vm.showReturnCalendar = true;
    }

    function loadTickets(){
      rTrip.getTickets(vm.query, function(result){
        vm.tickets  = result;
        bsLoadingOverlayService.stop({referenceId: 'routes-overlay'});
      });
    }


    function loadSchedulesAvailable(){
      if (vm.filter.route && vm.filter.originDateUI && vm.filter.busType){
        rTrip.query({routeid:vm.filter.route, busclassid:vm.filter.busType, date: moment(vm.filter.originDateUI).format('YYYY-MM-DD'), inclusive:true}, function(result){
          vm.schedulesAvailable  = result.records;

          vm.schedulesAvailable.map(function (trip) {
            trip.schedule.departureTimeUI = utilsService.mapToAMPM(
              trip.schedule.departureTime
            );
          });
        });

      }else{
        vm.schedulesAvailable = [];
      }
    }

    function searchTickets(form){
      vm.loading = true;
      if(!form.$valid) {
        vm.loading = false;
        vm.submitAttempt = true;
        return;
      }
      vm.query.id = vm.filter.selectedTrip.id;
      loadTickets();
    }

    function saveTicketsChecks(){
      rTicket.save({}, function() {
        angular.element('#modalCashRegisterForm').modal('hide');
        vm.loading = false;
        toastr.success('La Caja Registradora fue creado satisfactoriamente');
        $rootScope.$broadcast('cashRegistersRefresh');
      }, function(error){
        vm.loading = false;
        toastr.error('Hubo un error al crear la Caja Registradora', error.data.message);
      });
    }

    function editClient(client){
      angular.copy(client, vm.selectedClient);
      vm.selectedClient.originEdit = 'checks'
      angular.element('#modalClientForm').modal({ backdrop: 'static', keyboard: false });
    }

    function addUngeragePersonInformation(ticket){
      angular.copy(ticket, vm.selectedTicket);
      angular.element('#modalUnderagePersonForm').modal({backdrop: 'static', keyboard: false});
    }

    function addChecksLoadInformation(ticket){
      angular.copy(ticket, vm.selectedTicket);
      angular.element('#modalChecksLoadForm').modal({backdrop: 'static', keyboard: false});
    }

    function updateChecks(ticket){
      rTicket.checkin({id:ticket.invoiceNumber, check1:vm.check1[ticket.invoiceNumber], check2:vm.check2[ticket.invoiceNumber], check3:vm.check3[ticket.invoiceNumber]}, function() {
        vm.loading = false;
        toastr.success('El boleto fue actualizado satisfactoriamente');
      }, function(error){
        vm.loading = false;
        toastr.error('Hubo un error al actualizar el boleto', error.data.message);
      });
    }

    function releaseTicket(ticket){
      SweetAlert.swal({
          title:'',
          text: 'Está seguro que deseea liberar este boleto?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rTicket.release({id:ticket.invoiceNumber}, function(){
              toastr.success('Boleto liberado correctamente');
              loadTickets();
            }, function(error){
              toastr.error('Error al liberar el boleto', error.message);
            });
          }
        }
      );
    }

    function releaseTripTickets(trip){
      SweetAlert.swal({
          title:'',
          text: 'Está seguro que deseea liberar los boleto de este viaje?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rTrip.release({id:trip.id}, function(){
              toastr.success('Boletos liberados correctamente');
              loadTickets();
            }, function(error){
              toastr.error('Error al liberar los boletos', error.message);
            });
          }
        }
      );
    }

    function init(){
      loadRoutes();
      loadBusClasses();
    }

    checkTicketsRefresh = $rootScope.$on('checkTicketsRefresh', function() {
      loadTickets();
    });

    $rootScope.$on('$destroy', checkTicketsRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('CashMovController', CashMovController);

  /** @ngInject */
  function CashMovController($log) {
    var vm = this;

    init();

    function init(){
      $log.info('Cash Movements Controller', vm);
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('AgencySalesController', AgencySalesController);

  /** @ngInject */
  function AgencySalesController(authenticationService, rReseller, moment) {
    var vm = this,
      loggedUser = authenticationService.getUserInfo();

    vm.report = null;

    vm.getReport = getReport;

    vm.print = print;

    loadUserInformation();

    function loadUserInformation() {
      var allAuthInfo = authenticationService.getAllAuthInfo();
      vm.userInfo = allAuthInfo.userInfo;
      vm.selectedCountry = vm.userInfo.reseller.country;
    }

    function getReport(form) {
      vm.loading = true;
      if(!form.$valid) {
        vm.loading = false;
        vm.submitAttempt = true;
        return;
      }


      vm.query = {
        from: moment(vm.filter.originDateUI).format('YYYY-MM-DD'),
        to: moment(vm.filter.finalDateUI).format('YYYY-MM-DD'),
        id: loggedUser.reseller.id
      };

      rReseller.salesReport(vm.query, function(result){
        vm.salesReportList  = result;
      });

    }

    function print() {
      /* eslint-disable */
      window.print();
      /* eslint-enable */

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController(rPassword, $state, $timeout, $stateParams, PASSWORD_PATTERN) {
    var vm = this;
    vm.loading = false;
    vm.submitAttempt = false;
    vm.message='';
    vm.resetToken = $stateParams.resetToken; // token comes in the URL
    vm.passwordPattern = PASSWORD_PATTERN;

    vm.resetPasswordProcess = function(form) {
      vm.loading = true;
      vm.message='';
      if(!form.$valid) {
        vm.submitAttempt = true;
        vm.loading = false;
        return;
      }


      if (vm.password === vm.confirmPassword){
        rPassword.reset({password: vm.password, code: vm.resetToken}, function(){
          vm.message = 'Contraseña actualizada satisfactoriamente';
          vm.loading = false;
          $timeout(function(){
            $state.go('login');
          }, 2000);
        }, function(error){
          vm.message = error.data.message;
          vm.loading = false;
        });
      }else{vm.message = 'Su contraseña debe coincidir'; vm.loading = false;}
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('TicketsIssuedController', TicketsIssuedController);

  /** @ngInject */
  function TicketsIssuedController(rTicket, bsLoadingOverlayService, moment, $log, toastr) {
    var vm = this,
      now = moment();

    vm.dateConfig = { maxDate: now };

    vm.submitAttempt = false;

    vm.body = {};
    vm.type = 'CR';

    vm.openStartDate = openStartDate;
    vm.openEndDate = openEndDate;

    vm.startDate;
    vm.endDate;

    vm.requestTicketsIssued = requestTicketsIssued;


    function requestTicketsIssued(form) {
      vm.submitAttempt = true;

      if (!form.$valid){
        $log.error('error');
        return
      }


      var body = {
        start: moment(vm.startDate).format('YYYY-MM-DD'),
        end: moment(vm.endDate).format('YYYY-MM-DD'),
        type: vm.type
      };

      bsLoadingOverlayService.start({ referenceId: 'ticketsIssued-overlay' });
      rTicket.reportTicketsIssued(body, function (result) {
          $log.info(result);
          toastr.success('Reporte generado Satisfacoriamente', 'Será enviado a su correo');
          bsLoadingOverlayService.stop({ referenceId: 'ticketsIssued-overlay' });
        },
        function (error) {
          toastr.error('Error al generar reporte', error);
        });
    }


    function openStartDate() {
      vm.showStartCalendar = true;
    }

    function openEndDate() {
      vm.showEndCalendar = true;
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('SalesSummaryController', SalesSummaryController);

  /** @ngInject */
  function SalesSummaryController(rTicket, bsLoadingOverlayService, moment, $log, toastr) {
    var vm = this,
      now = moment();

    vm.dateConfig = { maxDate: now };

    vm.submitAttempt = false;

    vm.body = {};


    vm.openStartDate = openStartDate;
    vm.openEndDate = openEndDate;

    vm.startDate;
    vm.endDate;

    vm.submitForm = submitForm;

    vm.data = null;


    function submitForm(form) {
      vm.submitAttempt = true;

      if (!form.$valid){
        $log.error('error');
        return
      }


      var params = {
        start: moment(vm.startDate).format('YYYY-MM-DD'),
        end: moment(vm.endDate).format('YYYY-MM-DD')
      };

      bsLoadingOverlayService.start({ referenceId: 'sales-summary-overlay' });
      rTicket.reportSalesSummary(params, function (result) {
          $log.info(result);
          vm.data = result;
          bsLoadingOverlayService.stop({ referenceId: 'sales-summary-overlay' });
        },
        function (error) {
          toastr.error('Error al generar reporte', error);
          bsLoadingOverlayService.stop({ referenceId: 'sales-summary-overlay' });
        });
    }


    function openStartDate() {
      vm.showStartCalendar = true;
    }

    function openEndDate() {
      vm.showEndCalendar = true;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller("SalesReportController", SalesReportController);

  /** @ngInject */
  function SalesReportController(
    $log,
    $rootScope,
    rCountry,
    rTerminal,
    rReseller,
    rProfile,
    bsLoadingOverlayService,
    moment
  ) {
    var vm = this,
      salesReportRefresh;

    vm.query = {};
    vm.salesReportList = [];
    vm.countriesList = [];
    vm.terminalsList = [];
    vm.resellersList = [];
    vm.busDrivers = [];
    vm.selectedCountry = null;

    vm.allDrivers = false;

    vm.loadTerminals = loadTerminals;
    vm.loadResellers = loadResellers;
    vm.loadSelectData = loadSelectData;
    vm.openStartDate = openStartDate;
    vm.openEndDate = openEndDate;
    vm.filter = {};
    vm.print = print;
    vm.hasOnlyDriverPermission = hasOnlyDriverPermission;

    vm.loadBusDrivers = loadBusDrivers;

    vm.searchSalesReport = searchSalesReport;

    var driverResellerId = 28;

    function init() {
      vm.filter.type = hasOnlyDriverPermission() ? "driver" : "terminal";
      loadCountries();
    }
    init();

    function hasOnlyDriverPermission() {
      return (
        $rootScope.hasPermissionsFor("REPORT_TAXES") &&
        $rootScope.hasPermissionsFor("REPORT_DRIVER_TAXES")
      );
    }

    function loadCountries() {
      rCountry.query({}, function (result) {
        vm.countriesList = result.records;
        vm.filter.country = vm.countriesList[0];
        vm.loadSelectData();
      });
    }

    function loadSelectData() {
      loadTerminals();
      loadResellers();
    }

    function loadTerminals() {
      rTerminal.query(
        { country: vm.filter.country.id, page: 0, pageSize: 1000 },
        function (result) {
          vm.terminalsList = result.records;
        }
      );
    }

    function loadResellers() {
      rReseller.query(
        { country: vm.filter.country.id, page: 0, pageSize: 1000 },
        function (result) {
          vm.resellersList = result.records.filter(function (resu) {
            if (resu.name === "Choferes") {
              driverResellerId = resu.id;
            }
            return resu.name !== "Choferes";
          })
        }
      );
    }

    function loadSalesReport() {
      vm.allDrivers = false
      if (vm.filter.type == "terminal") {
        loadSalesReportByTerminal();
      } else {
        if (vm.filter.soldBy == 'all') {
          vm.allDrivers = true;
          loadSalesReportAllDrivers();
        }
        else{
          loadSalesReportByReseller();
        }

      }
    }

    function loadSalesReportByTerminal() {
      bsLoadingOverlayService.start({ referenceId: "salesReport-overlay" });
      rTerminal.salesReport(vm.query, function (result) {
        bsLoadingOverlayService.stop({ referenceId: "salesReport-overlay" });
        vm.salesReportList = result;
      });
    }

    function loadSalesReportByReseller() {
      bsLoadingOverlayService.start({ referenceId: "salesReport-overlay" });
      rReseller.salesReport(vm.query, function (result) {
        bsLoadingOverlayService.stop({ referenceId: "salesReport-overlay" });
        vm.salesReportList = result;
      });
    }

    function loadSalesReportAllDrivers() {
      bsLoadingOverlayService.start({ referenceId: "salesReport-overlay" });
      rReseller.salesReportAllDrivers(vm.query, function (result) {
        var tempArray = []

        angular.forEach(result.detail, function (item) {
          if (item.total > 0){
            tempArray.push(item)
          }
        });

        vm.salesReportList = result;
        vm.salesReportList.detail = tempArray;

        bsLoadingOverlayService.stop({ referenceId: "salesReport-overlay" });
      });
    }

    function loadBusDrivers() {
      if (vm.filter.type !== "driver"){
        return;
      }

      if (!vm.filter.from || !vm.filter.to) {
        return
      }

      if (vm.filter.to) {
        vm.query.to = moment(vm.filter.to).format("YYYY-MM-DD");
      }
      if (vm.filter.from) {
        vm.query.from = moment(vm.filter.from).format("YYYY-MM-DD");
      }

      rProfile.getUsersByRole({ id: 11, start: vm.query.from, end: vm.query.to }, function (result) {
        vm.busDrivers = result.map(function(item){
          return {
            id: item.id,
            username: item.username,
            fullName: item.fullName,
            displayName: item.fullName + "(" + item.username + ")"
          }
        }).sort(function (a, b) {
          return a.fullName.localeCompare(b.fullName);
        })
        vm.busDrivers.push({ id: 'all', username:'all', fullName: "Todos", displayName: "Todos" });
      });
    }

    function searchSalesReport() {
      if (vm.filter.to) {
        vm.query.to = moment(vm.filter.to).format("YYYY-MM-DD");
      }
      if (vm.filter.from) {
        vm.query.from = moment(vm.filter.from).format("YYYY-MM-DD");
      }
      if (vm.filter.type == "terminal") {
        vm.query.id = vm.filter.terminal.id;
      }
      if (vm.filter.type == "reseller") {
        vm.query.id = vm.filter.reseller.id;
      }


      if (vm.filter.type == "driver") {
        vm.query.id = driverResellerId;
      }

      if (vm.filter.soldBy) {
        vm.query.soldBy = vm.filter.soldBy;
      }
      vm.selectedCountry = vm.filter.country;

      loadSalesReport();
    }

    function openStartDate() {
      vm.showStartCalendar = true;
    }

    function openEndDate() {
      vm.showEndCalendar = true;
    }

    salesReportRefresh = $rootScope.$on("salesReportRefresh", function () {
      loadSalesReport();
    });

    $rootScope.$on("$destroy", salesReportRefresh);

    function print() {
      /* eslint-disable */
      window.print();
      /* eslint-enable */
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('PassengersController', PassengersController);

  /** @ngInject */
  function PassengersController($rootScope, $log, rRoute, rBus, rTrip, rTicket , DATE_ISO_FORMAT,  bsLoadingOverlayService,utilsService, toastr, moment, printService) {
    var vm = this,
      checkTicketsRefresh;
    vm.routesList = [];
    vm.busClasses = [];
    vm.schedulesAvailable = [];

    vm.openOriginDate = openOriginDate;
    vm.openReturnDate = openReturnDate;
    vm.searchTickets = searchTickets;

    vm.loadSchedulesAvailable = loadSchedulesAvailable;
    vm.print = print;

    vm.query = {};
    vm.filter = {};
    vm.report = {};

    init();

    function loadRoutes(){
      rRoute.query({ pagesize: 150 }, function(result){
        vm.routesList = result.records;
      });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function(result){
        vm.busClasses = result.records;
      });
    }

    function openOriginDate() {
      vm.showOriginCalendar = true;
    }

    function openReturnDate() {
      vm.showReturnCalendar = true;
    }

    function loadTickets(){
      vm.query.check2 = true;
      rTrip.getTickets(vm.query, function(result){
        vm.tickets  = result;
        convertDates();
        prepareReport();
        bsLoadingOverlayService.stop({referenceId: 'routes-overlay'});
      });
    }


    function convertDates(){
      angular.forEach(vm.tickets, function(ticket){
        if (ticket.invoiceNumber){
          ticket.client.birthdateUI = moment(ticket.client.birthdate, DATE_ISO_FORMAT).toDate()
        }
      })
    }

    function prepareReport() {
      vm.report.route =  vm.routesList.filter(function(route){ return route.id === vm.filter.route })[0];
      vm.report.trip = vm.filter.selectedTrip;
      vm.report.validTickets = vm.tickets.filter(function (ticket){ return (ticket.invoiceNumber) });

    }

    function loadSchedulesAvailable(){
      if (vm.filter.route && vm.filter.originDateUI && vm.filter.busType){
        rTrip.query({routeid:vm.filter.route, busclassid:vm.filter.busType, date: moment(vm.filter.originDateUI).format('YYYY-MM-DD'), inclusive:true}, function(result){
          vm.schedulesAvailable  = result.records;
          vm.schedulesAvailable.map(function (trip) {
            trip.schedule.departureTimeUI = utilsService.mapToAMPM(
              trip.schedule.departureTime
            );
          });
        });
      }else{
        vm.schedulesAvailable = [];
      }
    }

    function searchTickets(form){
      vm.loading = true;
      if(!form.$valid) {
        vm.loading = false;
        vm.submitAttempt = true;
        return;
      }
      $log.info(vm.filter);
      vm.query.id = vm.filter.selectedTrip.id;
      loadTickets();
    }

    function init(){
      loadRoutes();
      loadBusClasses();
      $log.info('Chequeos Controller', vm);
    }

    function print() {
      /* eslint-disable */
      var sourceHtml = angular.element(document.getElementById('passengerTable')).html();
      angular.element(document.getElementById('passengerTable-clone')).html(sourceHtml);

      var printContents = document.getElementById('printableArea').innerHTML;
      printService.print("printableAreaFrame", printContents);
      /* eslint-enable */

    }

    checkTicketsRefresh = $rootScope.$on('checkTicketsRefresh', function() {
      loadTickets();
    });

    $rootScope.$on('$destroy', checkTicketsRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ReportsController', ReportsController);

  /** @ngInject */
  function ReportsController() {

  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller("OtpReportController", OtpReportController);

  /** @ngInject */
  function OtpReportController(rTicket, toastr, $log, moment, DATE_FORMAT, DATE_TIME_FORMAT, PAGINATION_CONFIG, bsLoadingOverlayService) {
    var vm = this;

    // La BD guarda todo en UTC y el backend manda las fechas sin marca de zona
    // ("2026-09-09 21:03:30.047"). Por eso se parsean explicitamente como UTC y
    // luego se convierten a la hora local del navegador. Si algun dia vienen con
    // zona (Z u offset) moment ya sabe interpretarlas y solo hay que localizar.
    var BACKEND_DATE_FORMATS = ["YYYY-MM-DD HH:mm:ss.SSS", "YYYY-MM-DD HH:mm:ss"];
    var NO_OFFSET_PATTERN = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(\.\d+)?$/;

    vm.ticketToSearch = "";
    vm.searchedTicket = "";
    vm.searched = false;
    vm.events = [];

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.searchOtpHistory = searchOtpHistory;
    vm.toggleDetail = toggleDetail;
    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;

    function loadOtpHistory() {
      bsLoadingOverlayService.start({ referenceId: "otpReport-overlay" });

      rTicket.otpHistory(
        {
          id: vm.searchedTicket,
          page: vm.pagination.pageNum - 1,
          pagesize: vm.pagination.rangeSelected
        },
        function (result) {
          $log.info(result);
          vm.events = flattenEvents(result.records);
          vm.pagination.totalRecords = result.totalRecords;
          vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
          vm.pagination.totalPages = result.totalPages;
          vm.pagination.prevPage = result.previous;
          vm.pagination.nextPage = result.next;
          vm.searched = true;
          bsLoadingOverlayService.stop({ referenceId: "otpReport-overlay" });
        },
        function () {
          toastr.error("Este Tiquete no existe");
          vm.events = [];
          vm.searched = true;
          bsLoadingOverlayService.stop({ referenceId: "otpReport-overlay" });
        }
      );
    }

    // Cada sesion trae sus eventos anidados; se aplanan en una sola lista
    // arrastrando los datos de la sesion a cada fila.
    function flattenEvents(records) {
      var rows = [];

      angular.forEach(records, function (session) {
        var sessionDates = {
          created: formatDateTime(session.created),
          otpExpiresAt: formatDateTime(session.otpExpiresAt),
          usedAt: formatDateTime(session.usedAt),
          invalidatedAt: formatDateTime(session.invalidatedAt),
          editEnabledUntil: formatDateTime(session.editEnabledUntil),
          blockedUntil: formatDateTime(session.blockedUntil)
        };

        angular.forEach(session.events, function (event) {
          rows.push({
            session: session,
            sessionDates: sessionDates,
            event: event,
            eventDateText: formatDateTime(event.eventDate),
            previousTicketDataText: formatTicketData(event.previousTicketData),
            newTicketDataText: formatTicketData(event.newTicketData),
            expanded: false
          });
        });
      });

      rows.sort(function (a, b) {
        if (a.event.eventDate === b.event.eventDate) {
          return 0;
        }
        return a.event.eventDate > b.event.eventDate ? -1 : 1;
      });

      return rows;
    }

    function formatDateTime(value) {
      if (!value) {
        return "-";
      }

      var parsed = NO_OFFSET_PATTERN.test(value)
        ? moment.utc(value, BACKEND_DATE_FORMATS).local()
        : moment(value).local();

      return parsed.isValid() ? parsed.format(DATE_FORMAT + " " + DATE_TIME_FORMAT) : "-";
    }

    // El backend puede mandar estos campos como texto o como objeto.
    function formatTicketData(value) {
      if (value === null || angular.isUndefined(value) || value === "") {
        return "-";
      }
      if (angular.isObject(value)) {
        return angular.toJson(value, true);
      }
      return value;
    }

    function searchOtpHistory(form) {
      if (!form.$valid) {
        return;
      }

      vm.searchedTicket = vm.ticketToSearch;
      vm.pagination.pageNum = 1;
      loadOtpHistory();
    }

    function toggleDetail(row) {
      row.expanded = !row.expanded;
    }

    // Pagination Functions
    function setRecordsPerPage(num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadOtpHistory();
    }

    function goToPage(p) {
      vm.pagination.pageNum = p;
      loadOtpHistory();
    }

    function init() {}

    init();
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller("OccupationMatrixController", OccupationMatrixController);

  /** @ngInject */
  function OccupationMatrixController(
    $rootScope,
    rRoute,
    rTicket,
    bsLoadingOverlayService,
    moment,
    printService
  ) {
    var vm = this,
      occupationMatrizRefresh;

    vm.query = {};
    vm.filter = {};
    vm.occupationMatrizList = [];
    vm.selectedInvoice = [];
    vm.routesList = [];
    vm.visibleHeader = false;

    vm.openStartDate = openStartDate;
    vm.openEndDate = openEndDate;

    vm.openStartDateOC = openStartDateOC;
    vm.openEndDateOC = openEndDateOC;

    vm.searchOccupationMatriz = searchOccupationMatriz;
    vm.typeOfCell = typeOfCell;

    vm.occupancyReport = null;

    vm.print = print;
    vm.searchOccupancy = searchOccupancy;

    function init() {
      loadRoutes();
    }
    init();

    function loadRoutes() {
      rRoute.query({ pagesize: 150, publicRoute: true }, function (result) {
        vm.routesList = result.records;
      });
    }

    function loadOccupationMatriz() {
      bsLoadingOverlayService.start({
        referenceId: "occupationMatriz-overlay"
      });
      rRoute.occupation(vm.query, function (result) {
        vm.visibleHeader = true;
        vm.occupationMatrizList = result.detail;
        vm.schedulesList = result.schedules.sort();
        bsLoadingOverlayService.stop({
          referenceId: "occupationMatriz-overlay"
        });
      });
    }

    function searchOccupationMatriz() {
      vm.query.id = vm.filter.route.id;
      var date = vm.filter.date;
      if (date) {
        vm.query.month = moment(date).format("MM");
        vm.query.year = moment(date).format("YYYY");
      }
      loadOccupationMatriz();
    }

    function openStartDate() {
      vm.showStartCalendar = true;
    }

    function openEndDate() {
      vm.showEndCalendar = true;
    }

    function openStartDateOC() {
      vm.showStartCalendarOC = true;
    }

    function openEndDateOC() {
      vm.showEndCalendarOC = true;
    }

    function typeOfCell(quantity, locked) {
      var style = {};
      if (locked) {
        style["background-color"] = "#CCC";
      } else {
        if (quantity) {
          if (quantity > 36) {
            style["background-color"] = "#f51313";
          } else if (quantity > 25) {
            style["background-color"] = "#e17b07";
          } else if (quantity > 0) {
            style["background-color"] = "#8dc740";
          }
        }
      }

      return style;
    }

    /* OCCUPANCY */

    function loadOccupancy() {
      bsLoadingOverlayService.start({
        referenceId: "occupationMatriz-overlay"
      });
      rTicket.reportTicketsOcupancy(vm.query, function (result) {
        vm.occupancyReport = result;
        bsLoadingOverlayService.stop({
          referenceId: "occupationMatriz-overlay"
        });
      });
    }

    function searchOccupancy() {
      if (vm.filter.startDate && vm.filter.endDate) {
        vm.query.start = moment(vm.filter.startDate).format("YYYY-MM-DD");
        vm.query.end = moment(vm.filter.endDate).format("YYYY-MM-DD");
      }
      loadOccupancy();
    }

    function print() {
      /* eslint-disable */
      var printContents = document.getElementById("printableArea").innerHTML;
      printService.print("printableAreaFrame", printContents);
      /* eslint-enable */
    }

    occupationMatrizRefresh = $rootScope.$on(
      "occupationMatrizRefresh",
      function () {
        loadOccupationMatriz();
      }
    );

    $rootScope.$on("$destroy", occupationMatrizRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('InsurancesController', InsurancesController);

  /** @ngInject */
  function InsurancesController($log, rRoute, rBus, rTrip, toastr, moment, printService, DATE_FORMAT) {
    var vm = this;
    vm.routesList = [];
    vm.busClasses = [];
    vm.loadTips = [];
    vm.dateFormat = DATE_FORMAT;
    vm.openOriginDate = openOriginDate;
    vm.print = print;
    vm.query = {};
    vm.filter = {};
    vm.insurances = []
    vm.trips = []

    vm.loadTips = loadTips;
    vm.loadInsurances = loadInsurances;

    init();

    function loadRoutes(){
      rRoute.query({ pagesize: 150 }, function(result){
        vm.routesList = result.records;
      });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function(result){
        vm.busClasses = result.records;
      });
    }

    function openOriginDate() {
      vm.showOriginCalendar = true;
    }

    function loadTips(){
      if (vm.filter.route.id && vm.filter.originDateUI && vm.filter.busType.id){
        rTrip.query({routeid:vm.filter.route.id, busclassid:vm.filter.busType.id, date: moment(vm.filter.originDateUI).format('YYYY-MM-DD'), inclusive:true}, function(result){
          vm.tips = result.records.filter(function (item) {
            return item.schedule.visible === true && item.schedule.isDisplayable === true;
          });
          $log.info(result.records);
        });
      }else{
        vm.tips = [];
      }
    }

    function loadInsurances(){
      rTrip.insurances({id: vm.filter.trip.id, check3:true}, function(result){
        vm.insurances  = result;
        $log.info(result);
      });
    }

    function print() {
      /* eslint-disable */
      var sourceHtml = angular.element(document.getElementById('insurances')).html();
      angular.element(document.getElementById('insurances-clone')).html(sourceHtml);

      var printContents = document.getElementById('printableArea').innerHTML;
      printService.print("printableAreaFrame", printContents);
      /* eslint-enable */

    }

    function init(){
      loadRoutes();
      loadBusClasses();
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('ErpController', ErpController);

  /** @ngInject */
  function ErpController(rTicket, bsLoadingOverlayService, moment, $log, toastr) {
    var vm = this,
      now = moment();

    vm.dateConfig = { maxDate: now };

    vm.submitAttempt = false;

    vm.body = {};


    vm.openStartDate = openStartDate;
    vm.openEndDate = openEndDate;

    vm.startDate;
    vm.endDate;

    vm.requestErpReport = requestErpReport;


    function requestErpReport(form) {
      vm.submitAttempt = true;
      
      if (!form.$valid){
        $log.error('error');
        return
      }


      var body = {
        start: moment(vm.startDate).format('YYYY-MM-DD'),
        end: moment(vm.endDate).format('YYYY-MM-DD'),
      };

      bsLoadingOverlayService.start({ referenceId: 'erp-overlay' });
      rTicket.reportErp(body, function (result) {
          $log.info(result);
          toastr.success('Reporte generado Satisfacoriamente', 'Será enviado a su correo');
          bsLoadingOverlayService.stop({ referenceId: 'erp-overlay' });
        },
        function (error) {
          toastr.error('Error al generar reporte', error);
        });
    }


    function openStartDate() {
      vm.showStartCalendar = true;
    }

    function openEndDate() {
      vm.showEndCalendar = true;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .controller('EditedTicketsController', EditedTicketsController);

  /** @ngInject */
  function EditedTicketsController(rTicket, bsLoadingOverlayService, moment, $log, toastr) {
    var vm = this,
      now = moment();

    vm.dateConfig = { maxDate: now };

    vm.submitAttempt = false;

    vm.openStartDate = openStartDate;
    vm.openEndDate = openEndDate;

    vm.startDate;
    vm.endDate;

    vm.submitForm = submitForm;

    function submitForm(form) {
      vm.submitAttempt = true;

      if (!form.$valid) {
        $log.error('error');
        return;
      }

      var params = {
        start: moment(vm.startDate).format('YYYY-MM-DD'),
        end: moment(vm.endDate).format('YYYY-MM-DD')
      };

      bsLoadingOverlayService.start({ referenceId: 'edited-tickets-overlay' });
      rTicket.reportEditedTickets(params, function () {
          toastr.success('Reporte generado Satisfactoriamente', 'Será enviado a su correo');
          bsLoadingOverlayService.stop({ referenceId: 'edited-tickets-overlay' });
        },
        function (error) {
          toastr.error('Error al generar reporte', error);
          bsLoadingOverlayService.stop({ referenceId: 'edited-tickets-overlay' });
        });
    }

    function openStartDate() {
      vm.showStartCalendar = true;
    }

    function openEndDate() {
      vm.showEndCalendar = true;
    }
  }
})();

(function() {
  'use strict';

  angular.module('tnsp').controller('DriversPaymentController', DriversPaymentController);

  /** @ngInject */
  function DriversPaymentController(toastr, moment, rTicket, bsLoadingOverlayService) {
    var vm = this,
      now = moment();

    vm.dateConfig = { maxDate: now };

    vm.submitAttempt = false;

    vm.body = {};
    vm.branchName = 'CR';

    vm.openStartDate = openStartDate;
    vm.openEndDate = openEndDate;

    vm.startDate;
    vm.endDate;

    vm.requestReport = requestReport;


    function requestReport(form) {
      vm.submitAttempt = true;

      if (!form.$valid){
        bsLoadingOverlayService.stop({ referenceId: 'drivers-payment-overlay' });
        return
      }

      var body = {
        start: moment(vm.startDate).format('YYYY-MM-DD'),
        end: moment(vm.endDate).format('YYYY-MM-DD'),
        branchName: vm.branchName
      };

      bsLoadingOverlayService.start({ referenceId: 'drivers-payment-overlay' });

      rTicket.reportDriverSales(body, function () {
          toastr.success('Reporte generado Satisfacoriamente', 'Será enviado a su correo');
          bsLoadingOverlayService.stop({ referenceId: 'drivers-payment-overlay' });
        },
        function (error) {
          toastr.error('Error al generar reporte', error);
          bsLoadingOverlayService.stop({ referenceId: 'drivers-payment-overlay' });
        });
    }

    function openStartDate() {
      vm.showStartCalendar = true;
    }

    function openEndDate() {
      vm.showEndCalendar = true;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller("ConsolidatedSalesController", ConsolidatedSalesController);

  /** @ngInject */
  function ConsolidatedSalesController(
    rTicket,
    bsLoadingOverlayService,
    moment,
    $log,
    toastr
  ) {
    var vm = this,
      now = moment();

    vm.dateConfig = { maxDate: now };

    vm.submitAttempt = false;
    vm.submitAttemptSummary = false;
    vm.submitAttemptOutcome = false;

    vm.body = {};
    vm.type = "CR";
    vm.typeSummary = "CR";

    vm.openStartDateDetailed = openStartDateDetailed;
    vm.openEndDateDetailed = openEndDateDetailed;
    vm.openStartDateSummary = openStartDateSummary;
    vm.openEndDateSummary = openEndDateSummary;
    vm.openStartDateOutcome = openStartDateOutcome;
    vm.openEndDateOutcome = openEndDateOutcome;

    vm.showStartCalendarDetailed = false;
    vm.showEndCalendarDetailed = false;
    vm.showStartCalendarSummary = false;
    vm.showEndCalendarSummary = false;
    vm.showStartCalendarOutcome = false;
    vm.showEndCalendarOutcome = false;

    vm.startDetailed;
    vm.endDetailed;
    vm.startSummary;
    vm.endSummary;
    vm.startOutcome;
    vm.endOutcome;

    vm.requestConsolidatedSales = requestConsolidatedSales;
    vm.requestConsolidatedSalesSummary = requestConsolidatedSalesSummary;
    vm.requestOutcomeReport = requestOutcomeReport;

    function requestConsolidatedSales(form) {
      vm.submitAttempt = true;

      if (!form.$valid) {
        $log.error("error");
        return;
      }

      var body = {
        start: moment(vm.startDetailed).format("YYYY-MM-DD"),
        end: moment(vm.endDetailed).format("YYYY-MM-DD"),
        branchName: vm.type,
      };

      bsLoadingOverlayService.start({
        referenceId: "consolidatedSales-overlay",
      });
      rTicket.reportConsolidatedSales(
        body,
        function (result) {
          $log.info(result);
          toastr.success(
            "Reporte generado Satisfactoriamente",
            "Será enviado a su correo"
          );
          bsLoadingOverlayService.stop({
            referenceId: "consolidatedSales-overlay",
          });
        },
        function (error) {
          toastr.error("Error al generar reporte", error);
        }
      );
    }

    function requestConsolidatedSalesSummary(form) {
      vm.submitAttemptSummary = true;
      if (!form.$valid) {
        $log.error("error");
        vm.submitAttemptSummary = false;
        return;
      }

      var body = {
        start: moment(vm.startSummary).format("YYYY-MM-DD"),
        end: moment(vm.endSummary).format("YYYY-MM-DD"),
        branchName: vm.typeSummary,
      };

      bsLoadingOverlayService.start({
        referenceId: "consolidatedSales-overlay",
      });
      rTicket.reportConsolidatedSalesSummary(
        body,
        function (result) {
          $log.info(result);
          toastr.success(
            "Reporte generado Satisfactoriamente",
            "Será enviado a su correo"
          );
          bsLoadingOverlayService.stop({
            referenceId: "consolidatedSales-overlay",
          });
        },
        function (error) {
          toastr.error("Error al generar reporte", error);
        }
      );
    }

    function requestOutcomeReport(form) {
      vm.submitAttemptOutcome = true;
      if (!form.$valid) {
        $log.error("error");
        vm.submitAttemptOutcome = false;
        return;
      }
      var body = {
        start: moment(vm.startOutcome).format("YYYY-MM-DD"),
        end: moment(vm.endOutcome).format("YYYY-MM-DD"),
      };

      bsLoadingOverlayService.start({
        referenceId: "consolidatedSales-overlay",
      });
      rTicket.reportOutcome(
        body,
        function (result) {
          $log.info(result);
          toastr.success(
            "Reporte generado Satisfactoriamente",
            "Será enviado a su correo"
          );
          bsLoadingOverlayService.stop({
            referenceId: "consolidatedSales-overlay",
          });
        },
        function (error) {
          toastr.error("Error al generar reporte", error);
        }
      );

    }
    function openStartDateDetailed() {
      vm.showStartCalendarDetailed = true;
    }
    function openEndDateDetailed() {
      vm.showEndCalendarDetailed = true;
    }

    function openStartDateSummary() {
      vm.showStartCalendarSummary = true;
    }
    function openEndDateSummary() {
      vm.showEndCalendarSummary = true;
    }

    function openStartDateOutcome() {
      vm.showStartCalendarOutcome = true;
    }
    function openEndDateOutcome() {
      vm.showEndCalendarOutcome = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ClientTicketsController', ClientTicketsController);

  /** @ngInject */
  function ClientTicketsController($rootScope, SweetAlert, toastr, rClient, $state, rTicket, bsLoadingOverlayService, moment, $log) {
    var vm = this,
      clientTicketsRefresh;

    vm.query = {};
    vm.filter = {};
    vm.clientTicketsList = [];
    vm.printInvoice = printInvoice;
    vm.selectedInvoice = [];

    vm.openStartDate = openStartDate;
    vm.openEndDate = openEndDate;

    vm.searchClientTickets = searchClientTickets;

    function init () {
      // loadClientTickets();
    }
    init();

    function printInvoice(invoice){
      angular.copy([invoice], vm.selectedInvoice);
      angular.element('#modalTicketInvoice').modal({backdrop: 'static', keyboard: false});
    }

    function loadClientTickets(){
      $log.info(vm.query);
      bsLoadingOverlayService.start({referenceId: 'clientTickets-overlay'});
      rTicket.reportTicketsReference(vm.query, function(result){
        vm.clientTicketsList  = result;
        bsLoadingOverlayService.stop({referenceId: 'clientTickets-overlay'});
      });
    }

    function searchClientTickets (){
      vm.query.reference = vm.filter.reference;
      if (vm.filter.tripdatemax){
        vm.query.end = moment(vm.filter.tripdatemax).format('YYYY-MM-DD');
      }
      if (vm.filter.tripdatemin){
        vm.query.start = moment(vm.filter.tripdatemin).format('YYYY-MM-DD');
      }
      loadClientTickets();
    }

    function openStartDate() {
      vm.showStartCalendar = true;
    }

    function openEndDate() {
      vm.showEndCalendar = true;
    }

    clientTicketsRefresh = $rootScope.$on('clientTicketsRefresh', function() {
      loadClientTickets();
    });

    $rootScope.$on('$destroy', clientTicketsRefresh);
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller(
      "CashRegistersBalancesController",
      CashRegistersBalancesController
    );

  /** @ngInject */
  function CashRegistersBalancesController(
    $rootScope,
    rTerminal,
    rCashRegister,
    rUser,
    PAGINATION_CONFIG,
    bsLoadingOverlayService
  ) {
    var vm = this,
      cashRegistersBalancesRefresh;

    vm.query = {};
    vm.cashRegistersBalancesList = [];
    vm.terminalsList = [];
    vm.cashRegistersList = [];

    vm.loadCashRegisters = loadCashRegisters;
    vm.balanceDetail = balanceDetail;

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.searchCashRegistersBalances = searchCashRegistersBalances;

    function init() {
      //loadCashRegistersBalances();
      loadTerminals();
    }

    init();

    function balanceDetail(balance) {
      vm.selectedBalance = balance;
      angular
        .element("#modalCashRegisterBalance")
        .modal({ backdrop: "static", keyboard: false });
    }

    function loadTerminals() {
      rTerminal.query({}, function (result) {
        vm.terminalsList = result.records;
      });
    }

    function loadCashRegisters() {
      rUser.getMyCashiers({}, function (result) {
        if (result.length > 0) {
          vm.cashRegistersList = result;
        } else {
          rCashRegister.query(
            { terminalId: vm.filter.terminal.id, pagesize:500 },
            function (result) {
              if ($rootScope.isAdmin()){
                vm.cashRegistersList = result.records;
              }else{
                vm.cashRegistersList = result.records.filter(function (item) {
                  return item.name.toLowerCase().indexOf("test") < 0;
                });
              }

            }
          );
        }
      });
    }



    function loadCashRegistersBalances() {
      bsLoadingOverlayService.start({
        referenceId: "cashRegistersBalances-overlay"
      });

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum - 1;
      vm.query.terminalId = vm.filter.terminal.id;
      vm.query.cashRegisterId = vm.filter.cashRegister.id;

      rCashRegister.balances(vm.query, function (result) {
        vm.cashRegistersBalancesList = result.records;

        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({
          referenceId: "cashRegistersBalances-overlay"
        });
      });
    }

    function searchCashRegistersBalances() {
      vm.pagination.pageNum = 1;
      vm.selectedTerminal = vm.filter.terminal;
      vm.selectedCashRegister = vm.filter.cashRegister;
      vm.filter.terminalId = vm.filter.terminal.id;
      vm.filter.cashRegisterId = vm.filter.cashRegister.id;
      loadCashRegistersBalances();
    }

    // Pagination Functions
    function setRecordsPerPage(num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadCashRegistersBalances();
    }

    function goToPage(p) {
      vm.pagination.pageNum = p;
      loadCashRegistersBalances();
    }

    function range(n) {
      return new Array(n);
    }

    cashRegistersBalancesRefresh = $rootScope.$on(
      "cashRegistersBalancesRefresh",
      function () {
        loadCashRegistersBalances();
      }
    );

    $rootScope.$on("$destroy", cashRegistersBalancesRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('BusDriversAssignedController', BusDriversAssignedController);

  /** @ngInject */
  function BusDriversAssignedController($log, rRoute, rBus, rTrip, toastr, moment, printService, DATE_FORMAT) {
    var vm = this;
    vm.routesList = [];
    vm.busClasses = [];
    vm.schedulesAvailable = [];
    vm.dateFormat = DATE_FORMAT;

    vm.openOriginDate = openOriginDate;
    vm.loadSchedulesAvailable = loadSchedulesAvailable;
    vm.print = print;

    vm.query = {};
    vm.filter = {};
    vm.selectedTicket = {};

    init();

    function loadRoutes(){
      rRoute.query({ pagesize: 150 }, function(result){
        vm.routesList = result.records;
      });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function(result){
        vm.busClasses = result.records;
      });
    }

    function openOriginDate() {
      vm.showOriginCalendar = true;
    }

    function loadSchedulesAvailable(){
      if (vm.filter.route.id && vm.filter.originDateUI && vm.filter.busType.id){
        rTrip.query({routeid:vm.filter.route.id, busclassid:vm.filter.busType.id, date: moment(vm.filter.originDateUI).format('YYYY-MM-DD'), inclusive:true}, function(result){
          vm.schedulesAvailable = result.records.filter(function (item) {
            return item.schedule.visible === true && item.schedule.isDisplayable === true;
          });
        });
      }else{
        vm.schedulesAvailable = [];
      }
    }

    function print() {
      /* eslint-disable */
      var sourceHtml = angular.element(document.getElementById('schedules-available')).html();
      angular.element(document.getElementById('schedules-available-clone')).html(sourceHtml);

      var printContents = document.getElementById('printableArea').innerHTML;
      printService.print("printableAreaFrame", printContents);
      /* eslint-enable */

    }

    function init(){
      loadRoutes();
      loadBusClasses();
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('tnsp')
  .controller('AccountingController', AccountingController);

  /** @ngInject */
  function AccountingController(rTicket, bsLoadingOverlayService, moment, $log, toastr) {
    var vm = this,
      now = moment();

    vm.dateConfig = { maxDate: now };

    vm.submitAttempt = false;

    vm.body = {};
    vm.type = 'CR'


    vm.openStartDate = openStartDate;
    vm.openEndDate = openEndDate;

    vm.startDate;
    vm.endDate;

    vm.requestAccountingReport = requestAccountingReport;


    function requestAccountingReport(form) {
      vm.submitAttempt = true;

      if (!form.$valid){
        $log.error('error');
        return
      }


      var body = {
        start: moment(vm.startDate).format('YYYY-MM-DD'),
        end: moment(vm.endDate).format('YYYY-MM-DD'),
        type: vm.type
      };

      bsLoadingOverlayService.start({ referenceId: 'accounting-overlay' });
      rTicket.reportAccounting(body, function (result) {
          $log.info(result);
          toastr.success('Reporte generado Satisfacoriamente', 'Será enviado a su correo');
          bsLoadingOverlayService.stop({ referenceId: 'accounting-overlay' });
        },
        function (error) {
          toastr.error('Error al generar reporte', error);
        });
    }


    function openStartDate() {
      vm.showStartCalendar = true;
    }

    function openEndDate() {
      vm.showEndCalendar = true;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state ,authenticationService, toastr) {
    var vm = this;

    vm.loading = false;
    vm.submitAttempt = false;
    vm.credentials = {};
    vm.pass = {
      type: 'password',
      icon: 'fa-eye'
    };

    vm.loginProcess  = loginProcess;

    vm.tooglePasswordType = tooglePasswordType;


    function loginProcess(form){
      vm.loading = true;
      var isValidUser = vm.credentials.userName === 'autorizador@tig.com'  ? false : true;
      if(!form.$valid || !isValidUser) {
        vm.loading = false;
        vm.submitAttempt = true;
        if (!isValidUser) toastr.error('Usuario Invalido');
        return;
      }

      authenticationService.login(vm.credentials)
        .then(function(){
          $state.go('home');
          vm.loading = false;
        }, function(){
          vm.loading = false;
          toastr.error('Ha ingresado credenciales incorrectos, por favor intentelo de nuevo');
        });
    }

    function tooglePasswordType(){
      if (vm.pass.type === 'password'){
        vm.pass.type = 'text';
        vm.pass.icon = 'fa-eye-slash';
      } else {
        vm.pass.type = 'password';
        vm.pass.icon = 'fa-eye';
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($log) {
    var vm = this;

    $log.info(vm);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController(rPassword, toastr) {
    var vm = this;
    vm.loading = false;
    vm.submitAttempt = false;


    vm.forgotPasswordProcess = function(form) {
      vm.loading = true;
      if(!form.$valid){
        vm.submitAttempt = true;
        vm.loading = false;
        return;
      }

      rPassword.forgot({emailAddress:vm.email}, function(){
        toastr.success('Link para resetear contraseña ha sido enviado a su email');
        vm.loading = false;
      }, function(error){
        toastr.error(error.data.message);
        vm.loading = false;
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('EntrustController', EntrustController);

  /** @ngInject */
  function EntrustController($log) {
    var vm = this;
    $log.info('Encomiendas', vm);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('PackingTypesController', PackingTypesController);

  /** @ngInject */
  function PackingTypesController($rootScope, SweetAlert, toastr, $log, PAGINATION_CONFIG, rPackingType, bsLoadingOverlayService, rCountry) {
    var vm = this,
      packingTypesRefresh;

    vm.selectedPackingType = {};

    vm.query = {};
    vm.packingTypesList = [];
    vm.countriesList = [];

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createPackingType = createPackingType;
    vm.searchPackingTypes = searchPackingTypes;
    vm.editPackingType = editPackingType;
    vm.deletePackingType = deletePackingType;

    function init () {
      loadPackingTypes();
      loadCountries();
    }
    init();

    function loadPackingTypes(){
      bsLoadingOverlayService.start({referenceId: 'packingTypes-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rPackingType.query(vm.query, function(result){
        $log.info(result);
        vm.packingTypesList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'packingTypes-overlay'});
      });
    }

    function loadCountries(){
      rCountry.query({}, function(result){
        vm.countriesList = result.records;
      });
    }

    function createPackingType(){
      vm.selectedPackingType = null;
      angular.element('#modalPackingTypeForm').modal({backdrop: 'static', keyboard: false});
    }

    function editPackingType(packingType){
      angular.copy(packingType, vm.selectedPackingType);
      angular.element('#modalPackingTypeForm').modal({backdrop: 'static', keyboard: false});
    }

    function deletePackingType(packingType){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar este tipo de empaque?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rPackingType.delete({id:packingType.id}, function(){
              toastr.success('Tipo de Empaque Eliminado correctamente');
              loadPackingTypes();
            }, function(error){
              toastr.error('Error al Eliminar Tipo de Empaque', error.data.messages);
            });
          }
        }
      );
    }

    function searchPackingTypes (){
      vm.pagination.pageNum = 1;
      vm.query.name = vm.filter;
      vm.query.inclusive = false;
      loadPackingTypes();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadPackingTypes();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadPackingTypes();
    }

    function range (n) {
      return new Array(n);
    }

    packingTypesRefresh = $rootScope.$on('packingTypesRefresh', function() {
      loadPackingTypes();
    });

    $rootScope.$on('$destroy', packingTypesRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ConfController', ConfController);

  /** @ngInject */
  function ConfController() {

  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('UsersController', UsersController);

  /** @ngInject */
  function UsersController($rootScope, SweetAlert,rProfile, PAGINATION_CONFIG, rUser, bsLoadingOverlayService, toastr) {
    var vm = this,
      usersRefresh;

    vm.selectedUser = {};

    vm.query = {};
    vm.usersList = [];
    vm.countries = [];

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createUser = createUser;
    vm.searchUsers = searchUsers;
    vm.editUser = editUser;
    vm.deleteUser = deleteUser;

    function init () {
      loadUsers();
      loadProfiles();
    }
    init();

    function loadUsers(){
      bsLoadingOverlayService.start({referenceId: 'users-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rUser.query(vm.query, function(result){
        vm.usersList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'users-overlay'});
      });
    }

    function createUser(){
      vm.selectedUser = null;
      angular.element('#modalUserForm').modal({backdrop: 'static', keyboard: false});
    }

    function editUser(user){
      angular.copy(user, vm.selectedUser);
      angular.element('#modalUserForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteUser(user){
      SweetAlert.swal({
          title:'',
          text: 'Está seguro que deseea eliminar este usuario?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rUser.delete({id:user.id}, function(){
              toastr.success('Usuario Eliminado correctamente');
              loadUsers();
            }, function(error){
              toastr.error('Error al Eliminar usuario', error.message);
            });
          }
        }
      );
    }

    function loadProfiles() {
      rProfile.query({}, function(result){
        vm.profiles = result.records;
      });
    }

    function searchUsers (){
      vm.pagination.pageNum = 1;
      vm.query.firstname = vm.filter;
      vm.query.lastname = vm.filter;
      vm.query.identification = vm.filter;
      vm.query.username = vm.filter;
      loadUsers();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadUsers();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadUsers();
    }

    function range (n) {
      return new Array(n);
    }

    usersRefresh = $rootScope.$on('usersRefresh', function() {
      loadUsers();
    });

    $rootScope.$on('$destroy', usersRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('TerminalsController', TerminalsController);

  /** @ngInject */
  function TerminalsController($rootScope, SweetAlert, toastr, $log, PAGINATION_CONFIG, rCountry, rTerminal,  bsLoadingOverlayService) {
    var vm = this,
      terminalsRefresh;

    vm.selectedCountry = {};

    vm.query = {};
    vm.countriesList = [];

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createTerminal = createTerminal;
    vm.searchTerminals = searchTerminals;
    vm.editTerminal = editTerminal;
    vm.deleteTerminal = deleteTerminal;
    vm.openConfig = openConfig;

    function init () {
      loadTerminals();
      loadCountries();
    }
    init();

    function loadTerminals(){
      bsLoadingOverlayService.start({referenceId: 'terminals-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rTerminal.query(vm.query, function(result){
        vm.terminalsList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'terminals-overlay'});
      });
    }

    function loadCountries(){
      rCountry.query({}, function(result){
        vm.countriesList = result.records;
      });
    }


    function createTerminal(){
      vm.selectedTerminal = null;
      angular.element('#modalTerminalForm').modal({backdrop: 'static', keyboard: false});
    }

    function editTerminal(terminal){
      vm.selectedTerminal = terminal;
      angular.element('#modalTerminalForm').modal({backdrop: 'static', keyboard: false});
    }

    function openConfig(){
      angular.element('#modalConfigForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteTerminal(terminal){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar esta terminal?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rTerminal.delete({id:terminal.id}, function(){
              toastr.success('Terminal Eliminada correctamente');
              loadTerminals();
            }, function(error){
              toastr.error('Error al Eliminar Terminal', error.data.message);
            });
          }
        }
      );
    }

    function searchTerminals (){
      vm.pagination.pageNum = 1;
      vm.query.name = vm.filter;
      vm.query.inclusive = false;
      loadTerminals();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadTerminals();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadTerminals();
    }

    function range (n) {
      return new Array(n);
    }

    terminalsRefresh = $rootScope.$on('terminalsRefresh', function() {
      loadTerminals();
    });

    $rootScope.$on('$destroy', terminalsRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('SchedulesController', SchedulesController);

  /** @ngInject */
  function SchedulesController(rRoute, $rootScope, SweetAlert, toastr, rSchedule, $state, $log, PAGINATION_CONFIG, bsLoadingOverlayService) {
    var vm = this,
      schedulesRefresh,
      routeId = $state.params.routeId;

    vm.selectedSchedule = {};

    vm.query = {routeId:routeId};
    vm.schedulesList = [];
    vm.routeId = routeId;

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createSchedule = createSchedule;
    vm.editSchedule = editSchedule;
    vm.deleteSchedule = deleteSchedule;
    vm.generateTrips = generateTrips;

    function init () {
      loadRoute();
      loadSchedules();
    }
    init();


    function loadRoute(){
      rRoute.query({id:routeId}, function(result){
        vm.routeName = result.name;
      });
    }

    function loadSchedules(){
      bsLoadingOverlayService.start({referenceId: 'schedules-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rSchedule.query(vm.query, function(result){
        $log.info(result);
        vm.schedulesList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'schedules-overlay'});
      });
    }


    function createSchedule(){
      vm.selectedSchedule = null;
      angular.element('#modalScheduleForm').modal({backdrop: 'static', keyboard: false});
    }

    function generateTrips(schedule){
      angular.copy(schedule, vm.selectedSchedule);
      angular.element('#modalGenerateTripForm').modal({backdrop: 'static', keyboard: false});
    }

    function editSchedule(schedule){
      angular.copy(schedule, vm.selectedSchedule);
      angular.element('#modalScheduleForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteSchedule(schedule){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar este horario?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rSchedule.delete({id:schedule.id, routeId: vm.routeId}, function(){
              toastr.success('Horario Eliminado correctamente');
              loadSchedules();
            }, function(error){
              toastr.error('Error al Horario Bus', error.data.messages);
            });
          }
        }
      );
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadSchedules();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadSchedules();
    }

    function range (n) {
      return new Array(n);
    }

    schedulesRefresh = $rootScope.$on('schedulesRefresh', function() {
      loadSchedules();
    });

    $rootScope.$on('$destroy', schedulesRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('RoutesController', RoutesController);

  /** @ngInject */
  function RoutesController($rootScope, SweetAlert, toastr, rCountry, $log, PAGINATION_CONFIG, rRoute, bsLoadingOverlayService) {
    var vm = this,
      routesRefresh;

    vm.selectedRoute = {};

    vm.query = {};
    vm.routesList = [];
    vm.countriesList = [];

    vm.prefix = null;

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createRoute = createRoute;
    vm.searchRoutes = searchRoutes;
    vm.editRoute = editRoute;
    vm.deleteRoute = deleteRoute;
    vm.publish = publish;
    vm.unPublish = unPublish;

    function init () {
      loadRoutes();
      loadCountries();
    }
    init();

    function loadRoutes(){
      bsLoadingOverlayService.start({referenceId: 'routes-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rRoute.query(vm.query, function(result){
        $log.info(result);
        vm.routesList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'routes-overlay'});
      });
    }

    function loadCountries(){
      rCountry.query({}, function(result){
        vm.countriesList = result.records;
      });
    }

    function createRoute(){
      vm.selectedRoute = null;
      angular.element('#modalRouteForm').modal({backdrop: 'static', keyboard: false});
    }

    function editRoute(route){
      angular.copy(route, vm.selectedRoute);
      angular.element('#modalRouteForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteRoute(route){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar esta ruta?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rRoute.delete({id:route.id}, function(){
              toastr.success('Ruta Eliminado correctamente');
              loadRoutes();
            }, function(error){
              toastr.error('Error al Eliminar Ruta', error.data.messages);
            });
          }
        }
      );
    }

    function publish(route){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea mostrar esta ruta al publico?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rRoute.republish({id:route.id}, function(){
              toastr.success('Ruta Publicada Correctamente');
              loadRoutes();
            }, function(error){
              toastr.error('Error al Publicar Ruta', error.data.messages);
            });
          }
        }
      );
    }

    function unPublish(route){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea Ocultar esta ruta al publico?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rRoute.unpublish({id:route.id}, function(){
              toastr.success('Ruta Ocultada correctamente');
              loadRoutes();
            }, function(error){
              toastr.error('Error al Ocultar Ruta', error.data.messages);
            });
          }
        }
      );
    }

    function searchRoutes (){
      vm.pagination.pageNum = 1;
      vm.query.name = vm.filter;
      vm.query.departure = vm.filter;
      vm.query.destiny = vm.filter;
      vm.query.invoiceCounterNumberPrefix = vm.prefix;
      loadRoutes();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadRoutes();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadRoutes();
    }

    function range (n) {
      return new Array(n);
    }

    routesRefresh = $rootScope.$on('routesRefresh', function() {
      loadRoutes();
    });

    $rootScope.$on('$destroy', routesRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('RouteRatesController', RouteRatesController);

  /** @ngInject */
  function RouteRatesController(rRoute, $rootScope, SweetAlert, toastr, $state, $log, PAGINATION_CONFIG, rRouteRate, bsLoadingOverlayService) {
    var vm = this,
      routeRatesRefresh,
      routeId = $state.params.routeId;

    vm.selectedRouteRate = {};
    vm.routeName = '';

    vm.query = {routeId:routeId};
    vm.routeRatesList = [];
    vm.routeId = routeId;

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createRouteRate = createRouteRate;
    vm.searchRouteRates = searchRouteRates;
    vm.editRouteRate = editRouteRate;
    vm.deleteRouteRate = deleteRouteRate;

    function init () {
      loadRoute();
      loadRouteRates();
    }
    init();

    function loadRoute(){
      rRoute.query({id:routeId}, function(result){
        vm.routeName = result.name;
      });
    }

    function loadRouteRates(){
      bsLoadingOverlayService.start({referenceId: 'routeRates-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rRouteRate.query(vm.query, function(result){
        $log.info(vm.query);
        vm.routeRatesList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'route-rates-overlay'});
      });
    }

    function createRouteRate(){
      vm.selectedRouteRate = null;
      angular.element('#modalRouteRateForm').modal({backdrop: 'static', keyboard: false});
    }

    function editRouteRate(routeRate){
      angular.copy(routeRate, vm.selectedRouteRate);
      angular.element('#modalRouteRateForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteRouteRate(routeRate){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar este Precio?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rRouteRate.delete({id:routeRate.id, routeId: routeId}, function(){
              toastr.success('Precio Eliminado correctamente');
              loadRouteRates();
            }, function(error){
              toastr.error('Error al Eliminar el Precio', error.data.messages);
            });
          }
        }
      );
    }

    function searchRouteRates (){
      vm.pagination.pageNum = 1;
      vm.query.licenseplate = vm.filter;
      vm.query.inclusive = false;
      loadRouteRates();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadRouteRates();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadRouteRates();
    }

    function range (n) {
      return new Array(n);
    }

    routeRatesRefresh = $rootScope.$on('routeRatesRefresh', function() {
      loadRouteRates();
    });

    $rootScope.$on('$destroy', routeRatesRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ResellersController', ResellersController);

  /** @ngInject */
  function ResellersController($rootScope, SweetAlert, toastr, $log, PAGINATION_CONFIG, rCountry, rReseller,  bsLoadingOverlayService) {
    var vm = this,
      resellersRefresh;

    vm.selectedReseller = {};

    vm.query = {};
    vm.countriesList = [];

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createReseller = createReseller;
    vm.searchResellers = searchResellers;
    vm.editReseller = editReseller;
    vm.deleteReseller = deleteReseller;

    function init () {
      loadResellers();
      loadCountries();
    }
    init();

    function loadResellers(){
      bsLoadingOverlayService.start({referenceId: 'resellers-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rReseller.query(vm.query, function(result){
        vm.resellersList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'resellers-overlay'});
      });
    }

    function loadCountries(){
      rCountry.query({}, function(result){
        vm.countriesList = result.records;
      });
    }


    function createReseller(){
      vm.selectedReseller = null;
      angular.element('#modalResellerForm').modal({backdrop: 'static', keyboard: false});
    }

    function editReseller(reseller){
      angular.copy(reseller, vm.selectedReseller);
      angular.element('#modalResellerForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteReseller(reseller){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar esta agencia?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rReseller.delete({id:reseller.id}, function(){
              toastr.success('Agencia Eliminada correctamente');
              loadResellers();
            }, function(error){
              toastr.error('Error al eliminar agencia', error.data.message);
            });
          }
        }
      );
    }

    function searchResellers (){
      vm.pagination.pageNum = 1;
      vm.query.name = vm.filter;
      vm.query.inclusive = false;
      loadResellers();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadResellers();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadResellers();
    }

    function range (n) {
      return new Array(n);
    }

    resellersRefresh = $rootScope.$on('resellersRefresh', function() {
      loadResellers();
    });

    $rootScope.$on('$destroy', resellersRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ProfilesController', ProfilesController);

  /** @ngInject */
  function ProfilesController(rProfile, $rootScope, PAGINATION_CONFIG, bsLoadingOverlayService, SweetAlert, toastr) {
    var vm = this,
      profilesRefresh;

    vm.selectedProfile = {};

    vm.query = {};
    vm.profilesList = [];

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createProfile = createProfile;
    vm.searchProfiles = searchProfiles;
    vm.editProfile = editProfile;
    vm.deleteProfile = deleteProfile;

    function init () {
      loadProfiles();
    }
    init();

    function loadProfiles(){
      bsLoadingOverlayService.start({referenceId: 'profiles-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rProfile.query(vm.query, function(result){
        vm.profilesList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'profiles-overlay'});
      });
    }

    function createProfile(){
      vm.selectedProfile = null;
      angular.element('#modalProfileForm').modal({backdrop: 'static', keyboard: false});
    }

    function editProfile(profile){
      angular.copy(profile, vm.selectedProfile);
      angular.element('#modalProfileForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteProfile(profile){
      SweetAlert.swal({
          title:'',
          text: 'Está seguro que desea eliminar este perfil?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rProfile.delete({id:profile.id}, function(){
              toastr.success('Perfil Eliminado correctamente');
              loadProfiles();
            });
          }
        }
      );
    }

    function searchProfiles (){
      vm.pagination.pageNum = 1;
      vm.query.name = vm.filter;
      loadProfiles();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadProfiles();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadProfiles();
    }

    function range (n) {
      return new Array(n);
    }

    profilesRefresh = $rootScope.$on('profilesRefresh', function() {
      loadProfiles();
    });

    $rootScope.$on('$destroy', profilesRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('AdminController', AdminController);

  /** @ngInject */
  function AdminController() {

  }
})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .controller('GeneratedTripsController', GeneratedTripsController);

  /** @ngInject */
  function GeneratedTripsController(
    bsLoadingOverlayService,
    rRoute,
    rTrip,
    rBus,
    moment,
    PAGINATION_CONFIG,
    toastr,
    utilsService
  ) {
    var vm = this;
    vm.routesList = [];
    vm.busClasses = [];

    vm.trips = [];

    vm.loadSchedulesAvailable = loadSchedulesAvailable;
    vm.submit = submit;
    vm.deleteTrip = deleteTrip;
    vm.getAvailableSeats = getAvailableSeats;

    vm.submitAttempt = false;

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    init();


    function loadRoutes() {
      rRoute.query(
        { pagesize: 120, onlyActiveSchedules: true, publicRoute: true }
        , function (result) {
          vm.routesList = result.records;
        });
    }

    function loadBusClasses() {
      rBus.getBusClasses({}, function (result) {
        vm.busClasses = result.records;
      });
    }

    function submit(form) {
      if (!form.$valid) {
        vm.submitAttempt = true;
        return
      }

      loadSchedulesAvailable();

    }

    function loadSchedulesAvailable() {
      bsLoadingOverlayService.start({ referenceId: 'generatedTrips-overlay' });

      var query = {
        routeid: vm.filter.route,
        busclassid: vm.filter.busType,
        start: moment(vm.filter.originDateUI).format('YYYY-MM-DD'),
        end: moment(vm.filter.endDateUI).format('YYYY-MM-DD'),
        inclusive: true
      };

      query.pagesize = vm.pagination.rangeSelected;
      query.page = vm.pagination.pageNum - 1;

      rTrip.query(query, function (result) {
        vm.trips = result.records;

        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;

        bsLoadingOverlayService.stop({ referenceId: 'generatedTrips-overlay' });
      });
    }

    function deleteTrip(trip) {
      rTrip.delete({ id: trip.id }, function (result) {
        vm.trips = result.records;
        toastr.success('Viaje Eliminado correctamente');

        loadSchedulesAvailable();
      },
        function (error) {
          toastr.error('Hubo un error al eliminar el viaje', error.data.message);
        });
    }

    function getAvailableSeats(trip) {
      if (!trip) return;
      return utilsService.getAvailableSeats(trip);
    }

    function init() {
      loadRoutes();
      loadBusClasses();
    }


    // Pagination Functions
    function setRecordsPerPage(num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadSchedulesAvailable();
    }

    function goToPage(p) {
      vm.pagination.pageNum = p;
      loadSchedulesAvailable();
    }

    function range(n) {
      return new Array(n);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ExternalCodesController', ExternalCodesController);

  /** @ngInject */
  function ExternalCodesController($rootScope, SweetAlert,rExternalCode, PAGINATION_CONFIG, rUser, bsLoadingOverlayService, toastr) {
    var vm = this,
      extCodeRefresh;

    vm.selectedUser = {};

    vm.query = {};
    vm.usersList = [];
    vm.countries = [];

    vm.filterSeries = '';
    vm.filterCode = '';

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createExtCode = createExtCode;
    vm.searchExtCodes = searchExtCodes;
    vm.editExtCode = editExtCode;
    vm.deleteExtCode = deleteExtCode;

    function init () {
      loadExternalCodes();
    }
    init();

    function loadExternalCodes(){
      bsLoadingOverlayService.start({referenceId: 'extCodes-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rExternalCode.query(vm.query, function(result){
        vm.extCodesList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'extCodes-overlay'});
      },
      function(error){
        bsLoadingOverlayService.stop({referenceId: 'extCodes-overlay'});
        toastr.error('Error al cargar los Códigos Externos', error.data.message);
      });
    }

    function createExtCode(){
      vm.selectedExtCode = null;
      angular.element('#modalExtCodeForm').modal({backdrop: 'static', keyboard: false});
    }

    function editExtCode(extCode){
      angular.copy(extCode, vm.selectedExtCode);
      angular.element('#modalExtCodeForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteExtCode(extCode){
      SweetAlert.swal({
          title:'',
          text: 'Está seguro que deseea eliminar este Código Externo?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rExternalCode.delete({id:extCode.id}, function(){
              toastr.success('Código Externo Eliminado correctamente');
              loadExternalCodes();
            }, function(error){
              toastr.error('Error al Eliminar este Código Externo', error.message);
            });
          }
        }
      );
    }


    function searchExtCodes (){
      vm.pagination.pageNum = 1;
     
      vm.query.series = vm.filterSeries ? vm.filterSeries : null;
      vm.query.code = vm.filterCode ? vm.filterCode : null;

      loadExternalCodes();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadExternalCodes();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadExternalCodes();
    }

    function range (n) {
      return new Array(n);
    }

    extCodeRefresh = $rootScope.$on('extCodeRefresh', function() {
      loadExternalCodes();
    });

    $rootScope.$on('$destroy', extCodeRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('ExchangeController', ExchangeController);

  /** @ngInject */
  function ExchangeController($rootScope, SweetAlert, toastr, PAGINATION_CONFIG, rExchange, rCurrency,  bsLoadingOverlayService) {
    var vm = this,
      exchangeRefresh;

    vm.selectedExchange = {};

    vm.query = {};
    vm.exchangeList = [];

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createExchange = createExchange;
    vm.searchExchange = searchExchange;
    vm.editExchange = editExchange;
    vm.deleteExchange = deleteExchange;

    function init () {
      loadExchange();
      loadCurrencies();
    }
    init();

    function loadExchange(){
      bsLoadingOverlayService.start({referenceId: 'exchange-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rExchange.query(vm.query, function(result){
        vm.exchangesList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'exchange-overlay'});
      });
    }

    function loadCurrencies(){
      rCurrency.query({}, function(result){
        vm.currencies = result.records;
      });
    }


    function createExchange(){
      vm.selectedExchange = null;
      angular.element('#modalExchangeForm').modal({backdrop: 'static', keyboard: false});
    }

    function editExchange(exchange){
      angular.copy(exchange, vm.selectedExchange);
      angular.element('#modalExchangeForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteExchange(exchange){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar este tipo de cambio?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rExchange.delete({id:exchange.id}, function(){
              toastr.success('Tipo de cambio Eliminado correctamente');
              loadExchange();
            }, function(error){
              toastr.error('Error al eliminar agencia', error.data.message);
            });
          }
        }
      );
    }

    function searchExchange (){
      vm.pagination.pageNum = 1;
      vm.query.name = vm.filter;
      vm.query.inclusive = false;
      loadExchange();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadExchange();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadExchange();
    }

    function range (n) {
      return new Array(n);
    }

    exchangeRefresh = $rootScope.$on('exchangeRefresh', function() {
      loadExchange();
    });

    $rootScope.$on('$destroy', exchangeRefresh);
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .controller("DollarExchangeController", DollarExchangeController);

  /** @ngInject */
  function DollarExchangeController(
    $rootScope,
    SweetAlert,
    toastr,
    $log,
    PAGINATION_CONFIG,
    rDollarExchange,
    bsLoadingOverlayService
  ) {
    var vm = this,
      dollarExchangeRefresh;

    vm.dollarExchangeList = [];

    vm.createDollarExchange = createDollarExchange;
    vm.canCreateDollarExchange = canCreateDollarExchange;

    function init() {
      loadDollarExchange();
    }
    init();

    function canCreateDollarExchange() {
      return $rootScope.hasPermissionsFor("DOLLAR_EXCHANGE_ADD");
    }

    function loadDollarExchange() {
      bsLoadingOverlayService.start({ referenceId: "dollar-exchange-overlay" });

      $log.info("loadDollarExchange");
      rDollarExchange.query({}, function (result) {
        $log.info("loadDollarExchange result", result);
        vm.dollarExchangeList = result;
        bsLoadingOverlayService.stop({
          referenceId: "dollar-exchange-overlay",
        });
      });

      // TODO: remove
      bsLoadingOverlayService.stop({ referenceId: "dollar-exchange-overlay" });
    }

    function createDollarExchange() {
      angular
        .element("#modalDollarExchangeForm")
        .modal({ backdrop: "static", keyboard: false });
    }

    dollarExchangeRefresh = $rootScope.$on(
      "dollarExchangeRefresh",
      function () {
        loadDollarExchange();
      }
    );

    $rootScope.$on("$destroy", dollarExchangeRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('CountriesController', CountriesController);

  /** @ngInject */
  function CountriesController($rootScope, SweetAlert, toastr, $log, PAGINATION_CONFIG, rCountry, bsLoadingOverlayService) {
    var vm = this,
      countriesRefresh;

    vm.selectedCountry = {};

    vm.query = {};
    vm.countriesList = [];

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createCountry = createCountry;
    vm.searchCountries = searchCountries;
    vm.editCountry = editCountry;
    vm.deleteCountry = deleteCountry;

    function init () {
      loadCountries();
    }
    init();

    function loadCountries(){
      bsLoadingOverlayService.start({referenceId: 'countries-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rCountry.query(vm.query, function(result){
        $log.info(result);
        vm.countriesList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'countries-overlay'});
      });
    }


    function createCountry(){
      vm.selectedCountry = null;
      angular.element('#modalCountryForm').modal({backdrop: 'static', keyboard: false});
    }

    function editCountry(country){
      angular.copy(country, vm.selectedCountry);
      angular.element('#modalCountryForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteCountry(country){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar este país?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rCountry.delete({id:country.id}, function(){
              toastr.success('País Eliminado correctamente');
              loadCountries();
            }, function(error){
              toastr.error('Error al Eliminar País', error.data.messages);
            });
          }
        }
      );
    }

    function searchCountries (){
      vm.pagination.pageNum = 1;
      vm.query.name = vm.filter;
      vm.query.inclusive = false;
      loadCountries();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadCountries();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadCountries();
    }

    function range (n) {
      return new Array(n);
    }

    countriesRefresh = $rootScope.$on('countriesRefresh', function() {
      loadCountries();
    });

    $rootScope.$on('$destroy', countriesRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('BusesController', BusesController);

  /** @ngInject */
  function BusesController($rootScope, SweetAlert, toastr, rCountry, $log, PAGINATION_CONFIG, rBus, bsLoadingOverlayService) {
    var vm = this,
      busesRefresh;

    vm.selectedBus = {};

    vm.query = {};
    vm.busesList = [];
    vm.countriesList = [];

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createBus = createBus;
    vm.searchBuses = searchBuses;
    vm.editBus = editBus;
    vm.deleteBus = deleteBus;

    function init () {
      loadBuses();
      loadCountries();
    }
    init();

    function loadBuses(){
      bsLoadingOverlayService.start({referenceId: 'buses-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rBus.query(vm.query, function(result){
        $log.info(result);
        vm.busesList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'buses-overlay'});
      });
    }

    function loadCountries(){
      rCountry.query({}, function(result){
        vm.countriesList = result.records;
      });
    }


    function createBus(){
      vm.selectedBus = null;
      angular.element('#modalBusForm').modal({backdrop: 'static', keyboard: false});
    }

    function editBus(bus){
      angular.copy(bus, vm.selectedBus);
      angular.element('#modalBusForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteBus(bus){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar este bus?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rBus.delete({id:bus.id}, function(){
              toastr.success('Bus Eliminado correctamente');
              loadBuses();
            }, function(error){
              toastr.error('Error al Eliminar Bus', error.data.messages);
            });
          }
        }
      );
    }

    function searchBuses (){
      vm.pagination.pageNum = 1;
      vm.query.licenseplate = vm.filter;
      vm.query.inclusive = false;
      loadBuses();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadBuses();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadBuses();
    }

    function range (n) {
      return new Array(n);
    }

    busesRefresh = $rootScope.$on('busesRefresh', function() {
      loadBuses();
    });

    $rootScope.$on('$destroy', busesRefresh);
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .controller('BoardingsController', BoardingsController);

  /** @ngInject */
  function BoardingsController(rRoute, $rootScope, SweetAlert, toastr, rBoarding, $state, $log, PAGINATION_CONFIG, bsLoadingOverlayService) {
    var vm = this,
      boardingsRefresh,
      routeId = $state.params.routeId;

    vm.selectedBoarding = {};

    vm.query = {routeId:routeId};
    vm.boardingsList = [];
    vm.routeId = routeId;

    //pagination object:
    vm.pagination = {
      rangeSelected: PAGINATION_CONFIG.allowedRanges[0],
      pageNum: 1,
      prevPage: 0,
      nextPage: 0,
      totalPages: 0,
      totalRecords: 0,
      numberOfPageRecords: 0,
      allowedRanges: PAGINATION_CONFIG.allowedRanges,
      maxPaginationItems: PAGINATION_CONFIG.maxPaginationItems
    };

    vm.setRecordsPerPage = setRecordsPerPage;
    vm.goToPage = goToPage;
    vm.range = range;

    vm.createBoarding = createBoarding;
    vm.searchBoardings = searchBoardings;
    vm.editBoarding = editBoarding;
    vm.deleteBoarding = deleteBoarding;

    function init () {
      loadRoute();
      loadBoardings();
    }
    init();

    function loadRoute(){
      rRoute.query({id:routeId}, function(result){
        vm.routeName = result.name;
      });
    }

    function loadBoardings(){
      bsLoadingOverlayService.start({referenceId: 'boardings-overlay'});

      vm.query.pagesize = vm.pagination.rangeSelected;
      vm.query.page = vm.pagination.pageNum-1;

      rBoarding.query(vm.query, function(result){
        $log.info(result);
        vm.boardingsList  = result.records;
        vm.pagination.totalRecords = result.totalRecords;
        vm.pagination.numberOfPageRecords = result.numberOfPageRecords;
        vm.pagination.totalPages = result.totalPages;
        vm.pagination.prevPage = result.previous;
        vm.pagination.nextPage = result.next;
        bsLoadingOverlayService.stop({referenceId: 'boardings-overlay'});
      });
    }


    function createBoarding(){
      vm.selectedBoarding = null;
      angular.element('#modalBoardingForm').modal({backdrop: 'static', keyboard: false});
    }

    function editBoarding(boarding){
      angular.copy(boarding, vm.selectedBoarding);
      angular.element('#modalBoardingForm').modal({backdrop: 'static', keyboard: false});
    }

    function deleteBoarding(boarding){
      SweetAlert.swal({
          title:'',
          text: '¿Está seguro que desea eliminar este abordaje?',
          showCancelButton: true,
          confirmButtonText:'Si',
          closeOnConfirm: true,
          closeOnCancel: true,
          allowEscapeKey: false
        },
        function(isConfirm){
          if (isConfirm) {
            rBoarding.delete({id:boarding.id, routeId: routeId}, function(){
              toastr.success('Abordaje Eliminado correctamente');
              loadBoardings();
            }, function(error){
              toastr.error('Error al Horario Abordaje', error.data.messages);
            });
          }
        }
      );
    }

    function searchBoardings (){
      vm.pagination.pageNum = 1;
      vm.query.name = vm.filter;
      vm.query.description = vm.filter;
      vm.query.inclusive = false;
      loadBoardings();
    }

    // Pagination Functions
    function setRecordsPerPage (num) {
      vm.pagination.rangeSelected = num;
      vm.pagination.pageNum = 1;
      loadBoardings();
    }

    function goToPage (p) {
      vm.pagination.pageNum = p;
      loadBoardings();
    }

    function range (n) {
      return new Array(n);
    }

    boardingsRefresh = $rootScope.$on('boardingsRefresh', function() {
      loadBoardings();
    });

    $rootScope.$on('$destroy', boardingsRefresh);
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .directive("tnspValidateCitizenId", tnspValidateCitizenId);

  /** @ngInject */
  function tnspValidateCitizenId($q, rTicket) {
    var directive = {
      restrict: "A",
      require: "ngModel",
      link: linkFunction
    };

    return directive;

    /** @ngInject */
    function linkFunction(scope, elm, attrs, ctrl) {
      ctrl.$asyncValidators.customServerValidation = function (viewValue) {
        scope.$watch(function () { return ctrl.$viewValue }, function () {
          ctrl.$setValidity("deceasedCitizen", true);
          ctrl.$setValidity("notSeniorCitizen", true);
          ctrl.$setValidity("apiError", true);
        });
        if (!viewValue || viewValue.length !== 9) {
          return $q.resolve();
        }
        var def = $q.defer();
        rTicket.checkIfIsElderlyPerson({ citizenId: viewValue })
          .$promise.then(function (result) {
            if (result.decease) {
              ctrl.$setValidity("deceasedCitizen", false);
              return def.reject();
            } else if (result.goldCitizen) {
              return def.resolve();
            } else {
              ctrl.$setValidity("notSeniorCitizen", false);
              return def.reject();
            }
          }).catch(function () {
            ctrl.$setValidity("apiError", false);
            return def.reject();
          });
        return def.promise;
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspSidebar', tnspSidebar);

  /** @ngInject */
  function tnspSidebar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/sidebar/sidebar.html',
      controller: SidebarController,
      controllerAs: 'sidebar',
      scope:{
        title: '@'
      },
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SidebarController($rootScope, $state, HEADER_MENU, SIDEBAR_MENU) {
      var vm = this,
        onRolesLoaded;

      vm.selectedItem = $state.current.name;
      vm.selectedItem = vm.selectedItem.split('.')[0];
      vm.items  = [];
      vm.sideBarItems = SIDEBAR_MENU;

      onRolesLoaded = $rootScope.$on('rolesLoaded', function() {
        loadSidebar();
      });

      $rootScope.$on('$destroy', onRolesLoaded);


      function loadSidebar(){
        vm.items  = [];
        angular.forEach(HEADER_MENU, function(item) {
          if (item.routerState === vm.selectedItem){
            vm.items = item.subNavItems;
            /*if ($rootScope.user.sysAdmin){
              $scope.items = item.subNavItems;
            }else{
              if ($rootScope.userPermissions){
                angular.forEach(item.subNavItems, function(subItem){

                  if ($rootScope.isTenantAdmin && subItem.url !== '.roles'){
                    $scope.items.push(subItem);
                  }else{
                    angular.forEach(subItem.requiredPermissions, function(permissions){
                      if ($rootScope.userPermissions.indexOf(permissions) > -1){
                        $scope.items.push(subItem);
                      }
                    });
                  }
                });
              }
            }*/
          }
        });
      }

      loadSidebar();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('selectpicker', Selectpicker);

  /** @ngInject */
  function Selectpicker() {
    var directive = {
      restrict: 'A',
      scope:true,
      link:SelectpickerLink
    };

    return directive;

    /** @ngInject */
    function SelectpickerLink(scope, element, iAttrs){
      scope.$watchCollection(iAttrs['selectpicker'], function(){
        element.selectpicker();
      });
    }
  }

})();

(function () {
  "use strict";

  angular.module("tnsp").filter("tnspPhone", tnspPhone);

  /** @ngInject */
  function tnspPhone(phoneFormat) {
    return function (value) {
      return phoneFormat.format(phoneFormat.normalize(value));
    };
  }
})();

(function () {
  "use strict";

  angular.module("tnsp").directive("tnspPhoneMask", tnspPhoneMask);

  /** @ngInject */
  function tnspPhoneMask(phoneFormat) {
    var directive = {
      restrict: "A",
      require: "ngModel",
      link: linkFunction
    };

    return directive;

    /** @ngInject */
    function linkFunction(scope, elm, attrs, ctrl) {
      // Modelo ("+50688592161") -> vista ("+506 8859-2161").
      ctrl.$formatters.push(function (modelValue) {
        return phoneFormat.format(phoneFormat.normalize(modelValue));
      });

      // Vista -> modelo. El modelo va en E.164, o sea el + y los digitos sin
      // espacio ni guion, para que el POST /tickets y el PATCH
      // /tickets/{id}/contact manden "+50688592161".
      ctrl.$parsers.push(function (viewValue) {
        var digits = phoneFormat.digits(viewValue),
          formatted = phoneFormat.format(digits);

        // Repinta la vista con el + y los separadores ya puestos. Al reentrar,
        // formatted y viewValue coinciden y la recursion se corta.
        if (formatted !== viewValue) {
          ctrl.$setViewValue(formatted);
          ctrl.$render();
        }

        return digits ? "+" + digits : "";
      });

      // Se valida contra el modelo, no contra la vista: ngPattern evalua el
      // viewValue, y con el + y el guion en pantalla un /^[0-9]+$/ fallaria
      // siempre. Se normaliza para que un telefono guardado sin codigo de pais
      // no salga marcado como invalido con solo abrir el formulario.
      ctrl.$validators.phoneFormat = function (modelValue) {
        var digits = phoneFormat.normalize(modelValue);

        return digits.length === 0 || phoneFormat.isComplete(digits);
      };
    }
  }
})();

(function () {
  "use strict";

  angular.module("tnsp").factory("phoneFormat", phoneFormat);

  /**
   * Logica compartida entre la directiva tnspPhoneMask y el filtro tnspPhone,
   * para que el campo de edicion y el detalle del ticket muestren el telefono
   * de la misma forma.
   *
   * @ngInject
   */
  function phoneFormat() {
    var CR_CODE = "506",
      CR_LOCAL_DIGITS = 8,
      GROUP_AT = 4,
      // Tope de E.164: codigo de pais mas numero nacional nunca pasa de 15.
      MAX_DIGITS = 15,
      // Un numero de CR sin codigo de pais son 8 digitos. Pidiendo 9 como
      // minimo, olvidar el codigo cae en invalido en vez de colarse como
      // +88592161.
      MIN_DIGITS = 9;

    return {
      MAX_DIGITS: MAX_DIGITS,
      digits: digits,
      normalize: normalize,
      format: format,
      isComplete: isComplete
    };

    // Deja solo los digitos, sin el + ni los separadores de la vista.
    function digits(value) {
      if (value === null || angular.isUndefined(value)) {
        return "";
      }
      return String(value).replace(/[^0-9]/g, "").slice(0, MAX_DIGITS);
    }

    // Igual que digits, pero asume Costa Rica en los telefonos guardados
    // antes de que el codigo de pais fuera obligatorio: 8 digitos pelados y
    // sin +. Solo se usa leyendo del API, nunca sobre lo que el cajero teclea,
    // para no completar el codigo por su cuenta mientras escribe.
    function normalize(modelValue) {
      var value = digits(modelValue);

      if (value.length === CR_LOCAL_DIGITS && String(modelValue).indexOf("+") === -1) {
        return CR_CODE + value;
      }

      return value;
    }

    // 50688592161 -> "+506 8859-2161". Con cualquier otro codigo de pais no se
    // agrupa (15551234567 -> "+15551234567"): el largo del codigo no se puede
    // deducir de los digitos, y partir por los ultimos 8 dejaria un numero de
    // 10 digitos como "+155 5123-4567".
    function format(value) {
      var local;

      if (!value) {
        return "";
      }

      if (value.indexOf(CR_CODE) !== 0) {
        return "+" + value;
      }

      local = value.slice(CR_CODE.length);

      if (!local) {
        return "+" + CR_CODE;
      }

      if (local.length <= GROUP_AT) {
        return "+" + CR_CODE + " " + local;
      }

      return "+" + CR_CODE + " " + local.slice(0, GROUP_AT) + "-" + local.slice(GROUP_AT);
    }

    // Costa Rica se valida completo (506 + 8 digitos); del resto de los paises
    // solo se exige que el largo entre en E.164.
    function isComplete(value) {
      if (value.indexOf(CR_CODE) === 0) {
        return value.length === CR_CODE.length + CR_LOCAL_DIGITS;
      }

      return value.length >= MIN_DIGITS && value.length <= MAX_DIGITS;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalUserForm', tnspModalUserForm);

  /* @ngInject */
  function tnspModalUserForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-user-form/modal-user-form.html',
      controller: ModalUserFormController,
      controllerAs: 'mUserForm',
      bindToController: true,
      scope: {
        user: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalUserFormController(rProfile, rUser, rReseller, rTerminal, rCountry, rNationality, toastr, $rootScope, $timeout) {
      var vm = this;
      vm.identificationTypes = [];
      vm.resellers = [];
      vm.type = 'create';
      vm.submitProcess = submitProcess;
      vm.loadTerminals = loadTerminals;

      loadIdentificationTypes();
      loadProfiles();
      loadResellers();
      loadCountries();
      loadNationalities();

      function init() {
        if(vm.user) {
          loadUser();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
          vm.user = {};
          vm.user.roles = [];
          vm.user.country = {};
          vm.user.terminal = {};
        }
      }

      function loadUser() {
        rUser.query({id: vm.user.id}, function(result){
          vm.user = result;
          vm.user.country = {};
          vm.user.country.id = vm.user.terminal ? vm.user.terminal.country.id : null;
          loadTerminals();
        });
      }

      function loadIdentificationTypes() {
        rUser.getIdentificationTypes({}, function(result){
          vm.identificationTypes = result;
        });
      }

      function loadCountries() {
        rCountry.query({}, function(result){
          vm.countries = result.records;
        });
      }

      function loadNationalities() {
        rNationality.query({}, function(result){
          vm.nationalities = result;
        });
      }

      function loadProfiles() {
        rProfile.query({}, function(result){
          vm.profiles = result.records;
        });
      }

      function loadTerminals(_country) {
        rTerminal.query({country:_country}, function(result){
          vm.terminals = result.records;
        });
      }

      function loadResellers() {
        rReseller.query({}, function(result){
          vm.resellers = result.records;
        });
      }

      function profileChanged() {
        if (vm.user.roles[0].id!==6 && vm.user.roles[0].id!==11){
          vm.user.reseller= null;
        }else{
          vm.user.terminal= null;
        }
      }

      function submitProcess(form) {
        vm.loading = true;
        profileChanged();
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rUser.save(vm.user, function(result) {
          vm.user = result;
          angular.element('#modalUserForm').modal('hide');
          vm.loading = false;
          toastr.success('El usuario fue creado satisfactoriamente');
          $rootScope.$broadcast('usersRefresh');
        }, function(error){
          toastr.error('Hubo un error al crear el usuario', error.data.message);
        });
      }

      function updateProcess() {
        rUser.update(vm.user, function() {
          angular.element('#modalUserForm').modal('hide');
          vm.loading = false;
          toastr.success('El usuario fue editado satisfactoriamente');
          $rootScope.$broadcast('usersRefresh');
        }, function(error){
          toastr.error('Hubo un error al actualizar el usuario', error.data.message);
        });
      }

      angular.element('#modalUserForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalUserForm').on('shown.bs.modal', function () {
        $timeout(function(){
          init();
        },10);
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalUnderagePersonForm', tnspModalUnderagePersonForm);

  /* @ngInject */
  function tnspModalUnderagePersonForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-underage-person-form/modal-underage-person-form.html',
      controller: ModalUnderagePersonFormController,
      controllerAs: 'mUnderagePersonForm',
      bindToController: true,
      scope: {
        ticket: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalUnderagePersonFormController($log, toastr, $rootScope, rTicket) {
      var vm = this;
      vm.loading = false;
      vm.submitProcess = submitProcess;

      function init() {
        if(vm.ticket) {
          loadTicket();
        }
      }

      function loadTicket() {
        rTicket.query({id: vm.ticket.invoiceNumber}, function(result){
          $log.info(result);
          vm.ticket = result;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        updateProcess()
      }

      function updateProcess() {
        var updateTicket = {};  
        angular.copy(vm.ticket,updateTicket);

        updateTicket.id = updateTicket.invoiceNumber;

        rTicket.partialUpdate(updateTicket, function() {
          angular.element('#modalUnderagePersonForm').modal('hide');
          vm.loading = false;
          toastr.success('Las notas del menor de edad fue editada satisfactoriamente');
          $rootScope.$broadcast('checkTicketsRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al editar las notas del menor de edad', error.data.message);
        });
      }

      angular.element('#modalUnderagePersonForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalUnderagePersonForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalTicketRegistrationForm', tnspModalTicketRegistrationForm);

  /* @ngInject */
  function tnspModalTicketRegistrationForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-ticket-registration-form/modal-ticket-registration-form.html',
      controller: ModalTicketRegistrationFormController,
      controllerAs: 'mTicketRegistrationForm',
      bindToController: true,
      scope: {
        country: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalTicketRegistrationFormController() {
      var vm = this;
      vm.submitProcess = submitProcess;

      function init() {
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
      }

      angular.element('#modalTicketRegistrationForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalTicketRegistrationForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .directive("tnspModalTicketContactForm", tnspModalTicketContactForm);

  /* @ngInject */
  function tnspModalTicketContactForm() {
    var directive = {
      restrict: "E",
      templateUrl:
        "app/components/modal-ticket-contact-form/modal-ticket-contact-form.html",
      controller: ModalTicketContactFormController,
      controllerAs: "mTicketContactForm",
      bindToController: true,
      scope: {
        ticket: "="
      }
    };

    return directive;

    /* @ngInject */
    function ModalTicketContactFormController(
      rTicket,
      toastr,
      $rootScope,
      $timeout
    ) {
      var vm = this;
      vm.contact = {};
      vm.loading = false;
      vm.submitAttempt = false;
      vm.missingContact = false;
      vm.submitProcess = submitProcess;

      // El modal se abre desde el padre con .modal(); recargamos los valores en
      // cada apertura para que un "Cancelar" no deje ediciones a medias.
      angular
        .element("#modalTicketContactForm")
        .on("show.bs.modal", function () {
          $timeout(seedFromTicket);
        });

      function seedFromTicket() {
        vm.submitAttempt = false;
        vm.missingContact = false;
        vm.contact = {
          customerPhone: vm.ticket ? vm.ticket.customerPhone : null,
          email: vm.ticket ? vm.ticket.email : null
        };
      }

      function submitProcess(form) {
        vm.loading = true;
        vm.submitAttempt = true;

        // El API rechaza un body vacio con EMPTY_REQUEST, asi que exigimos al
        // menos uno de los dos campos.
        vm.missingContact = !vm.contact.customerPhone && !vm.contact.email;

        if (!form.$valid || vm.missingContact) {
          vm.loading = false;
          return;
        }
        updateContactProcess();
      }

      function updateContactProcess() {
        // Solo se envian los campos con valor: este endpoint no permite limpiar
        // un telefono o un correo, unicamente establecerlos.
        var contactInfo = {};
        if (vm.contact.customerPhone) {
          contactInfo.customerPhone = vm.contact.customerPhone;
        }
        if (vm.contact.email) {
          contactInfo.email = vm.contact.email;
        }

        // El {id} de la ruta es en realidad el invoiceNumber: el backend
        // resuelve el ticket con findOneByInvoiceNumber, no por el id numerico.
        // Va como parametro aparte para no ensuciar el body, que se deserializa
        // en un DTO que solo declara customerPhone y email.
        rTicket.updateContact(
          { id: vm.ticket.invoiceNumber },
          contactInfo,
          function (result) {
            angular.element("#modalTicketContactForm").modal("hide");
            vm.loading = false;
            toastr.success("Contacto actualizado");
            $rootScope.$broadcast("ticketContactUpdated", result);
          },
          function (error) {
            vm.loading = false;
            toastr.error(
              "Hubo un error al actualizar el contacto",
              error.data.message
            );
          }
        );
      }

      seedFromTicket();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalTerminalForm', tnspModalTerminalForm);

  /* @ngInject */
  function tnspModalTerminalForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-terminal-form/modal-terminal-form.html',
      controller: ModalTerminalFormController,
      controllerAs: 'mTerminalForm',
      bindToController: true,
      scope: {
        terminal: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalTerminalFormController(rTerminal, rCountry, $log, toastr, $rootScope) {
      var vm = this;
      vm.type = 'create';
      vm.loading = false;
      vm.submitProcess = submitProcess;

      vm.countries = [];

      loadCountries();


      function init() {
        if(vm.terminal) {
          loadTerminal();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
        }
      }

      function loadTerminal() {
        rTerminal.query({id: vm.terminal.id}, function(result){
          vm.terminal = result;
        });
      }

      function loadCountries() {
        rCountry.query({}, function(result){
          vm.countries = result.records;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rTerminal.save(vm.terminal, function() {
          angular.element('#modalTerminalForm').modal('hide');
          vm.loading = false;
          toastr.success('Terminal fue creada satisfactoriamente');
          $rootScope.$broadcast('terminalsRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear la terminal', error.data.message);
        });
      }

      function updateProcess() {
        rTerminal.update(vm.terminal, function() {
          angular.element('#modalTerminalForm').modal('hide');
          vm.loading = false;
          toastr.success('Terminal fue editada satisfactoriamente');
          $rootScope.$broadcast('terminalsRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear la terminal', error.data.message);
        });
      }

      angular.element('#modalTerminalForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalTerminalForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalScheduleForm', tnspModalScheduleForm);

  /* @ngInject */
  function tnspModalScheduleForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-schedule-form/modal-schedule-form.html',
      controller: ModalScheduleFormController,
      controllerAs: 'mScheduleForm',
      bindToController: true,
      scope: {
        schedule: '=',
        routeId: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalScheduleFormController(rRouteRate, rSchedule, rBoarding, rDropoff, toastr, $rootScope,$timeout, moment, DATE_ISO_FORMAT) {
      var vm = this;
      vm.datesConfigPeriod = {};
      vm.type = 'create';
      vm.loading = false;
      vm.routeRates = [];
      vm.boardings = [];
      vm.filterBoardings = '';
      vm.filterInvalidBoardings = '';
      /*vm.dropoffs = [];
      vm.filterDropoffs = '';
      vm.filterInvalidDropoffs = '';*/
      vm.submitProcess = submitProcess;
      vm.setMinDate = setMinDate;
      vm.toggleSelected = toggleSelected;
      vm.removeBoarding = removeBoarding;
      vm.addSelectedBoarding = addSelectedBoarding;
      vm.removeInvalidBoarding = removeInvalidBoarding;

      /*vm.removeDropoff = removeDropoff;
      vm.addSelectedDropoff = addSelectedDropoff;
      vm.removeInvalidDropoff = removeInvalidDropoff;*/

      loadRouteRates();

      function init() {
        $timeout(function(){
          if(vm.schedule && vm.schedule.id) {
            loadSchedule();
            vm.type = 'edit';
          }else{
            vm.type = 'create';
            vm.schedule = {routeId: vm.routeId, visible: true, invalidBoardings: []};
          }
        },500);
        loadBoardings();
        //loadDropoffs();
      }

      function loadRouteRates() {
        rRouteRate.query({routeId: vm.routeId}, function(result){
          vm.routeRates = result.records;
        });
      }

      function loadBoardings() {
        rBoarding.query({routeId: vm.routeId, pagesize:100}, function(result){
          vm.boardings = result.records;
        });
      }
      /*function loadDropoffs() {
        rDropoff.query({routeId: vm.routeId, scheduleId: vm.schedule.id, pagesize:100}, function(result){
          vm.dropoffs = result.records;
        });
      }*/

      function loadSchedule() {
        rSchedule.query({id: vm.schedule.id, routeId: vm.routeId}, function(result){
          vm.schedule = result;

          vm.schedule.startUI = vm.schedule.start ? moment(vm.schedule.start, DATE_ISO_FORMAT).toDate()  : null;
          vm.schedule.endUI = vm.schedule.end ? moment(vm.schedule.end, DATE_ISO_FORMAT).toDate()  : null;

          updateList(vm.boardings,vm.schedule.invalidBoardings);
          //updateList(vm.dropoffs,vm.schedule.invalidDropoffs);
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rSchedule.save(vm.schedule, function() {
          angular.element('#modalScheduleForm').modal('hide');
          vm.loading = false;
          toastr.success('El Horario fue creado satisfactoriamente');
          $rootScope.$broadcast('schedulesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el Horario', error.data.message);
        });
      }

      function updateProcess() {
        vm.schedule.routeId = vm.routeId;


        vm.schedule.start = vm.schedule.startUI ? moment(vm.schedule.startUI).format('YYYY-MM-DD') : null;
        vm.schedule.end = vm.schedule.endUI ? moment(vm.schedule.endUI).format('YYYY-MM-DD') : null;

        vm.loading = false;

        rSchedule.update(vm.schedule, function() {
          angular.element('#modalScheduleForm').modal('hide');
          vm.loading = false;
          toastr.success('El Horario fue editado satisfactoriamente');
          $rootScope.$broadcast('schedulesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el Horario', error.data.message);
        });
      }

      function setMinDate(){
        vm.datesConfigPeriod = { minDate: vm.schedule.startUI, initDate:vm.schedule.startUI }
      }


      function toggleSelected(item){
        item.selected = item.selected ? false : true;
      }

      function removeInvalidBoarding(boarding, index){
        displayElement(vm.boardings, boarding);
        vm.schedule.invalidBoardings.splice(index, 1);
      }

      function removeBoarding(boarding){
        vm.schedule.invalidBoardings.push(boarding);

        boarding.selected = false;
        boarding.hide = true;
      }

      function addSelectedBoarding(boarding){
        vm.boardings.push({id:boarding.id, name:boarding.name});
        boarding.selected = false;
        boarding.hide = true;
      }

      function updateList(list, list2){
        angular.forEach(list, function(item){
          angular.forEach(list2, function(item2){
            if (item.id === item2.id){
              item.hide = true;
            }
          });
        });
      }

      /*function removeInvalidDropoff(dropoff, index){
        displayElement(vm.dropoffs, dropoff);
        vm.schedule.invalidDropoffs.splice(index, 1);
      }

      function removeDropoff(dropoff){
        vm.schedule.invalidDropoffs.push(dropoff);

        dropoff.selected = false;
        dropoff.hide = true;
      }

      function addSelectedDropoff(dropoff){
        vm.dropoffs.push({id:dropoff.id, name:dropoff.name});
        dropoff.selected = false;
        dropoff.hide = true;
      }*/


      function displayElement(list, element){
        angular.forEach(list, function(item){
          if (item.id === element.id){
            item.hide = false;
          }
        });
      }

      function enableAllBoardings(){
        angular.forEach(vm.boardings, function(boarding){
          boarding.hide = false;
        });
      }

      angular.element('#modalProfileForm').on('hidden.bs.modal', function () {
        enableAllBoardings();
        vm.boardings = [];
      });

      angular.element('#modalScheduleForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
        vm.filterBoardings = '';
        vm.filterInvalidBoardings = '';
      });

      angular.element('#modalScheduleForm').on('shown.bs.modal', function () {
        init();
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalRouteRateForm', tnspModalRouteRateForm);

  /* @ngInject */
  function tnspModalRouteRateForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-route-rate-form/modal-route-rate-form.html',
      controller: ModalRouteRateFormController,
      controllerAs: 'mRouteRateForm',
      bindToController: true,
      scope: {
        routeRate: '=',
        routeId: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalRouteRateFormController($log, rRouteRate, rBus, rExchange, toastr, $rootScope, ONLY_NUMBERS_PATTERN) {
      var vm = this;
      vm.type = 'create';
      vm.loading = false;
      vm.busClasses = [];
      vm.onlyNumbers = ONLY_NUMBERS_PATTERN;
      vm.exchangeRate = 1;
      vm.submitProcess = submitProcess;
      vm.rateChange = rateChange;
      vm.updateColonesRate = updateColonesRate;


      function init() {
        loadExchange();
        loadBusClasses();

        if(vm.routeRate) {
          loadRouteRate();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
          vm.routeRate = {routeId: vm.routeId};
        }
      }

      function loadRouteRate() {
        rRouteRate.query({id: vm.routeRate.id, routeId: vm.routeId}, function(result){
          vm.routeRate = result;
          vm.rateChange();
        });
      }

      function loadBusClasses() {
        rBus.getBusClasses({}, function(result){
          vm.busClasses = result.records;
        });
      }

      function loadExchange() {
        rExchange.query(function(result){
          vm.exchangeRate = result.records[0].rate
        });
      }

      function rateChange() {
        vm.routeRate.finalRateNIC = (vm.routeRate.countryRates.NIC) ?  vm.routeRate.countryRates.NIC : 0;
        vm.routeRate.finalRateNIC += (parseFloat(vm.routeRate.dollarsAdjustmentRate)) ?  parseFloat(vm.routeRate.dollarsAdjustmentRate) : 0;

        vm.routeRate.finalRateHON = (vm.routeRate.countryRates.HON) ?  vm.routeRate.countryRates.HON : 0;
        vm.routeRate.finalRateHON += (parseFloat(vm.routeRate.dollarsAdjustmentRate)) ?  parseFloat(vm.routeRate.dollarsAdjustmentRate) : 0;

        updateColonesRate();
      }

      function updateColonesRate(){
        vm.routeRate.rateColones = (vm.routeRate.countryRates.CR) ?  vm.routeRate.countryRates.CR * vm.exchangeRate : 0;


        if (parseFloat(vm.routeRate.colonesAdjustmentRate)){
          vm.routeRate.finalRateCR = vm.routeRate.rateColones + parseFloat(vm.routeRate.colonesAdjustmentRate);
        }else {
          vm.routeRate.finalRateCR = vm.routeRate.rateColones;
        }
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rRouteRate.save(vm.routeRate, function() {
          angular.element('#modalRouteRateForm').modal('hide');
          vm.loading = false;
          toastr.success('El Precio fue creado satisfactoriamente');
          $rootScope.$broadcast('routeRatesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el Precio', error.data.message);
        });
      }

      function updateProcess() {
        vm.routeRate.routeId = vm.routeId;
        rRouteRate.update(vm.routeRate, function() {
          angular.element('#modalRouteRateForm').modal('hide');
          vm.loading = false;
          toastr.success('El Precio fue editado satisfactoriamente');
          $rootScope.$broadcast('routeRatesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el Precio', error.data.message);
        });
      }

      angular.element('#modalRouteRateForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalRouteRateForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalRouteForm', tnspModalRouteForm);

  /* @ngInject */
  function tnspModalRouteForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-route-form/modal-route-form.html',
      controller: ModalRouteFormController,
      controllerAs: 'mRouteForm',
      bindToController: true,
      scope: {
        route: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalRouteFormController($log, ONLY_NUMBERS_PATTERN, INVOICE_PREFIX, rRoute, rCountry, toastr, $rootScope) {
      var vm = this;
      vm.countries = [];
      vm.routesList = [];
      vm.type = 'create';
      vm.loading = false;
      vm.onlyNumber = ONLY_NUMBERS_PATTERN;
      vm.submitProcess = submitProcess;
      vm.invoicePrefixes = INVOICE_PREFIX;

      loadCountries();

      function init() {
        loadRoutesList();

        if(vm.route) {
          loadRoute();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
          vm.route = {transfer:false, subRoutes:[{}, {}]};
        }
      }

      function loadRoute() {
        rRoute.query({id: vm.route.id}, function(result){
          vm.route = result;
        });
      }

      function loadCountries() {
        rCountry.query({}, function(result){
          vm.countries = result.records;
        });
      }

      function loadRoutesList(){
        rRoute.query({ pagesize: 150 }, function(result){
          vm.routesList = result.records;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        if (vm.route.transfer == false){
          vm.route.subRoutes = null;
        }else{
          angular.forEach(vm.route.subRoutes, function(route, index){
            route.order = index;
          });
        }
        rRoute.save(vm.route, function() {
          angular.element('#modalRouteForm').modal('hide');
          vm.loading = false;
          toastr.success('La ruta fue creado satisfactoriamente');
          $rootScope.$broadcast('routesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear la ruta', error.data.message);
        });
      }

      function updateProcess() {
        if (vm.route.transfer == false){
          vm.route.subRoutes = null;
        }else{
          angular.forEach(vm.route.subRoutes, function(route, index){
            route.order = index;
          });
        }
        rRoute.update(vm.route, function() {
          angular.element('#modalRouteForm').modal('hide');
          vm.loading = false;
          toastr.success('La ruta fue editado satisfactoriamente');
          $rootScope.$broadcast('routesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear la ruta', error.data.message);
        });
      }

      angular.element('#modalRouteForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalRouteForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalResellerForm', tnspModalResellerForm);

  /* @ngInject */
  function tnspModalResellerForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-reseller-form/modal-reseller-form.html',
      controller: ModalResellerFormController,
      controllerAs: 'mResellerForm',
      bindToController: true,
      scope: {
        reseller: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalResellerFormController(rReseller, rCountry, $log, toastr, $rootScope) {
      var vm = this;
      vm.type = 'create';
      vm.submitProcess = submitProcess;
      vm.loading = false;

      vm.countries = [];

      loadCountries();


      function init() {
        $log.info('init', vm.reseller);
        if(vm.reseller) {
          loadReseller();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
        }
      }

      function loadReseller() {
        rReseller.query({id: vm.reseller.id}, function(result){
          vm.reseller = result;
        });
      }

      function loadCountries() {
        rCountry.query({}, function(result){
          vm.countries = result.records;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rReseller.save(vm.reseller, function() {
          angular.element('#modalResellerForm').modal('hide');
          vm.loading = false;
          toastr.success('Agencia fue creada satisfactoriamente');
          $rootScope.$broadcast('resellersRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear la agencia', error.data.message);
        });
      }

      function updateProcess() {
        rReseller.update(vm.reseller, function() {
          angular.element('#modalResellerForm').modal('hide');
          toastr.success('Agencia fue editada satisfactoriamente');
          $rootScope.$broadcast('resellersRefresh');
          vm.loading = false;
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear la agencia', error.data.message);
        });
      }

      angular.element('#modalResellerForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalResellerForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalProfileForm', tnspModalProfileForm);

  /* @ngInject */
  function tnspModalProfileForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-profile-form/modal-profile-form.html',
      controller: ModalProfileFormController,
      controllerAs: 'mProfileForm',
      bindToController: true,
      scope: {
        profile: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalProfileFormController($log, rProfile, rPermission, toastr, $rootScope, $timeout) {
      var vm = this;
      vm.permissions = [];
      vm.type = 'create';
      vm.toggleSelected = toggleSelected;
      vm.removePermission = removePermission;
      vm.addSelectedPermission = addSelectedPermission;

      vm.submitProcess = submitProcess;


      loadPermissions();

      function init() {
        if(vm.profile) {
          loadProfile();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
          vm.profile = {};
          vm.profile.permissions = [];
        }
      }

      function loadProfile() {
        rProfile.query({id: vm.profile.id}, function(result){
          vm.profile = result;
          updateList(vm.permissions, vm.profile.permissions);
        });
      }

      function loadPermissions() {
        rPermission.query({pagesize: 500}, function(result){
          vm.permissions = result.records;
        });
      }

      function toggleSelected(permission){
        permission.selected = permission.selected ? false : true;
      }

      function removePermission(permission, index){
        displayElement(vm.permissions, permission);
        vm.profile.permissions.splice(index, 1);
      }

      function addSelectedPermission(permission){
        vm.profile.permissions.push({id:permission.id, name:permission.name});
        permission.selected = false;
        permission.hide = true;
      }

      function updateList(list, list2){
        angular.forEach(list, function(item){
          angular.forEach(list2, function(item2){
            if (item.id === item2.id){
              item.hide = true;
            }
          });
        });
      }

      function displayElement(list, element){
        angular.forEach(list, function(item){
          if (item.id === element.id){
            item.hide = false;
          }
        });
      }
      function enableAllPermissions(){
        angular.forEach(vm.permissions, function(permission){
          permission.hide = false;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rProfile.save(vm.profile, function() {
          angular.element('#modalProfileForm').modal('hide');
          vm.loading = false;
          toastr.success('El Perfil fue creado satisfactoriamente');
          $rootScope.$broadcast('profilesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el Perfil', error.data.message);
        });
      }

      function updateProcess() {
        rProfile.update(vm.profile, function() {
          angular.element('#modalProfileForm').modal('hide');
          vm.loading = false;
          toastr.success('El perfil fue editado satisfactoriamente');
          $rootScope.$broadcast('profilesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el perfil', error.data.message);
        });
      }

      angular.element('#modalProfileForm').on('hidden.bs.modal', function () {
        enableAllPermissions();
        vm.profile.permissions = [];
      });

      angular.element('#modalProfileForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalProfileForm').on('shown.bs.modal', function () {
        $timeout(function(){
          init();
        },10);
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalPrintTicketInvoice', tnspModalPrintTicketInvoice);

  /* @ngInject */
  function tnspModalPrintTicketInvoice() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-print-ticket-invoice/modal-print-ticket-invoice.html',
      controller: ModalPrintTicketInvoiceController,
      controllerAs: 'mTicketInvoice',
      bindToController: true,
      scope: {
        invoicesIds: '=',
        showPreview: '=',
        paymentMethod: '=',
        /* Presente solo cuando el comprobante es por una edicion de boleto:
           { originalPrice, paidDifference }. */
        editInfo: '=?'
      }
    };

    return directive;

    /* @ngInject */
    function ModalPrintTicketInvoiceController(rTicketInvoice, rTicket, moment, printService, utilsService, DATE_TIME_FORMAT, DATE_FORMAT, toastr, $rootScope, $timeout) {
      var vm = this;
      vm.print = print;
      vm.sms = sms;
      vm.dateTimeFormat = DATE_TIME_FORMAT;
      vm.dateFormat = DATE_FORMAT;
      vm.invoices = [];
      vm.now = moment();
      vm.isCortesia = false;
      vm.isOldTicket = false;

      vm.isWheelChairSeat = isWheelChairSeat;
      vm.getSeatLabel = getSeatLabel;

      function init() {
        vm.isCortesia = false //(vm.paymentMethod.id == 4 ); // 'Cortesia'
        vm.isOldTicket = false //(vm.paymentMethod.id == 6 ); // 'Boleto Antiguo';
        loadInvoices();

      }

      function loadInvoices() {
        vm.invoices = [];

        var invoiceNumbers = [];
        angular.forEach(vm.invoicesIds, function (invoice) {
          invoiceNumbers.push(invoice.invoiceNumber);
        });


        rTicketInvoice.getInvoices({ invoice: invoiceNumbers }, function (result) {
          angular.forEach(result, function (invoice) {
            invoice.timeUI = utilsService.mapToAMPM(invoice.time)
            vm.invoices.push(invoice);
          });

        });

      }

      angular.element('#modalTicketInvoice').on('shown.bs.modal', function () {
        init();
      });

      angular.element('#modalTicketInvoice').on('hidden.bs.modal', function () {
        $rootScope.$broadcast('restartTicketsEvent');
      });

      function sms() {
        angular.forEach(vm.invoicesIds, function (invoiceId) {
          rTicket.sendSMS({ id: invoiceId.invoiceNumber }, function () {
            toastr.success('SMS enviado');
            angular.element('#modalTicketInvoice').modal('hide');
          });
        });


      }

      function print(sms) {
        /* eslint-disable */
        var printContents = document.getElementById('printableArea').innerHTML;
        printService.print("printableAreaFrame", printContents);
        /* eslint-enable */

        if (sms) {
          sms();
        }

        $timeout(function () {
          angular.element('#modalTicketInvoice').modal('hide');
        }, 2000);
      }

      function isWheelChairSeat(layoutType, seatNumber) {
        return utilsService.isWheelChairSeat(layoutType, seatNumber);
      }

      function getSeatLabel(layoutType, seatNumber) {
        return utilsService.getSeatLabel(layoutType, seatNumber);
      }

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalPackingTypeForm', tnspModalPackingTypeForm);

  /* @ngInject */
  function tnspModalPackingTypeForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-packing-type-form/modal-packing-type-form.html',
      controller: ModalPackingTypeFormController,
      controllerAs: 'mPackingTypeForm',
      bindToController: true,
      scope: {
        packingType: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalPackingTypeFormController($log, rPackingType, rCountry, toastr, $rootScope, ONLY_NUMBERS_PATTERN) {
      var vm = this;
      vm.countries = [];
      vm.packingTypeClasses = [];
      vm.type = 'create';
      vm.loading = false;
      vm.submitProcess = submitProcess;
      vm.onlyNumbers = ONLY_NUMBERS_PATTERN;

      loadCountries();

      function init() {
        if(vm.packingType) {
          loadPackingType();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
          vm.packingType = {};
        }
      }

      function loadPackingType() {
        rPackingType.query({id: vm.packingType.id}, function(result){
          vm.packingType = result;
        });
      }

      function loadCountries() {
        rCountry.query({}, function(result){
          vm.countries = result.records;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rPackingType.save(vm.packingType, function() {
          angular.element('#modalPackingTypeForm').modal('hide');
          vm.loading = false;
          toastr.success('El tipo de empaque fue creado satisfactoriamente');
          $rootScope.$broadcast('packingTypesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el empaque', error.data.message);
        });
      }

      function updateProcess() {
        rPackingType.update(vm.packingType, function() {
          angular.element('#modalPackingTypeForm').modal('hide');
          vm.loading = false;
          toastr.success('El tipo de empaque fue editado satisfactoriamente');
          $rootScope.$broadcast('packingTypesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el empaque', error.data.message);
        });
      }

      angular.element('#modalPackingTypeForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalPackingTypeForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .directive("tnspModalOpenCashRegisterForm", tnspModalOpenCashRegisterForm);

  /* @ngInject */
  function tnspModalOpenCashRegisterForm() {
    var directive = {
      restrict: "E",
      templateUrl:
        "app/components/modal-open-cash-register-form/modal-open-cash-register-form.html",
      controller: ModalOpenCashRegisterFormController,
      controllerAs: "mOpenCashRegisterForm",
      bindToController: true
    };

    return directive;

    /* @ngInject */
    function ModalOpenCashRegisterFormController(
      rCashRegister,
      rUser,
      toastr,
      ONLY_NUMBERS_PATTERN,
      authenticationService,
      $rootScope
    ) {
      var vm = this;
      var loggedUser = authenticationService.getUserInfo();
      vm.loading = false;
      vm.submitProcess = submitProcess;
      vm.onlyNumbers = ONLY_NUMBERS_PATTERN;
      vm.terminalId = loggedUser.terminal.id;

      function init() {
        loadCashRegisters();
        vm.openCashRegister = { terminalId: vm.terminalId };
      }

      function loadCashRegisters() {
        rUser.getMyCashiers({}, function (result) {
          if (result.length > 0) {
            vm.cashRegisters = result;
            vm.openCashRegister.cashRegisterId = result[0].id;
          } else {
            rCashRegister.query(
              { terminalId: vm.terminalId, pagesize: 500 },
              function (result) {
                vm.cashRegisters = result.records;
              }
            );
          }
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if (!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        openProcess();
      }

      function openProcess() {
        rCashRegister.open(
          vm.openCashRegister,
          function () {
            angular.element("#modalOpenCashRegisterForm").modal("hide");
            vm.loading = false;
            toastr.success(
              "La Caja Registradora fue abierta satisfactoriamente"
            );
            authenticationService.refreshUserInfo(loggedUser.id);
            $rootScope.$broadcast("tillRefresh");
          },
          function (error) {
            vm.loading = false;
            toastr.error(
              "Hubo un error al abrir la Caja Registradora",
              error.data.message
            );
          }
        );
      }

      angular
        .element("#modalOpenCashRegisterForm")
        .on("show.bs.modal", function () {
          vm.submitAttempt = false;
        });

      angular
        .element("#modalOpenCashRegisterForm")
        .on("shown.bs.modal", function () {
          init();
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalGenerateTripForm', tnspModalGenerateTripForm);

  /* @ngInject */
  function tnspModalGenerateTripForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-generate-trip-form/modal-generate-trip-form.html',
      controller: ModalGenerateTripController,
      controllerAs: 'mTripForm',
      bindToController: true,
      scope: {
        schedule: '=',
        routeId: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalGenerateTripController(
      rSchedule,
      rBus,
      toastr,
      moment
    ) {
      var vm = this,
        minDate = new Date();

      vm.openStartDate = openStartDate;
      vm.openEndDate = openEndDate;

      vm.loading = false;

      vm.submitProcess = submitProcess;
      vm.dateConfig = { minDate: minDate};
      vm.addDate = addDate;
      vm.tripDates = [{ dateUI: '', date: '', open: false }];

      vm.startDate = '';
      vm.endDate = '';

      vm.busId = '';
      vm.buses = [];

      function init() {
        loadBuses();
      }

      function loadBuses() {
        rBus.query({ pagesize: 500 }, function(result){
          vm.buses = result.records;
        });
      }

      function addDate() {
        vm.tripDates.push({ dateUI: '', date: '', open: false });
      }

      function submitProcess(form) {
        vm.loading = true;
        vm.submitAttempt = true;

        if (!form.$valid || (vm.endDate < vm.startDate ) ) {
          vm.loading = false;
          toastr.error('Debe agregar un rango de fechas valido');
          return;
        }

        var currentDate = moment(vm.startDate);
        var datesArray = [];
        while (currentDate <= vm.endDate){
          datesArray.push(moment(currentDate).format('YYYY-MM-DD'));
          currentDate = currentDate.add(1, 'day');
        }

        generateTrip(datesArray);
      }

      function generateTrip(dates) {
        var body = prepareBody(dates);

          rSchedule.generateTrips(
            body,
            function () {
              angular.element('#modalGenerateTripForm').modal('hide');
              vm.loading = false;
              toastr.success('Los Viajes fueron creados satisfactoriamente');
            },
            function (error) {
              vm.loading = false;
              toastr.error(
                'Hubo un error al generar viajes',
                error.data.message
              );
            }
          );
      }

      function prepareBody(dates) {
        var body = {
          routeId: vm.routeId,
          id: vm.schedule.id,
          tripDates: dates,
          busId: vm.busId
        };

        /*angular.forEach(vm.tripDates, function (dateObj) {
          if (dateObj.dateUI) {
            body.tripDates.push(moment(dateObj.dateUI).format('YYYY-MM-DD'));
          }
        });*/

        return body;
      }

      function openStartDate() {
        vm.showStartCalendar = true;
      }

      function openEndDate() {
        vm.showEndCalendar = true;
      }

      angular
        .element('#modalGenerateTripForm')
        .on('show.bs.modal', function () {
          vm.submitAttempt = false;
          vm.tripDates = [{ dateUI: '', date: '', open: false }];
          vm.startDate = '';
          vm.endDate = ''
        });

      angular
        .element('#modalGenerateTripForm')
        .on('shown.bs.modal', function () {
          init();
        });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalExtCodeForm', tnspModalExtCodeForm);

  /* @ngInject */
  function tnspModalExtCodeForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-ext-code-form/modal-ext-code-form.html',
      controller: ModalExtCodeFormController,
      controllerAs: 'mExtCodeForm',
      bindToController: true,
      scope: {
        extCode: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalExtCodeFormController(rExternalCode, rUser, toastr, $rootScope, $timeout) {
      var vm = this;
      vm.type = 'create';
      vm.submitProcess = submitProcess;
      vm.userList = [];


      function init() {
        loadUsers();
        if(vm.extCode) {
          loadExtCode();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
          vm.extCode = {};
        }
      }

      function loadExtCode() {
        rExternalCode.query({id: vm.extCode.id}, function(result){
          vm.extCode = result;
        });
      }

      function loadUsers(){
        rUser.query({pagesize: 200}, function(result){
          vm.userList = result.records;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rExternalCode.save(vm.extCode, function(result) {
          vm.extCode = result;
          angular.element('#modalExtCodeForm').modal('hide');
          vm.loading = false;
          toastr.success('El Código externo fue creado satisfactoriamente');
          $rootScope.$broadcast('extCodeRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el Código Externo', error.data.message);
        });
      }

      function updateProcess() {
        rExternalCode.update(vm.extCode, function() {
          angular.element('#modalExtCodeForm').modal('hide');
          vm.loading = false;
          toastr.success('El Código externo fue editado satisfactoriamente');
          $rootScope.$broadcast('extCodeRefresh');
        }, function(error){
          toastr.error('Hubo un error al actualizar el Código Externo', error.data.message);
          vm.loading = false;
        });
      }

      angular.element('#modalExtCodeForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalExtCodeForm').on('shown.bs.modal', function () {
        $timeout(function(){
          init();
        },10);
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalExchangeForm', tnspModalExchangeForm);

  /* @ngInject */
  function tnspModalExchangeForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-exchange-form/modal-exchange-form.html',
      controller: ModalExchangeFormController,
      controllerAs: 'mExchangeForm',
      bindToController: true,
      scope: {
        exchange: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalExchangeFormController(rExchange, rCurrency, $log, toastr, $rootScope) {
      var vm = this;
      vm.type = 'create';
      vm.submitProcess = submitProcess;
      vm.loading = false;

      vm.countries = [];

      loadCurrencies();


      function init() {
        $log.info('init', vm.exchange);
        if(vm.exchange) {
          loadExchange();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
        }
      }

      function loadExchange() {
        rExchange.query({id: vm.exchange.id}, function(result){
          vm.exchange = result;
        });
      }

      function loadCurrencies() {
        rCurrency.query({}, function(result){
          vm.currencies = result.records;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid || !(vm.exchange.from.id !== vm.exchange.to.id)) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rExchange.save(vm.exchange, function() {
          angular.element('#modalExchangeForm').modal('hide');
          vm.loading = false;
          toastr.success('Tipo de Cambio fue creado satisfactoriamente');
          $rootScope.$broadcast('exchangeRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el tipo de cambio', error.data.message);
        });
      }

      function updateProcess() {
        rExchange.update(vm.exchange, function() {
          angular.element('#modalExchangeForm').modal('hide');
          toastr.success('Tipo de cambio fue editado satisfactoriamente');
          $rootScope.$broadcast('exchangeRefresh');
          vm.loading = false;
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el tipo de cambio', error.data.message);
        });
      }

      angular.element('#modalExchangeForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalExchangeForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .directive("tnspModalDollarExchangeForm", tnspModalDollarExchangeForm);

  /* @ngInject */
  function tnspModalDollarExchangeForm() {
    var directive = {
      restrict: "E",
      templateUrl:
        "app/components/modal-dollar-exchange-form/modal-dollar-exchange-form.html",
      controller: ModalDollarExchangeFormController,
      controllerAs: "mDollarExchangeForm",
      bindToController: true,
    };

    return directive;

    /* @ngInject */
    function ModalDollarExchangeFormController(
      rDollarExchange,
      $log,
      toastr,
      $rootScope
    ) {
      var vm = this;
      vm.type = "create";
      vm.submitProcess = submitProcess;
      vm.loading = false;

      function submitProcess(form) {
        vm.loading = true;
        if (!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        createProcess();
      }

      function createProcess() {
        rDollarExchange.save(
          vm.dollarExchange,
          function () {
            angular.element("#modalDollarExchangeForm").modal("hide");
            vm.loading = false;
            toastr.success("Tipo de Cambio fue creado satisfactoriamente");
            $rootScope.$broadcast("dollarExchangeRefresh");
          },
          function (error) {
            vm.loading = false;
            toastr.error(
              "Hubo un error al crear el tipo de cambio",
              error.data.message
            );
          }
        );
      }

      angular
        .element("#modalDollarExchangeForm")
        .on("show.bs.modal", function () {
          vm.submitAttempt = false;
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalCountryForm', tnspModalCountryForm);

  /* @ngInject */
  function tnspModalCountryForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-country-form/modal-country-form.html',
      controller: ModalCountryFormController,
      controllerAs: 'mCountryForm',
      bindToController: true,
      scope: {
        country: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalCountryFormController($log, rCountry, rCurrency, toastr, $rootScope, ONLY_NUMBERS_PATTERN) {
      var vm = this;
      vm.currencies = [];
      vm.type = 'create';
      vm.loading = false;
      vm.submitProcess = submitProcess;
      vm.onlyNumbers = ONLY_NUMBERS_PATTERN;

      loadCurrencies();

      function init() {
        if(vm.country) {
          loadCountry();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
          vm.country = {};
        }
      }

      function loadCountry() {
        rCountry.query({id: vm.country.id}, function(result){
          vm.country = result;
        });
      }

      function loadCurrencies() {
        rCurrency.query({}, function(result){
          vm.currencies = result.records;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rCountry.save(vm.country, function() {
          angular.element('#modalCountryForm').modal('hide');
          vm.loading = false;
          toastr.success('El país fue creado satisfactoriamente');
          $rootScope.$broadcast('countriesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el país', error.data.message);
        });
      }

      function updateProcess() {
        rCountry.update(vm.country, function() {
          angular.element('#modalCountryForm').modal('hide');
          vm.loading = false;
          toastr.success('El país fue editado satisfactoriamente');
          $rootScope.$broadcast('countriesRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el país', error.data.message);
        });
      }

      angular.element('#modalCountryForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalCountryForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  "use strict";

  angular.module("tnsp").directive("tnspModalConfigForm", tnspModalConfigForm);

  /* @ngInject */
  function tnspModalConfigForm() {
    var directive = {
      restrict: "E",
      templateUrl: "app/components/modal-config-form/modal-config-form.html",
      controller: ModalConfigFormController,
      controllerAs: "mConfigForm",
      bindToController: true
    };

    return directive;

    /* @ngInject */
    function ModalConfigFormController(rConfig, $log, toastr) {
      var vm = this;

      vm.loading = false;
      vm.submitProcess = submitProcess;

      vm.publicEditTime = null;

      function init() {
        loadConfig();
      }

      function loadConfig() {
        rConfig.query({ id: "PUBLIC_EDIT_TIME" }, function (result) {
          $log.info(result);
          vm.publicEditTime = result.value;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if (!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }

        updateProcess();
      }

      function updateProcess() {
        rConfig.update(
          { id: "PUBLIC_EDIT_TIME", value: vm.publicEditTime },

          function () {
            angular.element("#modalConfigForm").modal("hide");
            vm.loading = false;
            toastr.success("Configuración Actualizada correctamente");
          },
          function (error) {
            vm.loading = false;
            toastr.error(
              "Hubo un error al actualizar la configuración",
              error.data.message
            );
          }
        );
      }

      angular.element("#modalConfigForm").on("show.bs.modal", function () {
        vm.submitAttempt = false;
      });

      angular.element("#modalConfigForm").on("shown.bs.modal", function () {
        init();
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .directive(
      "tnspModalCloseCashRegisterForm",
      tnspModalCloseCashRegisterForm
    );

  /* @ngInject */
  function tnspModalCloseCashRegisterForm() {
    var directive = {
      restrict: "E",
      templateUrl:
        "app/components/modal-close-cash-register-form/modal-close-cash-register-form.html",
      controller: ModalCloseCashRegisterFormController,
      controllerAs: "mCloseCashRegisterForm",
      bindToController: true,
    };

    return directive;

    /* @ngInject */
    function ModalCloseCashRegisterFormController(
      rCashRegister,
      rUser,
      toastr,
      $rootScope,
      $log,
      authenticationService,
      SweetAlert
    ) {
      var vm = this;
      var loggedUser = authenticationService.getUserInfo();
      $log.info(loggedUser);

      vm.submitProcess = submitProcess;
      vm.terminalId = loggedUser.terminal.id;

      vm.differences = {
        adjustments: 0,
        income: 0,
        outcome: 0,
        dollars: 0,
        colones: 0,
      };

      vm.calculateDifferences = calculateDifferences;

      function init() {
        loadCashRegisterBalance();
        vm.closeCashRegister = { terminalId: vm.terminalId, id: loggedUser.openCash.id };
      }

      function calculateDifferences() {
        if (!vm.closeCashRegister || !vm.cashRegisterBalance) {
          return;
        }

        // Calculate adjustments difference
        var reportedAdjustments =
          parseFloat(vm.closeCashRegister.reportedAdjustments) || 0;
        var systemAdjustments =
          parseFloat(vm.cashRegisterBalance.adjustments) || 0;
        vm.differences.adjustments = reportedAdjustments - systemAdjustments;

        // Calculate income difference
        var reportedIncome =
          parseFloat(vm.closeCashRegister.reportedIncome) || 0;
        var systemIncome = parseFloat(vm.cashRegisterBalance.income) || 0;
        vm.differences.income = reportedIncome - systemIncome;

        // Calculate outcome difference
        var reportedEgress =
          parseFloat(vm.closeCashRegister.reportedEgress) || 0;
        var systemOutcome = parseFloat(vm.cashRegisterBalance.outcome) || 0;
        vm.differences.outcome = reportedEgress - systemOutcome;

        // Calculate dollars difference
        var reportedDollars =
          parseFloat(vm.closeCashRegister.totalDollarsHandedOver) || 0;
        var systemDollars =
          parseFloat(vm.cashRegisterBalance.dollarsReceived) || 0;
        vm.differences.dollars = reportedDollars - systemDollars;

        // Calculate colones difference
        var reportedColones =
          parseFloat(vm.closeCashRegister.totalColonesHandedOver) || 0;
        var systemColones =
          parseFloat(vm.cashRegisterBalance.totalBalance) || 0;
        vm.differences.colones = reportedColones - systemColones;
      }

      function loadCashRegisterBalance() {
        rCashRegister.currentMovements(
          {
            cashRegisterId: loggedUser.openCash.id,
            terminalId: loggedUser.terminal.id,
          },
          function (result) {
            vm.cashRegisterBalance = result;
            //splitTickets();
            calculateDifferences();
          }
        );
      }

      function submitProcess(form) {
        vm.loading = true;
        if (!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }

        // Check if there are any differences
        if (hasDifferences()) {
          vm.loading = false;
          SweetAlert.swal(
            {
              title: "",
              text: "El cierre de caja no cerro perfecto sobra o falta dinero desea continuar ?",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Si",
              cancelButtonText: "No",
              closeOnConfirm: true,
              closeOnCancel: true,
              allowEscapeKey: false,
            },
            function (isConfirm) {
              if (isConfirm) {
                vm.loading = true;
                closeProcess();
              }
            }
          );
        } else {
          closeProcess();
        }
      }

      function hasDifferences() {
        if (!vm.differences) {
          return false;
        }
        return (
          vm.differences.adjustments < 0 ||
          vm.differences.income < 0 ||
          vm.differences.outcome < 0 ||
          vm.differences.dollars < 0 ||
          vm.differences.colones < 0
        );
      }

      function closeProcess() {
        rCashRegister.close(
          vm.closeCashRegister,
          function () {
            angular.element("#modalCloseCashRegisterForm").modal("hide");
            vm.loading = false;
            toastr.success(
              "La Caja Registradora fue cerrada satisfactoriamente"
            );
            authenticationService.refreshUserInfo(loggedUser.id);
            $rootScope.$broadcast("tillRefresh");
          },
          function (error) {
            vm.loading = false;
            toastr.error(
              "Hubo un error al cerrar la Caja Registradora",
              error.data.message
            );
          }
        );
      }

      angular
        .element("#modalCloseCashRegisterForm")
        .on("show.bs.modal", function () {
          vm.submitAttempt = false;
        });

      angular
        .element("#modalCloseCashRegisterForm")
        .on("shown.bs.modal", function () {
          init();
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalClientForm', tnspModalClientForm);

  /* @ngInject */
  function tnspModalClientForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-client-form/modal-client-form.html',
      controller: ModalClientController,
      controllerAs: 'mClientForm',
      bindToController: true,
      scope: {
        client: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalClientController(rClient, toastr, $rootScope, $timeout, rUser,rNationality, CIVIL_STATUS, GENRES) {
      var vm = this;
      vm.identificationTypes = [];
      vm.civilStatues = CIVIL_STATUS;
      vm.genres = GENRES;
      vm.type = 'create';
      vm.submitProcess = submitProcess;
      vm.openIECalendar = openIECalendar;
      vm.openBDCalendar = openBDCalendar;

      vm.disableFields = false;

      loadIdentificationTypes();
      loadNationalities();

      function init() {
        if(vm.client) {
          loadClient();
          vm.type = 'edit';
          if (vm.client.originEdit && vm.client.originEdit === 'checks'){
            vm.disableFields = true;
          }
        }else{
          vm.type = 'create';
          vm.client = {};
        }
      }

      function loadClient() {
        rClient.query({id: vm.client.id}, function(result){
          vm.client = result;
        });
      }

      function loadIdentificationTypes() {
        rUser.getIdentificationTypes({}, function(result){
          vm.identificationTypes = result;
        });
      }

      function loadNationalities() {
        rNationality.query({}, function(result){
          vm.nationalities = result;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rClient.save(vm.client, function() {
          angular.element('#modalClientForm').modal('hide');
          vm.loading = false;
          toastr.success('El Cliente fue creado satisfactoriamente');
          $rootScope.$broadcast('clientCreated');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el cliente', error.data.message);
        });
      }

      function updateProcess() {
        rClient.update(vm.client, function() {
          angular.element('#modalClientForm').modal('hide');
          toastr.success('El cliente fue editado satisfactoriamente');
          $rootScope.$broadcast('clientUpdated');
          vm.loading = false;
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al editar el cliente', error.data.message);
        });
      }

      function openIECalendar(){
        vm.showIECalendar = true;
      }
      function openBDCalendar(){
        vm.showBDCalendar = true;
      }

      angular.element('#modalClientForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalClientForm').on('shown.bs.modal', function () {
        $timeout(function(){
          init();
        },10);
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalChecksLoadForm', tnspModalChecksLoadForm);

  /* @ngInject */
  function tnspModalChecksLoadForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-checks-load-form/modal-checks-load-form.html',
      controller: ModalChecksLoadFormController,
      controllerAs: 'mChecksLoadForm',
      bindToController: true,
      scope: {
        ticket: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalChecksLoadFormController($timeout, rPackingType, rTicket, authenticationService, printService, LUGGAGE_PAYMENT_TYPES, toastr, moment) {
      var vm = this;
      vm.loading = false;
      vm.packingTypesList = [];
      vm.luggage = [];
      vm.luggageList = [];
      vm.paymentTypes = LUGGAGE_PAYMENT_TYPES;
      vm.now = moment();
      vm.newLuggage = {};
      vm.newFreeLuggage = {};
      vm.totalToPay = 0;
      vm.userInfo = authenticationService.getUserInfo();

      vm.submitProcess = submitProcess;
      vm.addLuggage = addLuggage;
      vm.addFreeLuggage = addFreeLuggage;
      vm.removeLuggage = removeLuggage;
      vm.calcDifference  = calcDifference;
      vm.resetNewLuggage = resetNewLuggage;

      function init() {
        vm.luggage = [];
        vm.totalToPay = 0;
        vm.amount = '';
        vm.difference = '';

        calcTotal();
        calcDifference();
        loadPackingTypes();
        loadRegisteredLuggage();
      }

      function loadPackingTypes(){
        rPackingType.query({pagesize:500, country:vm.userInfo.terminal.country.id}, function(result){
          vm.packingTypesList  = result.records;
        });
      }

      function loadRegisteredLuggage(){
        rTicket.getLuggage({id:vm.ticket.invoiceNumber}, function(result){
          vm.luggageList  = result;
        });
      }

      function resetNewLuggage (item) {
        vm.newLuggage = {};
        vm.newLuggage = angular.copy(item);
      }

      function addLuggage(){
        if(vm.newLuggage.name && (vm.newLuggage.billableRate || vm.newLuggage.billableRate > -1 ) && vm.newLuggage.serial){
          if(vm.newLuggage.billableRate == 0){
            vm.newLuggage.includedOnTicket = true;
          }
          vm.luggage.push(vm.newLuggage);
          vm.newLuggage = {};
          calcTotal();
        }
      }
      function addFreeLuggage(){
        if(vm.newFreeLuggage.name && (vm.newFreeLuggage.billableRate || vm.newFreeLuggage.billableRate > -1 ) && vm.newFreeLuggage.serial){
          vm.newFreeLuggage.includedOnTicket = true;
          vm.luggage.push(vm.newFreeLuggage);
          vm.newFreeLuggage = {};
          calcTotal();
        }
      }
      function removeLuggage(index){
        vm.luggage.splice(index, 1);
        calcTotal();
      }

      function calcTotal(){
         var total = 0;
        angular.forEach(vm.luggage, function(luggage){
          total =  parseFloat(total) + parseFloat(luggage.billableRate);
        });

        vm.totalToPay = total;
      }

      function calcDifference(){
        if (vm.totalToPay && vm.totalToPay > 0){
          vm.difference = (vm.totalToPay - vm.amount );
        }
      }
      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid || vm.luggage.length < 1) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        checksLoadProcess();
      }

      function checksLoadProcess() {
        var luggage = {id:vm.ticket.invoiceNumber, luggage:vm.luggage};
        luggage.paymentTypes = vm.paymentType ?  [{paymentType: vm.paymentType.name, amount:vm.totalToPay}] : [];


        rTicket.registerLuggage(luggage, function(result){
          vm.registerLuggage = result;
          vm.loading = false;
          toastr.success('Equipaje agregado Correctamente', 'Imprima su Factura');
          $timeout(function(){
            print();
          },100);
        }, function(error){
          vm.loading = false;
          toastr.error(error.data.message, 'Error al registar Equipaje')
        });
      }

      function print() {


        $timeout(function(){
          /* eslint-disable */
          var printContents = document.getElementById('printableArea').innerHTML;
          printService.print("printableAreaFrame", printContents);
          /* eslint-enable */
        }, 100);

        $timeout(function(){
          angular.element('#modalChecksLoadForm').modal('hide');
        }, 3000);
      }

      angular.element('#modalChecksLoadForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalChecksLoadForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .directive("tnspModalCashRegisterForm", tnspModalCashRegisterForm);

  /* @ngInject */
  function tnspModalCashRegisterForm() {
    var directive = {
      restrict: "E",
      templateUrl:
        "app/components/modal-cash-register-form/modal-cash-register-form.html",
      controller: ModalCashRegisterFormController,
      controllerAs: "mCashRegisterForm",
      bindToController: true,
      scope: {
        cashRegister: "=",
        terminalId: "="
      }
    };

    return directive;

    /* @ngInject */
    function ModalCashRegisterFormController(
      rUser,
      rCashRegister,
      toastr,
      $rootScope
    ) {
      var vm = this;
      vm.type = "create";
      vm.loading = false;
      vm.submitProcess = submitProcess;
      vm.users = [];

      function init() {
        loadUsers();
        if (vm.cashRegister) {
          loadCashRegister();
          vm.type = "edit";
        } else {
          vm.type = "create";
          vm.cashRegister = { terminalId: vm.terminalId, user: {} };
        }
      }

      function loadCashRegister() {
        rCashRegister.query(
          { id: vm.cashRegister.id, terminalId: vm.terminalId },
          function (result) {
            vm.cashRegister = result;
          }
        );
      }

      function submitProcess(form) {
        vm.loading = true;
        if (!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if (vm.type === "create") {
          createProcess();
        } else {
          updateProcess();
        }
      }

      function createProcess() {
        rCashRegister.save(
          vm.cashRegister,
          function () {
            angular.element("#modalCashRegisterForm").modal("hide");
            vm.loading = false;
            toastr.success(
              "La Caja Registradora fue creado satisfactoriamente"
            );
            $rootScope.$broadcast("cashRegistersRefresh");
          },
          function (error) {
            vm.loading = false;
            toastr.error(
              "Hubo un error al crear la Caja Registradora",
              error.data.message
            );
          }
        );
      }

      function updateProcess() {
        vm.cashRegister.terminalId = vm.terminalId;
        rCashRegister.update(
          vm.cashRegister,
          function () {
            angular.element("#modalCashRegisterForm").modal("hide");
            vm.loading = false;
            toastr.success(
              "La Caja Registradora fue editado satisfactoriamente"
            );
            $rootScope.$broadcast("cashRegistersRefresh");
          },
          function (error) {
            vm.loading = false;
            toastr.error(
              "Hubo un error al crear la Caja Registradora",
              error.data.message
            );
          }
        );
      }

      function loadUsers() {
        rUser.query({ pagesize: 500 }, function (result) {
          vm.users = result.records;
        });
      }

      angular
        .element("#modalCashRegisterForm")
        .on("show.bs.modal", function () {
          vm.submitAttempt = false;
        });

      angular
        .element("#modalCashRegisterForm")
        .on("shown.bs.modal", function () {
          init();
        });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .directive("tnspModalCashRegisterBalance", tnspModalCashRegisterBalance);

  /* @ngInject */
  function tnspModalCashRegisterBalance() {
    var directive = {
      restrict: "E",
      templateUrl:
        "app/components/modal-cash-register-balance/modal-cash-register-balance.html",
      controller: ModalCashRegisterBalanceController,
      controllerAs: "mCashRegisterBalance",
      bindToController: true,
      scope: {
        cashRegister: "=",
        terminal: "=",
        balance: "=",
        current: "="
      }
    };

    return directive;

    /* @ngInject */
    function ModalCashRegisterBalanceController(
      $log,
      rCashRegister,
      printService,
      authenticationService
    ) {
      var vm = this;
      vm.loading = false;

      vm.print = print;

      vm.ticketListCR = [];
      vm.ticketListNY = [];

      function init() {
        loadCashRegister();
      }

      function loadCashRegister() {
        if (!vm.current) {
          rCashRegister.balances(
            {
              cashRegisterId: vm.cashRegister.id,
              terminalId: vm.terminal.id,
              id: vm.balance.id
            },
            function (result) {
              $log.info(result);
              vm.cashRegisterBalance = result;
              splitTickets();
            }
          );
        } else {
          var currentInfo = authenticationService.getUserInfo();
          rCashRegister.currentMovements(
            {
              cashRegisterId: currentInfo.openCash.id,
              terminalId: currentInfo.terminal.id
            },
            function (result) {
              vm.cashRegisterBalance = result;
              splitTickets();
            }
          );
        }
      }

      function splitTickets() {
        vm.ticketListCR = [];
        vm.ticketListNY = [];
        for (var i = 0; i < vm.cashRegisterBalance.ticketList.length; i++) {
          if (vm.cashRegisterBalance.ticketList[i].invoiceType === "CR") {
            vm.ticketListCR.push(vm.cashRegisterBalance.ticketList[i]);
          } else {
            vm.ticketListNY.push(vm.cashRegisterBalance.ticketList[i]);
          }
        }
      }

      function print() {
        /* eslint-disable */
        var printContents = document.getElementById("printableArea").innerHTML;
        printService.print("printableAreaFrame", printContents);
        /* eslint-enable */

        angular.element("#modalCashRegisterBalance").modal("hide");
      }

      angular
        .element("#modalCashRegisterBalance")
        .on("shown.bs.modal", function () {
          init();
        });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("tnsp")
    .directive("tnspModalBuyDollarsForm", tnspModalBuyDollarsForm);

  /* @ngInject */
  function tnspModalBuyDollarsForm() {
    var directive = {
      restrict: "E",
      templateUrl:
        "app/components/modal-buy-dollars-form/modal-buy-dollars-form.html",
      controller: ModalBuyDollarsFormController,
      controllerAs: "mBuyDollarsForm",
      scope: {},
      bindToController: true,
    };

    return directive;

    /* @ngInject */
    function ModalBuyDollarsFormController(
      rExchangeTransaction,
      rDollarExchange,
      toastr,
      $rootScope
    ) {
      var vm = this;
      vm.today = moment().format("DD/MM/YYYY");
      vm.exchangeRate = 0;
      vm.dollarExchange = {};
      vm.submitProcess = submitProcess;
      vm.calculateTotal = calculateTotal;
      vm.loading = false;

      function calculateTotal() {
        if (vm.dollarExchange.dollarsReceived && vm.exchangeRate) {
          vm.dollarExchange.calculation =
            parseFloat(vm.dollarExchange.dollarsReceived) *
            parseFloat(vm.exchangeRate);
        } else {
          vm.dollarExchange.calculation = 0;
        }
      }

      function submitProcess(form) {
        vm.loading = true;
        if (!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        exchangeTransactionProcess();
      }

      function exchangeTransactionProcess() {
        rExchangeTransaction.buyDollars(
          vm.dollarExchange,
          function () {
            angular.element("#modalBuyDollarsForm").modal("hide");
            vm.loading = false;
            toastr.success("Compra de dolares satisfactoria");
            $rootScope.$broadcast("exchangeTransactionRefresh");
          },
          function (error) {
            vm.loading = false;
            toastr.error(
              "Hubo un error al comprar dolares",
              error.data.message
            );
          }
        );
      }

      function loadExchangeRate() {
        rDollarExchange.latest({}, function (result) {
          if (result && result.rate) {
            vm.exchangeRate = result.rate;
            // Recalculate if amount is already entered
            calculateTotal();
          }
        });
      }

      function init() {
        loadExchangeRate();
      }

      init();

      angular.element("#modalBuyDollarsForm").on("show.bs.modal", function () {
        vm.submitAttempt = false;
        vm.dollarExchange = {};
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalBusForm', tnspModalBusForm);

  /* @ngInject */
  function tnspModalBusForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-bus-form/modal-bus-form.html',
      controller: ModalBusFormController,
      controllerAs: 'mBusForm',
      bindToController: true,
      scope: {
        bus: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalBusFormController(rBus, rCountry, toastr, $rootScope, ONLY_NUMBERS_PATTERN, BUS_LAYOUTS) {
      var vm = this;
      vm.countries = [];
      vm.busClasses = [];
      vm.type = 'create';
      vm.loading = false;
      vm.submitProcess = submitProcess;
      vm.onlyNumbers = ONLY_NUMBERS_PATTERN;
      vm.layoutTypes = BUS_LAYOUTS;

      loadCountries();
      loadBusClasses();

      function init() {
        if (vm.bus) {
          loadBus();
          vm.type = 'edit';
        } else {
          vm.type = 'create';
          vm.bus = {};
        }
      }

      function loadBus() {
        rBus.query({ id: vm.bus.id }, function (result) {
          vm.bus = result;
        });
      }

      function loadCountries() {
        rCountry.query({}, function (result) {
          vm.countries = result.records;
        });
      }

      function loadBusClasses() {
        rBus.getBusClasses({}, function (result) {
          vm.busClasses = result.records;
        }, function () {
          toastr.error('No se encontró un cliente con esa identificación');
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if (!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if (vm.type === 'create') {
          createProcess()
        } else {
          updateProcess()
        }
      }

      function createProcess() {
        rBus.save(vm.bus, function () {
          angular.element('#modalBusForm').modal('hide');
          vm.loading = false;
          toastr.success('El bus fue creado satisfactoriamente');
          $rootScope.$broadcast('busesRefresh');
        }, function (error) {
          vm.loading = false;
          toastr.error('Hubo un error al crear el bus', error.data.message);
        });
      }

      function updateProcess() {
        rBus.update(vm.bus, function () {
          angular.element('#modalBusForm').modal('hide');
          vm.loading = false;
          toastr.success('El bus fue editado satisfactoriamente');
          $rootScope.$broadcast('busesRefresh');
        }, function (error) {
          vm.loading = false;
          toastr.error('Hubo un error al crear el bus', error.data.message);
        });
      }

      angular.element('#modalBusForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalBusForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalBoardingForm', tnspModalBoardingForm);

  /* @ngInject */
  function tnspModalBoardingForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-boarding-form/modal-boarding-form.html',
      controller: ModalBoardingFormController,
      controllerAs: 'mBoardingForm',
      bindToController: true,
      scope: {
        boarding: '=',
        routeId: '='
      }
    };

    return directive;

    /* @ngInject */
    function ModalBoardingFormController($log, rBoarding, toastr, $rootScope) {
      var vm = this;
      vm.type = 'create';
      vm.loading = false;
      vm.submitProcess = submitProcess;

      function init() {
        if(vm.boarding) {
          loadBoarding();
          vm.type = 'edit';
        }else{
          vm.type = 'create';
          vm.boarding = {routeId: vm.routeId};
        }
      }

      function loadBoarding() {
        rBoarding.query({id: vm.boarding.id, routeId: vm.routeId}, function(result){
          $log.info(result);
          vm.boarding = result;
        });
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        if(vm.type === 'create') {
          createProcess()
        }else{
          updateProcess()
        }
      }

      function createProcess() {
        rBoarding.save(vm.boarding, function() {
          angular.element('#modalBoardingForm').modal('hide');
          vm.loading = false;
          toastr.success('El Abordaje fue creado satisfactoriamente');
          $rootScope.$broadcast('boardingsRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el Abordaje', error.data.message);
        });
      }

      function updateProcess() {
        vm.boarding.routeId = vm.routeId;
        rBoarding.update(vm.boarding, function() {
          angular.element('#modalBoardingForm').modal('hide');
          vm.loading = false;
          toastr.success('El Abordaje fue editado satisfactoriamente');
          $rootScope.$broadcast('boardingsRefresh');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al crear el Abordaje', error.data.message);
        });
      }

      angular.element('#modalBoardingForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalBoardingForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalAddMovementForm', tnspModalAddMovementForm);

  /* @ngInject */
  function tnspModalAddMovementForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-add-movement-form/modal-add-movement-form.html',
      controller: ModalAddMovementFormController,
      controllerAs: 'mAddMovementForm',
      bindToController: true
    };

    return directive;

    /* @ngInject */
    function ModalAddMovementFormController($log, rCashRegister, toastr, $rootScope, authenticationService) {
      var vm = this;
      var loggedUser = authenticationService.getUserInfo();
      var allAuthInfo = authenticationService.getAllAuthInfo();
      vm.submitProcess = submitProcess;
      vm.terminalId = loggedUser.terminal.id;
      vm.userInfo = allAuthInfo.userInfo;

      vm.additionalEgressFieldNeededs = null;
      vm.additionalIncomeFieldNeededs = null;
      vm.transactionTypeIncomeExpense = [8, 9];

      vm.isSingleLineDetail = isSingleLineDetail;
      vm.cleanDetail = cleanDetail;

      function init() {
        loadCashRegisters();
        loadtransactionTypes();
        vm.addMovement = { terminalId: vm.terminalId };
      }

      function loadCashRegisters() {
        rCashRegister.query({ terminalId: vm.terminalId, pagesize: 500 }, function (result) {
          vm.cashRegisters = result.records;
        });
      }

      function loadtransactionTypes() {
        rCashRegister.transactionTypes({}, function (result) {
          vm.transactionTypes = result;
          vm.additionalEgressFieldNeededs = vm.transactionTypes.find(function (tt) { return tt.name.toLowerCase().includes('egreso') }).id;
          vm.additionalIncomeFieldNeededs = vm.transactionTypes.find(function (tt) { return tt.name.toLowerCase().includes('ingresos') }).id;

        });
      }

      function isSingleLineDetail() {
        if (!vm.addMovement || !vm.addMovement.type) {
          return false;
        }
        return vm.addMovement.type &&
          vm.transactionTypeIncomeExpense.includes(vm.addMovement.type.id);
      }

      function cleanDetail() {
        if (vm.isSingleLineDetail()) {
          var value = vm.addMovement.detail || '';
          value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ ]/g, '');
          vm.addMovement.detail = value;
        }
      }

      function submitProcess(form) {
        vm.loading = true;
        if (!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        vm.addMovement.id = vm.userInfo.openCash.id;
        addMovementProcess();
      }

      function addMovementProcess() {
        rCashRegister.addMovement(vm.addMovement, function () {
          angular.element('#modalAddMovementForm').modal('hide');
          vm.loading = false;
          toastr.success('El Movimiento fue creado satisfactoriamente');
        }, function (error) {
          vm.loading = false;
          toastr.error('Hubo un error al crear el Movimiento', error.data.message);
        });
      }

      angular.element('#modalAddMovementForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalAddMovementForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspHeader', tnspHeader);

  /** @ngInject */
  function tnspHeader() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/header/header.html',
      controller: HeaderController,
      controllerAs: 'header',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function HeaderController($log, HEADER_MENU ,$rootScope, $state,  authenticationService) {
      var vm = this,
          stateChangeSuccess,
          userRefreshed,
          allAuthInfo = null;


      vm.menu = HEADER_MENU;
      vm.showMenu = true;
      vm.isLoggedIn = false;
      vm.userInfo = null;
      vm.logout = logout;


      function logout(){
        authenticationService.logout();
      }

      function checkMenuPermissions(){
        angular.forEach(vm.menu, function(item){
          item.isUserAllowed = false;
          angular.forEach(item.requiredPermissions, function(requiredP){
            angular.forEach(vm.userInfo.permissions, function(permission){
              if (requiredP == permission){
                item.isUserAllowed = true;
              }
            });
          });
        })
      }

      /*Verify if navigation should be showed  **NOT showed for authentication screens */
      stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState){
        allAuthInfo = authenticationService.getAllAuthInfo();
        vm.isLoggedIn = allAuthInfo.isLoggedIn;
        vm.userInfo = allAuthInfo.userInfo;

        if (vm.userInfo && vm.userInfo.reseller){
          vm.userInfo.permissions.push('AGENCY');
        }

        if (toState && toState.data){
          vm.showMenu = !toState.data.isPublic;
        }else{
          vm.showMenu = true;
        }

        //TODO: Fix this to ask if state are for public page
        if (!vm.isLoggedIn){
          logout();
        }else{
          if (toState.name === 'login'){
            $state.go('home');
          }else{
            checkMenuPermissions();
            setSubmenu(toState);
          }
        }
      });

      userRefreshed = $rootScope.$on('userRefreshed', function(){
        allAuthInfo = authenticationService.getAllAuthInfo();
        vm.userInfo = allAuthInfo.userInfo;
      });

      function setSubmenu(state){
        var selectedItem,
          found = false;
        selectedItem = state.name;
        selectedItem = selectedItem.split('.')[0];


        angular.forEach(HEADER_MENU, function(item) {
          if (selectedItem === item.routerState){
            vm.submenu = item.subNavItems || [];
            found = true;
          }
        });
        vm.submenu = (!found) ? []: vm.submenu;

        angular.forEach(vm.submenu, function(item){
          item.isUserAllowed = false;
          angular.forEach(item.requiredPermissions, function(requiredP){
            angular.forEach(vm.userInfo.permissions, function(permission){
              if (!(vm.userInfo.reseller != null && (item.text == 'Redimir' || item.text == 'Editar Boletos' ))) {
                if (requiredP == permission){
                  item.isUserAllowed = true;
                }
              }
            });
          });

        })
      }


      $rootScope.$on('$destroy', stateChangeSuccess);

      $rootScope.$on('$destroy', userRefreshed);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspModalAddCancellationForm', tnspModalAddCancellationForm);

  /* @ngInject */
  function tnspModalAddCancellationForm() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/modal-add-cancellation-form/modal-add-cancellation-form.html',
      controller: ModalAddCancellationFormController,
      controllerAs: 'mAddCancellationForm',
      bindToController: true
    };

    return directive;

    /* @ngInject */
    function ModalAddCancellationFormController($log, rTicket, toastr) {
      var vm = this;
      vm.submitProcess = submitProcess;

      function init() {
      }

      function submitProcess(form) {
        vm.loading = true;
        if(!form.$valid) {
          vm.loading = false;
          vm.submitAttempt = true;
          return;
        }
        addCancellationProcess();
      }

      function addCancellationProcess() {
        rTicket.cancel(vm.addCancellation, function() {
          angular.element('#modalAddCancellationForm').modal('hide');
          vm.loading = false;
          toastr.success('El tiquete fue cancelado satisfactoriamente');
        }, function(error){
          vm.loading = false;
          toastr.error('Hubo un error al cancelar el tiquete', error.data.message);
        });
      }

      angular.element('#modalAddCancellationForm').on('show.bs.modal', function () {
        vm.submitAttempt = false;
      });

      angular.element('#modalAddCancellationForm').on('shown.bs.modal', function () {
        init();
      });

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspFooter', tnspFooter);

  /** @ngInject */
  function tnspFooter(FOOTER_MENU) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      controller: FooterController,
      controllerAs: 'footer',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController() {
      var vm = this;

      vm.menu = FOOTER_MENU;

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .directive('enterKey', enterKey);

  /** @ngInject */
  function enterKey() {
    var directive = {
      restrict: 'A',
      scope:true,
      link:SelectpickerLink
    };

    return directive;

    /** @ngInject */
    function SelectpickerLink(scope, element, attrs){
      element.bind('keydown keypress', function(event) {
        var keyCode = event.which || event.keyCode;

        // If enter key is pressed
        if (keyCode === 13) {
          scope.$apply(function() {
            // Evaluate the expression
            scope.$eval(attrs.enterKey);
          });

          event.preventDefault();
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .directive('tnspBusLayout', tnspBusLayout);

  /* @ngInject */
  function tnspBusLayout(BUS_LAYOUTS) {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/bus-layout/bus-layout.html',
      controller: BusLayoutController,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        inputLayoutType: '<',
        inputIsTripLocked: '<',
        inputTripSeats: '<',
        inputIsEditTicket: '<',
        inputTicketClients: '<?',
        outputSelectedSeats: '&'
      }
    };

    return directive;

    /* @ngInject */
    function BusLayoutController() {
      var vm = this;

      vm.maxSelection = 5;
      vm.selectedSeats = [];

      // Public methods
      vm.toggleSeatSelection = toggleSeatSelection;
      vm.isSeatDisabled = isSeatDisabled;

      // Initialize
      vm.$onChanges = function (changes) {
        if (changes.inputLayoutType) {
          vm.busLayout = angular.copy(BUS_LAYOUTS.find(function (b) { return b.type === vm.inputLayoutType; }) || BUS_LAYOUTS[0]);
          /* Los asientos elegidos son objetos de la copia anterior del layout:
             al reconstruirlo hay que soltarlos, si no el padre se queda con
             asientos de otro bus (o de otro tiquete). */
          clearSelection();
        }

        if (changes.inputIsTripLocked || changes.inputTripSeats) {
          initSeats();
        }
      };

      function initSeats() {
        if (!vm.busLayout || Object.keys(vm.busLayout).length === 0) return;

        if (vm.inputIsTripLocked) {
          lockTripSeats();
        } else {
          /* Sin asientos ocupados igual hay que repintar: de lo contrario
             sobreviven las marcas del viaje anterior. */
          checkOccupiedSeats();
        }
      }

      function clearSelection() {
        if (vm.selectedSeats.length === 0) return;

        vm.selectedSeats = [];
        vm.outputSelectedSeats({ selectedSeats: vm.selectedSeats });
      }

      /* En edicion el limite es la cantidad de clientes; mientras el tiquete
         carga es desconocido y no se debe permitir seleccionar. */
      function seatLimit() {
        if (!vm.inputIsEditTicket) return vm.maxSelection;

        return vm.inputTicketClients || 0;
      }

      // --- Functions ---
      function checkOccupiedSeats() {
        var tripSeatNumbers = (vm.inputTripSeats || []).map(function (s) { return s.seatNumber; });
        vm.busLayout.seatMatrixLevels.forEach(function (level) {
          markSeats(level, function (seat) { return isOccupiedByTripSeats(seat, tripSeatNumbers); });
        });
        markSeats(vm.busLayout.standingSeats, function (seat) { return isOccupiedByTripSeats(seat, tripSeatNumbers); });
        markSeats(vm.busLayout.wheelchairSeats, function (seat) { return isOccupiedByTripSeats(seat, tripSeatNumbers); });
      }

      function lockTripSeats() {
        vm.busLayout.seatMatrixLevels.forEach(function (level) {
          markSeats(level, function (seat) { return !!seat; });
        });
        markSeats(vm.busLayout.standingSeats, function (seat) { return !!seat; });
        markSeats(vm.busLayout.wheelchairSeats, function (seat) { return !!seat; });
      }

      function markSeats(busSeats, conditionFn) {
        if (!busSeats || busSeats.length === 0) return;
        var flatSeats = angular.isArray(busSeats[0]) ? busSeats.flat() : busSeats;
        flatSeats.forEach(function (seat) {
          if (seat) seat.isOccupied = conditionFn(seat);
        });
      }

      function isOccupiedByTripSeats(seat, tripSeatNumbers) {
        return !!seat && tripSeatNumbers.includes(seat.seatNumber);
      }

      function toggleSeatSelection(seat) {
        if (seat.isOccupied) return;

        var index = vm.selectedSeats.findIndex(function (s) { return s.seatNumber === seat.seatNumber; });
        if (index >= 0) {
          vm.selectedSeats.splice(index, 1);
          seat.selected = false;
        } else {
          if (vm.selectedSeats.length < seatLimit()) {
            vm.selectedSeats.push(seat);
            seat.selected = true;
          }
        }

        vm.outputSelectedSeats({ selectedSeats: vm.selectedSeats });
      }

      function isSeatDisabled(seat) {
        if (seat.isOccupied) return true;
        return (vm.selectedSeats.length >= seatLimit() && !seat.selected);
      }


    }
  }

})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .factory('utilsService', cacheService);

  function cacheService(
    BUS_LAYOUTS
  ) {

    function isObjectOnList(obj, list, key) {
      var found = false;
      angular.forEach(list, function (item) {
        if (item[key] === obj[key]) {
          found = true;
        }
      });

      return found;
    }

    function mapToAMPM(time) {
      var uiTime = time;
      var hours = time.split(':')[0];
      var minutes = time.split(':')[1];
      var uiHours;
      var amPm = 'AM';

      switch (hours) {
        case '00':
          uiHours = '12';
          amPm = 'AM';
          break;
        case '12':
          uiHours = '12';
          amPm = 'PM';
          break;
        case '13':
          uiHours = '01';
          amPm = 'PM';
          break;
        case '14':
          uiHours = '02';
          amPm = 'PM';
          break;
        case '15':
          uiHours = '03';
          amPm = 'PM';
          break;
        case '16':
          uiHours = '04';
          amPm = 'PM';
          break;
        case '17':
          uiHours = '05';
          amPm = 'PM';
          break;
        case '18':
          uiHours = '06';
          amPm = 'PM';
          break;
        case '19':
          uiHours = '07';
          amPm = 'PM';
          break;
        case '20':
          uiHours = '08';
          amPm = 'PM';
          break;
        case '21':
          uiHours = '09';
          amPm = 'PM';
          break;
        case '22':
          uiHours = '10';
          amPm = 'PM';
          break;
        case '23':
          uiHours = '11';
          amPm = 'PM';
          break;
        case '24':
          uiHours = '12';
          amPm = 'PM';
          break;

        default:
          uiHours = hours;
      }

      uiTime = uiHours + ':' + minutes + ' ' + amPm;

      return uiTime;
    }

    function getSeatLabel(layoutType, seatNumber) {
      var layout = layoutType ? BUS_LAYOUTS.find(function (b) { return b.type === layoutType; }) : BUS_LAYOUTS[0];
      var seat = findSeat(layout, seatNumber);
      return formatSeatLabel(seat);
    }

    function isWheelChairSeat(layoutType, seatNumber) {
      var layout = layoutType ? BUS_LAYOUTS.find(function (b) { return b.type === layoutType; }) : BUS_LAYOUTS[0];
      var seat = findSeat(layout, seatNumber);
      return !!seat && seat.type === 'wheelchair';
    }

    function findSeat(layout, seatNumber) {
      if (!layout) return undefined;

      var matrixSeats = [];
      if (layout.seatMatrixLevels) {
        layout.seatMatrixLevels.forEach(function (level) {
          level.forEach(function (row) {
            row.forEach(function (seat) {
              if (seat) matrixSeats.push(seat);
            });
          });
        });
      }

      var seatGroups = Object.keys(layout).map(function (key) { return layout[key]; })
        .filter(function (value) {
          return angular.isArray(value) && value.every(function (v) {
            return v && angular.isObject(v) && 'seatNumber' in v;
          });
        });

      var allSeats = matrixSeats.concat.apply(matrixSeats, seatGroups);

      for (var i = 0; i < allSeats.length; i++) {
        if (allSeats[i].seatNumber === seatNumber) {
          return allSeats[i];
        }
      }

      return undefined;
    }


    function formatSeatLabel(seat) {
      if (!seat) return '';
      if (seat.type === 'normal' || seat.type === 'preferential') {
        return seat.largeLabel + ' ' + seat.seatNumber;
      }
      return seat.largeLabel || '';
    }

    function getAvailableSeats(trip) {
      var layoutRules = {
        DEFAULT: function (t) { return { available: t.seats - t.tripSeats.length, total: t.seats }; }
      }

      BUS_LAYOUTS.forEach(function (layout) {
        if (layout.type === 3) {
          layoutRules[layout.type] = function (trip) { return { available: trip.seats - trip.tripSeats.length - 2, total: trip.seats - 2 }; };
        }
      });

      var layoutType = trip.bus && trip.bus.layoutType ? trip.bus.layoutType : 'DEFAULT';
      var rule = layoutRules[layoutType] || layoutRules.DEFAULT;

      return trip.locked ? { available: 0, total: 0 } : rule(trip);
    }

    function roundNearest10(num) {
      return Math.round(num / 10) * 10;
    }


    return {
      isObjectOnList: isObjectOnList,
      mapToAMPM: mapToAMPM,
      getSeatLabel: getSeatLabel,
      isWheelChairSeat: isWheelChairSeat,
      getAvailableSeats: getAvailableSeats,
      roundNearest10: roundNearest10
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('tnsp')
    .factory('printService', printService);

    function printService() {

      function print(divName, printContents) {

        var mywindow = window.open('', 'Factura', 'height=800,width=600,top=100,left=100');



        mywindow.document.write('<html><head><title>' + document.title  + '</title>');

      var links_html = '';
      
      angular.forEach(document.getElementsByTagName('link'), function(value) {
        links_html += value.outerHTML + ' '
      });


      mywindow.document.write(links_html);
      mywindow.document.write('</head><body >');

      mywindow.document.write(printContents);
      mywindow.document.write('</body></html>');

      mywindow.focus();


      setTimeout(function(){
        mywindow.print();

        setTimeout(function(){
          mywindow.close();
        }, 500);

      }, 1000);
    }
    return {
      print: print
    };
  }
})();

(function() {
  'use strict';

  angular
  .module('tnsp')
  .factory('cacheService', cacheService);

  function cacheService(/*rVendor,*/ $window) {
    var vendorsList = [];


    function loadVendosrList(){
      if ($window.sessionStorage['vendorsList']){
        vendorsList = angular.fromJson($window.sessionStorage['vendorsList']);
      }else{
        /*rVendor.query({pagesize:350, sort:'company'}, function(result){
          vendorsList = result.records;
          $window.sessionStorage['vendorsList'] = angular.toJson(vendorsList);
        });*/
      }
    }


    function getVendorsList() {
      return vendorsList;
    }

    function init() {
      loadVendosrList();
    }



    return {
      init:init,
      getVendorsList:getVendorsList
    };
  }
})();

(function() {
  'use strict';

  /*global $*/

  angular
    .module('tnsp')
    .factory('authenticationService', authenticationService);

  function authenticationService($q, $http, $rootScope, $state, $window, rUser) {
    var loginInfo,
      isUserloggedIn = false,
      loggedUserInfo = null;

    var credentials = {
      grantType:'password',
      userName:'',
      password:'',
      clientId:'tig-trusted-client',
      clientSecret:'secret'
    };

    function login(_credentials){
      var deferred = $q.defer();

      credentials.userName =_credentials.userName;
      credentials.password =_credentials.password;

      $http({
        url: 'api/oauth/token',
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: $.param({
          grant_type:credentials.grantType,
          username:credentials.userName,
          password:credentials.password,
          client_id:credentials.clientId,
          client_secret:credentials.clientSecret
        })
      })
        .then(function(result){

          var headers = result.headers()

          if(!result.data.internal_user){
            loginInfo = {
              accessToken: result.data.access_token,
              refreshToken: result.data.refresh_token,
              userId: result.data.user_id,
              traceId: headers['x-trace-id']
            };

            $window.sessionStorage['loginInfo'] = angular.toJson(loginInfo);

            $http.defaults.headers.common.Authorization = 'Bearer ' + loginInfo.accessToken;
            $http.defaults.headers.common['x-trace-id'] = loginInfo.traceId;
            isUserloggedIn = true;

            rUser.query({id:loginInfo.userId}, function(result){
              loggedUserInfo = result;

              var isDriver  = loggedUserInfo.roles.findIndex( function (role){return role.name === 'Chofer Cajero' } )

              if (isDriver < 0 ){

                $window.sessionStorage['userInfo'] = angular.toJson(loggedUserInfo);
                deferred.resolve(loginInfo);
              } else {

                isUserloggedIn = false;
                $http.defaults.headers.common.Authorization = '' ;
                $window.sessionStorage['loginInfo'] = null;
                $http.defaults.headers.common['x-trace-id'] = null;
                deferred.reject('Driver user');
                logout();
              }

            });
          }else{
            isUserloggedIn = false;
            $http.defaults.headers.common.Authorization = '' ;
            deferred.reject('Internal user');
          }

          },
          function(error){
            isUserloggedIn = false;
            $http.defaults.headers.common.Authorization = '' ;
            deferred.reject(error);
          });

      return deferred.promise;
    }

    function logout(){
      angular.element('.modal').hide();
      isUserloggedIn = false;
      loginInfo = {};
      loggedUserInfo = {};
      $http.defaults.headers.common.Authorization = '' ;
      $window.sessionStorage.clear();

      $state.go('login');
    }

    function refreshUserInfo(userId){
      rUser.query({id:userId}, function(result){
        loggedUserInfo = result;
        $window.sessionStorage['userInfo'] = angular.toJson(loggedUserInfo);
        $rootScope.$broadcast('userRefreshed');
      });
    }

    function checkPermissions(){
      //TODO: Check Roles or permissions
      return true;
    }

    function isLoggedIn(){
      return isUserloggedIn;
    }
    function getLoginInfo() {
      return loginInfo;
    }
    function getUserInfo() {
      return loggedUserInfo;
    }
    function getAllAuthInfo(){
      return {isLoggedIn:isUserloggedIn, userInfo:loggedUserInfo}
    }

    function init() {
      if ($window.sessionStorage['loginInfo']) {
        loginInfo = angular.fromJson($window.sessionStorage['loginInfo']);
        isUserloggedIn = true;
        $http.defaults.headers.common.Authorization = 'Bearer ' + loginInfo.accessToken;
        $http.defaults.headers.common['x-trace-id'] = loginInfo.traceId;

        if ($window.sessionStorage['userInfo']) {
          loggedUserInfo = angular.fromJson($window.sessionStorage['userInfo']);
        }else{
          rUser.query({id:loginInfo.userId}, function(result){
            loggedUserInfo = result;
            $window.sessionStorage['userInfo'] = angular.toJson(loggedUserInfo);
          });
        }
      }
    }

    init();


    return {
      login: login,
      logout:logout,
      isLoggedIn: isLoggedIn,
      getLoginInfo:getLoginInfo,
      getUserInfo:getUserInfo,
      refreshUserInfo:refreshUserInfo,
      getAllAuthInfo: getAllAuthInfo,
      checkPermissions:checkPermissions
    };
  }
})();

(function() {
	'use strict';


	angular.module('tnsp')
	.factory('authHttpResponseInterceptor', function($q, $rootScope) {
		return {
			response: function(response) {
				if(response.status === 401) {
					$rootScope.$broadcast('401UnauthorizedError');
				}
				return response || $q.when(response);
			},
			responseError: function(rejection) {
				if(rejection.status === 401) {
					$rootScope.$broadcast('401UnauthorizedError');
				}
				return $q.reject(rejection);
			}
		};
	});
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rUser', function($resource) {
    return $resource('api/users/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/users/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/users/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/users'
      },
      'update': {
        method: 'PUT',
        url: 'api/users/:id',
        params:{
          id:'@id'
        }
      },
      'getIdentificationTypes': {
        method: 'GET',
        url: 'api/identificationtypes/:id',
        params:{
          id:'@id'
        },
        isArray: true
      },
      'getMyCashiers': {
        method: 'GET',
        url: 'api/users/me/cash-registers',
        isArray: true
      }
    });
  });
})();

(function () {
  'use strict';
  angular
    .module('tnsp')
    .factory('rTrip', function ($resource) {
      return $resource('api/trips/:id', {
        id: '@id'
      },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/trips/:id',
            params: {
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/trips/:id',
            params: {
              id: '@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/trips/'
          },
          'update': {
            method: 'PUT',
            url: 'api/trips/:id',
            params: {
              id: '@id'
            }
          },
          'patchTrip': {
            method: 'PATCH',
            url: 'api/trips/:id',
            params: {
              id: '@id'
            }
          },
          'getOccupiedSeats': {
            method: 'GET',
            url: 'api/trips/:id/seats',
            params: {
              id: '@id'
            },
            isArray: true
          },
          'getTickets': {
            method: 'GET',
            url: 'api/trips/:id/tickets',
            params: {
              id: '@id'
            },
            isArray: true
          },
          'release': {
            method: 'POST',
            url: 'api/trips/:id/release',
            params: {
              id: '@id'
            }
          },
          'insurances': {
            method: 'GET',
            url: 'api/trips/:id/insurancereport',
            params: {
              id: '@id'
            },
            isArray: true
          },
          'lock': {
            method: 'POST',
            url: 'api/trips/:id/lock',
            params: {
              id: '@id'
            }
          },
          'unlock': {
            method: 'DELETE',
            url: 'api/trips/:id/lock',
            params: {
              id: '@id'
            }
          }
        });
    });
})();

(function() {
'use strict';
angular
  .module('tnsp')
  .factory('rTicketInvoice', function($resource) {
    return $resource('api/ticketinvoices/:id', {
      id: '@id'
    },
    {
      'query': {
        method: 'GET',
        url: 'api/ticketinvoices/:id',
        params:{
          id: '@id'
        }
      },
      'getInvoices': {
        method: 'GET',
        url: 'api/ticketinvoices',
        params:{
          id:'@id'
        },
        isArray:true
      }
    }
    );
  });
})();

(function () {
  "use strict";
  angular.module("tnsp").factory("rTicket", function ($resource) {
    return $resource(
      "api/tickets/:id",
      {
        id: "@id",
        citizenId: "@citizenId"
      },
      {
        delete: {
          method: "DELETE",
          url: "api/tickets/:id",
          params: {
            id: "@id"
          }
        },
        query: {
          method: "GET",
          url: "api/tickets/:id",
          params: {
            id: "@id"
          }
        },
        save: {
          method: "POST",
          url: "api/tickets/",
          isArray: true
        },
        update: {
          method: "PUT",
          url: "api/tickets/:id",
          params: {
            id: "@id"
          }
        },
        partialUpdate: {
          method: "PATCH",
          url: "api/tickets/:id",
          params: {
            id: "@id"
          }
        },
        updateContact: {
          method: "PATCH",
          url: "api/tickets/:id/contact",
          params: {
            id: "@id"
          }
        },
        adjust: {
          method: "POST",
          url: "api/tickets/:id/adjust",
          params: {
            id: "@id"
          }
        },
        reserve: {
          method: "POST",
          url: "api/tickets/reserve"
        },
        cancelReserve: {
          method: "POST",
          url: "api/tickets/cancelreserve"
        },
        checkin: {
          method: "POST",
          url: "api/tickets/:id/checkin",
          params: {
            id: "@id"
          }
        },
        cancel: {
          method: "POST",
          url: "api/tickets/:id/cancel",
          params: {
            id: "@id"
          }
        },
        redeem: {
          method: "POST",
          url: "api/tickets/:id/redeem",
          params: {
            id: "@id"
          }
        },
        registerLuggage: {
          method: "POST",
          url: "api/tickets/:id/luggage",
          params: {
            id: "@id"
          }
        },
        getLuggage: {
          method: "GET",
          url: "api/tickets/:id/luggage",
          params: {
            id: "@id"
          },
          isArray: true
        },
        release: {
          method: "POST",
          url: "api/tickets/:id/release",
          params: {
            id: "@id"
          }
        },
        sendSMS: {
          method: "POST",
          url: "api/tickets/:id/sms",
          params: {
            id: "@id"
          }
        },
        reportDriverSales: {
          method: "POST",
          url: "api/reports/driver-sales/send"
        },
        reportTicketsIssued: {
          method: "POST",
          url: "api/ticket-report"
        },
        reportTicketsReference: {
          method: "GET",
          url: "api/ticket-report/summary",
          isArray: true
        },
        reportErp: {
          method: "POST",
          url: "api/ticket-report/accounting-erp"
        },
        reportAccounting: {
          method: "POST",
          url: "api/ticket-report/accounting"
        },
        reportSalesSummary: {
          method: "GET",
          url: "api/ticket-report/sales"
        },
        reportTicketsOcupancy: {
          method: "GET",
          url: "api/ticket-report/occupancy"
        },
        reportEditedTickets: {
          method: "GET",
          url: "api/ticket-report/edited-tickets",
          isArray: true
        },
        reportTicketHistory: {
          method: "GET",
          url: "api/ticket-report/:id/history",
          isArray: true
        },
        otpHistory: {
          method: "GET",
          url: "api/tickets/:id/otp-history",
          params: {
            id: "@id"
          }
        },
        clearChecks: {
          method: "POST",
          url: "api/tickets/:id/clear-checks"
        },
        putOnHold: {
          method: "PUT",
          url: "api/tickets/:id/on-hold"
        },
        checkIfIsElderlyPerson: {
          method: "GET",
          url: "api/citizens/:citizenId",
           params: {
            citizenId: "@citizenId"
          }
        },
        reportConsolidatedSales: {
          method: "POST",
          url: "api/reports/consolidated-sales/send"
        },
        reportConsolidatedSalesSummary: {
          method: "POST",
          url: "api/reports/consolidated-sales-summary/send"
        },
        reportOutcome: {
          method: "POST",
          url: "api/reports/outcome/send"
        }
      }
    );
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rTerminal', function($resource) {
      return $resource('api/terminals/:id', {
          id: '@id'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/terminals/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/terminals/:id',
            params:{
              id: '@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/terminals/'
          },
          'update': {
            method: 'PUT',
            url: 'api/terminals/:id',
            params:{
              id: '@id'
            }
          },
          'salesReport': {
            method: 'GET',
            url: 'api/terminals/:id/salesreport',
            params:{
              id: '@id'
            }
          }
        });
    });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rSchedule', function($resource) {
      return $resource('api/routes/:routeId/schedules/:id', {
          id: '@id'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/routes/:routeId/schedules/:id',
            params:{
              id: '@id',
              routeId: '@routeId'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/routes/:routeId/schedules/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/routes/:routeId/schedules/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          },
          'update': {
            method: 'PUT',
            url: 'api/routes/:routeId/schedules/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          },
          'generateTrips': {
            method: 'POST',
            url: 'api/routes/:routeId/schedules/:id/trips',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          }
        });
    });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rRouteRate', function($resource) {
      return $resource('api/routes/:routeId/routerates/:id', {
          id: '@id',
          routeId: '@routeId'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/routes/:routeId/routerates/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/routes/:routeId/routerates/:id',
            params:{
              id:'@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/routes/:routeId/routerates/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          },
          'update': {
            method: 'PUT',
            url: 'api/routes/:routeId/routerates/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          }
        });
    });
})();

(function() {
'use strict';
angular
  .module('tnsp')
  .factory('rRoute', function($resource) {
    return $resource('api/routes/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/routes/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/routes/:id',
        params:{
          id: '@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/routes/'
      },
      'update': {
        method: 'PUT',
        url: 'api/routes/:id',
        params:{
          id: '@id'
        }
      },
      'occupation': {
        method: 'GET',
        url: 'api/routes/:id/ocupationmatriz',
        params:{
          id: '@id'
        }
      },
      'unpublish': {
        method: 'POST',
        url: 'api/routes/:id/unpublish',
        params:{
          id: '@id'
        }
      },
      'republish': {
        method: 'POST',
        url: 'api/routes/:id/republish',
        params:{
          id: '@id'
        }
      }
    });
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rReseller', function($resource) {
      return $resource('api/resellers/:id', {
          id: '@id',
          resellerId: '@resellerId'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/resellers/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/resellers/:id',
            params:{
              id: '@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/resellers/'
          },
          'update': {
            method: 'PUT',
            url: 'api/resellers/:id',
            params:{
              id: '@id'
            }
          },
          'addUser': {
            method: 'POST',
            url: 'api/resellers/:resellerId/users/:id',
            params:{
              id:'@id',
              routeId: '@resellerId'
            }
          },
          'deleteUser': {
            method: 'DELETE',
            url: 'api/resellers/:resellerId/users/:id',
            params:{
              id:'@id',
              routeId: '@resellerId'
            }
          },
          'salesReport': {
            method: 'GET',
            url: 'api/resellers/:id/salesreport',
            params:{
              id: '@id'
            }
          },
          'salesReportAllDrivers': {
            method: 'GET',
            url: 'api/resellers/:id/salesreport/all-drivers',
            params:{
              id: '@id'
            }
          }
        });
    });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rProfile', function($resource) {
    return $resource('api/roles/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/roles/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/roles/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/roles'
      },
      'update': {
        method: 'PUT',
        url: 'api/roles/:id',
        params:{
          id:'@id'
        }
      },
      'getUsersByRole': {
        method: 'GET',
        url: 'api/roles/:id/sellers',
        params:{
          id:'@id'
        },
        isArray:true
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rPermission', function($resource) {
    return $resource('api/permissions/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/permissions/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/permissions/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/permissions/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/permissions/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rPassword', function($resource) {
      return $resource('api/forgotpassword', {
      },{
        'forgot': {
          method: 'POST',
          url: 'api/forgotpassword'
        },
        'reset': {
          method: 'POST',
          url: 'api/resetpassword/'
        }
      });
    });

})();

(function() {
'use strict';
angular
  .module('tnsp')
  .factory('rPackingType', function($resource) {
    return $resource('api/packingtypes/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/packingtypes/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/packingtypes/:id',
        params:{
          id: '@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/packingtypes/'
      },
      'update': {
        method: 'PUT',
        url: 'api/packingtypes/:id',
        params:{
          id: '@id'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rNationality', function($resource) {
    return $resource('api/nationalities/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/nationalities/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/nationalities/:id',
        params:{
          id:'@id'
        },
        isArray:true
      },
      'save': {
        method: 'POST',
        url: 'api/nationalities/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/nationalities/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rInvoice', function($resource) {
      return $resource('api/invoices/:id', {
          id: '@id'
        },
        {
          'query': {
            method: 'GET',
            url: 'api/invoices/:id',
            params:{
              id: '@id'
            }
          }
        });
    });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rGreenPay', function($resource) {
      return $resource('api/payments/green-pay', {},
        {
          'createOrder': {
            method: 'POST',
            url: 'api/payments/green-pay/create-order'
          }
        });
    });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rExternalCode', function($resource) {
    return $resource('api/valid-external-codes/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/valid-external-codes/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/valid-external-codes/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/valid-external-codes'
      },
      'update': {
        method: 'PUT',
        url: 'api/valid-external-codes/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rExchange', function($resource) {
    return $resource('api/exchanges/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/exchanges/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/exchanges/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/exchanges/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/exchanges/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rDropoff', function($resource) {
      return $resource('api/routes/:routeId/schedules/:scheduleId/drop-offs/:id', {
          id: '@id',
          scheduleId: '@scheduleId',
          routeId: '@routeId'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/routes/:routeId/schedules/:scheduleId/drop-offs/:id',
            params:{
              id: '@id',
              scheduleId: '@scheduleId'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/routes/:routeId/schedules/:scheduleId/drop-offs/:id',
            params:{
              id:'@id',
              scheduleId: '@scheduleId'
            },
            isArray:true
          },
          'save': {
            method: 'POST',
            url: 'api/routes/:routeId/schedules/:scheduleId/drop-offs/:id',
            params:{
              id:'@id',
              routeId: '@routeId',
              scheduleId: '@scheduleId'
            }
          },
          'update': {
            method: 'PUT',
            url: 'api/routes/:routeId/schedules/:scheduleId/drop-offs/:id',
            params:{
              id:'@id',
              routeId: '@routeId',
              scheduleId: '@scheduleId'
            }
          }
        });
    });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rExchangeTransaction', function($resource) {
    return $resource('api/dollar-exchange-transactions/:id', {
      id: '@id'
    },
    {
      'query': {
        method: 'GET',
        url: 'api/dollar-exchange-transactions',
        isArray: true
      },
      'save': {
        method: 'POST',
        url: 'api/dollar-exchange-transactions/:id'
      },
      'buyDollars': {
        method: 'POST',
        url: 'api/dollar-exchange-transactions/buy-colones',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rDollarExchange', function($resource) {
    return $resource('api/dollar-exchange-rates/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/dollar-exchange-rates/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/dollar-exchange-rates',
        isArray: true
      },
      'latest': {
        method: 'GET',
        url: 'api/dollar-exchange-rates/latest'
      },
      'save': {
        method: 'POST',
        url: 'api/dollar-exchange-rates/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/dollar-exchange-rates/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rCurrency', function($resource) {
    return $resource('api/currencies/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/currencies/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/currencies/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/currencies/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/currencies/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rCountry', function($resource) {
    return $resource('api/countries/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/countries/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/countries/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/countries/:id'
      },
      'update': {
        method: 'PUT',
        url: 'api/countries/:id',
        params:{
          id:'@id'
        }
      },
      'getTerminals': {
        method: 'GET',
        url: 'api/countries/:countryId/terminals/:id',
        params:{
          id: '@id',
          countryId:'@countryId'
        }
      }
    });
  });
})();

(function() {
'use strict';

angular
  .module('tnsp')
  .factory('rConfig', function($resource) {
    return $resource('api/config/key-values/:id', {
      id: '@id'
    },
    {
      'query': {
        method: 'GET',
        url: 'api/config/key-values/:id',
        params:{
          id:'@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/config/key-values'
      },
      'update': {
        method: 'PUT',
        url: 'api/config/key-values/:id',
        params:{
          id:'@id'
        }
      }
    });
  });
})();

(function() {
  'use strict';
  angular
    .module('tnsp')
    .factory('rClient', function($resource ,$http, DATE_ISO_FORMAT, moment) {
      return $resource('api/clients/:id', {
          id: '@id'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/clients/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/clients/:id',
            params:{
              id: '@id'
            },
            transformResponse: $http.defaults.transformRequest.concat(transformResponse)
          },
          'save': {
            method: 'POST',
            url: 'api/clients/',
            transformRequest: [transformRequest].concat($http.defaults.transformRequest)
          },
          'update': {
            method: 'PUT',
            url: 'api/clients/:id',
            params:{
              id: '@id'
            },
            transformRequest: [transformRequest].concat($http.defaults.transformRequest)
          },
          'tickets': {
            method: 'GET',
            url: 'api/clients/tickets',
            isArray:true
          }
        });

      function transformResponse(response) {
        try {
          var clientResponse = angular.fromJson(response);

          if(clientResponse.records) {
            angular.forEach(clientResponse.records, function(client) {
              client.identificationExpirationUI =  client.identificationExpiration ? moment(client.identificationExpiration, DATE_ISO_FORMAT).toDate() : '';
              client.birthdateUI =  client.birthdate ? moment(client.birthdate, DATE_ISO_FORMAT).toDate() : '';
            });
          } else {
            clientResponse.identificationExpirationUI =  clientResponse.identificationExpiration ? moment(clientResponse.identificationExpiration, DATE_ISO_FORMAT).toDate() : '';
            clientResponse.birthdateUI =  clientResponse.birthdate ? moment(clientResponse.birthdate, DATE_ISO_FORMAT).toDate() : '';

          }
          return clientResponse;
        } catch(e) {
          return angular.fromJson(response);
        }
      }

      function transformRequest(request) {
        if(!request) {return null;}

        if(request.identificationExpirationUI !== null && request.identificationExpirationUI !==''){
          request.identificationExpiration = moment(request.identificationExpirationUI).format('YYYY-MM-DD');
          request.birthdate = moment(request.birthdateUI).format('YYYY-MM-DD');
        }

        return request;
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rCashRegister', function($resource) {
      return $resource('api/terminals/:terminalId/cashregisters/:id', {
          id: '@id',
          terminalId: '@terminalId',
          cashRegisterId: '@cashRegisterId'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/terminals/:terminalId/cashregisters/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/terminals/:terminalId/cashregisters/:id',
            params:{
              id:'@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/terminals/:terminalId/cashregisters/:id',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'update': {
            method: 'PUT',
            url: 'api/terminals/:terminalId/cashregisters/:id',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'open': {
            method: 'POST',
            url: 'api/terminals/:terminalId/cashregisters/:id/open',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'close': {
            method: 'POST',
            url: 'api/terminals/:terminalId/cashregisters/:id/close',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'addMovement': {
            method: 'POST',
            url: 'api/terminals/:terminalId/cashregisters/:id/transactions',
            params:{
              id:'@id',
              terminalId: '@terminalId'
            }
          },
          'transactionTypes': {
            method: 'GET',
            url: 'api/transactiontypes',
            params:{
              id:'@id'
            },
            isArray:true
          },
          'balances': {
            method: 'GET',
            url: 'api/terminals/:terminalId/cashregisters/:cashRegisterId/balances/:id',
            params:{
              id:'@cashRegisterid',
              terminalId: '@terminalId',
              cashRegisterId: '@cashRegisterId'
            }
          },
          'currentMovements': {
            method: 'GET',
            url: 'api/terminals/:terminalId/cashregisters/:cashRegisterId/balances/current',
            params:{
              terminalId: '@terminalId',
              cashRegisterId: '@cashRegisterId'
            }
          }
        });
    });
})();

(function() {
'use strict';
angular
  .module('tnsp')
  .factory('rBus', function($resource) {
    return $resource('api/buses/:id', {
      id: '@id'
    },
    {
      'delete': {
        method: 'DELETE',
        url: 'api/buses/:id',
        params:{
          id: '@id'
        }
      },
      'query': {
        method: 'GET',
        url: 'api/buses/:id',
        params:{
          id: '@id'
        }
      },
      'save': {
        method: 'POST',
        url: 'api/buses/'
      },
      'update': {
        method: 'PUT',
        url: 'api/buses/:id',
        params:{
          id: '@id'
        }
      },
      'getBusClasses': {
        method: 'GET',
        url: 'api/busclasses',
        params:{
        }
      }
    });
  });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .factory('rBoarding', function($resource) {
      return $resource('api/routes/:routeId/boardings/:id', {
          id: '@id',
          routeId: '@routeId'
        },
        {
          'delete': {
            method: 'DELETE',
            url: 'api/routes/:routeId/boardings/:id',
            params:{
              id: '@id'
            }
          },
          'query': {
            method: 'GET',
            url: 'api/routes/:routeId/boardings/:id',
            params:{
              id:'@id'
            }
          },
          'save': {
            method: 'POST',
            url: 'api/routes/:routeId/boardings/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          },
          'update': {
            method: 'PUT',
            url: 'api/routes/:routeId/boardings/:id',
            params:{
              id:'@id',
              routeId: '@routeId'
            }
          }
        });
    });
})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .run(runBlock);

  /** @ngInject */
  function runBlock(bsLoadingOverlayService, $state, $rootScope, authenticationService, Idle, $document, APP_TITLE, DATE_FORMAT, DATE_PICKER_FORMAT) {

    var APIAuthError,
      stateChange,
      idleTimeout;

    function updateIdleWatch(toState) {
      var isLoggedIn = authenticationService.isLoggedIn();
      var isLoginState = toState && toState.name === 'login';
      if (isLoggedIn && !isLoginState) {
        Idle.watch();
      } else {
        Idle.unwatch();
      }
    }

    idleTimeout = $rootScope.$on('IdleTimeout', function() {
      Idle.unwatch();
      authenticationService.logout();
    });

    $rootScope.dateFormat = DATE_FORMAT;
    $rootScope.datePickerFormat = DATE_PICKER_FORMAT;


    bsLoadingOverlayService.setGlobalConfig({
      delay: 50,
      activeClass: 'active-overlay',
      templateUrl: 'app/components/loading-overlay/loading-overlay.html'
    });

    stateChange = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
      updateIdleWatch(toState);
      // Restore app title when leaving login (e.g. after logging in again)
      if (toState && toState.name !== 'login') {
        $document[0].title = APP_TITLE;
      }
      if(toState && toState.params){
        if(toState.params.autoActivateChild){
          $state.go(toState.params.autoActivateChild);
        }else if (toState.params.childList){
          $state.go(toState.params.childList[0].routerState);
        }
      }
    });

    // Start idle watch on app load if user is already logged in
    updateIdleWatch($state.current);


    APIAuthError = $rootScope.$on('401UnauthorizedError', function() {
      authenticationService.logout();
    });

    $rootScope.hasPermissionsFor = function(permissionRequired) {
      var hasPermission =  false;

      var userInfo = authenticationService.getUserInfo();


      if (userInfo){
        var permissions = userInfo.permissions;

        if (permissions){
          if(permissions.indexOf(permissionRequired) > 0){
            hasPermission =  true;
          }
        }

      }
      return hasPermission;
    };

    $rootScope.isAdmin = function() {

      var userInfo = authenticationService.getUserInfo();
      return userInfo.sysAdmin;
    };

    $rootScope.$on('$destroy', APIAuthError);
    $rootScope.$on('$destroy', stateChange);
    $rootScope.$on('$destroy', idleTimeout);
  }

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {

    $urlRouterProvider.otherwise('/login');

    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/pages/login/login.html',
        controller: 'LoginController',
        controllerAs: 'login',
        data:{isPublic:true}
      })
      .state('home', {
        url: '/',
        templateUrl: 'app/pages/home/home.html',
        controller: 'HomeController',
        controllerAs: 'home'
      })
      .state('forgot-password', {
        url: '/olvido-contasena',
        templateUrl: 'app/pages/forgot-password/forgot-password.html',
        controller: 'ForgotPasswordController',
        controllerAs: 'forgotPassword',
        data:{isPublic:true}
      })
      .state('reset-password', {
        url: '/resetear-contrasena/:resetToken',
        templateUrl: 'app/pages/reset-password/reset-password.html',
        controller: 'ResetPasswordController',
        controllerAs: 'resetPassword',
        data:{isPublic:true}
      })
      .state('administration', {
        url: '/administracion',
        templateUrl: 'app/pages/administration-parent/administration.html',
        controller: 'AdminController',
        controllerAs: 'administration',
        params: {
          childList:[
            {routerState:'administration.users', requiredPermissions: []},
            {routerState:'administration.countries', requiredPermissions: []},
            {routerState:'administration.roles', requiredPermissions: []}
          ]
        }
      })
      .state('administration.profiles', {
        url: '/perfiles',
        templateUrl: 'app/pages/administration-profiles/profiles.html',
        controller: 'ProfilesController',
        controllerAs: 'profiles'
      })
      .state('administration.users', {
        url: '/usuarios',
        templateUrl: 'app/pages/administration-users/users.html',
        controller: 'UsersController',
        controllerAs: 'users'
      })
      .state('administration.external-codes', {
        url: '/codigos-externos',
        templateUrl: 'app/pages/administration-external-codes/external-codes.html',
        controller: 'ExternalCodesController',
        controllerAs: 'extCodes'
      })
      .state('administration.countries', {
        url: '/paises',
        templateUrl: 'app/pages/administration-countries/countries.html',
        controller: 'CountriesController',
        controllerAs: 'countries'
      })
      .state('administration.terminals', {
        url: '/terminales',
        templateUrl: 'app/pages/administration-terminals/terminals.html',
        controller: 'TerminalsController',
        controllerAs: 'terminals'
      })
      .state('administration.resellers', {
        url: '/agencias',
        templateUrl: 'app/pages/administration-resellers/resellers.html',
        controller: 'ResellersController',
        controllerAs: 'resellers'
      })
      .state('administration.generatedTrips', {
        url: '/viajes-generados',
        templateUrl: 'app/pages/administration-generated-trips/generated-trips.html',
        controller: 'GeneratedTripsController',
        controllerAs: 'generatedTrips'
      })
      .state('administration.trips', {
        url: '/viajes',
        templateUrl: 'app/pages/administration-manage-trips/manage-trips.html',
        controller: 'ManageTripsController',
        controllerAs: 'manageTrips'
      })
      .state('administration.dollarExchange', {
        url: '/tipo-de-cambio',
        templateUrl: 'app/pages/administration-dollar-exchange/dollar-exchange.html',
        controller: 'DollarExchangeController',
        controllerAs: 'dollarExchange'
      })
      .state('administration.buses', {
        url: '/buses',
        templateUrl: 'app/pages/administration-buses/buses.html',
        controller: 'BusesController',
        controllerAs: 'buses'
      })
      .state('administration.routes', {
        url: '/rutas',
        templateUrl: 'app/pages/administration-routes/routes.html',
        controller: 'RoutesController',
        controllerAs: 'routes'
      })
      .state('administration.schedules', {
        url: '/rutas/:routeId/horarios',
        templateUrl: 'app/pages/administration-schedules/schedules.html',
        controller: 'SchedulesController',
        controllerAs: 'schedules'
      })
      .state('administration.routeRates', {
        url: '/rutas/:routeId/precios',
        templateUrl: 'app/pages/administration-route-rates/route-rates.html',
        controller: 'RouteRatesController',
        controllerAs: 'routeRates'
      })
      .state('administration.boardings', {
        url: '/rutas/:routeId/abordajes',
        templateUrl: 'app/pages/administration-boardings/boardings.html',
        controller: 'BoardingsController',
        controllerAs: 'boardings'
      })
      .state('administration.cashRegisters', {
        url: '/rutas/:terminalId/cajas-registradoras',
        templateUrl: 'app/pages/administration-cash-registers/cash-registers.html',
        controller: 'CashRegistersController',
        controllerAs: 'cashRegisters'
      })
      .state('sales', {
        url: '/ventas',
        templateUrl: 'app/pages/sales-parent/sales.html',
        controller: 'SalesController',
        controllerAs: 'sales',
        params: {
          childList:[
            {routerState:'sales.tickets', requiredPermissions: []},
            {routerState:'sales.searchTickets', requiredPermissions: []},
            {routerState:'sales.editTickets', requiredPermissions: []},
            {routerState:'sales.editTicketsBoarding', requiredPermissions: []},
            {routerState:'sales.till', requiredPermissions: []},
            {routerState:'sales.agencySales', requiredPermissions: []},
            {routerState:'sales.cash-movements', requiredPermissions: []}
          ]
        }
      })
      .state('sales.till', {
        url: '/cajas',
        templateUrl: 'app/pages/sales-till/till.html',
        controller: 'TillController',
        controllerAs: 'till'
      })
      .state('sales.tickets', {
        url: '/boletos',
        templateUrl: 'app/pages/sales-tickets/tickets.html',
        controller: 'TicketsController',
        controllerAs: 'tickets'
      })
      .state('sales.searchTickets', {
        url: '/buscar-boletos',
        templateUrl: 'app/pages/sales-tickets-search/search-tickets.html',
        controller: 'SearchTicketsController',
        controllerAs: 'searchTickets'
      })
      .state('sales.editTickets', {
        url: '/editar-boletos',
        templateUrl: 'app/pages/sales-tickets-edit/edit-tickets.html',
        controller: 'EditTicketsController',
        controllerAs: 'editTickets'
      })
      .state('sales.ticketsHistory', {
        url: '/historico-boleto',
        templateUrl: 'app/pages/sales-ticket-history/ticket-history.html',
        controller: 'TicketHistoryController',
        controllerAs: 'ticketHistory'
      })
      .state('sales.editTicketsBoarding', {
        url: '/editar-abordaje',
        templateUrl: 'app/pages/sales-tickets-edit-boarding/edit-tickets-boarding.html',
        controller: 'EditTicketsBoardingController',
        controllerAs: 'editTicketsBoarding'
      })
      .state('sales.tripChecks', {
        url: '/chequeos',
        templateUrl: 'app/pages/sales-checks/checks.html',
        controller: 'ChecksController',
        controllerAs: 'checks'
      })
      .state('sales.redeem', {
        url: '/redimir-boleto',
        templateUrl: 'app/pages/sales-redeem/redeem.html',
        controller: 'RedeemController',
        controllerAs: 'redeem'
      })
      .state('sales.cash-movements', {
        url: '/movimiento-cajas',
        templateUrl: 'app/pages/sales-cash-movements/cash-movements.html',
        controller: 'CashMovController',
        controllerAs: 'cashMov'
      })
    .state('sales.agencySales', {
      url: '/ventas-agencia',
      templateUrl: 'app/pages/sales-agency-sales/agency-sales.html',
      controller: 'AgencySalesController',
      controllerAs: 'agencySales'
    })
      .state('entrust', {
        url: '/cargas',
        templateUrl: 'app/pages/entrust-parent/entrust.html',
        controller: 'EntrustController',
        controllerAs: 'entrust',
        params: {
          childList:[
            {routerState:'entrust.packingTypes', requiredPermissions: []}
          ]
        }
      })
      .state('entrust.packingTypes', {
        url: '/tipos-de-empaques',
        templateUrl: 'app/pages/entrust-packing-types/packing-types.html',
        controller: 'PackingTypesController',
        controllerAs: 'packingTypes'
      })
      .state('reports', {
        url: '/reportes',
        templateUrl: 'app/pages/reports-parent/reports.html',
        controller: 'ReportsController',
        controllerAs: 'reports',
        params: {
          childList:[
            {routerState:'reports.clientTickets', requiredPermissions: []}
          ]
        }
      })
      .state('reports.clientTickets', {
        url: '/cliente-boletos',
        templateUrl: 'app/pages/reports-client-tickets/client-tickets.html',
        controller: 'ClientTicketsController',
        controllerAs: 'clientTickets'
      })
      .state('reports.ticketsIssued', {
        url: '/boletos-emitidos',
        templateUrl: 'app/pages/reports-tickets-issued/tickets-issued.html',
        controller: 'TicketsIssuedController',
        controllerAs: 'ticketsIssued'
      })
      .state('reports.consolidatedSales', {
        url: '/consolidado-ventas',
        templateUrl: 'app/pages/reports-consolidated-sales/consolidated-sales.html',
        controller: 'ConsolidatedSalesController',
        controllerAs: 'consolidatedSales'
      })
      .state('reports.accounting', {
        url: '/contabilidad',
        templateUrl: 'app/pages/reports-accounting/accounting.html',
        controller: 'AccountingController',
        controllerAs: 'accountingReport'
      })
      .state('reports.erp', {
        url: '/erp',
        templateUrl: 'app/pages/reports-erp/erp.html',
        controller: 'ErpController',
        controllerAs: 'erpReport'
      })
      .state('reports.salesSummary', {
        url: '/resumen-ventas',
        templateUrl: 'app/pages/reports-sales-summary/sales-summary.html',
        controller: 'SalesSummaryController',
        controllerAs: 'salesSummaryReport'
      })
      .state('reports.cashRegistersBalances', {
        url: '/balances-cajas-registradoras',
        templateUrl: 'app/pages/reports-cash-registers-balances/cash-registers-balances.html',
        controller: 'CashRegistersBalancesController',
        controllerAs: 'cashRegistersBalances'
      })
      .state('reports.occupationMatrix', {
        url: '/matriz-ocupacion',
        templateUrl: 'app/pages/reports-occupation-matrix/occupation-matrix.html',
        controller: 'OccupationMatrixController',
        controllerAs: 'occupationMatrix'
      })
      .state('reports.salesReport', {
        url: '/reporte-de-impuestos',
        templateUrl: 'app/pages/reports-sales/sales-report.html',
        controller: 'SalesReportController',
        controllerAs: 'salesReport'
      })
      .state('reports.busDriversReport', {
        url: '/reporte-de-choferes-asginados',
        templateUrl: 'app/pages/reports-bus-drivers-assigned/bus-drivers-assigned.html',
        controller: 'BusDriversAssignedController',
        controllerAs: 'busDriversAssigned'
      })
      .state('reports.driverPayment', {
        url: '/reporte-pago-choferes',
        templateUrl: 'app/pages/reports-drivers-payment/reports-drivers-payment.html',
        controller: 'DriversPaymentController',
        controllerAs: 'driversPayment'
      })
      .state('reports.insuranceReport', {
        url: '/reporte-de-seguros',
        templateUrl: 'app/pages/reports-insurances/insurances.html',
        controller: 'InsurancesController',
        controllerAs: 'insuranceReport'
      })
      .state('reports.otpReport', {
        url: '/reporte-otp',
        templateUrl: 'app/pages/reports-otp/otp-report.html',
        controller: 'OtpReportController',
        controllerAs: 'otpReport'
      })
      .state('reports.passengersReport', {
        url: '/reporte-de-pasajeros',
        templateUrl: 'app/pages/reports-passengers/passengers.html',
        controller: 'PassengersController',
        controllerAs: 'passengersReport'
      })
      .state('reports.editedTickets', {
        url: '/boletos-editados',
        templateUrl: 'app/pages/reports-edited-tickets/edited-tickets.html',
        controller: 'EditedTicketsController',
        controllerAs: 'editedTickets'
      })
      .state('configuration', {
        url: '/configuracion',
        templateUrl: 'app/pages/configuration-parent/configuration.html',
        controller: 'ConfController',
        controllerAs: 'configuration'
      });
  }

})();

/* global moment:false */
(function () {
  'use strict';

  angular
    .module('tnsp')
    .constant('moment', moment)
    .constant('DATE_FORMAT', 'DD/MM/YYYY')
    .constant('DATE_ISO_FORMAT', 'YYYY-MM-DD')
    .constant('DATE_PICKER_FORMAT', 'MM/dd/yyyy')
    .constant('DATE_TIME_FORMAT', 'h:mm A')
    .constant('APP_TITLE', 'Transporte Inteligente de Guanacaste')
    .constant('ONLY_NUMBERS_PATTERN', /^\d+$/)
    .constant('SALES_TIME_AFTER_DETARTURE', 5)
    .constant('SALES_TIME_AFTER_DETARTURE_RESELLER', 120)
    .constant('DISCOUNT', 25.00)
    .constant('INVOICE_PREFIX', [{ id: 1, prefix: 'CR', name: 'Santa Cruz' }, { id: 2, prefix: 'NY', name: 'Nicoya' }])
    .constant('PAGINATION_CONFIG', { allowedRanges: [10, 15, 25, 50], maxPaginationItems: 5 })
    .constant('CIVIL_STATUS', [{ id: 1, name: 'Soltero' }, { id: 2, name: 'Casado' }, { id: 3, name: 'Divorciado' }, { id: 4, name: 'Viudo' }])
    .constant('PAYMENT_TYPES', [{ id: 1, name: 'Efectivo' }, { id: 2, name: 'Tarjeta' }, { id: 3, name: 'Agencia' }, { id: 4, name: 'Cortesia' }])
    .constant('SALE_PAYMENT_TYPES', [{ id: 2, name: 'Tarjeta' }, { id: 5, name: 'SINPE Movil' }, { id: 1, name: 'Efectivo' }, { id: 3, name: 'Mixto' }])
    .constant('LUGGAGE_PAYMENT_TYPES', [{ id: 1, name: 'Efectivo' }, { id: 2, name: 'Tarjeta' }])
    .constant('REDEEM_PAYMENT_TYPES', [{ id: 1, name: 'Efectivo' }])
    .constant('GENRES', [{ id: 'M', name: 'Masculino' }, { id: 'F', name: 'Femenino' }])
    .constant('WEEKDAYS', [{ id: 1, name: 'Lunes' }, { id: 2, name: 'Martes' }, { id: 3, name: 'Miercoles' }, { id: 4, name: 'Jueves' }, { id: 5, name: 'Viernes' }, { id: 6, name: 'Sábado' }, { id: 7, name: 'Domingo' }])
    .constant('MONTHS', [{ id: 1, name: 'Enero' }, { id: 2, name: 'Febrero' }, { id: 3, name: 'Marzo' }, { id: 4, name: 'Abril' }, { id: 5, name: 'Mayo' }, { id: 4, name: 'Junio' }, { id: 1, name: 'Julio' }, { id: 8, name: 'Agosto' }, { id: 9, name: 'Setiembre' }, { id: 10, name: 'Octubre' }, { id: 11, name: 'Noviembre' }, { id: 12, name: 'Diciembre' }])
    .constant('BUS_LAYOUTS', [
      {
        type: 1,
        label: 'Bus 1 piso 68 pasajeros',
        name: 'Autobús de un nivel:',
        seatMatrixLevels: [
          [
            [
              { seatNumber: 57, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 52, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 48, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 46, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 42, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 38, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 34, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 32, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 28, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 24, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 20, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 16, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 12, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 8, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 4, largeLabel: 'Ventana', type: 'preferential', isOccupied: false, selected: false }
            ],
            [
              { seatNumber: 56, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 51, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 47, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 45, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 41, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 37, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 33, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 31, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 27, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 23, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 19, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 15, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 11, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 7, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 3, largeLabel: 'Pasillo', type: 'preferential', isOccupied: false, selected: false }
            ],
            [
              { seatNumber: 55, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null, null, null, null, null, null, null, null, null, null, null, null, null, null
            ],
            [
              { seatNumber: 54, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 50, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null,
              { seatNumber: 44, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 40, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 36, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null,
              { seatNumber: 30, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 26, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 22, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 17, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 14, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 10, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 6, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 2, largeLabel: 'Pasillo', type: 'preferential', isOccupied: false, selected: false }
            ],
            [
              { seatNumber: 53, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 49, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              null,
              { seatNumber: 43, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 39, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 35, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              null,
              { seatNumber: 29, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 25, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 21, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 18, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 13, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 9, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 5, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 1, largeLabel: 'Ventana', type: 'preferential', isOccupied: false, selected: false }
            ]
          ]
        ],
        standingSeats: [
          { seatNumber: 58, shortLabel: 'DP1', largeLabel: 'De pie 1', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 59, shortLabel: 'DP2', largeLabel: 'De pie 2', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 60, shortLabel: 'DP3', largeLabel: 'De pie 3', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 61, shortLabel: 'DP4', largeLabel: 'De pie 4', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 62, shortLabel: 'DP5', largeLabel: 'De pie 5', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 63, shortLabel: 'DP6', largeLabel: 'De pie 6', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 64, shortLabel: 'DP7', largeLabel: 'De pie 7', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 65, shortLabel: 'DP8', largeLabel: 'De pie 8', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 66, shortLabel: 'DP9', largeLabel: 'De pie 9', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 67, shortLabel: 'DP10', largeLabel: 'De pie 10', type: 'standing', isOccupied: false, selected: false }
        ],
        wheelchairSeats: [
          { seatNumber: 68, shortLabel: 'SR', largeLabel: 'Silla de ruedas', type: 'wheelchair', isOccupied: false, selected: false }
        ]
      },
      {
        type: 2,
        label: 'Bus 2 piso 95 pasajeros',
        name: 'Autobús de dos niveles:',
        seatMatrixLevels: [
          [
            [
              { seatNumber: 80, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 76, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 72, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 68, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 64, largeLabel: 'Ventana', type: 'preferential', isOccupied: false, selected: false },
              { seatNumber: 62, largeLabel: 'Ventana', type: 'preferential', isOccupied: false, selected: false },
              null
            ],
            [
              { seatNumber: 81, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 77, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 73, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 69, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 65, largeLabel: 'Pasillo', type: 'preferential', isOccupied: false, selected: false },
              { seatNumber: 63, largeLabel: 'Pasillo', type: 'preferential', isOccupied: false, selected: false },
              null
            ],
            [
              { seatNumber: 84, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null, null, null, null, null, null
            ],
            [
              { seatNumber: 83, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 79, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 75, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 71, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null, null, null
            ],
            [
              { seatNumber: 82, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 78, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 74, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 70, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 66, shortLabel: 'SR', largeLabel: 'Silla de ruedas', type: 'wheelchair', isOccupied: false, selected: false },
              null,
              { seatNumber: 85, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false }
            ]
          ],
          [
            [
              { seatNumber: 57, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 53, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 49, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 45, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 41, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 37, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 33, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 29, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 25, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 21, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 17, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 15, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 13, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 9, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 5, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 1, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false }
            ],
            [
              { seatNumber: 58, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 54, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 50, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 46, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 42, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 38, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 34, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 30, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 26, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 22, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 18, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 16, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 14, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 10, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 6, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 2, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false }
            ],
            [
              { seatNumber: 61, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null, null, null, null, null, null, null, null, null, null, null, null, null, null, null
            ],
            [
              { seatNumber: 60, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 56, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 52, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 48, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 44, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 40, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 36, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 32, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 28, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 24, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 20, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null, null,
              { seatNumber: 12, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 8, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 4, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false }
            ],
            [
              { seatNumber: 59, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 55, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 51, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 47, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 43, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 39, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 35, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 31, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 27, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 23, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 19, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              null, null,
              { seatNumber: 11, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 7, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 3, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false }
            ]
          ]
        ],
        standingSeats: [
          { seatNumber: 86, shortLabel: 'DP1', largeLabel: 'De pie 1', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 87, shortLabel: 'DP2', largeLabel: 'De pie 2', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 88, shortLabel: 'DP3', largeLabel: 'De pie 3', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 89, shortLabel: 'DP4', largeLabel: 'De pie 4', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 90, shortLabel: 'DP5', largeLabel: 'De pie 5', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 91, shortLabel: 'DP6', largeLabel: 'De pie 6', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 92, shortLabel: 'DP7', largeLabel: 'De pie 7', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 93, shortLabel: 'DP8', largeLabel: 'De pie 8', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 94, shortLabel: 'DP9', largeLabel: 'De pie 9', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 95, shortLabel: 'DP10', largeLabel: 'De pie 10', type: 'standing', isOccupied: false, selected: false }
        ],
        wheelchairSeats: []
      },
      {
        type: 3,
        label: 'Bus 3 piso 64 pasajeros',
        name: 'Autobús de un nivel:',
        seatMatrixLevels: [
          [
            [
              { seatNumber: 55, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 50, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 48, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 44, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 40, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 36, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 32, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 28, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 24, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 20, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 16, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 12, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 8, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 4, largeLabel: 'Ventana', type: 'preferential', isOccupied: false, selected: false }
            ],
            [
              { seatNumber: 54, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 49, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 47, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 43, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 39, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 35, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 31, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 27, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 23, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 19, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 15, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 11, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 7, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 3, largeLabel: 'Pasillo', type: 'preferential', isOccupied: false, selected: false }
            ],
            [
              { seatNumber: 53, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null, null, null, null, null, null, null, null, null, null, null, null, null, null
            ],
            [
              { seatNumber: 52, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null,
              { seatNumber: 46, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 42, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 38, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 34, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              null,
              { seatNumber: 26, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 22, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 18, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 14, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 10, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 6, largeLabel: 'Pasillo', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 2, largeLabel: 'Pasillo', type: 'preferential', isOccupied: false, selected: false }
            ],
            [
              { seatNumber: 51, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              null,
              { seatNumber: 45, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 41, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 37, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 33, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              null,
              { seatNumber: 25, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 21, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 17, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 13, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 9, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 5, largeLabel: 'Ventana', type: 'normal', isOccupied: false, selected: false },
              { seatNumber: 1, largeLabel: 'Ventana', type: 'preferential', isOccupied: false, selected: false }
            ]
          ]
        ],
        standingSeats: [
          { seatNumber: 56, shortLabel: 'DP1', largeLabel: 'De pie 1', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 57, shortLabel: 'DP2', largeLabel: 'De pie 2', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 58, shortLabel: 'DP3', largeLabel: 'De pie 3', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 59, shortLabel: 'DP4', largeLabel: 'De pie 4', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 60, shortLabel: 'DP5', largeLabel: 'De pie 5', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 61, shortLabel: 'DP6', largeLabel: 'De pie 6', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 62, shortLabel: 'DP7', largeLabel: 'De pie 7', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 63, shortLabel: 'DP8', largeLabel: 'De pie 8', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 64, shortLabel: 'DP9', largeLabel: 'De pie 9', type: 'standing', isOccupied: false, selected: false },
          { seatNumber: 65, shortLabel: 'DP10', largeLabel: 'De pie 10', type: 'standing', isOccupied: false, selected: false }
        ],
        wheelchairSeats: [
          { seatNumber: 66, shortLabel: 'SR', largeLabel: 'Silla de ruedas', type: 'wheelchair', isOccupied: false, selected: false }
        ]
      }
    ])
    .constant('HEADER_MENU', [
      {
        text: 'Ventas',
        title: 'Ventas',
        routerState: 'sales',
        icon: 'fa-user',
        requiredPermissions: ['TICKET_EDIT', 'TICKET_READ', 'CASH_EDIT', 'TICKET_EDIT_SPECIAL', 'PASSENGER_LIST_VIEW'],
        subNavItems: [
          {
            text: 'Boletos',
            title: 'Boletos',
            routerState: 'sales.tickets',
            icon: 'fa-ticket',
            requiredPermissions: ['TICKET_EDIT']
          },
          {
            text: 'Buscar Boleto',
            title: 'Buscar Boleto',
            routerState: 'sales.searchTickets',
            icon: 'fa-ticket',
            requiredPermissions: ['TICKET_EDIT']
          },
          {
            text: 'Editar Boleto',
            title: 'Editar Boleto',
            routerState: 'sales.editTickets',
            icon: 'fa-ticket',
            requiredPermissions: ['TICKET_EDIT_SPECIAL']
          },
          {
            text: 'Historial Boleto',
            title: 'Historial de Boleto',
            routerState: 'sales.ticketsHistory',
            icon: 'fa-ticket',
            requiredPermissions: ['TICKET_EDIT']
          },
          {
            text: 'Cambiar Abordaje',
            title: 'Cambiar Abordaje',
            routerState: 'sales.editTicketsBoarding',
            icon: 'fa-ticket',
            requiredPermissions: ['TICKET_EDIT']
          },
          /*{
            text:'Redimir',
            title:'Redimir',
            routerState:'sales.redeem',
            icon: 'fa-ticket',
            requiredPermissions: ['TICKET_EDIT']
          },*/
          {
            text: 'Control de Cajas',
            title: 'Control de Cajas',
            routerState: 'sales.till',
            icon: 'fa-cash',
            requiredPermissions: ['CASH_EDIT']
          },
          {
            text: 'Ventas de Agencia',
            title: 'Ventas de Agencia',
            routerState: 'sales.agencySales',
            icon: 'fa-cash',
            requiredPermissions: ['AGENCY']
          },
          {
            text: 'Chequeos',
            title: 'Chequeos',
            routerState: 'sales.tripChecks',
            icon: 'fa-ticket',
            requiredPermissions: ['PASSENGER_LIST_VIEW']
          }
        ]
      },
      /*{
        text:'Carga',
        title:'Carga',
        routerState:'entrust',
        icon: 'fa-user',
        requiredPermissions: ['PACKING_TYPES_READ'],
        subNavItems :[
          {
            text:'Tipos de Carga',
            routerState:'entrust.packingTypes',
            title:'Mantenimiento de Tipos de Carga',
            requiredPermissions: ['PACKING_TYPES_READ']
          }
        ]
      },*/
      {
        text: 'Reportes',
        title: 'Reportes',
        routerState: 'reports',
        icon: 'fa-user',
        requiredPermissions: ['REPORT_TICKETS', 'REPORT_CASHIER_BALANCE', 'REPORT_OCUPATION_MATRIX', 'REPORT_TAXES', 'REPORT_DRIVERS', 'REPORT_INSURANCE', 'ACCOUNTING', 'REPORT_DRIVER_TAXES', 'REPORT_CLIENT_TICKETS', 'REPORT_OTP', 'REPORT_TICKETS_EDITED'],
        subNavItems: [
          {
            text: 'Cierre de Cajas',
            routerState: 'reports.cashRegistersBalances',
            title: 'Reporte de Cierres de Caja',
            requiredPermissions: ['REPORT_CASHIER_BALANCE']
          },
          {
            text: 'Resumen de Ventas',
            routerState: 'reports.salesSummary',
            title: 'Resumen de Ventas',
            requiredPermissions: ['ACCOUNTING']
          },
          {
            text: 'Matriz de ocupación',
            routerState: 'reports.occupationMatrix',
            title: 'Matriz de ocupación',
            requiredPermissions: ['REPORT_OCUPATION_MATRIX']
          },
          {
            text: 'Ventas',
            routerState: 'reports.salesReport',
            title: 'Reporte de Ventas',
            requiredPermissions: ['REPORT_TAXES', 'REPORT_DRIVER_TAXES']
          },
          {
            text: 'Choferes Asignados',
            routerState: 'reports.busDriversReport',
            title: 'Reporte de Choferes Asignados',
            requiredPermissions: ['REPORT_DRIVERS']
          },
          {
            text: 'Pago a Choferes',
            routerState: 'reports.driverPayment',
            title: 'Reporte para pago a choferes',
            requiredPermissions: ['REPORT_DRIVERS']
          },
          {
            text: 'Seguros',
            routerState: 'reports.insuranceReport',
            title: 'Reporte de Seguros',
            requiredPermissions: ['REPORT_INSURANCE']
          },
          /*{
            text:'Pasajeros',
            routerState:'reports.passengersReport',
            title:'Reporte de Pasajeros',
            requiredPermissions: ['CASH_READ']
          },*/
          {
            text: 'Boletos Emitidos',
            routerState: 'reports.ticketsIssued',
            title: 'Reporte de Boletos Emitidos',
            requiredPermissions: ['REPORT_TICKETS']
          },
          {
            text: 'Consolidado de Ventas',
            routerState: 'reports.consolidatedSales',
            title: 'Reporte de Consolidado de Ventas',
            requiredPermissions: ['ACCOUNTING']
          },
          {
            text: 'Boletos por Referencia',
            routerState: 'reports.clientTickets',
            title: 'Reporte de Boletos por referencia',
            requiredPermissions: ['REPORT_TICKETS', 'REPORT_CLIENT_TICKETS']
          },
          {
            text: 'Contabilidad',
            routerState: 'reports.accounting',
            title: 'Reporte de Contabilidad',
            requiredPermissions: ['ACCOUNTING']
          },
          {
            text: 'ERP',
            routerState: 'reports.erp',
            title: 'Reporte ERP (Ventas y Egresos)',
            requiredPermissions: ['ACCOUNTING']
          },
          {
            text: 'OTP',
            routerState: 'reports.otpReport',
            title: 'Reporte OTP',
            requiredPermissions: ['REPORT_OTP']
          },
          {
            text: 'Boletos Editados',
            routerState: 'reports.editedTickets',
            title: 'Reporte de boletos editados',
            requiredPermissions: ['REPORT_TICKETS_EDITED']
          }
        ]
      },
      {
        text: 'Administración',
        title: 'Administración',
        routerState: 'administration',
        icon: 'fa-user',
        requiredPermissions: ['USER_READ', 'ROLE_READ', 'CURRENCY_READ', 'TERMINAL_READ', 'BUS_READ', 'ROUTE_READ', 'RESELLER_READ', 'TRIP_READ', 'EXCHANGE_READ'],
        subNavItems: [
          {
            text: 'Usuarios',
            routerState: 'administration.users',
            title: 'Administración de Usuarios',
            requiredPermissions: ['USER_READ']
          },
          {
            text: 'Perfiles',
            routerState: 'administration.profiles',
            title: 'Administración de Perfiles',
            requiredPermissions: ['ROLE_READ']
          },
          {
            text: 'Paises',
            routerState: 'administration.countries',
            title: 'Mantenimiento de Paises',
            requiredPermissions: ['CURRENCY_READ']
          },
          {
            text: 'Terminales',
            routerState: 'administration.terminals',
            title: 'Mantenimiento de Paises',
            requiredPermissions: ['TERMINAL_READ']
          },
          {
            text: 'Buses',
            routerState: 'administration.buses',
            title: 'Mantenimiento de Buses',
            requiredPermissions: ['BUS_READ']
          },
          {
            text: 'Rutas',
            routerState: 'administration.routes',
            title: 'Mantenimiento de Rutas',
            requiredPermissions: ['ROUTE_READ']
          },
          /*{
            text:'Códigos Externos',
            routerState:'administration.external-codes',
            title:'Mantenimiento de Códigos Externos',
            requiredPermissions: ['ROUTE_READ']
          },*/
          {
            text: 'Agencias',
            routerState: 'administration.resellers',
            title: 'Mantenimiento de Agencias',
            requiredPermissions: ['RESELLER_READ']
          },
          {
            text: 'Viajes Generados',
            routerState: 'administration.generatedTrips',
            title: 'Viajes Generados',
            requiredPermissions: ['TRIP_READ']
          },
          {
            text: 'Administrar Viaje',
            routerState: 'administration.trips',
            title: 'Administración de Viajes',
            requiredPermissions: ['TRIP_READ']
          },
          {
            text: 'Tipo de Cambio',
            routerState: 'administration.dollarExchange',
            title: 'Tipo de Cambio',
            requiredPermissions: ['DOLLAR_EXCHANGE_READ']
          }
        ]
      }/*,
      {
        text:'Configuración',
        title:'Configuración',
        routerState:'configuration',
        icon: 'fa-user',
        requiredPermissions: [],
        subNavItems :[
        ]
      }*/
    ])
    .constant('FOOTER_MENU', [
      {
        text: 'Ayuda',
        title: 'Ayuda',
        routerState: 'ayuda'
      },
      {
        text: 'Políticas',
        title: 'Políticas',
        routerState: 'politicas'
      },
      {
        text: 'Terminos y Condiciones',
        title: 'Terminos y Condiciones',
        routerState: 'terminos'
      }
    ])
    .constant('PUBLIC_KEY', 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDL+IL/JABs/hLvBrVeOXky47TE79rUNEyAaXhXvDyZAY2rWeCojtIZBZ/HOxGX94PUvERUz7lj5UiBOUfIxN5sgZ/9fu2BLe+Clm3f3mELxs1Kzt5A6JiYLtzp02rtoP7fkejlOcjNpH3b5dPyjqg/8pnUBIMJ02uth+I9PPb/BwIDAQAB')
    .constant('PROD_PUBLIC_KEY', 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGMpEa3deZmzbUAZfszmdwrltHzZLdIkoG9NG35N8gHyQv4i6sWuGXJvIIvgdnWntWIIdaJSr/8cTQqvnd7YUGecRJ10RNwt17W7axCSTGB3ROppnGfihEVJ3w4L0zrwcotfDE58HML7nx7Gwsh9zuUp+aNc+jv9IeDt382DhDyQIDAQAB');

})();

(function() {
  'use strict';

  angular
    .module('tnsp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $httpProvider, IdleProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // HTTP Interceptor
    $httpProvider.interceptors.push('authHttpResponseInterceptor');

    // Set Toastr options
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.progressBar = true;
    toastrConfig.closeButton = true;

    // Idle: 10 min in production)
    IdleProvider.idle(600);
    IdleProvider.timeout(5);
  }

})();

angular.module("tnsp").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/bus-layout/bus-layout.html","<div class=container><div ng-repeat=\"level in vm.busLayout.seatMatrixLevels track by $index\" class=\"row m-bottom-10\" ng-class=\"{\'justify-content-end\': vm.busLayout.seatMatrixLevels.length > 1 && $index === 0}\"><div class=col-md-12 ng-class=\"{\'col-lg-7 col-xl-6\': vm.busLayout.seatMatrixLevels.length > 1 && $index === 0}\"><h5 ng-if=\"vm.busLayout.seatMatrixLevels.length === 1 && $index === 0\" class=\"title-bus-level d-none d-lg-block\">Ventana</h5><div ng-if=\"vm.busLayout.seatMatrixLevels.length > 1\"><h5 ng-if=\"$index === 0\" class=title-bus-level>Primer nivel</h5><h5 ng-if=\"$index === 1\" class=title-bus-level>Segundo nivel</h5></div><div class=seat-normal-leves ng-class=\"{\'show-caption-seat\': vm.busLayout.seatMatrixLevels.length === 1 && $index === 0}\"><div class=seat-container-leves><div class=seat-row-leves ng-repeat=\"row in level track by $index\"><div class=seat-btn-normal ng-repeat=\"seat in row track by $index\"><button ng-if=seat type=button class=btn-seat ng-class=\"{\n                        \'btn-border-normal\': seat.type === \'normal\',\n                        \'btn-border-special\': seat.type === \'preferential\',\n                        \'btn-border-wheel\': seat.type === \'wheelchair\',\n                        \'selected\': seat.selected,\n                        \'occupied\': seat.isOccupied\n                      }\" ng-disabled=vm.isSeatDisabled(seat) ng-click=vm.toggleSeatSelection(seat)>{{ seat.type === \'wheelchair\' ? seat.shortLabel : seat.seatNumber }}</button></div></div></div><div ng-if=\"$index === 0\" class=steering-wheel><img src=/assets/images/steering-wheel.png alt=\"steering wheel\" class=img-fluid></div></div><h5 ng-if=\"vm.busLayout.seatMatrixLevels.length === 1 && $index === 0\" class=\"title-bus-level d-none d-lg-block\">Ventana</h5></div></div><!-- Standing seats --><div ng-if=\"vm.busLayout.standingSeats.length > 0\" class=\"row m-bottom-10\"><div class=col-md-12><h5 class=title-bus-level>De pie</h5><div class=seat-special-leves><div class=seat-container-leves><div class=\"seat-row-leves seat-special-row-leves\"><div class=seat-btn-special ng-repeat=\"seat in vm.busLayout.standingSeats track by $index\"><button type=button class=\"btn-seat btn-border-standing\" ng-class=\"{\n                        \'selected\': seat.selected,\n                        \'occupied\': seat.isOccupied\n                      }\" ng-disabled=vm.isSeatDisabled(seat) ng-click=vm.toggleSeatSelection(seat)>{{ seat.shortLabel }}</button></div></div></div></div></div></div><!-- Wheelchair seats --><div ng-if=\"vm.busLayout.wheelchairSeats.length > 0\" class=\"row m-bottom-20\"><div class=col-md-12><h5 class=title-bus-level>Silla de ruedas</h5><div class=seat-special-leves><div class=seat-container-leves><div class=\"seat-row-leves seat-special-row-leves\"><div class=seat-btn-special ng-repeat=\"seat in vm.busLayout.wheelchairSeats track by $index\"><button type=button class=\"btn-seat btn-border-wheel\" ng-class=\"{\n                        \'selected\': seat.selected,\n                        \'occupied\': seat.isOccupied\n                      }\" ng-disabled=vm.isSeatDisabled(seat) ng-click=vm.toggleSeatSelection(seat)>{{ seat.shortLabel }}</button></div></div></div></div></div></div><!-- Legend --><div class=\"row m-bottom-20\"><div class=\"col-xs-12 col-sm-2 col-lg\"><div class=\"media m-bottom-10\"><div class=media-left><div class=seat-caption-available></div></div><div class=\"media-body caption-content-center\"><h5 class=seat-caption>Silla disponible</h5></div></div></div><div class=\"col-xs-12 col-sm-2 col-lg\"><div class=\"media m-bottom-10\"><div class=media-left><div class=seat-caption-occupied></div></div><div class=\"media-body caption-content-center\"><h5 class=seat-caption>Silla ocupada</h5></div></div></div><div class=\"col-xs-12 col-sm-2 col-lg\"><div class=\"media m-bottom-10\"><div class=media-left><div class=seat-caption-selected></div></div><div class=\"media-body caption-content-center\"><h5 class=seat-caption>Silla elegida</h5></div></div></div><div class=\"col-xs-12 col-sm-2 col-lg\"><div class=\"media m-bottom-10\"><div class=media-left><div class=seat-caption-special-needs></div></div><div class=\"media-body caption-content-center\"><h5 class=seat-caption>Silla especial</h5></div></div></div><div class=\"col-xs-12 col-sm-2 col-lg\"><div class=\"media m-bottom-10\"><div class=media-left><div class=seat-caption-wheel>SR</div></div><div class=\"media-body caption-content-center\"><h5 class=seat-caption>Silla de ruedas</h5></div></div></div></div></div>");
$templateCache.put("app/components/footer/footer.html","<footer class=container-fluid><div class=\"row max-width-content\"><div class=col-xs-12><p>Designed By: crpassion</p></div></div></footer>");
$templateCache.put("app/components/header/header.html","<header class=container-fluid><div class=row><nav class=\"navbar navbar-static-top\"><div class=col-xs-12><div class=navbar-header><a class=navbar-brand ui-sref=home title=TIG><img src=assets/images/tig-logo.png class=img-responsive alt=TIG></a></div><div id=HeaderNavbar ng-if=header.showMenu><div class=\"nav navbar-nav pull-left\"><a ng-show=header.userInfo.openCash class=cashier ui-sref=sales.till><i class=\"fa fa-laptop\"></i> {{header.userInfo.openCash.name}}</a> <a ng-show=\"header.userInfo.reseller != null\" class=cashier><i class=\"fa fa-home\"></i> {{header.userInfo.reseller.name}}</a></div><div class=\"nav navbar-nav pull-right\"><div class=\"header-settings dropdown\"><a class=dropdown-toggle data-toggle=dropdown href=# ng-click=$event.preventDefault();>{{header.userInfo.firstName}} {{header.userInfo.lastName}} <i class=\"fa fa-angle-down\"></i></a><ul class=dropdown-menu><li><a ng-click=header.logout()>Salir</a></li></ul></div></div><ul class=\"nav navbar-nav pull-right\"><li ng-repeat=\"item in header.menu\" ng-if=\"item.isUserAllowed && !(header.userInfo.reseller != null && item.title==\'Administración\' )\"><a ui-sref={{item.routerState}} title={{item.title}} ui-sref-active=active><i ng-if=item.icon class=\"fa fa-{{item.icon}}\"></i>{{item.text}}</a></li></ul></div></div></nav><div class=\"sub-menu hidden-print\" ng-show=\"header.submenu.length > 0\" ng-if=header.showMenu><div class=\"row max-width-content\"><div class=col-xs-12><ul class=\"nav navbar-nav\"><li ng-repeat=\"item in header.submenu\" ng-if=item.isUserAllowed><a ui-sref={{item.routerState}} title={{item.title}} ui-sref-active=active>{{item.text}}</a></li></ul></div></div></div></div></header>");
$templateCache.put("app/components/modal-add-cancellation-form/modal-add-cancellation-form.html","<div class=\"modal fade\" id=modalAddCancellationForm tabindex=-1 role=dialog aria-labelledby=modalAddCancellationForm><div class=modal-dialog role=document><div class=modal-content><form id=addCancellationForm name=addCancellationForm ng-submit=mAddCancellationForm.submitProcess(addCancellationForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Anulaciones</h4></div><div class=modal-body><div class=row><div class=col-xs-12><div class=form-group><label>Número de Tiquete</label><input type=text name=Id id=Id class=form-control ng-model=mAddCancellationForm.addCancellation.id required><div class=error ng-messages=addCancellationForm.Id.$error ng-show=mAddCancellationForm.submitAttempt><p ng-message=required>El número de tiquete es requerido</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mAddCancellationForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/loading-overlay/loading-overlay.html","<div class=tnsp-overlay><img src=assets/images/loading.gif alt=loading></div>");
$templateCache.put("app/components/modal-add-movement-form/modal-add-movement-form.html","<div class=\"modal fade\" id=modalAddMovementForm tabindex=-1 role=dialog aria-labelledby=modalAddMovementForm><div class=modal-dialog role=document><div class=modal-content><form id=addMovementForm name=addMovementForm ng-submit=mAddMovementForm.submitProcess(addMovementForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Agregar Movimiento</h4></div><div class=modal-body><div class=row><div class=col-xs-12><div class=form-group><label>Tipo</label><select name=Type id=Type class=form-control ng-model=mAddMovementForm.addMovement.type.id ng-options=\"tt.id as tt.name for tt in mAddMovementForm.transactionTypes\" ng-change=\"mAddMovementForm.addMovement.detail = \'\'\" required><option value=\"\">Seleccione un tipo</option></select><div class=error ng-messages=addMovementForm.Type.$error ng-show=mAddMovementForm.submitAttempt><p ng-message=required>El Tipo es requerido</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Detalle</label><textarea name=Detail class=form-control ng-model=mAddMovementForm.addMovement.detail ng-change=mAddMovementForm.cleanDetail() ng-attr-rows=\"{{ mAddMovementForm.isSingleLineDetail() ? 1 : 3 }}\" maxlength=\"{{ mAddMovementForm.isSingleLineDetail() ? 49 : \'\' }}\" ng-keydown=\"mAddMovementForm.isSingleLineDetail() && $event.keyCode == 13 ? $event.preventDefault() : null\" required>\n                </textarea><div class=error ng-messages=addMovementForm.Detail.$error ng-show=mAddMovementForm.submitAttempt><p ng-message=required>El Detalle es requerido</p></div></div></div></div><div class=row ng-show=\"mAddMovementForm.addMovement.type.id !== mAddMovementForm.additionalIncomeFieldNeededs\"><div class=col-xs-12><div class=form-group><label>Monto</label><input type=text name=Rate id=Rate class=form-control ng-model=mAddMovementForm.addMovement.rate ui-number-mask ng-required=\"mAddMovementForm.addMovement.type.id !== mAddMovementForm.additionalIncomeFieldNeededs\"><div class=error ng-messages=addMovementForm.Rate.$error ng-show=mAddMovementForm.submitAttempt><p ng-message=required>El Monto es requerido</p></div></div></div></div><div ng-show=\"mAddMovementForm.addMovement.type.id === mAddMovementForm.additionalIncomeFieldNeededs\"><div class=row><div class=col-xs-6><div class=form-group><label>Tarjeta</label><input type=text name=CardAmount id=CardAmount class=form-control ng-model=mAddMovementForm.addMovement.cardAmount ng-required=\"mAddMovementForm.addMovement.type.id === mAddMovementForm.additionalIncomeFieldNeededs && !mAddMovementForm.addMovement.cardAmount && !mAddMovementForm.addMovement.sinpeAmount && !mAddMovementForm.addMovement.cashAmount\" ng-pattern=/^[0-9]+$/ oninput=\"this.value=this.value.replace(/[^0-9]/g,\'\')\"></div></div><div class=col-xs-6><div class=form-group><label>Autorización</label><input type=text name=CardReference id=CardReference class=form-control ng-model=mAddMovementForm.addMovement.cardReference ng-required=\"mAddMovementForm.addMovement.type.id === mAddMovementForm.additionalIncomeFieldNeededs && !!mAddMovementForm.addMovement.cardAmount\" ng-pattern=/^[0-9]+$/ oninput=\"this.value=this.value.replace(/[^0-9]/g,\'\')\"><div class=error ng-messages=addMovementForm.CardReference.$error ng-show=mAddMovementForm.submitAttempt><p ng-message=required>La autorización es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>SINPE</label><input type=text name=SinpeAmount id=SinpeAmount class=form-control ng-model=mAddMovementForm.addMovement.sinpeAmount ng-required=\"mAddMovementForm.addMovement.type.id === mAddMovementForm.additionalIncomeFieldNeededs && !mAddMovementForm.addMovement.cardAmount && !mAddMovementForm.addMovement.sinpeAmount && !mAddMovementForm.addMovement.cashAmount\" ng-pattern=/^[0-9]+$/ oninput=\"this.value=this.value.replace(/[^0-9]/g,\'\')\"></div></div><div class=col-xs-6><div class=form-group><label>Autorización</label><input type=text name=SinpeReference id=SinpeReference class=form-control ng-model=mAddMovementForm.addMovement.sinpeReference ng-required=\"mAddMovementForm.addMovement.type.id === mAddMovementForm.additionalIncomeFieldNeededs && !!mAddMovementForm.addMovement.sinpeReference\" ng-pattern=/^[0-9]+$/ oninput=\"this.value=this.value.replace(/[^0-9]/g,\'\')\"><div class=error ng-messages=addMovementForm.SinpeReference.$error ng-show=mAddMovementForm.submitAttempt><p ng-message=required>La autorización es requerida</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Efectivo</label><input type=text name=CashAmount id=CashAmount class=form-control ng-model=mAddMovementForm.addMovement.cashAmount ng-required=\"mAddMovementForm.addMovement.type.id === mAddMovementForm.additionalIncomeFieldNeededs && !mAddMovementForm.addMovement.cardAmount && !mAddMovementForm.addMovement.sinpeAmount && !mAddMovementForm.addMovement.cashAmount\" ng-pattern=/^[0-9]+$/ oninput=\"this.value=this.value.replace(/[^0-9]/g,\'\')\"></div></div></div><div class=row><div class=col-xs-12><div class=error ng-show=\"mAddMovementForm.submitAttempt && !mAddMovementForm.addMovement.cardAmount && !mAddMovementForm.addMovement.sinpeAmount && !mAddMovementForm.addMovement.cashAmount\"><p>Elige un metodo de ingreso</p></div></div></div></div><div class=row ng-show=\"mAddMovementForm.addMovement.type.id === mAddMovementForm.additionalEgressFieldNeededs\"><div class=col-xs-12><hr><div class=form-group><label>Factura de soporte (solo números)</label><input type=text name=Invoice id=Invoice class=form-control ng-model=mAddMovementForm.addMovement.transactionExternalId ng-required=\"mAddMovementForm.addMovement.type.id === mAddMovementForm.additionalEgressFieldNeededs\" ng-pattern=/^[0-9]+$/ oninput=\"this.value=this.value.replace(/[^0-9]/g,\'\')\"><div class=error ng-messages=addMovementForm.Invoice.$error ng-show=mAddMovementForm.submitAttempt><p ng-message=required>El Monto es requerido</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mAddMovementForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-boarding-form/modal-boarding-form.html","<div class=\"modal fade\" id=modalBoardingForm tabindex=-1 role=dialog aria-labelledby=modalBoardingForm><div class=modal-dialog role=document><div class=modal-content><form id=boardingForm name=boardingForm ng-submit=mBoardingForm.submitProcess(boardingForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mBoardingForm.type===\'create\'\">Crear</span> <span ng-show=\"mBoardingForm.type===\'edit\'\">Editar</span> Abordaje</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=Name id=Name class=form-control ng-model=mBoardingForm.boarding.name required><div class=error ng-messages=boardingForm.Name.$error ng-show=mBoardingForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Precio</label><input type=text name=Rate id=Rate class=form-control ng-model=mBoardingForm.boarding.rate ui-number-mask></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Description</label><textarea rows=4 name=Description id=Description class=form-control ng-model=mBoardingForm.boarding.description required></textarea><div class=error ng-messages=boardingForm.Description.$error ng-show=mBoardingForm.submitAttempt><p ng-message=required>La Descripción es requerida</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mBoardingForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-bus-form/modal-bus-form.html","<div class=\"modal fade\" id=modalBusForm tabindex=-1 role=dialog aria-labelledby=modalBusForm><div class=modal-dialog role=document><div class=modal-content><form id=busForm name=busForm ng-submit=mBusForm.submitProcess(busForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mBusForm.type===\'create\'\">Crear</span> <span ng-show=\"mBusForm.type===\'edit\'\">Editar</span> Bus</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Placa</label><input type=text name=LicensePlate id=LicensePlate class=form-control ng-model=mBusForm.bus.licensePlate required><div class=error ng-messages=busForm.LicensePlate.$error ng-show=mBusForm.submitAttempt><p ng-message=required>La Placa es requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label>Capacidad</label><input type=text name=Capacity id=Capacity class=form-control ng-model=mBusForm.bus.capacity ng-pattern=mBusForm.onlyNumbers required><div class=error ng-messages=busForm.Capacity.$error ng-show=mBusForm.submitAttempt><p ng-message=required>La Capacidad es requerida</p><p ng-message=pattern>Solo números</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Clase de Bus</label><select name=BusClass id=BusClass class=form-control ng-model=mBusForm.bus.busClass.id ng-options=\"bc.id as bc.name for bc in mBusForm.busClasses\" required><option value=\"\">Seleccione una Clase de Bus</option></select><div class=error ng-messages=busForm.BusClass.$error ng-show=mBusForm.submitAttempt><p ng-message=required>La Clase de Bus es requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label>Diseño de bus</label><select name=layoutType id=layoutType class=form-control ng-model=mBusForm.bus.layoutType ng-options=\"lt.type as lt.label for lt in mBusForm.layoutTypes\" required><option value=\"\">Seleccione un diseño</option></select><div class=error ng-messages=busForm.layoutType.$error ng-show=mBusForm.submitAttempt><p ng-message=required>El diseño es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>País</label><select name=Country id=Country class=form-control ng-model=mBusForm.bus.country.id ng-options=\"c.id as c.name for c in mBusForm.countries\" required><option value=\"\">Seleccione un País</option></select><div class=error ng-messages=busForm.Country.$error ng-show=mBusForm.submitAttempt><p ng-message=required>El País es requerido</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mBusForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-buy-dollars-form/modal-buy-dollars-form.html","<div class=\"modal fade\" id=modalBuyDollarsForm tabindex=-1 role=dialog aria-labelledby=modalBuyDollarsForm><div class=\"modal-dialog modal-md\" role=document><div class=modal-content><form id=BuyDollarsForm name=BuyDollarsForm ng-submit=mBuyDollarsForm.submitProcess(BuyDollarsForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Compra de dolares</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><p class=form-control-static>Fecha: <b>{{mBuyDollarsForm.today}}</b></p></div></div><div class=col-xs-6><div class=form-group><p class=form-control-static>Tipo de cambio: <b>{{mBuyDollarsForm.exchangeRate | currency:\"₡\":2}}</b></p></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=Amount>Monto en dolares</label><input type=text class=\"form-control text-right\" name=Amount id=Amount ng-model=mBuyDollarsForm.dollarExchange.dollarsReceived ng-change=mBuyDollarsForm.calculateTotal() required ui-number-mask><div class=error ng-messages=BuyDollarsForm.Amount.$error ng-show=mBuyDollarsForm.submitAttempt><p ng-message=required>Monto requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label for=Calculation>Monto en colones</label><input type=text class=\"form-control text-right\" name=Calculation id=Calculation ng-model=mBuyDollarsForm.dollarExchange.calculation readonly ui-number-mask></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mBuyDollarsForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-cash-register-balance/modal-cash-register-balance.html","<div class=\"modal fade\" id=modalCashRegisterBalance tabindex=-1 role=dialog aria-labelledby=modalCashRegisterBalance><div class=\"modal-dialog modal-xl\" role=document><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Detalle del cierre de caja</h4></div><div id=printableArea><div class=modal-body><div class=row><div class=col-xs-3><strong>Fecha de Apertura</strong><br>{{mCashRegisterBalance.cashRegisterBalance.openAt | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</div><div class=col-xs-3><strong>Fecha de Cierre</strong><br>{{mCashRegisterBalance.cashRegisterBalance.closeAt | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</div><div class=col-xs-3><strong>Consecutivo de cierre</strong><br>{{mCashRegisterBalance.cashRegisterBalance.consecutive}}</div><div class=col-xs-3><strong>Cajero</strong><br>{{mCashRegisterBalance.cashRegisterBalance.cashOwner}}</div></div><div class=\"row m-top-10\"><div class=col-xs-3><strong>Efectivo Inicial en caja</strong><br><span class=\"text-muted font-light-small\">(dinero con que abrió la caja)</span><br>{{mCashRegisterBalance.cashRegisterBalance.openingAmount | currency:\"₡\":0}}</div><div class=col-xs-3><strong>Egresos / salida de efectivo</strong><br><span class=\"text-muted font-light-small\">(dinero que sale de la caja)</span><br>({{mCashRegisterBalance.cashRegisterBalance.totalEgress | currency:\"₡\":0}})</div><div class=col-xs-3><strong>Compra de dólares</strong><br><span class=\"text-muted font-light-small\">(colones utilizados para comprar dólares)</span><br>{{mCashRegisterBalance.cashRegisterBalance.colonesSold | currency:\"₡\":0}}</div><div class=col-xs-3><strong>Dólares en caja</strong><br><span class=\"text-muted font-light-small\">(lo que debería haber fisicamente)</span><br>{{mCashRegisterBalance.cashRegisterBalance.dollarsReceived | currency:\"$\":0}}</div></div><div class=\"row m-top-10\"><div class=col-xs-3><strong>Ventas cobradas con Tarjeta</strong><br><span class=\"text-muted font-light-small\">(Boletos + ajustes con Tarjeta)</span><br>{{mCashRegisterBalance.cashRegisterBalance.totalCard | currency:\"₡\":0}}</div><div class=col-xs-3><strong>Ventas cobradas por SINPE</strong><br><span class=\"text-muted font-light-small\">(Boletos + ajustes por SINPE)</span><br>{{mCashRegisterBalance.cashRegisterBalance.totalSinpe | currency:\"₡\":0}}</div><div class=col-xs-3><strong>Cierre total de ventas</strong><br><span class=\"text-muted font-light-small\">(Efectivo + tarjeta + Sinpe + ajustes en tarjeta + ajustes en Sinpe + ajustes en efectivo - egresos - compra de dólares)</span><br>{{mCashRegisterBalance.cashRegisterBalance.totalIncome | currency:\"₡\":0}}</div><div class=col-xs-3><strong>Efectivo en caja (colones)</strong><br><span class=\"text-muted font-light-small\">(Efectivo + ajustes en efectivo - egresos - compra de dólares)</span><br>{{mCashRegisterBalance.cashRegisterBalance.totalCash | currency:\"₡\":0}}</div></div><div class=row ng-if=!mCashRegisterBalance.current><div class=col-xs-12><hr style=\"border-color: #CCC; border-width: 1px\"></div><div class=col-xs-4><strong>Efectivo en Colones</strong> <span class=\"text-muted font-light-small\">(esperados / entregados)</span><br>{{mCashRegisterBalance.cashRegisterBalance.totalColonesExpected | currency:\"₡\":0}} / {{mCashRegisterBalance.cashRegisterBalance.totalColonesHandedOver | currency:\"₡\":0}}</div><div class=col-xs-4><strong>Efectivo en Dólares</strong> <span class=\"text-muted font-light-small\">(esperados / entregados)</span><br>{{mCashRegisterBalance.cashRegisterBalance.totalDollarsExpected | currency:\"$\":0}} / {{mCashRegisterBalance.cashRegisterBalance.totalDollarsHandedOver || 0 | currency:\"$\":0}}</div><div class=col-xs-4><strong>Observaciones</strong><br>{{mCashRegisterBalance.cashRegisterBalance.observations}}</div></div><hr style=\"border-color: #CCC; border-width: 1px\"><div class=\"row m-top-10\"><div class=col-xs-12><h4>Boletos Vendidos Santa Cruz</h4></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th>Boleto</th><th>Efectivo</th><th>Tarjeta</th><th>SINPE</th><th>Referencia</th><th>AM</th><th>Regular</th><th>Fecha de venta</th><th>Usuario</th></tr></thead><tbody><tr ng-repeat=\"clientTicket in mCashRegisterBalance.ticketListCR\"><td>{{clientTicket.invoiceNumber}}</td><td><span>{{clientTicket.cashAmount | currency:\"₡\":0}}</span></td><td><span>{{clientTicket.cardAmount | currency:\"₡\":0}}</span></td><td><span>{{clientTicket.sinpeAmount | currency:\"₡\":0}}</span></td><td>{{clientTicket.cardReference}}</td><td>{{clientTicket.discount > 0 ? \'1\' : \'\'}}</td><td>{{clientTicket.discount > 0 ? \'\' : \'1\'}}</td><td>{{clientTicket.date | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{clientTicket.user.fullName}}</td></tr><tr><td><b>Totales</b></td><td>{{mCashRegisterBalance.cashRegisterBalance.CR.ticketsOnCash | currency:\"₡\":0}}</td><td>{{mCashRegisterBalance.cashRegisterBalance.CR.ticketsOnCard | currency:\"₡\":0}}</td><td>{{mCashRegisterBalance.cashRegisterBalance.CR.ticketsOnSinpe | currency:\"₡\":0}}</td><td></td><td>{{mCashRegisterBalance.cashRegisterBalance.CR.ticketsOnAmCount}}</td><td>{{mCashRegisterBalance.cashRegisterBalance.CR.ticketsOnRegularCount}}</td><td></td><td><b>Vendidos en Efectivo:</b> {{mCashRegisterBalance.cashRegisterBalance.CR.ticketsOnCashCount}}</td></tr><tr><td colspan=3></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en SINPE móvil:</b> {{mCashRegisterBalance.cashRegisterBalance.CR.ticketsOnSinpeCount}}</td></tr><tr><td colspan=3></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en Tarjeta:</b> {{mCashRegisterBalance.cashRegisterBalance.CR.ticketsOnCardCount}}</td></tr><tr><td colspan=3><b>TOTAL: {{mCashRegisterBalance.cashRegisterBalance.CR.totalTickets | currency:\"₡\":0}}</b></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en Mixto:</b> {{mCashRegisterBalance.cashRegisterBalance.CR.tickesOnMixed}}</td></tr></tbody></table></div></div><div class=\"row m-top-10\"><div class=col-xs-12><h4>Boletos Vendidos Nicoya</h4></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th>Boleto</th><th>Efectivo</th><th>Tarjeta</th><th>SINPE</th><th>Referencia</th><th>AM</th><th>Regular</th><th>Fecha de venta</th><th>Usuario</th></tr></thead><tbody><tr ng-repeat=\"clientTicket in mCashRegisterBalance.ticketListNY\"><td>{{clientTicket.invoiceNumber}}</td><td><span>{{clientTicket.cashAmount | currency:\"₡\":0}}</span></td><td><span>{{clientTicket.cardAmount | currency:\"₡\":0}}</span></td><td><span>{{clientTicket.sinpeAmount | currency:\"₡\":0}}</span></td><td>{{clientTicket.cardReference}}</td><td>{{clientTicket.discount > 0 ? \'1\' : \'\'}}</td><td>{{clientTicket.discount > 0 ? \'\' : \'1\'}}</td><td>{{clientTicket.date | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{clientTicket.user.fullName}}</td></tr><tr><td><b>Totales</b></td><td>{{mCashRegisterBalance.cashRegisterBalance.NY.ticketsOnCash | currency:\"₡\":0}}</td><td>{{mCashRegisterBalance.cashRegisterBalance.NY.ticketsOnCard | currency:\"₡\":0}}</td><td>{{mCashRegisterBalance.cashRegisterBalance.NY.ticketsOnSinpe | currency:\"₡\":0}}</td><td></td><td>{{mCashRegisterBalance.cashRegisterBalance.NY.ticketsOnAmCount}}</td><td>{{mCashRegisterBalance.cashRegisterBalance.NY.ticketsOnRegularCount}}</td><td></td><td><b>Vendidos en Efectivo:</b> {{mCashRegisterBalance.cashRegisterBalance.NY.ticketsOnCashCount}}</td></tr><tr><td colspan=3></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en SINPE móvil:</b> {{mCashRegisterBalance.cashRegisterBalance.NY.ticketsOnSinpeCount}}</td></tr><tr><td colspan=3></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en Tarjeta:</b> {{mCashRegisterBalance.cashRegisterBalance.NY.ticketsOnCardCount}}</td></tr><tr><td colspan=3><b>TOTAL: {{mCashRegisterBalance.cashRegisterBalance.NY.totalTickets | currency:\"₡\":0}}</b></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en Mixto:</b> {{mCashRegisterBalance.cashRegisterBalance.NY.tickesOnMixed}}</td></tr></tbody></table></div></div><hr><div class=row><div class=col-xs-12><h4>Ajustes de Precio</h4></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th>Boleto</th><th>Efectivo</th><th>Tarjeta</th><th>SINPE</th><th>Referencia</th><th>Fecha</th><th>Usuario</th></tr></thead><tbody><tr ng-repeat=\"priceAdjustment in mCashRegisterBalance.cashRegisterBalance.priceAdjustments.tickets\"><td>{{priceAdjustment.invoiceNumber}}</td><td>{{priceAdjustment.cashAmount | currency:\"₡\":0}}</td><td>{{priceAdjustment.cardAmount | currency:\"₡\":0}}</td><td>{{priceAdjustment.sinpeAmount | currency:\"₡\":0}}</td><td>{{priceAdjustment.cardReference}}</td><td>{{priceAdjustment.created | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{priceAdjustment.soldBy}}</td></tr><tr><td><b>Totales</b></td><td>{{mCashRegisterBalance.cashRegisterBalance.priceAdjustments.onCash | currency:\"₡\":0}}</td><td>{{mCashRegisterBalance.cashRegisterBalance.priceAdjustments.onCard | currency:\"₡\":0}}</td><td>{{mCashRegisterBalance.cashRegisterBalance.priceAdjustments.onSinpe | currency:\"₡\":0}}</td><td></td><td></td><td><b>Boletos ajustados:</b> {{mCashRegisterBalance.cashRegisterBalance.priceAdjustments.totalTicketsCount}}</td></tr><tr><td colspan=2><b>TOTAL: {{mCashRegisterBalance.cashRegisterBalance.priceAdjustments.totalTickets | currency:\"₡\":0}}</b></td><td></td><td></td><td></td><td></td><td></td></tr></tbody></table></div></div><hr><div class=row><div class=col-xs-12><h4>Ajustes</h4></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th>Fecha</th><th>Tipo</th><th>Detalle</th><th>Monto</th><th>Empleado</th></tr></thead><tbody><tr ng-repeat=\"adjustment in mCashRegisterBalance.cashRegisterBalance.adjustmentList\"><td>{{adjustment.date | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{adjustment.type.name}}</td><td>{{adjustment.detail}}</td><td>{{adjustment.rate | currency:\"₡\":0}}</td><td>{{adjustment.user.fullName}}</td></tr><tr><td colspan=3 class=text-right>Total</td><td>{{mCashRegisterBalance.cashRegisterBalance.adjustments | currency:\"₡\":0}}</td><td></td></tr></tbody></table></div></div><hr><div class=row><div class=col-xs-12><h4>Compra de Dolares</h4></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th>Fecha</th><th>Monto en dolares</th><th>Monto en colones</th><th>Tipo de cambio</th><th>Empleado</th></tr></thead><tbody><tr ng-repeat=\"transaction in mCashRegisterBalance.cashRegisterBalance.colonesSoldList\"><td>{{transaction.created | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{transaction.dollarsReceived | currency:\"$\":0}}</td><td>{{transaction.colonesSold | currency:\"₡\":0}}</td><td>{{transaction.exchangeRate | currency:\"₡\":0}}</td><td>{{transaction.userFullName}}</td></tr><tr><td class=text-right><b>Total</b></td><td><b>{{mCashRegisterBalance.cashRegisterBalance.dollarsReceived | currency:\"$\":0}}</b></td><td><b>{{mCashRegisterBalance.cashRegisterBalance.colonesSold | currency:\"₡\":0}}</b></td><td></td><td></td></tr></tbody></table></div></div><hr><div class=row><div class=col-xs-12><h4>Otros Ingresos</h4></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th>Fecha</th><th>Tipo</th><th>Detalle</th><th>Monto</th><th>Empleado</th></tr></thead><tbody><tr ng-repeat=\"otherIncome in mCashRegisterBalance.cashRegisterBalance.incomeList\"><td>{{otherIncome.date | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{otherIncome.type.name}}</td><td>{{otherIncome.detail}}</td><td>{{otherIncome.rate | currency:\"₡\":0}}</td><td>{{otherIncome.user.fullName}}</td></tr><tr><td colspan=3 class=text-right>Total</td><td>{{mCashRegisterBalance.cashRegisterBalance.income | currency:\"₡\":0}}</td><td></td></tr></tbody></table></div></div><hr><div class=row><div class=col-xs-12><h4>Otros Egresos</h4></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\"><thead><tr><th>Fecha</th><th>Tipo</th><th>Detalle</th><th>Monto</th><th>Empleado</th></tr></thead><tbody><tr ng-repeat=\"otherOutCome in mCashRegisterBalance.cashRegisterBalance.outcomeList\"><td>{{otherOutCome.date | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{otherOutCome.type.name}}</td><td>{{otherOutCome.detail}}</td><td>{{otherOutCome.rate | currency:\"₡\":0}}</td><td>{{otherOutCome.user.fullName}}</td></tr><tr><td colspan=3 class=text-right>Total</td><td>{{mCashRegisterBalance.cashRegisterBalance.outcome | currency:\"₡\":0}}</td><td></td></tr></tbody></table></div></div></div></div><iframe id=printableAreaFrame name=printableAreaFrame style=\"display: none\"></iframe><div class=modal-footer><button type=button class=\"btn btn-primary\" ng-click=mCashRegisterBalance.print()>Imprimir</button> <button type=button class=\"btn btn-default\" data-dismiss=modal>Cerrar</button></div></div></div></div>");
$templateCache.put("app/components/modal-cash-register-form/modal-cash-register-form.html","<div class=\"modal fade\" id=modalCashRegisterForm tabindex=-1 role=dialog aria-labelledby=modalCashRegisterForm><div class=modal-dialog role=document><div class=modal-content><form id=cashRegisterForm name=cashRegisterForm ng-submit=mCashRegisterForm.submitProcess(cashRegisterForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mCashRegisterForm.type===\'create\'\">Crear</span> <span ng-show=\"mCashRegisterForm.type===\'edit\'\">Editar</span> Caja Registradora</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=Name id=Name class=form-control ng-model=mCashRegisterForm.cashRegister.name required><div class=error ng-messages=cashRegisterForm.Name.$error ng-show=mCashRegisterForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Descripción</label><textarea rows=4 name=Description id=Description class=form-control ng-model=mCashRegisterForm.cashRegister.description required></textarea><div class=error ng-messages=cashRegisterForm.Description.$error ng-show=mCashRegisterForm.submitAttempt><p ng-message=required>La Descripción es requerida</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Usuario Asignado</label><select name=User id=User class=form-control ng-model=mCashRegisterForm.cashRegister.user.id ng-options=\"user.id as user.fullName for user in mCashRegisterForm.users\"><option value=\"\">Seleccione un Usuario</option></select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mCashRegisterForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-client-form/modal-client-form.html","<div class=\"modal fade\" id=modalClientForm tabindex=-1 role=dialog aria-labelledby=modalClientForm><div class=modal-dialog role=document><div class=modal-content><form id=clientForm name=clientForm ng-submit=mClientForm.submitProcess(clientForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mClientForm.type === \'create\'\">Crear</span> <span ng-show=\"mClientForm.type === \'edit\'\">Editar</span> Cliente</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label for=FirstName>Nombre</label><input type=text name=FirstName id=FirstName class=form-control ng-model=mClientForm.client.firstName required ng-disabled=mClientForm.disableFields><div class=error ng-messages=clientForm.FirstName.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label for=LastName>Apellido</label><input type=text name=LastName id=LastName class=form-control ng-model=mClientForm.client.lastName required ng-disabled=mClientForm.disableFields><div class=error ng-messages=clientForm.LastName.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Apellido es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=LastName2>Segundo Apellido</label><input type=text name=LastName2 id=LastName2 class=form-control ng-model=mClientForm.client.lastName2 required ng-disabled=mClientForm.disableFields><div class=error ng-messages=clientForm.LastName2.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Segundo Apellido es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Genero</label><div><div class=\"radio radio-inline\" ng-repeat=\"genre in mClientForm.genres\"><input type=radio name=genre id=genre{{$index}} ng-value=genre.id ng-model=mClientForm.client.genre required ng-disabled=mClientForm.disableFields><label for=genre{{$index}}>{{genre.name}}</label></div></div><div class=error ng-messages=clientForm.genre.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Genero es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=IdentificationType>Tipo de Identificación</label><select name=IdentificationType id=IdentificationType class=form-control ng-model=mClientForm.client.identificationType.id ng-options=\"it.id as it.name for it in mClientForm.identificationTypes\" required ng-disabled=mClientForm.disableFields><option value=\"\">Tipo de Identificación</option></select><div class=error ng-messages=clientForm.IdentificationType.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Tipo de Identificación es requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label for=ClientIdentification>Identificación</label><input type=text name=ClientIdentification id=ClientIdentification class=form-control ng-model=mClientForm.client.identification required ng-disabled=mClientForm.disableFields><div class=error ng-messages=clientForm.ClientIdentification.$error ng-show=mClientForm.submitAttempt><p ng-message=required>La Identificación es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=IdentificationExpiration>Vencimiento de Identificación</label><p class=input-group><input type=text name=IdentificationExpiration id=IdentificationExpiration class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=mClientForm.client.identificationExpirationUI is-open=mClientForm.showIECalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=true ng-disabled=mClientForm.disableFields> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=mClientForm.openIECalendar() ng-disabled=mClientForm.disableFields><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=clientForm.IdentificationExpiration.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Vencimiento de Identificación es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label for=birthdate>Fecha de Nacimiento</label><p class=input-group><input type=text name=birthdate id=birthdate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=mClientForm.client.birthdateUI is-open=mClientForm.showBDCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=true ng-disabled=mClientForm.disableFields> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=mClientForm.openBDCalendar() ng-disabled=mClientForm.disableFields><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=clientForm.birthdate.$error ng-show=mClientForm.submitAttempt><p ng-message=required>La Fecha de nacimiento es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=civilStatus>Estado Civil</label><select name=civilStatus id=civilStatus class=form-control ng-options=\"cs.name as cs.name for cs in mClientForm.civilStatues\" ng-model=mClientForm.client.civilStatus required ng-disabled=mClientForm.disableFields><option value=\"\">Estado Civil</option></select><div class=error ng-messages=clientForm.civilStatus.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El estado civil es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label for=Email>Correo Electrónico</label><input type=email name=Email id=Email class=form-control ng-model=mClientForm.client.email required ng-disabled=mClientForm.disableFields><div class=error ng-messages=clientForm.Email.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El correo electrónico es requerido</p><p ng-message=email>Correo electrónico invalido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><div class=form-group><label>País de origen (Nacionalidad)</label><select name=Nationality id=Nationality class=form-control ng-model=mClientForm.client.nationality required ng-options=\"na.name as na.name for na in mClientForm.nationalities\" ng-disabled=mClientForm.disableFields><option value=\"\">Nacionalidad</option></select><div class=error ng-messages=clientForm.Nationality.$error ng-show=mClientForm.submitAttempt><p ng-message=required>La Nacionalidad es requerida</p></div></div></div></div><div class=col-xs-6><div class=form-group><label for=MigratoryStatus>Estatus Migratorio</label><select name=MigratoryStatus id=MigratoryStatus class=form-control ng-model=mClientForm.client.migratoryStatus><option value=\"\">Estatus Migratorio</option><option value=\"No residente\">No residente</option><option value=Residente>Residente</option><option value=Turista>Turista</option></select></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=Profession>Profesión</label><input type=text name=Profession id=Profession class=form-control ng-model=mClientForm.client.profession required ng-disabled=mClientForm.disableFields><div class=error ng-messages=clientForm.Profession.$error ng-show=mClientForm.submitAttempt><p ng-message=required>La Profesión es requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label>Teléfono</label><input type=text name=Phone id=Phone class=form-control ng-model=mClientForm.client.phone required ng-disabled=mClientForm.disableFields><div class=error ng-messages=clientForm.Phone.$error ng-show=mClientForm.submitAttempt><p ng-message=required>El Teléfono es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=Address>Dirección de destino</label><textarea class=form-control name=Address id=Address cols=30 rows=10 ng-model=mClientForm.client.address required></textarea><div class=error ng-messages=clientForm.Address.$error ng-show=mClientForm.submitAttempt><p ng-message=required>La dirección es requerida</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-close-cash-register-form/modal-close-cash-register-form.html","<div class=\"modal fade\" id=modalCloseCashRegisterForm tabindex=-1 role=dialog aria-labelledby=modalCloseCashRegisterForm><div class=\"modal-dialog modal-lg\" role=document><div class=modal-content><form id=closeCashRegisterForm name=closeCashRegisterForm ng-submit=mCloseCashRegisterForm.submitProcess(closeCashRegisterForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Cerrar Caja</h4></div><div class=modal-body><div class=row><div class=col-xs-3><div class=form-group><label>Fecha de apertura</label><p class=mt-10>{{mCloseCashRegisterForm.cashRegisterBalance.openAt | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</p></div></div><div class=col-xs-3><div class=form-group><label>Número de Caja</label><p class=mt-10>{{mCloseCashRegisterForm.cashRegisterBalance.cashId}}</p></div></div><div class=col-xs-3><div class=form-group><label>Consecutivo</label><p class=mt-10>{{mCloseCashRegisterForm.cashRegisterBalance.consecutive}}</p></div></div><div class=col-xs-3><div class=form-group><label>Nombre del cajero</label><p class=mt-10>{{mCloseCashRegisterForm.cashRegisterBalance.cashOwner}}</p></div></div></div><div class=row><div class=col-xs-3><div class=form-group><label>Fondo fijo inicial</label><p class=mt-10><b>{{mCloseCashRegisterForm.cashRegisterBalance.openingAmount | currency:\"₡\":0}}</b></p></div></div><div class=col-xs-3><div class=form-group><label>Ingresos operativos</label><p class=mt-10><b>{{mCloseCashRegisterForm.cashRegisterBalance.totalIngres | currency:\"₡\":0}}</b></p></div></div><div class=col-xs-3><div class=form-group><label>Egresos operativos</label><p class=mt-10><b>{{mCloseCashRegisterForm.cashRegisterBalance.totalEgress | currency:\"₡\":0}}</b></p></div></div><div class=col-xs-3><div class=form-group><label>Efectivo esperado en caja</label><p class=mt-10><b>{{mCloseCashRegisterForm.cashRegisterBalance.totalBalance | currency:\"₡\":0}} / {{mCloseCashRegisterForm.cashRegisterBalance.dollarsReceived | currency:\"$\":0}}</b></p></div></div></div><div class=row><div class=col-xs-12><hr style=\"border-color: #000; border-width: 1px\"></div><div class=col-xs-4><p class=text-center><b>Venta cobradas en efectivo</b></p><p class=text-center><b>{{mCloseCashRegisterForm.cashRegisterBalance.totalCash | currency:\"₡\":0}}</b></p></div><div class=col-xs-4><p class=text-center><b>Venta cobradas con tarjeta:</b></p><p class=text-center><b>{{mCloseCashRegisterForm.cashRegisterBalance.totalCard | currency:\"₡\":0}}</b></p></div><div class=col-xs-4><p class=text-center><b>Venta cobradas por SINPE:</b></p><p class=text-center><b>{{mCloseCashRegisterForm.cashRegisterBalance.totalSinpe | currency:\"₡\":0}}</b></p></div></div><div class=details><table class=\"table table-bordered\"><thead><tr><th>Concepto</th><th>Monto entregado</th><th>Monto esperado</th><th>Diferencia</th></tr></thead><tbody><tr><td><p><b>Ingresos adicionales (+)</b></p></td><td><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.closeCashRegister.reportedIncome ng-change=mCloseCashRegisterForm.calculateDifferences() ui-number-mask=decimal:0></td><td><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.cashRegisterBalance.income readonly ui-number-mask=decimal:0></td><td><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.differences.income readonly ui-number-mask=decimal:0></td></tr><tr><td><p><b>Salidas de efectivo (-)</b></p></td><td><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.closeCashRegister.reportedEgress ng-change=mCloseCashRegisterForm.calculateDifferences() ui-number-mask=decimal:0></td><td><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.cashRegisterBalance.outcome readonly ui-number-mask=decimal:0></td><td><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.differences.outcome readonly ui-number-mask=decimal:0></td></tr><tr><td colspan=5><hr></td></tr><tr><td><p><b>Dólares entregados</b></p></td><td class=v-align-top><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.closeCashRegister.totalDollarsHandedOver ng-change=mCloseCashRegisterForm.calculateDifferences() ui-number-mask=decimal:0></td><td class=v-align-top><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.cashRegisterBalance.dollarsReceived readonly ui-number-mask=decimal:0> <span class=\"text-right d-block mt-5\">Conversión referencial: {{mCloseCashRegisterForm.cashRegisterBalance.colonesSold | currency:\"₡\":0}}</span></td><td class=v-align-top><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.differences.dollars readonly ui-number-mask=decimal:0></td></tr><tr><td><p><b>Efectivo fisico entregado</b></p></td><td><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.closeCashRegister.totalColonesHandedOver ng-change=mCloseCashRegisterForm.calculateDifferences() ui-number-mask=decimal:0></td><td><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.cashRegisterBalance.totalBalance readonly ui-number-mask=decimal:0></td><td><input type=text class=\"form-control text-right\" ng-model=mCloseCashRegisterForm.differences.colones readonly ui-number-mask=decimal:0></td></tr><tr><td><p><b>Observaciones</b></p></td><td colspan=3><textarea class=form-control ng-model=mCloseCashRegisterForm.closeCashRegister.observations></textarea></td></tr></tbody></table></div><div class=row><div class=col-xs-12><div class=form-group><label>Contraseña para confirmar</label><input type=password name=closeCashRegisterPassword id=closeCashRegisterPassword class=form-control ng-model=mCloseCashRegisterForm.closeCashRegister.password autocomplete=new-password required><div class=error ng-messages=closeCashRegisterForm.closeCashRegisterPassword.$error ng-show=mCloseCashRegisterForm.submitAttempt><p ng-message=required>La Contraseña es requerida</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mCloseCashRegisterForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-config-form/modal-config-form.html","<div class=\"modal fade\" id=modalConfigForm tabindex=-1 role=dialog aria-labelledby=modalConfigForm><div class=modal-dialog role=document><div class=modal-content><form id=ConfigForm name=ConfigForm ng-submit=mConfigForm.submitProcess(ConfigForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Editar Configuracion</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label class=mt-4>Tiempo de edición publica (en minutos):</label></div></div><div class=col-xs-6><div class=form-group><input type=text name=editTime id=editTime class=form-control ng-model=mConfigForm.publicEditTime required><div class=error ng-messages=ConfigForm.editTime.$error ng-show=mConfigForm.submitAttempt><p ng-message=required>Tiempo de edición requerido</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mConfigForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-country-form/modal-country-form.html","<div class=\"modal fade\" id=modalCountryForm tabindex=-1 role=dialog aria-labelledby=modalCountryForm><div class=modal-dialog role=document><div class=modal-content><form id=countryForm name=countryForm ng-submit=mCountryForm.submitProcess(countryForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mCountryForm.type===\'create\'\">Crear</span> <span ng-show=\"mCountryForm.type===\'edit\'\">Editar</span> País</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=Name id=Name class=form-control ng-model=mCountryForm.country.name required><div class=error ng-messages=countryForm.Name.$error ng-show=mCountryForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Compañia</label><input type=text name=CompanyName id=CompanyName class=form-control ng-model=mCountryForm.country.companyName required><div class=error ng-messages=countryForm.CompanyName.$error ng-show=mCountryForm.submitAttempt><p ng-message=required>La Compañia es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Capacidad Mínima del Bus</label><input type=text name=BusMinCapacity id=BusMinCapacity class=form-control ng-model=mCountryForm.country.busMinCapacity ng-pattern=mCountryForm.onlyNumbers required><div class=error ng-messages=countryForm.BusMinCapacity.$error ng-show=mCountryForm.submitAttempt><p ng-message=required>La Capacidad Mínima del Bus es requerida</p><p ng-message=pattern>Solo números</p></div></div></div><div class=col-xs-6><div class=form-group><label>Capacidad Máxima del Bus</label><input type=text name=BusMaxCapacity id=BusMaxCapacity class=form-control ng-model=mCountryForm.country.busMaxCapacity ng-pattern=mCountryForm.onlyNumbers required><div class=error ng-messages=countryForm.BusMaxCapacity.$error ng-show=mCountryForm.submitAttempt><p ng-message=required>La Capacidad Máxima del Bus es requerida</p><p ng-message=pattern>Solo números</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Nombre del Impuesto</label><input type=input name=TaxName id=TaxName class=form-control ng-model=mCountryForm.country.taxName></div></div><div class=col-xs-6><div class=form-group><label>Porcentaje de Impuesto</label><input type=text name=TaxPercent id=TaxPercent class=form-control ng-model=mCountryForm.country.taxPercent ui-percentage-mask=0><div class=error ng-messages=countryForm.TaxPercent.$error ng-show=mCountryForm.submitAttempt><p ng-message=pattern>Solo números</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Nombre del Impuesto 2</label><input type=input name=TaxName2 id=TaxName2 class=form-control ng-model=mCountryForm.country.taxName2></div></div><div class=col-xs-6><div class=form-group><label>Porcentaje de Impuesto 2</label><input type=text name=TaxPercent2 id=TaxPercent2 class=form-control ng-model=mCountryForm.country.taxPercent2 ui-percentage-mask=0><div class=error ng-messages=countryForm.TaxPercent2.$error ng-show=mCountryForm.submitAttempt><p ng-message=pattern>Solo números</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Código de Cortesía</label><input type=text name=CourtesyTicketCode id=CourtesyTicketCode class=form-control ng-model=mCountryForm.country.courtesyTicketCode min=0 required><div class=error ng-messages=countryForm.CourtesyTicketCode.$error ng-show=mCountryForm.submitAttempt><p ng-message=required>Código requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Moneda de Precios</label><select name=Currency id=Currency class=form-control ng-model=mCountryForm.country.currency.id ng-options=\"c.id as c.name for c in mCountryForm.currencies\" required><option value=\"\">Moneda de precios</option></select><div class=error ng-messages=countryForm.Currency.$error ng-show=mCountryForm.submitAttempt><p ng-message=required>La Moneda de precios es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Moneda de Facturación</label><select name=BillingCurrency id=BillingCurrency class=form-control ng-model=mCountryForm.country.billingCurrency.id ng-options=\"c.id as c.name for c in mCountryForm.currencies\" required><option value=\"\">Moneda de Facturación</option></select><div class=error ng-messages=countryForm.BillingCurrency.$error ng-show=mCountryForm.submitAttempt><p ng-message=required>La Moneda de Facturación es requerida</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mCountryForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-dollar-exchange-form/modal-dollar-exchange-form.html","<div class=\"modal fade\" id=modalDollarExchangeForm tabindex=-1 role=dialog aria-labelledby=modalDollarExchangeForm><div class=\"modal-dialog modal-md\" role=document><div class=modal-content><form id=DollarExchangeForm name=DollarExchangeForm ng-submit=mDollarExchangeForm.submitProcess(DollarExchangeForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mDollarExchangeForm.type===\'create\'\">Crear</span> <span ng-show=\"mDollarExchangeForm.type===\'edit\'\">Editar</span> Tipo de cambio</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label for=Rate>Monto</label><input type=text class=\"form-control text-right\" name=Rate id=Rate ng-model=mDollarExchangeForm.dollarExchange.rate required ui-number-mask><div class=error ng-messages=DollarExchangeForm.Rate.$error ng-show=mDollarExchangeForm.submitAttempt><p ng-message=required>Tipo de Cambio requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label for=Description>Descripción</label><input type=text class=\"form-control text-right\" name=Description id=Description ng-model=mDollarExchangeForm.dollarExchange.description required><div class=error ng-messages=DollarExchangeForm.Description.$error ng-show=mDollarExchangeForm.submitAttempt><p ng-message=required>Descripción requerida</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mDollarExchangeForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-exchange-form/modal-exchange-form.html","<div class=\"modal fade\" id=modalExchangeForm tabindex=-1 role=dialog aria-labelledby=modalExchangeForm><div class=\"modal-dialog modal-lg\" role=document><div class=modal-content><form id=ExchangeForm name=ExchangeForm ng-submit=mExchangeForm.submitProcess(ExchangeForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mExchangeForm.type===\'create\'\">Crear</span> <span ng-show=\"mExchangeForm.type===\'edit\'\">Editar</span> Tipo de cambio</h4></div><div class=modal-body><div class=row><div class=col-xs-4><div class=form-group><label for=CurrencyTo>Moneda Origen</label><select name=CurrencyTo id=CurrencyTo class=form-control ng-model=mExchangeForm.exchange.to.id ng-options=\"c.id as c.name for c in mExchangeForm.currencies\" required><option value=\"\">Moneda Origen</option></select><div class=error ng-messages=ExchangeForm.CurrencyTo.$error ng-show=mExchangeForm.submitAttempt><p ng-message=required>Moneda Origen requerida</p></div></div></div><div class=col-xs-4><div class=form-group><label for=Rate>Tipo de cambio</label><input type=text class=\"form-control text-right\" name=Rate id=Rate ng-model=mExchangeForm.exchange.rate required ui-number-mask><div class=error ng-messages=ExchangeForm.Rate.$error ng-show=mExchangeForm.submitAttempt><p ng-message=required>Tipo de Cambio requerido</p></div></div></div><div class=col-xs-4><div class=form-group><label for=CurrencyFrom>Moneda Destino</label><select name=CurrencyFrom id=CurrencyFrom class=form-control ng-model=mExchangeForm.exchange.from.id ng-options=\"c.id as c.name for c in mExchangeForm.currencies\" required><option value=\"\">Moneda Destino</option></select><div class=error ng-messages=ExchangeForm.CurrencyFrom.$error ng-show=mExchangeForm.submitAttempt><p ng-message=required>Moneda Destino requerida</p></div></div></div></div><div class=row ng-show=mExchangeForm.submitAttempt><div class=\"col-xs-12 error\"><p ng-show=\"mExchangeForm.exchange.to.id && (mExchangeForm.exchange.to.id === mExchangeForm.exchange.from.id)\">La moneda de origen y destino deben ser diferentes</p></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mExchangeForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-ext-code-form/modal-ext-code-form.html","<div class=\"modal fade\" id=modalExtCodeForm tabindex=-1 role=dialog aria-labelledby=modalExtCodeForm><div class=modal-dialog role=document><div class=modal-content><form id=extCodeForm name=extCodeForm ng-submit=mExtCodeForm.submitProcess(extCodeForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mExtCodeForm.type === \'create\'\">Crear</span> <span ng-show=\"mExtCodeForm.type === \'edit\'\">Editar</span> Código Externo</h4></div><div class=modal-body><div class=row><div class=col-xs-12><div class=form-group><label>Serie</label><input type=text name=Serie id=Serie class=form-control ng-model=mExtCodeForm.extCode.series required maxlength=5><div class=error ng-messages=extCodeForm.Serie.$error ng-show=mExtCodeForm.submitAttempt><p ng-message=required>La serie es requerida</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Inicio</label><input type=text name=Start id=Start class=form-control ng-model=mExtCodeForm.extCode.start required><div class=error ng-messages=extCodeForm.Start.$error ng-show=mExtCodeForm.submitAttempt><p ng-message=required>Código de Inicio es requerido</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Final</label><input type=text name=End id=End class=form-control ng-model=mExtCodeForm.extCode.end required><div class=error ng-messages=extCodeForm.End.$error ng-show=mExtCodeForm.submitAttempt><p ng-message=required>Código de Final es requerido</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Asignado a:</label><select name=AssignedTo id=AssignedTo class=form-control ng-model=mExtCodeForm.extCode.assignedTo ng-options=\"user.fullName as user.fullName for user in mExtCodeForm.userList\" required><option value=\"\">Usuarios</option></select><div class=error ng-messages=extCodeForm.AssignedTo.$error ng-show=mExtCodeForm.submitAttempt><p ng-message=required>Asignar los códigos es requerido</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mExtCodeForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-generate-trip-form/modal-generate-trip-form.html","<div class=\"modal fade\" id=modalGenerateTripForm tabindex=-1 role=dialog aria-labelledby=modalGenerateTripForm><div class=modal-dialog role=document><div class=modal-content><form id=generateTripForm name=tripForm ng-submit=mTripForm.submitProcess(tripForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Generar Viajes</h4></div><div class=modal-body><!--<div class=\"row\" ng-repeat=\"date in mTripForm.tripDates track by $index\">\n            <div class=\"col-xs-6\">\n              <div class=\"form-group\">\n                <label>Fecha de viaje</label>\n                <p class=\"input-group\">\n                  <input type=\"text\" name=\"date-{{$index}}\" class=\"form-control\" uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=\"date.dateUI\" is-open=\"date.open\"\n                    alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=\"mTripForm.dateConfig\"/>\n                  <span class=\"input-group-btn\">\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"date.open = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                  </span>\n                </p>\n              </div>\n            </div>\n            <div class=\"col-xs-6\">\n              <button type=\"button\" title=\"Agregar Fecha\" class=\"btn btn-primary m-top-24\" ng-click=\"mTripForm.addDate()\" ng-show=\"$last\">\n                <i class=\"fa fa-plus\"></i>\n              </button>\n            </div>\n          </div>--><div class=row><div class=col-xs-6><div class=form-group><label for=StartDate>Fecha Inicial:</label><p class=input-group><input type=text name=StartDate id=StartDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=mTripForm.startDate is-open=mTripForm.showStartCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=mTripForm.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=mTripForm.openStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=tripForm.StartDate.$error ng-show=mTripForm.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label for=EndDate>Fecha Final:</label><p class=input-group><input type=text name=EndDate id=EndDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=mTripForm.endDate is-open=mTripForm.showEndCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=mTripForm.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=mTripForm.openEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=tripForm.EndDate.$error ng-show=mTripForm.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=BusId>Bus:</label><select name=BusId id=BusId class=form-control ng-model=mTripForm.busId ng-options=\"bus.id as bus.licensePlate + \' (\' + bus.capacity + \') - Bus: \' + bus.layoutType for bus in mTripForm.buses\"><option value=\"\">Seleccione un Bus</option></select></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mTripForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-open-cash-register-form/modal-open-cash-register-form.html","<div class=\"modal fade\" id=modalOpenCashRegisterForm tabindex=-1 role=dialog aria-labelledby=modalOpenCashRegisterForm><div class=modal-dialog role=document><div class=modal-content><form id=openCashRegisterForm name=openCashRegisterForm ng-submit=mOpenCashRegisterForm.submitProcess(openCashRegisterForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Abrir Caja</h4></div><div class=modal-body><div class=row><div class=col-xs-12><div class=form-group><label>Caja</label><select name=CashRegister id=CashRegister class=form-control ng-model=mOpenCashRegisterForm.openCashRegister.id ng-options=\"cr.id as cr.name for cr in mOpenCashRegisterForm.cashRegisters\" required><option value=\"\">Seleccione una caja</option></select><div class=error ng-messages=openCashRegisterForm.CashRegister.$error ng-show=mOpenCashRegisterForm.submitAttempt><p ng-message=required>La Caja es requerida</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Saldo</label><input type=text name=StartingAmount id=StartingAmount class=form-control ng-model=mOpenCashRegisterForm.openCashRegister.startingAmount ng-pattern=mOpenCashRegisterForm.onlyNumbers required><div class=error ng-messages=openCashRegisterForm.StartingAmount.$error ng-show=mOpenCashRegisterForm.submitAttempt><p ng-message=required>El Saldo es requerido</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Contraseña</label><input type=password name=Password id=Password class=form-control ng-model=mOpenCashRegisterForm.openCashRegister.password required><div class=error ng-messages=openCashRegisterForm.Password.$error ng-show=mOpenCashRegisterForm.submitAttempt><p ng-message=required>La Contraseña es requerida</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mOpenCashRegisterForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-packing-type-form/modal-packing-type-form.html","<div class=\"modal fade\" id=modalPackingTypeForm tabindex=-1 role=dialog aria-labelledby=modalPackingTypeForm><div class=modal-dialog role=document><div class=modal-content><form id=packingTypeForm name=packingTypeForm ng-submit=mPackingTypeForm.submitProcess(packingTypeForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mPackingTypeForm.type===\'create\'\">Crear</span> <span ng-show=\"mPackingTypeForm.type===\'edit\'\">Editar</span> Tipo de Empaque</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=Name id=Name class=form-control ng-model=mPackingTypeForm.packingType.name required><div class=error ng-messages=packingTypeForm.Name.$error ng-show=mPackingTypeForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Precio</label><input type=text name=Rate id=Rate class=form-control ng-model=mPackingTypeForm.packingType.rate required ui-number-mask><div class=error ng-messages=packingTypeForm.Rate.$error ng-show=mPackingTypeForm.submitAttempt><p ng-message=required>El Precio es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>País</label><select name=Country id=Country class=form-control ng-model=mPackingTypeForm.packingType.country.id ng-options=\"c.id as c.name for c in mPackingTypeForm.countries\" required><option value=\"\">Seleccione un País</option></select><div class=error ng-messages=packingTypeForm.Country.$error ng-show=mPackingTypeForm.submitAttempt><p ng-message=required>El País es requerido</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mPackingTypeForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-print-ticket-invoice/modal-print-ticket-invoice.html","<div class=\"modal fade\" id=modalTicketInvoice tabindex=-1 role=dialog aria-labelledby=modalTicketInvoice><div class=modal-dialog role=document><div class=modal-content><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title ng-if=!mTicketInvoice.editInfo>Confirmación de boleto</h4><h4 class=modal-title ng-if=mTicketInvoice.editInfo>Edición de boleto</h4></div><div class=modal-body ng-show=mTicketInvoice.showPreview><div class=\"row ticket-print\"><div id=printableArea class=col-xs-12><div class=print-ticket-container ng-repeat=\"invoice in mTicketInvoice.invoices\"><div class=row><div class=\"col-xs-12 text-center\"><h3 class=text-uppercase>{{invoice.terminal.country.companyName}}</h3><p>Ced: Juridica: {{invoice.terminal.contributorNumber}}</p><p>Tel: {{invoice.terminal.phone}}</p><p>{{invoice.terminal.address}}</p></div><div class=\"col-xs-12 text-center\"><hr><h4><span ng-if=mTicketInvoice.editInfo>Edición de boleto</span> <span ng-if=\"!mTicketInvoice.editInfo && !mTicketInvoice.isCortesia\">Boleto <span ng-if=mTicketInvoice.isOldTicket>- A</span></span> <span ng-if=\"!mTicketInvoice.editInfo && mTicketInvoice.isCortesia\">Cortesía</span></h4><hr><div class=row><div class=\"col-xs-6 text-left\"><h4>{{ mTicketInvoice.isWheelChairSeat(invoice.layoutType, invoice.seatNumber) ? \"Campo para silla de ruedas:\" : \"Boleto:\" }}</h4></div><div class=\"col-xs-6 text-right\"><h4>{{invoice.invoiceNumber}}</h4></div></div><div class=row><div class=\"col-xs-6 text-left\"><h4>Reserva:</h4></div><div class=\"col-xs-6 text-right\"><h4>{{invoice.reserveNumber}}</h4></div></div><div class=row ng-if=invoice.mainRoute><div class=\"col-xs-12 text-left\"><h5>Ruta con transbordo</h5></div><div class=\"col-xs-12 text-left\"><h5>{{invoice.mainRoute}}</h5></div></div><div class=row><div class=\"col-xs-3 text-left\"><h5>Ruta:</h5></div><div class=\"col-xs-9 text-right\"><h5>{{invoice.route}}</h5></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Fecha:</b></div><div class=\"col-xs-7 text-right\"><p>{{invoice.date | amDateFormat:mTicketInvoice.dateFormat}}</p></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Hora:</b></div><div class=\"col-xs-7 text-right\"><p>{{invoice.timeUI}}</p></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Terminal:</b></div><div class=\"col-xs-7 text-right\"><p>{{invoice.terminal.name}}</p></div></div><hr><div class=row><div class=\"col-xs-5 text-left\"><b>Abordaje:</b></div><div class=\"col-xs-7 text-right\"><p ng-show=invoice.boarding>{{invoice.boarding}}</p><p ng-show=!invoice.boarding>{{invoice.terminal.name}}</p></div></div><hr ng-show=invoice.dropOff><div class=row ng-show=invoice.dropOff><div class=\"col-xs-5 text-left\"><b>Destino Final:</b></div><div class=\"col-xs-7 text-right\"><p>{{invoice.dropOff.name}}</p></div></div><hr ng-if=\"!mTicketInvoice.isWheelChair(invoice.seatCount, invoice.seatNumber)\"><div ng-if=\"!mTicketInvoice.isWheelChair(invoice.seatCount, invoice.seatNumber)\" class=row><div class=\"col-xs-5 text-left\"><h4>Asiento:</h4></div><div class=\"col-xs-7 text-right\"><h4>{{ mTicketInvoice.getSeatLabel(invoice.layoutType, invoice.seatNumber)}}</h4></div></div><hr><div ng-show=!mTicketInvoice.isCortesia><div class=row ng-if=!mTicketInvoice.editInfo><div class=\"col-xs-6 text-left\"><b>Total:</b></div><div class=\"col-xs-6 text-right\"><p>₡{{invoice.finalPrice}}</p></div></div><div ng-if=mTicketInvoice.editInfo><div class=row><div class=\"col-xs-7 text-left\"><b>Precio original:</b></div><div class=\"col-xs-5 text-right\"><p>₡{{mTicketInvoice.editInfo.originalPrice | number: 0}}</p></div></div><div class=row><div class=\"col-xs-7 text-left\"><h4>DIFERENCIA PAGADA:</h4></div><div class=\"col-xs-5 text-right\"><h4>₡{{mTicketInvoice.editInfo.paidDifference | number: 0}}</h4></div></div></div></div><div class=row><div class=\"col-xs-4 text-left\"><b>Cajero:</b></div><div class=\"col-xs-8 text-right\"><p>{{invoice.cashier.split(\" \")[0]}}</p></div></div><hr><div class=row><div class=\"col-xs-12 text-center\"><img alt=\"Qr Code\" ng-src=data:image/png;base64,{{invoice.base64QrCode}}></div></div><hr><div class=row><div class=\"col-xs-12 text-center\"><p>{{invoice.terminal.tradeNumber}}</p></div></div><div class=row><div class=\"col-xs-12 text-center\"><small>{{mTicketInvoice.now | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</small></div></div></div></div></div></div><iframe id=printableAreaFrame name=printableAreaFrame style=display:none></iframe></div></div><div class=modal-footer><!--<button type=\"button\" class=\"btn btn-secondary\" ng-click=\"mTicketInvoice.sms()\">SMS</button>--> <button type=button class=\"btn btn-primary\" ng-click=mTicketInvoice.print()>Imprimir</button><!--<button type=\"button\" class=\"btn btn-primary\" ng-click=\"mTicketInvoice.print(true)\">Imprimir y SMS</button>--></div></div></div></div>");
$templateCache.put("app/components/modal-profile-form/modal-profile-form.html","<div class=\"modal fade\" id=modalProfileForm tabindex=-1 role=dialog aria-labelledby=modalProfileForm><div class=modal-dialog role=document><div class=modal-content><form id=profileForm name=profileForm ng-submit=mProfileForm.submitProcess(profileForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mProfileForm.type === \'create\'\">Crear</span> <span ng-show=\"mProfileForm.type === \'edit\'\">Editar</span> Perfil</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=Name id=Name class=form-control ng-model=mProfileForm.profile.name required><div class=error ng-messages=profileForm.Name.$error ng-show=mProfileForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Descripción</label><input type=text name=Description id=Description class=form-control ng-model=mProfileForm.profile.description required><div class=error ng-messages=profileForm.Description.$error ng-show=mProfileForm.submitAttempt><p ng-message=required>La Descripción es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Permisos del Perfil</label><p class=small>Doble click para remover permisos</p><div class=\"box no-padding\"><div class=\"form-group search\"><input type=text placeholder=\"Buscar Permiso\" ng-model=mProfileForm.filterProfilePermission> <button type=button role=button><i class=\"fa fa-search\"></i></button></div><ul class=\"list-items-selection list-unstyled max-height-250\"><li ng-repeat=\"permission in mProfileForm.profile.permissions | filter:{name: mProfileForm.filterProfilePermission}\" ng-click=mProfileForm.toggleSelected(permission) ng-dblclick=\"mProfileForm.removePermission(permission, $index)\" ng-class={selected:permission.selected}>{{permission.name}} <i class=\"fa fa-times\"></i></li></ul></div></div></div><div class=col-xs-6><div class=form-group><label>Permisos del sistema</label><p class=small>Doble click para agregar permisos</p><div class=\"box no-padding\"><div class=\"form-group search\"><input type=text placeholder=\"Buscar Permiso\" ng-model=mProfileForm.filterPermission> <button type=button role=button><i class=\"fa fa-search\"></i></button></div><ul class=\"list-items-selection list-unstyled max-height-250\"><li ng-repeat=\"permission in mProfileForm.permissions | filter:{name:mProfileForm.filterPermission}\" ng-click=mProfileForm.toggleSelected(permission) ng-dblclick=mProfileForm.addSelectedPermission(permission) ng-class={selected:permission.selected} ng-hide=permission.hide>{{permission.name}} <i class=\"fa fa-check\"></i></li></ul></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mProfileForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-reseller-form/modal-reseller-form.html","<div class=\"modal fade\" id=modalResellerForm tabindex=-1 role=dialog aria-labelledby=modalResellerForm><div class=modal-dialog role=document><div class=modal-content><form id=ResellerForm name=ResellerForm ng-submit=mResellerForm.submitProcess(ResellerForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mResellerForm.type===\'create\'\">Crear</span> <span ng-show=\"mResellerForm.type===\'edit\'\">Editar</span> Agencia</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=Name id=Name class=form-control ng-model=mResellerForm.reseller.name required><div class=error ng-messages=ResellerForm.Name.$error ng-show=mResellerForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>País</label><select name=Country id=Country required class=form-control ng-model=mResellerForm.reseller.country.id ng-options=\"country.id as country.name for country in mResellerForm.countries\" required><option value=\"\">Seleccione un País</option></select><div class=error ng-messages=ResellerForm.Country.$error ng-show=mResellerForm.submitAttempt><p ng-message=required>El País es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Contacto</label><input type=text name=Contact id=Contact class=form-control ng-model=mResellerForm.reseller.contact required><div class=error ng-messages=ResellerForm.Contact.$error ng-show=mResellerForm.submitAttempt><p ng-message=required>El Contacto es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Teléfono</label><input type=text name=Phone id=Phone class=form-control ng-model=mResellerForm.reseller.phone required><div class=error ng-messages=ResellerForm.Phone.$error ng-show=mResellerForm.submitAttempt><p ng-message=required>El Teléfono es requerido</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mResellerForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-route-form/modal-route-form.html","<div class=\"modal fade\" id=modalRouteForm tabindex=-1 role=dialog aria-labelledby=modalRouteForm><div class=modal-dialog role=document><div class=modal-content><form id=routeForm name=routeForm ng-submit=mRouteForm.submitProcess(routeForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mRouteForm.type===\'create\'\">Crear</span> <span ng-show=\"mRouteForm.type===\'edit\'\">Editar</span> Rutas</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=Name id=Name class=form-control ng-model=mRouteForm.route.name required><div class=error ng-messages=routeForm.Name.$error ng-show=mRouteForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>País de Origen</label><select name=Country id=Country class=form-control ng-model=mRouteForm.route.country.id ng-options=\"c.id as c.name for c in mRouteForm.countries\" required><option value=\"\">Seleccione un País</option></select><div class=error ng-messages=routeForm.Country.$error ng-show=mRouteForm.submitAttempt><p ng-message=required>El País es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Lugar de Partida</label><input type=text name=Departure id=Departure class=form-control ng-model=mRouteForm.route.departure required><div class=error ng-messages=routeForm.Departure.$error ng-show=mRouteForm.submitAttempt><p ng-message=required>La salida es requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label>Lugar de Destino</label><input type=text name=Destiny id=Destiny class=form-control ng-model=mRouteForm.route.destiny required><div class=error ng-messages=routeForm.Destiny.$error ng-show=mRouteForm.submitAttempt><p ng-message=required>El destino es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><select name=InvoicePrefix id=InvoicePrefix class=form-control ng-options=\"prefix.id as prefix.name for prefix in mRouteForm.invoicePrefixes\" ng-model=mRouteForm.route.invoiceCounterNumber.id ng-disabled=\"mRouteForm.type===\'edit\'\"><option value=\"\">Prefijo Facturación</option></select></div></div><div class=row><div class=col-xs-6><div class=form-group><div class=checkbox><input type=checkbox name=Transfer id=Transfer ng-model=mRouteForm.route.transfer><label for=Transfer>Ruta con Transbordo</label></div></div></div><div class=col-xs-6 ng-show=mRouteForm.route.transfer><div class=form-group><label>Ruta Inicial</label><select name=Route1 id=Route1 class=form-control ng-model=mRouteForm.route.subRoutes[0].id ng-options=\"r.id as r.name for r in mRouteForm.routesList\" ng-required=mRouteForm.route.transfer><option value=\"\">Seleccione la ruta inicial</option></select><div class=error ng-messages=routeForm.Route1.$error ng-show=mRouteForm.submitAttempt><p ng-message=required>La Ruta inicial es requerida</p></div></div><div class=form-group><label>Conexión</label><select name=Route2 id=Route2 class=form-control ng-model=mRouteForm.route.subRoutes[1].id ng-options=\"r.id as r.name for r in mRouteForm.routesList\" ng-required=mRouteForm.route.transfer><option value=\"\">Seleccione la ruta de conexión</option></select><div class=error ng-messages=routeForm.Route2.$error ng-show=mRouteForm.submitAttempt><p ng-message=required>La Ruta de conexión es requerida</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mRouteForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-route-rate-form/modal-route-rate-form.html","<div class=\"modal fade\" id=modalRouteRateForm tabindex=-1 role=dialog aria-labelledby=modalRouteRateForm><div class=modal-dialog role=document><div class=\"modal-content modal-lg\"><form id=routeRatesForm name=routeRatesForm ng-submit=mRouteRateForm.submitProcess(routeRatesForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mRouteRateForm.type===\'create\'\">Crear</span> <span ng-show=\"mRouteRateForm.type===\'edit\'\">Editar</span> Precio</h4></div><div class=modal-body><div class=row><div class=col-xs-12><div class=form-group><label>Tipo de Bus</label><select name=BusClass id=BusClass class=form-control ng-model=mRouteRateForm.routeRate.busClass.id ng-options=\"bc.id as bc.name for bc in mRouteRateForm.busClasses\" required><option value=\"\">Seleccione una Clase de Bus</option></select><div class=error ng-messages=routeRatesForm.BusClass.$error ng-show=mRouteRateForm.submitAttempt><p ng-message=required>El Tipo de Bus es requerido</p></div></div></div></div><!-- CR --><div class=row><div class=col-xs-3><div class=form-group><label>Precio CR</label><input type=text name=RateCR id=RateCR class=\"form-control text-right\" ng-model=mRouteRateForm.routeRate.countryRates.CR ui-number-mask required ng-change=mRouteRateForm.rateChange()><div class=error ng-messages=routeRatesForm.RateCR.$error ng-show=mRouteRateForm.submitAttempt><p ng-message=required>El Precio es requerido</p></div></div></div><!--<div class=\"col-xs-3\">\n              <div class=\"form-group\">\n                <label>Precio en cólones</label>\n                <input type=\"text\" name=\"rateColones\" id=\"rateColones\" class=\"form-control text-right\" ng-model=\"mRouteRateForm.routeRate.rateColones\"  ui-number-mask disabled />\n              </div>\n            </div>\n            <div class=\"col-xs-3\">\n              <div class=\"form-group\">\n                <label>Ajuste en cólones</label>\n                <input type=\"text\" name=\"colonesAdjustmentRate\" id=\"colonesAdjustmentRate\" class=\"form-control text-right\" ng-model=\"mRouteRateForm.routeRate.colonesAdjustmentRate\" ui-number-mask ng-change=\"mRouteRateForm.updateColonesRate()\" />\n              </div>\n            </div>\n            <div class=\"col-xs-3\">\n              <div class=\"form-group\">\n                <label>Precio Final CR</label>\n                <input type=\"text\" name=\"FinalRateCR\" id=\"FinalRateCR\" class=\"form-control text-right\" ng-model=\"mRouteRateForm.routeRate.finalRateCR\"  ui-number-mask disabled />\n              </div>\n            </div>--></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mRouteRateForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-schedule-form/modal-schedule-form.html","<div class=\"modal fade\" id=modalScheduleForm tabindex=-1 role=dialog aria-labelledby=modalScheduleForm><div class=modal-dialog role=document><div class=modal-content><form id=scheduleForm name=scheduleForm ng-submit=mScheduleForm.submitProcess(scheduleForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mScheduleForm.type===\'create\'\">Crear</span> <span ng-show=\"mScheduleForm.type===\'edit\'\">Editar</span> Horario</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=Name id=Name class=form-control ng-model=mScheduleForm.schedule.name required><div class=error ng-messages=scheduleForm.Name.$error ng-show=mScheduleForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Tipo de viaje</label><select name=RouteRate id=RouteRate class=form-control ng-model=mScheduleForm.schedule.routeRate.id ng-options=\"rr.id as rr.busClass.name for rr in mScheduleForm.routeRates\" required><option value=\"\">Seleccione un tipo de viaje</option></select><div class=error ng-messages=scheduleForm.RouteRate.$error ng-show=mScheduleForm.submitAttempt><p ng-message=required>El Tipo de viaje es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Hora de Salida</label><input type=text name=DepartureTime id=DepartureTime class=form-control placeholder=14:30 ng-model=mScheduleForm.schedule.departureTime required><div class=error ng-messages=scheduleForm.DepartureTime.$error ng-show=mScheduleForm.submitAttempt><p ng-message=required>Hora de Salida es requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label>Hora de Llegada</label><input type=text name=ArrivalTime id=ArrivalTime class=form-control placeholder=19:30 ng-model=mScheduleForm.schedule.arrivalTime required><div class=error ng-messages=scheduleForm.ArrivalTime.$error ng-show=mScheduleForm.submitAttempt><p ng-message=required>La Hora de Llegada es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Visible</label><input type=checkbox class=checkbox name=RouteVisible id=RouteVisible class=form-control ng-model=mScheduleForm.schedule.visible></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Abordajes de la ruta</label><p class=small>Doble click para remover abordajes</p><div class=\"box no-padding\"><div class=\"form-group search\"><input type=text placeholder=\"Buscar Abordaje\" ng-model=mScheduleForm.filterBoardings> <button type=button role=button><i class=\"fa fa-search\"></i></button></div><ul class=\"list-items-selection list-unstyled max-height-250\"><li ng-repeat=\"boarding in mScheduleForm.boardings | filter:{name: mScheduleForm.filterBoardings}\" ng-click=mScheduleForm.toggleSelected(boarding) ng-dblclick=\"mScheduleForm.removeBoarding(boarding, $index)\" ng-class={selected:boarding.selected} ng-hide=boarding.hide>{{boarding.name}} <i class=\"fa fa-times\"></i></li></ul></div></div></div><div class=col-xs-6><div class=form-group><label>Abordajes Removidos</label><p class=small>Doble click para volver a agregar el abordaje</p><div class=\"box no-padding\"><div class=\"form-group search\"><input type=text placeholder=\"Buscar Abordaje\" ng-model=mScheduleForm.filterInvalidBoardings> <button type=button role=button><i class=\"fa fa-search\"></i></button></div><ul class=\"list-items-selection list-unstyled max-height-250\"><li ng-repeat=\"boarding in mScheduleForm.schedule.invalidBoardings | filter:{name:mScheduleForm.filterInvalidBoardings}\" ng-click=mScheduleForm.toggleSelected(boarding) ng-dblclick=\"mScheduleForm.removeInvalidBoarding(boarding, $index)\" ng-class={selected:boarding.selected}>{{boarding.name}} <i class=\"fa fa-check\"></i></li></ul></div></div></div></div><!--<div class=\"row\">\n            <div class=\"col-xs-6\">\n              <div class=\"form-group\">\n                <label>Desembarcos de la ruta</label>\n                <p class=\"small\">Doble click para remover Destino Final</p>\n\n                <div class=\"box no-padding\">\n                  <div class=\"form-group search\">\n                    <input type=\"text\" placeholder=\"Buscar Destino Final\" ng-model=\"mScheduleForm.filterDropoff\">\n                    <button type=\"button\" role=\"button\"><i class=\"fa fa-search\"></i></button>\n                  </div>\n\n                  <ul class=\"list-items-selection list-unstyled max-height-250\">\n                    <li ng-repeat=\"dropoff in mScheduleForm.dropoffs | filter:{name: mScheduleForm.filterDropoff}\" ng-click=\"mScheduleForm.toggleSelected(dropoff)\" ng-dblclick=\"mScheduleForm.removeDropoff(dropoff, $index)\" ng-class=\"{selected:dropoff.selected}\" ng-hide=\"dropoff.hide\">\n                      {{dropoff.name}} <i class=\"fa fa-times\"></i>\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class=\"col-xs-6\">\n              <div class=\"form-group\">\n                <label>Desembarcos Removidos</label>\n                <p class=\"small\">Doble click para volver a agregar el Destino Final</p>\n                <div class=\"box no-padding\">\n                  <div class=\"form-group search\">\n                    <input type=\"text\" placeholder=\"Buscar Destino Final\" ng-model=\"mScheduleForm.filterInvalidDropoff\">\n                    <button type=\"button\" role=\"button\"><i class=\"fa fa-search\"></i></button>\n                  </div>\n\n                  <ul class=\"list-items-selection list-unstyled max-height-250\">\n                    <li ng-repeat=\"dropoff in mScheduleForm.schedule.invalidDropoffs | filter:{name:mScheduleForm.filterInvalidDropoff}\" ng-click=\"mScheduleForm.toggleSelected(dropoff)\" ng-dblclick=\"mScheduleForm.removeInvalidDropoff(dropoff, $index)\" ng-class=\"{selected:dropoff.selected}\">\n                      {{dropoff.name}} <i class=\"fa fa-check\"></i>\n                    </li>\n                  </ul>\n                </div>\n              </div>\n            </div>\n          </div> --></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mScheduleForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-terminal-form/modal-terminal-form.html","<div class=\"modal fade\" id=modalTerminalForm tabindex=-1 role=dialog aria-labelledby=modalTerminalForm><div class=modal-dialog role=document><div class=modal-content><form id=TerminalForm name=TerminalForm ng-submit=mTerminalForm.submitProcess(TerminalForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mTerminalForm.type===\'create\'\">Crear</span> <span ng-show=\"mTerminalForm.type===\'edit\'\">Editar</span> Terminal</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=Name id=Name class=form-control ng-model=mTerminalForm.terminal.name required><div class=error ng-messages=TerminalForm.Name.$error ng-show=mTerminalForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>País</label><select name=Country id=Country required class=form-control ng-model=mTerminalForm.terminal.country.id ng-options=\"country.id as country.name for country in mTerminalForm.countries\" required><option value=\"\">Seleccione un País</option></select><div class=error ng-messages=TerminalForm.Country.$error ng-show=mTerminalForm.submitAttempt><p ng-message=required>El País es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Ciudad</label><input type=text name=City id=City class=form-control ng-model=mTerminalForm.terminal.city required><div class=error ng-messages=TerminalForm.City.$error ng-show=mTerminalForm.submitAttempt><p ng-message=required>La ciudad es requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label>Dirección</label><input type=text name=Address id=Address class=form-control ng-model=mTerminalForm.terminal.address required><div class=error ng-messages=TerminalForm.Address.$error ng-show=mTerminalForm.submitAttempt><p ng-message=required>La dirección es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Teléfono</label><input type=text name=Phone id=Phone class=form-control ng-model=mTerminalForm.terminal.phone required><div class=error ng-messages=TerminalForm.Phone.$error ng-show=mTerminalForm.submitAttempt><p ng-message=required>El Teléfono es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Fax</label><input type=text name=Fax id=Fax class=form-control ng-model=mTerminalForm.terminal.fax required><div class=error ng-messages=TerminalForm.Fax.$error ng-show=mTerminalForm.submitAttempt><p ng-message=required>El Fax es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Email</label><input type=email name=Email id=Email class=form-control ng-model=mTerminalForm.terminal.email required><div class=error ng-messages=TerminalForm.Email.$error ng-show=mTerminalForm.submitAttempt><p ng-message=required>El Email es requerido</p><p ng-message=email>El Email es invalido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Sitio Web</label><input type=text name=Website id=Website class=form-control ng-model=mTerminalForm.terminal.website></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Numero de Contribuyente</label><input type=text name=contributorNumber id=contributorNumber class=form-control ng-model=mTerminalForm.terminal.contributorNumber required><div class=error ng-messages=TerminalForm.contributorNumber.$error ng-show=mTerminalForm.submitAttempt><p ng-message=required>El Numero de contribuyente es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Contacto</label><input type=text name=Contacto id=Contacto class=form-control ng-model=mTerminalForm.terminal.contact></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Número de Oficio</label><input type=text name=tradeNumber id=tradeNumber class=form-control ng-model=mTerminalForm.terminal.tradeNumber required><div class=error ng-messages=TerminalForm.tradeNumber.$error ng-show=mTerminalForm.submitAttempt><p ng-message=required>El Numero de oficio es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Ruta de Impresora</label><input type=text name=printerRoute id=printerRoute class=form-control ng-model=mTerminalForm.terminal.printerRoute></div></div></div><!--<div class=\"row\">\n            <div class=\"col-xs-6\">\n              <div class=\"form-group\">\n                <label>Ruta de Maquina de pesaje</label>\n                <input type=\"text\" name=\"weighingMachineRoute\" id=\"weighingMachineRoute\" class=\"form-control\" ng-model=\"mTerminalForm.terminal.weighingMachineRoute\" />\n              </div>\n            </div>\n          </div>--></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mTerminalForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-ticket-contact-form/modal-ticket-contact-form.html","<div class=\"modal fade\" id=modalTicketContactForm tabindex=-1 role=dialog aria-labelledby=modalTicketContactForm><div class=\"modal-dialog modal-md\" role=document><div class=modal-content><form id=TicketContactForm name=TicketContactForm ng-submit=mTicketContactForm.submitProcess(TicketContactForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Editar contacto</h4></div><div class=modal-body><div class=row><div class=col-xs-12><p class=\"text-muted font-light-small\">Estos datos son los que se usan para enviarle al cliente el codigo de verificacion cuando edita su boleto.</p></div></div><div class=row><div class=col-xs-6><div class=form-group><label for=ContactPhone>Teléfono</label><input type=text class=form-control name=ContactPhone id=ContactPhone ng-model=mTicketContactForm.contact.customerPhone tnsp-phone-mask maxlength=16 placeholder=\"+506 8859-2161\"><p class=\"text-muted font-light-small\">Incluya el código de país.</p><div class=error ng-messages=TicketContactForm.ContactPhone.$error ng-show=mTicketContactForm.submitAttempt><p ng-message=phoneFormat>Teléfono debe incluir el código de país, ej. +506 8859-2161</p></div></div></div><div class=col-xs-6><div class=form-group><label for=ContactEmail>Correo electrónico</label><input type=email class=form-control name=ContactEmail id=ContactEmail ng-model=mTicketContactForm.contact.email placeholder=cliente@ejemplo.com><div class=error ng-messages=TicketContactForm.ContactEmail.$error ng-show=mTicketContactForm.submitAttempt><p ng-message=email>Correo electrónico invalido</p></div></div></div></div><div class=row ng-show=mTicketContactForm.missingContact><div class=col-xs-12><div class=error><p>Ingrese al menos un teléfono o un correo electrónico</p></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mTicketContactForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-ticket-registration-form/modal-ticket-registration-form.html","<div class=\"modal fade\" id=modalTicketRegistrationForm tabindex=-1 role=dialog aria-labelledby=modalTicketRegistrationForm><div class=modal-dialog role=document><div class=modal-content><form id=ticketRegistrationForm name=ticketRegistrationForm ng-submit=mTicketRegistrationForm.submitProcess(ticketRegistrationForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Registrar Boleto fisico</h4></div><div class=modal-body><div class=row><div class=col-xs-12><div class=form-group><label>Número</label><input type=text name=TicketNumber id=TicketNumber class=form-control ng-model=mTicketRegistrationForm.ticketNumber required><div class=error ng-messages=ticketRegistrationForm.TicketNumber.$error ng-show=mTicketRegistrationForm.submitAttempt><p ng-message=required>El Número es requerido</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Vencimiento</label><input type=text name=DueDate id=DueDate class=form-control ng-model=mTicketRegistrationForm.dueDate required><div class=error ng-messages=ticketRegistrationForm.DueDate.$error ng-show=mTicketRegistrationForm.submitAttempt><p ng-message=required>La Fecha de Vencimiento es requerida</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Destino</label><select name=Destiny id=Destiny class=form-control ng-model=mTicketRegistrationForm.destiny.id required><option value=\"\">Seleccione un destino</option></select><div class=error ng-messages=ticketRegistrationForm.Destiny.$error ng-show=mTicketRegistrationForm.submitAttempt><p ng-message=required>El Destino es requerido</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Hora</label><select name=Hour id=Hour class=form-control ng-model=mTicketRegistrationForm.hour required><option value=\"\">Seleccione una hora</option></select><div class=error ng-messages=ticketRegistrationForm.Hour.$error ng-show=mTicketRegistrationForm.submitAttempt><p ng-message=required>La hora es requerida</p></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><label>Descripción</label><textarea name=Description rows=3 id=Description class=form-control ng-model=mTicketRegistrationForm.description required>\n                <div class=error ng-messages=ticketRegistrationForm.Description.$error ng-show=mTicketRegistrationForm.submitAttempt>\n                  <p ng-message=required>La Descripción es requerida</p>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=row>\n            <div class=col-xs-12>\n              <div class=form-group>\n                <label>Contraseña</label>\n                <input type=password name=Password id=Password class=form-control ng-model=mOpenCashRegisterForm.password required>\n                <div class=error ng-messages=ticketRegistrationForm.Password.$error ng-show=mTicketRegistrationForm.submitAttempt>\n                  <p ng-message=required>La Contraseña es requerida</p>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=modal-footer>\n          <button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button>\n          <button type=submit ladda=mOpenCashRegisterForm.loading class=\"btn btn-primary\">Guardar</button>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/components/modal-underage-person-form/modal-underage-person-form.html","<div class=\"modal fade\" id=modalUnderagePersonForm tabindex=-1 role=dialog aria-labelledby=modalUnderagePersonForm><div class=modal-dialog role=document><div class=modal-content><form id=underagePersonForm name=underagePersonForm ng-submit=mUnderagePersonForm.submitProcess(underagePersonForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Menor de Edad</h4></div><div class=modal-body><div class=row><div class=col-xs-12><div class=form-group><label>Notas</label><textarea type=text class=form-control required rows=10 ng-model=mUnderagePersonForm.ticket.underAgeNotes> </textarea></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=mUnderagePersonForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/modal-user-form/modal-user-form.html","<div class=\"modal fade\" id=modalUserForm tabindex=-1 role=dialog aria-labelledby=modalUserForm><div class=modal-dialog role=document><div class=modal-content><form id=userForm name=userForm ng-submit=mUserForm.submitProcess(userForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title><span ng-show=\"mUserForm.type === \'create\'\">Crear</span> <span ng-show=\"mUserForm.type === \'edit\'\">Editar</span> Usuario</h4></div><div class=modal-body><div class=row><div class=col-xs-6><div class=form-group><label>Nombre</label><input type=text name=FirstName id=FirstName class=form-control ng-model=mUserForm.user.firstName required><div class=error ng-messages=userForm.FirstName.$error ng-show=mUserForm.submitAttempt><p ng-message=required>El Nombre es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Apellido</label><input type=text name=LastName id=LastName class=form-control ng-model=mUserForm.user.lastName required><div class=error ng-messages=userForm.LastName.$error ng-show=mUserForm.submitAttempt><p ng-message=required>El Apellido es requerido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Tipo de Identificación</label><select name=IdentificationType id=IdentificationType class=form-control ng-model=mUserForm.user.identificationType.id ng-options=\"it.id as it.name for it in mUserForm.identificationTypes\" required><option value=\"\">Tipo de Identificación</option></select><div class=error ng-messages=userForm.IdentificationType.$error ng-show=mUserForm.submitAttempt><p ng-message=required>El Tipo de Identificación es requerida</p></div></div></div><div class=col-xs-6><div class=form-group><label>Identificación</label><input type=text name=Identification id=Identification class=form-control ng-model=mUserForm.user.identification required><div class=error ng-messages=userForm.Identification.$error ng-show=mUserForm.submitAttempt><p ng-message=required>La Identificación es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Nombre de Usuario</label><input type=text name=Username id=Username class=form-control ng-model=mUserForm.user.username required><div class=error ng-messages=userForm.Username.$error ng-show=mUserForm.submitAttempt><p ng-message=required>El nombre de usuario es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Correo Electrónico</label><input type=email name=Email id=Email class=form-control ng-model=mUserForm.user.email required><div class=error ng-messages=userForm.Email.$error ng-show=mUserForm.submitAttempt><p ng-message=required>El correo electrónico es requerido</p><p ng-message=email>Correo electrónico invalido</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Perfil</label><select name=Profile id=Profile class=form-control ng-model=mUserForm.user.roles[0].id ng-options=\"profile.id as profile.name for profile in mUserForm.profiles\" required><option value=\"\">Perfil</option></select><div class=error ng-messages=userForm.Profile.$error ng-show=mUserForm.submitAttempt><p ng-message=required>El Perfil es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>País de origen (Nacionalidad)</label><select name=Nationality id=Nationality class=form-control ng-model=mUserForm.user.nationality required ng-options=\"na.name as na.name for na in mUserForm.nationalities\"><option value=\"\">Nacionalidad</option></select><div class=error ng-messages=userForm.Nationality.$error ng-show=mUserForm.submitAttempt><p ng-message=required>La Nacionalidad es requerida</p></div></div></div></div><div class=row ng-show=\"mUserForm.user.roles[0].id!==6 && mUserForm.user.roles[0].id!==11\"><div class=col-xs-6><div class=form-group><label>País donde labora</label><select name=country id=country class=form-control ng-model=mUserForm.user.country.id ng-required=\"mUserForm.user.roles[0].id!==6 && mUserForm.user.roles[0].id!==11\" ng-options=\"country.id as country.name for country in mUserForm.countries\" ng-change=mUserForm.loadTerminals(mUserForm.country)><option value=\"\">País</option></select><div class=error ng-messages=userForm.country.$error ng-show=mUserForm.submitAttempt><p ng-message=required>El País donde labora es requerido</p></div></div></div><div class=col-xs-6><div class=form-group><label>Terminal</label><select name=terminal id=terminal class=form-control ng-model=mUserForm.user.terminal.id ng-required=\"mUserForm.user.roles[0].id!==6 && mUserForm.user.roles[0].id!==11\" ng-options=\"terminal.id as terminal.name for terminal in mUserForm.terminals\"><option value=\"\">Terminal</option></select><div class=error ng-messages=userForm.terminal.$error ng-show=mUserForm.submitAttempt><p ng-message=required>La terminal es requerida</p></div></div></div></div><div class=row><div class=col-xs-6><div class=form-group><label>Teléfono</label><input type=text name=Phone id=Phone class=form-control ng-model=mUserForm.user.phone required><div class=error ng-messages=userForm.Phone.$error ng-show=mUserForm.submitAttempt><p ng-message=required>El Teléfono es requerido</p></div></div></div><div class=col-xs-6 ng-show=\"mUserForm.type===\'create\'\"><div class=form-group><label>Contraseña</label><input type=password name=Password id=Password class=form-control ng-model=mUserForm.user.password ng-required=\"mUserForm.type===\'create\'\"><div class=error ng-messages=userForm.Password.$error ng-show=mUserForm.submitAttempt><p ng-message=required>La Contraseña es requerida</p></div></div></div></div><div class=row ng-show=\"mUserForm.user.roles[0].id===6 || mUserForm.user.roles[0].id===11\"><div class=col-xs-6><div class=form-group><label>Agencias</label><select name=Reseller id=Reseller class=form-control ng-model=mUserForm.user.reseller.id ng-options=\"reseller.id as reseller.name for reseller in mUserForm.resellers\" ng-required=\"mUserForm.user.roles[0].id===6 || mUserForm.user.roles[0].id===11\"><option value=\"\">Seleccione una Agencia</option></select><div class=error ng-messages=userForm.Reseller.$error ng-show=mUserForm.submitAttempt><p ng-message=required>La Agencia es requerida</p></div></div></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit ladda=modalUserForm.loading class=\"btn btn-primary\">Guardar</button></div></form></div></div></div>");
$templateCache.put("app/components/sidebar/sidebar.html","<aside><ul class=general-items><li ng-repeat=\"item in sidebar.sideBarItems\"><a ui-sref={{item.routerState}} title={{item.title}} ui-sref-active=active><i class=\"fa {{item.icon}}\"></i> {{item.text}}</a></li></ul><hr><h2 ng-if=sidebar.title>{{sidebar.title}}</h2><ul><li ng-repeat=\"item in sidebar.items\"><a ui-sref={{item.routerState}} title={{item.title}} ui-sref-active=active><i class=\"fa {{item.icon}}\"></i> {{item.text}}</a></li></ul></aside>");
$templateCache.put("app/pages/administration-boardings/boardings.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=boardings-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><a ui-sref=administration.routes title=Rutas><i class=\"fa fa-angle-left\"></i> Volver a rutas</a><h2>Ruta: <span class=gray-title>{{boardings.routeName}}</span></h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=boardings.createBoarding()>Nuevo Abordaje</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Abordajes</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=boardings.searchBoardings()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=form-control id=searchBox ng-model=boardings.filter> <button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"boardings.boardingsList.length > 0\"><thead><tr><th>Nombre</th><th>Descripción</th><th>Precio</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"boarding in boardings.boardingsList\"><td>{{boarding.name}}</td><td>{{boarding.description}}</td><td>{{boarding.rate ? (boarding.rate | currency:\"₡\":0) : \'-\' }}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=boardings.editBoarding(boarding)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=boardings.deleteBoarding(boarding)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!boardings.boardingsList.length > 0\">No hay datos para mostrar</p></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"boardings.boardingsList.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(boardings.pagination.rangeSelected * (boardings.pagination.pageNum -1))+1}}-{{(boardings.pagination.rangeSelected* (boardings.pagination.pageNum -1))+boardings.pagination.numberOfPageRecords}} de {{boardings.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=boardings.pagination.totalRecords items-per-page=boardings.pagination.rangeSelected ng-change=boardings.goToPage(boardings.pagination.pageNum) ng-model=boardings.pagination.pageNum max-size=boardings.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in boardings.pagination.allowedRanges\"><a class=\"{{boardings.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=boardings.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-boarding-form boarding=boardings.selectedBoarding route-id=boardings.routeId></tnsp-modal-boarding-form>");
$templateCache.put("app/pages/administration-buses/buses.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=buses-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Buses</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=buses.createBus()>Nuevo Bus</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Buses</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=buses.searchBuses()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=\"form-control m-right-10\" id=searchBox ng-model=buses.filter><label for=FilterCountry>Pais:</label><select name=FilterCountry id=FilterCountry class=\"form-control m-right-10\" ng-model=buses.query.country ng-options=\"country.id as country.name for country in buses.countriesList\"><option value=\"\">Seleccione un País</option></select><button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"buses.busesList.length > 0\"><thead><tr><th>Placa</th><th>Capacidad</th><th>Clase</th><th>Pais</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"bus in buses.busesList\"><td>{{bus.licensePlate}}</td><td>{{bus.capacity}}</td><td>{{bus.busClass.name}}</td><td>{{bus.country.name}}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=buses.editBus(bus)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=buses.deleteBus(bus)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!buses.busesList.length > 0\">No hay datos para mostrar</p></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"buses.busesList.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(buses.pagination.rangeSelected * (buses.pagination.pageNum -1))+1}}-{{(buses.pagination.rangeSelected* (buses.pagination.pageNum -1))+buses.pagination.numberOfPageRecords}} de {{buses.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=buses.pagination.totalRecords items-per-page=buses.pagination.rangeSelected ng-change=buses.goToPage(buses.pagination.pageNum) ng-model=buses.pagination.pageNum max-size=buses.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in buses.pagination.allowedRanges\"><a class=\"{{buses.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=buses.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-bus-form bus=buses.selectedBus></tnsp-modal-bus-form>");
$templateCache.put("app/pages/administration-cash-registers/cash-registers.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=cashRegisters-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><a ui-sref=administration.terminals title=Terminales><i class=\"fa fa-angle-left\"></i> Volver a terminales</a><h2>Terminal <span class=gray-title>{{cashRegisters.terminalName}}</span></h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=cashRegisters.createCashRegister()>Nueva Caja Registradora</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Cajas Registradas</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=cashRegisters.searchCashRegisters()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=form-control id=searchBox ng-model=cashRegisters.filter> <button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"cashRegisters.cashRegistersList.length > 0\"><thead><tr><th>Nombre</th><th>Descripción</th></tr></thead><tbody><tr ng-repeat=\"cashRegister in cashRegisters.cashRegistersList\"><td>{{cashRegister.name}}</td><td>{{cashRegister.description}}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=cashRegisters.editCashRegister(cashRegister)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=cashRegisters.deleteCashRegister(cashRegister)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!cashRegisters.cashRegistersList.length > 0\">No hay datos para mostrar</p></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"cashRegisters.cashRegistersList.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(cashRegisters.pagination.rangeSelected * (cashRegisters.pagination.pageNum -1))+1}}-{{(cashRegisters.pagination.rangeSelected* (cashRegisters.pagination.pageNum -1))+cashRegisters.pagination.numberOfPageRecords}} de {{cashRegisters.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=cashRegisters.pagination.totalRecords items-per-page=cashRegisters.pagination.rangeSelected ng-change=cashRegisters.goToPage(cashRegisters.pagination.pageNum) ng-model=cashRegisters.pagination.pageNum max-size=cashRegisters.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in cashRegisters.pagination.allowedRanges\"><a class=\"{{cashRegisters.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=cashRegisters.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-cash-register-form cash-register=cashRegisters.selectedCashRegister terminal-id=cashRegisters.terminalId></tnsp-modal-cash-register-form>");
$templateCache.put("app/pages/administration-countries/countries.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=countries-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Paises</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=countries.createCountry()>Nuevo País</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Paises</h1></div></div><div class=row><div class=\"col-xs-4 col-xs-offset-4\"><form class=\"form-inline m-top-20\" ng-submit=countries.searchCountries()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=form-control id=searchBox ng-model=countries.filter> <button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"countries.countriesList.length > 0\"><thead><tr><th>Nombre</th><th>Compañía</th><th>Terminales</th><th>Moneda de Precios</th><th>Moneda de Cobro</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"country in countries.countriesList\"><td>{{country.name}}</td><td>{{country.companyName}}</td><td><span ng-repeat=\"terminal in country.terminals\" ng-bind=\"terminal.name + ($last ? \'\' : \', \')\"></span></td><td>{{country.currency.name}} ({{country.currency.symbol}})</td><td>{{country.billingCurrency.name}} ({{country.billingCurrency.symbol}})</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=countries.editCountry(country)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=countries.deleteCountry(country)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!countries.countriesList.length > 0\">No hay datos para mostrar</p></div></div><div class=row ng-show=\"countries.countriesList.length > 0\"><div class=\"col-xs-12 pagination-container\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(countries.pagination.rangeSelected * (countries.pagination.pageNum -1))+1}}-{{(countries.pagination.rangeSelected* (countries.pagination.pageNum -1))+countries.pagination.numberOfPageRecords}} de {{countries.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=countries.pagination.totalRecords items-per-page=countries.pagination.rangeSelected ng-change=countries.goToPage(countries.pagination.pageNum) ng-model=countries.pagination.pageNum max-size=countries.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in countries.pagination.allowedRanges\"><a class=\"{{countries.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=countries.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-country-form country=countries.selectedCountry></tnsp-modal-country-form>");
$templateCache.put("app/pages/administration-dollar-exchange/dollar-exchange.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=dollar-exchange-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Tipo de Cambio</h2></div><div class=\"col-xs-6 text-right\"><button ng-if=dollarExchange.canCreateDollarExchange() type=button class=\"btn btn-secondary\" ng-click=dollarExchange.createDollarExchange()>Nuevo Tipo de Cambio</button></div></div></div></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"dollarExchange.dollarExchangeList.length > 0\"><thead><tr><th>Monto</th><th>Description</th><th>Fecha</th><th>Creado por</th></tr></thead><tbody><tr ng-repeat=\"ex in dollarExchange.dollarExchangeList\"><td>{{ex.rate | currency:\"₡\":2}}</td><td>{{ex.description}}</td><td>{{ex.created | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{ex.fullName}}</td></tr></tbody></table><p ng-show=\"!dollarExchange.dollarExchangeList.length > 0\">No hay datos para mostrar</p></div></div></div><tnsp-modal-dollar-exchange-form></tnsp-modal-dollar-exchange-form>");
$templateCache.put("app/pages/administration-exchange/exchange.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=exchange-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Tipo de Cambio</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=exchange.createExchange()>Nuevo Tipo de Cambio</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de tipos de cambio</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=exchange.searchExchange()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=form-control id=searchBox ng-model=exchange.filter> <button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"exchange.exchangesList.length > 0\"><thead><tr><th>Base</th><th>Moneda Origen</th><th>Moneda Destino</th><th>Tipo de cambio</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"ex in exchange.exchangesList\"><td>1</td><td>{{ex.to.name}} ({{ex.to.symbol}})</td><td>{{ex.from.name}} ({{ex.from.symbol}})</td><td>{{ex.rate}}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=exchange.editExchange(ex)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=exchange.deleteExchange(ex)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!exchange.exchangesList.length > 0\">No hay datos para mostrar</p></div></div><div class=row ng-show=\"exchange.exchangesList.length > 0\"><div class=\"col-xs-12 pagination-container\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(exchange.pagination.rangeSelected * (exchange.pagination.pageNum -1))+1}}-{{(exchange.pagination.rangeSelected* (exchange.pagination.pageNum -1))+exchange.pagination.numberOfPageRecords}} de {{exchange.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=exchange.pagination.totalRecords items-per-page=exchange.pagination.rangeSelected ng-change=exchange.goToPage(exchange.pagination.pageNum) ng-model=exchange.pagination.pageNum max-size=exchange.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in exchange.pagination.allowedRanges\"><a class=\"{{exchange.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=exchange.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-exchange-form exchange=exchange.selectedExchange></tnsp-modal-exchange-form>");
$templateCache.put("app/pages/administration-external-codes/external-codes.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=extCodes-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Códigos Externos</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=extCodes.createExtCode()>Nuevo Talonario de Códigos</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Códigos Externos</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=extCodes.searchExtCodes()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=\"form-control m-right-10\" id=series placeholder=series ng-model=extCodes.filterSeries> <input type=text class=\"form-control m-right-10\" id=code placeholder=code ng-model=extCodes.filterCode> <button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"extCodes.extCodesList.length > 0\"><thead><tr><th>Creado Por</th><th>Serie</th><th>Inicio</th><th>Fin</th><th>Asignado A:</th><th>Acciónes</th></tr></thead><tbody><tr ng-repeat=\"extCode in extCodes.extCodesList\"><td>{{extCode.createdBy}}</td><td>{{extCode.series}}</td><td>{{extCode.start}}</td><td>{{extCode.end}}</td><td>{{extCode.assignedTo}}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=extCodes.editExtCode(extCode) ng-disabled=!isAdmin()><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=extCodes.deleteExtCode(extCode) ng-disabled=!isAdmin()><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!extCodes.extCodesList.length > 0\">No Hay datos para mostrar</p></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"extCodes.extCodesList.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(extCodes.pagination.rangeSelected * (extCodes.pagination.pageNum -1))+1}}-{{(extCodes.pagination.rangeSelected* (extCodes.pagination.pageNum -1))+extCodes.pagination.numberOfPageRecords}} de {{extCodes.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=extCodes.pagination.totalRecords items-per-page=extCodes.pagination.rangeSelected ng-change=extCodes.goToPage(extCodes.pagination.pageNum) ng-model=extCodes.pagination.pageNum max-size=extCodes.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in extCodes.pagination.allowedRanges\"><a class=\"{{extCodes.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=extCodes.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-ext-code-form ext-code=extCodes.selectedExtCode></tnsp-modal-ext-code-form>");
$templateCache.put("app/pages/administration-generated-trips/generated-trips.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=generatedTrips-overlay><div class=container-fluid><div class=row><div class=col-xs-12><h1>Viajes Generados</h1></div></div><form role=form id=filterForm name=filterForm class=m-top-20 novalidate ng-submit=generatedTrips.submit(filterForm)><div class=row><div class=col-xs-12><h4>Seleccione su Horario</h4></div></div><div class=row><div class=col-xs-3><div class=form-group><label for=Route>Ruta:</label><select name=Route id=Route class=form-control ng-options=\"route.id as route.name for route in generatedTrips.routesList\" ng-model=generatedTrips.filter.route required><option value=\"\">Ruta</option></select><div class=error ng-messages=filterForm.Route.$error ng-show=generatedTrips.submitAttempt><p ng-message=required>La Ruta es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=OriginDate>Fecha Inicio:</label><p class=\"input-group m-bottom-0\"><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=generatedTrips.filter.originDateUI is-open=generatedTrips.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"generatedTrips.showOriginCalendar = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=filterForm.OriginDate.$error ng-show=generatedTrips.submitAttempt><p ng-message=required>La Fecha es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=EndDate>Fecha Final:</label><p class=\"input-group m-bottom-0\"><input type=text name=EndDate id=EndDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=generatedTrips.filter.endDateUI is-open=generatedTrips.showEndCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"generatedTrips.showEndCalendar = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=filterForm.EndDate.$error ng-show=generatedTrips.submitAttempt><p ng-message=required>La Fecha es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=BusType>Tipo de Bus:</label><select name=BusType id=BusType class=form-control ng-options=\"busType.id as busType.name for busType in generatedTrips.busClasses\" ng-model=generatedTrips.filter.busType required><option value=\"\">Tipo de Bus</option></select><div class=error ng-messages=filterForm.BusType.$error ng-show=generatedTrips.submitAttempt><p ng-message=required>El Tipo de Bus es requerido</p></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-24\">Buscar</button></div></div></form></div><div class=row ng-if=\"generatedTrips.trips.length > 0\"><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"generatedTrips.trips.length > 0\"><thead><tr><th>Id</th><th>Fecha</th><th>Salida</th><th>Activo</th><th>Bus</th><th>Chofer</th><th>Asientos<br>Disponibles / Total</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"trip in generatedTrips.trips\"><td>{{trip.id}}</td><td>{{trip.date | amDateFormat:\'DD/MM/YYYY\'}}</td><td>{{trip.schedule.departureTime}}</td><td>{{trip.schedule.active ? \'Si\': \'No\'}}</td><td>{{trip.schedule.routeRate.busClass.name}}</td><td>{{trip.driver ? trip.driver.fullName : \'-\'}}</td><td ng-init=\"info = generatedTrips.getAvailableSeats(trip)\">{{ info.available }} / {{ info.total }}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=generatedTrips.deleteTrip(trip)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!generatedTrips.trips.length > 0\">No hay datos para mostrar</p></div></div><div class=row ng-show=\"generatedTrips.trips.length > 0\"><div class=\"col-xs-12 pagination-container\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(generatedTrips.pagination.rangeSelected * (generatedTrips.pagination.pageNum -1))+1}}-{{(generatedTrips.pagination.rangeSelected* (generatedTrips.pagination.pageNum -1))+generatedTrips.pagination.numberOfPageRecords}} de {{generatedTrips.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=generatedTrips.pagination.totalRecords items-per-page=generatedTrips.pagination.rangeSelected ng-change=generatedTrips.goToPage(generatedTrips.pagination.pageNum) ng-model=generatedTrips.pagination.pageNum max-size=generatedTrips.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in generatedTrips.pagination.allowedRanges\"><a class=\"{{generatedTrips.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=generatedTrips.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div>");
$templateCache.put("app/pages/administration-manage-trips/manage-trips.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=manageTrips-overlay><div class=row><div class=col-xs-12><h1>Administrar Viajes</h1></div></div><form id=filterForm name=filterForm class=m-top-20 novalidate><div class=row><div class=col-xs-12><h4>Seleccione su viaje</h4></div></div><div class=row><div class=col-xs-3><div class=form-group><label for=Route>Ruta:</label><select name=Route id=Route class=form-control ng-options=\"route.id as route.name for route in manageTrips.routesList\" ng-model=manageTrips.filter.route required><option value=\"\">Ruta</option></select><div class=error ng-messages=filterForm.Route.$error ng-show=manageTrips.submitAttempt><p ng-message=required>La Ruta es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=OriginDate>Fecha:</label><p class=input-group><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=manageTrips.filter.originDateUI is-open=manageTrips.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=manageTrips.openOriginDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=filterForm.OriginDate.$error ng-show=manageTrips.submitAttempt><p ng-message=required>La Fecha es requerida</p></div></div></div><div class=col-xs-3><div class=form-group><label for=BusType>Tipo de Bus:</label><select name=BusType id=BusType class=form-control ng-options=\"busType.id as busType.name for busType in manageTrips.busClasses\" ng-model=manageTrips.filter.busType ng-change=manageTrips.loadSchedulesAvailable() required><option value=\"\">Tipo de Bus</option></select><div class=error ng-messages=filterForm.BusType.$error ng-show=manageTrips.submitAttempt><p ng-message=required>El Tipo de Bus es requerido</p></div></div></div><div class=col-xs-2><div class=form-group><label for=SchedulesAvailable>Horarios</label><select name=SchedulesAvailable id=SchedulesAvailable class=form-control ng-options=\"trip as trip.schedule.departureTime for trip in manageTrips.schedulesAvailable\" ng-model=manageTrips.filter.selectedTrip ng-change=manageTrips.tripSelected() required><option value=\"\">Horarios</option></select><div class=error ng-messages=filterForm.SchedulesAvailable.$error ng-show=manageTrips.submitAttempt><p ng-message=required>El horario es requerido</p></div></div></div><div class=col-xs-2></div></div></form></div><div class=row ng-show=manageTrips.filter.selectedTrip><div class=col-xs-12><form id=TripForm name=TripForm class=m-top-20 ng-submit=manageTrips.updateTrip(TripForm) novalidate><div class=row><div class=col-xs-12><p><bold>Datos del viaje</bold></p></div></div><div class=row><div class=col-xs-3><div class=form-group><label for=Seats>Cantidad de asientos:</label><input type=number class=form-control ng-model=manageTrips.filter.selectedTrip.seats id=Seats name=Seats ng-max=manageTrips.max step=1 min=0><div class=error ng-messages=TripForm.Seats.$error ng-show=manageTrips.submitAttempt><p ng-message=required>Asientos requeridos</p><p ng-message=max>No puede exeder de {{manageTrips.max}} que es la capacidad del bus</p></div></div></div><div class=col-xs-6></div><div class=col-xs-3><button type=button ng-show=manageTrips.canLockTrip(manageTrips.filter.selectedTrip) class=\"btn btn-danger m-top-25\" ng-click=manageTrips.lock() ng-disabled=\"manageTrips.filter.selectedTrip.tripSeats.length > 0\">Bloquear Viaje</button> <button type=button ng-show=manageTrips.canUnLockTrip(manageTrips.filter.selectedTrip) class=\"btn btn-danger m-top-25\" ng-click=manageTrips.unlock() ng-disabled=\"manageTrips.filter.selectedTrip.tripSeats.length > 0\">Desbloquear Viaje</button></div></div><div class=row><div class=col-xs-3><div class=form-group><label>Bus:</label><select name=Bus id=Bus class=form-control ng-model=manageTrips.filter.selectedTrip.bus.id ng-options=\"b.id as (b.licensePlate + \' (Bus \' + b.layoutType + \')\') for b in manageTrips.buses\" ng-change=manageTrips.busSelected(manageTrips.filter.selectedTrip.bus.id)><option value=\"\">Seleccione un bus</option></select><div class=error ng-messages=TripForm.Bus.$error ng-show=manageTrips.submitAttempt><p ng-message=required>Bus requerido</p></div></div></div></div><div class=row><div class=col-xs-3><div class=form-group><label>Chofer:</label><select name=Driver id=Driver class=form-control ng-model=manageTrips.filter.selectedTrip.driver.id ng-options=\"bd.id as bd.fullName for bd in manageTrips.busDrivers\"><option value=\"\">Seleccione un chofer</option></select><div class=error ng-messages=TripForm.Driver.$error ng-show=manageTrips.submitAttempt><p ng-message=required>Chofer requerido</p></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Actualizar</button></div></div></form></div></div>");
$templateCache.put("app/pages/administration-parent/administration.html","<div class=\"container-fluid page-container\"><div class=\"row max-width-content\"><div class=\"col-xs-12 no-padding\"><div class=animated-view ui-view></div></div></div></div>");
$templateCache.put("app/pages/administration-profiles/profiles.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=profiles-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Perfiles</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=profiles.createProfile()>Nuevo Perfil</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de perfiles</h1></div></div><div class=row><div class=\"col-xs-4 col-xs-offset-4\"><form class=\"form-inline m-top-20\" ng-submit=profiles.searchProfiles()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=form-control id=searchBox ng-model=profiles.filter> <button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"profiles.profilesList.length > 0\"><thead><tr><th>Nombre</th><th>Descripción</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"profile in profiles.profilesList\"><td>{{profile.name}}</td><td>{{profile.description}}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=profiles.editProfile(profile)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=profiles.deleteProfile(profile) ng-disabled=profile.locked><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!profiles.profilesList.length > 0\">No hay datos para mostrar</p></div></div><div class=row ng-show=\"profiles.profilesList.length > 0\"><div class=\"col-xs-12 pagination-container\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(profiles.pagination.rangeSelected * (profiles.pagination.pageNum -1))+1}}-{{(profiles.pagination.rangeSelected* (profiles.pagination.pageNum -1))+profiles.pagination.numberOfPageRecords}} de {{profiles.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=profiles.pagination.totalRecords items-per-page=profiles.pagination.rangeSelected ng-change=profiles.goToPage(profiles.pagination.pageNum) ng-model=profiles.pagination.pageNum max-size=profiles.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in profiles.pagination.allowedRanges\"><a class=\"{{profiles.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=profiles.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-profile-form profile=profiles.selectedProfile></tnsp-modal-profile-form>");
$templateCache.put("app/pages/administration-resellers/resellers.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=resellers-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Agencias</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=resellers.createReseller()>Nueva Agencia</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Agencias</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=resellers.searchResellers()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=\"form-control m-right-10\" id=searchBox ng-model=resellers.filter><label for=FilterCountry>Pais:</label><select name=FilterCountry id=FilterCountry class=\"form-control m-right-10\" ng-model=resellers.query.country ng-options=\"country.id as country.name for country in resellers.countriesList\"><option value=\"\">Seleccione un País</option></select><button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"resellers.resellersList.length > 0\"><thead><tr><th>Nombre</th><th>País</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"reseller in resellers.resellersList\"><td>{{reseller.name}}</td><td>{{reseller.country.name}}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=resellers.editReseller(reseller)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=resellers.deleteReseller(reseller)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!resellers.resellersList.length > 0\">No hay datos para mostrar</p></div></div><div class=row ng-show=\"resellers.resellersList.length > 0\"><div class=\"col-xs-12 pagination-container\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(resellers.pagination.rangeSelected * (resellers.pagination.pageNum -1))+1}}-{{(resellers.pagination.rangeSelected* (resellers.pagination.pageNum -1))+resellers.pagination.numberOfPageRecords}} de {{resellers.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=resellers.pagination.totalRecords items-per-page=resellers.pagination.rangeSelected ng-change=resellers.goToPage(resellers.pagination.pageNum) ng-model=resellers.pagination.pageNum max-size=resellers.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in resellers.pagination.allowedRanges\"><a class=\"{{resellers.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=resellers.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-reseller-form reseller=resellers.selectedReseller></tnsp-modal-reseller-form>");
$templateCache.put("app/pages/administration-route-rates/route-rates.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=route-rate-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><a ui-sref=administration.routes title=Rutas><i class=\"fa fa-angle-left\"></i> Volver a rutas</a><h2>Ruta: <span class=gray-title>{{routeRates.routeName}}</span></h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=routeRates.createRouteRate()>Nuevo Precio</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Precios</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=routeRates.searchRouteRates()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=\"form-control m-right-10\" id=searchBox ng-model=routeRates.filter> <button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"routeRates.routeRatesList.length > 0\"><thead><tr><th>Clase de Bus</th><th>Precio CR</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"routeRate in routeRates.routeRatesList\"><td>{{routeRate.busClass.name}}</td><td>{{routeRate.countryRates.CR | currency:\"₡\"}}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=routeRates.editRouteRate(routeRate)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=routeRates.deleteRouteRate(routeRate)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!routeRates.routeRatesList.length > 0\">No hay datos para mostrar</p></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"routeRates.routeRatesList.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(routeRates.pagination.rangeSelected * (routeRates.pagination.pageNum -1))+1}}-{{(routeRates.pagination.rangeSelected* (routeRates.pagination.pageNum -1))+routeRates.pagination.numberOfPageRecords}} de {{routeRates.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=routeRates.pagination.totalRecords items-per-page=routeRates.pagination.rangeSelected ng-change=routeRates.goToPage(routeRates.pagination.pageNum) ng-model=routeRates.pagination.pageNum max-size=routeRates.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in routeRates.pagination.allowedRanges\"><a class=\"{{routeRates.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=routeRates.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-route-rate-form route-rate=routeRates.selectedRouteRate route-id=routeRates.routeId></tnsp-modal-route-rate-form>");
$templateCache.put("app/pages/administration-routes/routes.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=routes-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Rutas</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=routes.createRoute()>Nueva Ruta</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Rutas</h1></div></div><div class=row><div class=\"col-xs-7 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=routes.searchRoutes()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=\"form-control m-right-10\" id=searchBox ng-model=routes.filter><label for=FilterCountry>Pais:</label><select name=FilterCountry id=FilterCountry class=\"form-control m-right-10\" ng-model=routes.query.country ng-options=\"country.id as country.name for country in routes.countriesList\"><option value=\"\">Seleccione un País</option></select><button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div><div class=col-xs-3><div class=\"form-group m-top-25\"><div class=\"radio radio-inline\"><input type=radio id=CR name=prefix value=CR ng-model=routes.prefix ng-change=routes.searchRoutes()><label for=CR>Santa Cruz</label></div><div class=\"radio radio-inline\"><input type=radio id=NY name=prefix value=NY ng-model=routes.prefix ng-change=routes.searchRoutes()><label for=NY>Nicoya</label></div><div class=\"radio radio-inline\"><input type=radio id=TOTALS name=prefix ng-value=null ng-model=routes.prefix ng-change=routes.searchRoutes()><label for=TOTALS>Todas</label></div></div></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"routes.routesList.length > 0\"><thead><tr><th>Nombre</th><th>Salida</th><th>Destino</th><th class=text-center>Prefijo Fac.</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"route in routes.routesList\"><td>{{route.name}}</td><td>{{route.departure}}</td><td>{{route.destiny}}</td><td class=text-center>{{route.invoiceCounterNumber.prefix}}</td><td class=\"actions actions-7 text-right\"><button ng-if=route.publicRoute type=button class=\"btn btn-clear\" ng-click=routes.unPublish(route) title=\"Ocultar Ruta al Publico\"><i class=\"fa fa-eye\"></i></button> <button ng-if=!route.publicRoute type=button class=\"btn btn-clear\" ng-click=routes.publish(route) title=\"Mostrar Ruta al Publico\"><i class=\"fa fa-eye-slash\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=routes.editRoute(route) title=\"Editar Ruta\"><i class=\"fa fa-pencil edit-icon\"></i></button> <a ui-sref=administration.routeRates({routeId:route.id}) title=\"Precio de Ruta\"><i class=\"fa fa-usd\"></i> </a><a ui-sref=administration.schedules({routeId:route.id}) title=\"Horarios de Ruta\" ng-show=!route.transfer><i class=\"fa fa-clock-o\"></i> </a><a ui-sref=administration.boardings({routeId:route.id}) title=\"Abordajes de Ruta\" ng-show=!route.transfer><i class=\"fa fa-bus\"></i> </a><button type=button class=\"btn btn-clear\" ng-click=routes.deleteRoute(route) title=\"Eliminar Ruta\"><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!routes.routesList.length > 0\">No hay datos para mostrar</p></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"routes.routesList.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(routes.pagination.rangeSelected * (routes.pagination.pageNum -1))+1}}-{{(routes.pagination.rangeSelected* (routes.pagination.pageNum -1))+routes.pagination.numberOfPageRecords}} de {{routes.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=routes.pagination.totalRecords items-per-page=routes.pagination.rangeSelected ng-change=routes.goToPage(routes.pagination.pageNum) ng-model=routes.pagination.pageNum max-size=routes.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in routes.pagination.allowedRanges\"><a class=\"{{routes.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=routes.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-route-form route=routes.selectedRoute></tnsp-modal-route-form>");
$templateCache.put("app/pages/administration-schedules/schedules.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=schedules-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><a ui-sref=administration.routes title=Rutas><i class=\"fa fa-angle-left\"></i> Volver a rutas</a><h2>Ruta: <span class=gray-title>{{schedules.routeName}}</span></h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=schedules.createSchedule()>Nuevo Horario</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Horarios</h1></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"schedules.schedulesList.length > 0\"><thead><tr><th>Nombre</th><th>Hora de salida</th><th>Hora de llegada</th><th>Tipo de Viaje</th><th>Visible</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"schedule in schedules.schedulesList\"><td>{{schedule.name}}</td><td>{{schedule.departureTime}}</td><td>{{schedule.arrivalTime}}</td><td>{{schedule.routeRate.busClass.name}}</td><td>{{(schedule.visible) ? \'SI\' : \'NO\'}}</td><td class=actions><button type=button title=\"Generar Viaje\" class=\"btn btn-clear\" ng-click=schedules.generateTrips(schedule)><i class=\"fa fa-rocket\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=schedules.editSchedule(schedule)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=schedules.deleteSchedule(schedule)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!schedules.schedulesList.length > 0\">No hay datos para mostrar</p></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"schedules.schedulesList.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(schedules.pagination.rangeSelected * (schedules.pagination.pageNum -1))+1}}-{{(schedules.pagination.rangeSelected* (schedules.pagination.pageNum -1))+schedules.pagination.numberOfPageRecords}} de {{schedules.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=schedules.pagination.totalRecords items-per-page=schedules.pagination.rangeSelected ng-change=schedules.goToPage(schedules.pagination.pageNum) ng-model=schedules.pagination.pageNum max-size=schedules.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in schedules.pagination.allowedRanges\"><a class=\"{{schedules.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=schedules.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-schedule-form schedule=schedules.selectedSchedule route-id=schedules.routeId></tnsp-modal-schedule-form><tnsp-modal-generate-trip-form schedule=schedules.selectedSchedule route-id=schedules.routeId></tnsp-modal-generate-trip-form>");
$templateCache.put("app/pages/administration-terminals/terminals.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=terminals-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Terminales</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=terminals.createTerminal()>Nuevo Terminal</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Terminales</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=terminals.searchTerminals()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=\"form-control m-right-10\" id=searchBox ng-model=terminals.filter><label for=FilterCountry>Pais:</label><select name=FilterCountry id=FilterCountry class=\"form-control m-right-10\" ng-model=terminals.query.country ng-options=\"country.id as country.name for country in terminals.countriesList\"><option value=\"\">Seleccione un País</option></select><button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"terminals.terminalsList.length > 0\"><thead><tr><th>Nombre</th><th>País</th><th>Teléfono</th><th>Correo Electrónico</th><th>Numero de contribuyente</th><th>Acción</th></tr></thead><tbody><tr ng-repeat=\"terminal in terminals.terminalsList\"><td>{{terminal.name}}</td><td>{{terminal.country.name}}</td><td>{{terminal.phone}}</td><td>{{terminal.email}}</td><td>{{terminal.contributorNumber}}</td><td class=\"actions actions-6\"><button type=button class=\"btn btn-clear\" ng-click=terminals.openConfig()><i class=\"fa fa-cog edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=terminals.editTerminal(terminal)><i class=\"fa fa-pencil edit-icon\"></i></button> <a ui-sref=administration.cashRegisters({terminalId:terminal.id}) title=\"Cajas Registradoras\"><i class=\"fa fa-calculator\"></i> </a><button type=button class=\"btn btn-clear\" ng-click=terminals.deleteTerminal(terminal)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!terminals.terminalsList.length > 0\">No hay datos para mostrar</p></div></div><div class=row ng-show=\"terminals.terminalsList.length > 0\"><div class=\"col-xs-12 pagination-container\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(terminals.pagination.rangeSelected * (terminals.pagination.pageNum -1))+1}}-{{(terminals.pagination.rangeSelected* (terminals.pagination.pageNum -1))+terminals.pagination.numberOfPageRecords}} de {{terminals.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=terminals.pagination.totalRecords items-per-page=terminals.pagination.rangeSelected ng-change=terminals.goToPage(terminals.pagination.pageNum) ng-model=terminals.pagination.pageNum max-size=terminals.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in terminals.pagination.allowedRanges\"><a class=\"{{terminals.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=terminals.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-terminal-form terminal=terminals.selectedTerminal></tnsp-modal-terminal-form><tnsp-modal-config-form></tnsp-modal-config-form>");
$templateCache.put("app/pages/administration-users/users.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=users-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Usuarios</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=users.createUser()>Nuevo Usuario</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Usuarios</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=users.searchUsers()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=\"form-control m-right-10\" id=searchBox ng-model=users.filter><label for=FilterProfile>Perfil:</label><select name=FilterProfile id=FilterProfile class=\"form-control m-right-10\" ng-model=users.query.role ng-options=\"profile.id as profile.name for profile in users.profiles\"><option value=\"\">Seleccione un Perfil</option></select><button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"users.usersList.length > 0\"><thead><tr><th>Identificación</th><th>Nombre Completo</th><th>Nombre de usuario</th><th>Correo Electrónico</th><th>Perfil</th><th>Acciónes</th></tr></thead><tbody><tr ng-repeat=\"user in users.usersList\"><td>{{user.identification}}</td><td>{{user.fullName}}</td><td>{{user.username}}</td><td>{{user.email}}</td><td>{{user.roles[0].name}}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=users.editUser(user)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=users.deleteUser(user)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!users.usersList.length > 0\">No Hay datos para mostrar</p></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"users.usersList.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(users.pagination.rangeSelected * (users.pagination.pageNum -1))+1}}-{{(users.pagination.rangeSelected* (users.pagination.pageNum -1))+users.pagination.numberOfPageRecords}} de {{users.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=users.pagination.totalRecords items-per-page=users.pagination.rangeSelected ng-change=users.goToPage(users.pagination.pageNum) ng-model=users.pagination.pageNum max-size=users.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in users.pagination.allowedRanges\"><a class=\"{{users.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=users.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-user-form user=users.selectedUser></tnsp-modal-user-form>");
$templateCache.put("app/pages/configuration-parent/configuration.html","<div class=\"container-fluid page-container\"><div class=\"row max-width-content\"><div class=\"col-xs-12 no-padding\"><h1>Configuración</h1><div class=animated-view ui-view></div></div></div></div>");
$templateCache.put("app/pages/entrust-packing-types/packing-types.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=packingTypes-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Tipos de Carga</h2></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-secondary\" ng-click=packingTypes.createPackingType()>Nuevo Tipo de Carga</button></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de Tipos de Carga</h1></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><form class=\"form-inline m-top-20\" ng-submit=packingTypes.searchPackingTypes()><div class=form-group><label for=searchBox>Buscar:</label><input type=text class=form-control id=searchBox ng-model=packingTypes.filter><label for=FilterCountry>Pais:</label><select name=FilterCountry id=FilterCountry class=\"form-control m-right-10\" ng-model=packingTypes.query.country ng-options=\"country.id as country.name for country in packingTypes.countriesList\"><option value=\"\">Seleccione un País</option></select><button type=submit class=\"btn btn-primary\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"packingTypes.packingTypesList.length > 0\"><thead><tr><th>Nombre</th><th>Precio</th><th>País</th></tr></thead><tbody><tr ng-repeat=\"packingType in packingTypes.packingTypesList\"><td>{{packingType.name}}</td><td>{{packingType.rate}}</td><td>{{packingType.country.name}}</td><td class=actions><button type=button class=\"btn btn-clear\" ng-click=packingTypes.editPackingType(packingType)><i class=\"fa fa-pencil edit-icon\"></i></button> <button type=button class=\"btn btn-clear\" ng-click=packingTypes.deletePackingType(packingType)><i class=\"fa fa-times\"></i></button></td></tr></tbody></table><p ng-show=\"!packingTypes.packingTypesList.length > 0\">No hay datos para mostrar</p></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"packingTypes.packingTypesList.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(packingTypes.pagination.rangeSelected * (packingTypes.pagination.pageNum -1))+1}}-{{(packingTypes.pagination.rangeSelected* (packingTypes.pagination.pageNum -1))+packingTypes.pagination.numberOfPageRecords}} de {{packingTypes.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=packingTypes.pagination.totalRecords items-per-page=packingTypes.pagination.rangeSelected ng-change=packingTypes.goToPage(packingTypes.pagination.pageNum) ng-model=packingTypes.pagination.pageNum max-size=packingTypes.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in packingTypes.pagination.allowedRanges\"><a class=\"{{packingTypes.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=packingTypes.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-packing-type-form packing-type=packingTypes.selectedPackingType></tnsp-modal-packing-type-form>");
$templateCache.put("app/pages/entrust-parent/entrust.html","<div class=\"container-fluid page-container\"><div class=\"row max-width-content\"><div class=\"col-xs-12 no-padding\"><div class=animated-view ui-view></div></div></div></div>");
$templateCache.put("app/pages/forgot-password/forgot-password.html","<div class=\"container-fluid page-container authentication-form-container\"><div class=\"row max-width-content\"><div class=col-xs-12><h1>Olvidó su contraseña</h1><hr><form role=form name=forgotForm ng-submit=forgotPassword.forgotPasswordProcess(forgotForm) novalidate><div class=form-group><label for=email>Dirección de correo electrónico:</label><input type=email id=email name=email placeholder=ejemplo@ejemplo.com class=form-control ng-model=forgotPassword.email required><div ng-messages=forgotForm.email.$error ng-show=forgotPassword.submitAttempt class=m-top-10><span ng-message=required class=error>Correo electrónico es requerido.</span> <span ng-message=email class=error>Correo electrónico inválido.</span></div></div><p class=error>{{ forgotPassword.message }}</p><div class=form-group><button type=submit ladda=forgotPassword.loading data-style=zoom-in class=\"btn btn-primary\">Enviar</button></div></form></div></div></div>");
$templateCache.put("app/pages/home/home.html","<div class=\"container-fluid page-container\"><div class=\"row max-width-content m-top-40\"><div class=\"col-xs-8 col-xs-offset-2 m-top-40\"><h1 class=\"text-center m-top-40\">Bienvenido a TIG</h1><h3 class=text-center>Sistema integrado de facturación y venta de boletos</h3><!--<button class=\"btn btn-primary\" ng-click=\"home.createUser()\">Crear Usuario</button>\n      <button class=\"btn btn-primary\" ng-click=\"home.createRole()\">Crear Role</button>\n      <button class=\"btn btn-primary\" ng-click=\"home.createBus()\">Crear Bus</button>\n      <button class=\"btn btn-primary\" ng-click=\"home.createBusDriver()\">Crear Chofer</button>--></div></div><!--<tnsp-modal-user-form user=\"home.selectedUser\"></tnsp-modal-user-form>\n  <tnsp-modal-create-role></tnsp-modal-create-role>\n  <tnsp-modal-create-bus></tnsp-modal-create-bus>\n  <tnsp-modal-create-bus-driver></tnsp-modal-create-bus-driver>--></div>");
$templateCache.put("app/pages/login/login.html","<div class=\"container authentication-form-container\"><div class=row><div class=col-xs-12><h1>Ingreso</h1><hr><form role=form name=loginForm ng-submit=login.loginProcess(loginForm) novalidate><div class=form-group><label for=username>Nombre de usuario:</label><input type=text id=username name=username placeholder=Username class=form-control ng-model=login.credentials.userName required><div class=error ng-messages=loginForm.username.$error ng-show=login.submitAttempt><p ng-message=required>Username is required</p></div></div><div class=\"form-group relative-pos\"><label for=password>Contraseña:</label><input type={{login.pass.type}} name=password placeholder=Password class=form-control ng-model=login.credentials.password required><div class=error ng-messages=loginForm.password.$error ng-show=login.submitAttempt><p ng-message=required>Password is required</p></div><button type=button class=\"btn btn-eye\" ng-click=login.tooglePasswordType()><i class=fa ng-class=login.pass.icon></i></button></div><p class=error>{{ login.message }}</p><div class=form-group><button type=submit ladda=login.loading data-style=zoom-in class=\"btn btn-primary\">Ingresar</button></div></form></div></div></div>");
$templateCache.put("app/pages/reports-accounting/accounting.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=accounting-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Contabilidad</h2></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Reporte de contabilidad</h1></div></div><div class=row><form role=form name=form class=\"form-inline m-top-20\" ng-submit=accountingReport.requestAccountingReport(form) novalidate><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha Inicial:</label><p class=input-group><input type=text name=StartDate id=StartDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=accountingReport.startDate is-open=accountingReport.showStartCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\"> <span class=input-group-btn datepicker-options=accountingReport.dateConfig><button type=button class=\"btn btn-default\" ng-click=accountingReport.openStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.StartDate.$error ng-show=accountingReport.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=EndDate>Fecha Final:</label><p class=input-group><input type=text name=EndDate id=EndDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=accountingReport.endDate is-open=accountingReport.showEndCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=accountingReport.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=accountingReport.openEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.EndDate.$error ng-show=accountingReport.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-3><div class=\"form-group m-top-25\"><div class=\"radio radio-inline\"><input type=radio id=CR name=reportType value=CR ng-checked=true ng-model=accountingReport.type><label for=CR>Santa Cruz</label></div><div class=\"radio radio-inline\"><input type=radio id=NY name=reportType value=NY ng-model=accountingReport.type><label for=NY>Nicoya</label></div><div class=\"radio radio-inline\"><input type=radio id=TOTALS name=reportType value=TOTALS ng-model=accountingReport.type><label for=TOTALS>Total</label></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Generar</button></div></form></div><div class=row><div class=col-xs-12><p>El reporte de contabilidad será enviado el correo electrónico del usuario con que ingresó al sistema.</p></div></div></div>");
$templateCache.put("app/components/modal-checks-load-form/modal-checks-load-form.html","<div class=\"modal fade\" id=modalChecksLoadForm tabindex=-1 role=dialog aria-labelledby=modalChecksLoadForm><div class=\"modal-dialog modal-lg\" role=document><div class=modal-content><form id=checksLoadForm name=checksLoadForm ng-submit=mChecksLoadForm.submitProcess(checksLoadForm) novalidate><div class=modal-header><button type=button class=close data-dismiss=modal aria-label=Close><span aria-hidden=true>&times;</span></button><h4 class=modal-title>Cargas</h4></div><div class=modal-body><div class=row><div class=col-xs-6><h1>Carga del pasajero</h1></div></div><div class=row><div class=col-xs-12><table id=checksLoadTable class=\"table table-striped\"><thead><tr><th>Carga</th><th>Precio</th><th>Etiqueta</th><th></th></tr></thead><tbody><tr ng-repeat=\"luggage in mChecksLoadForm.luggage track by $index\"><td>{{luggage.name}}</td><td>{{luggage.billableRate}}</td><td>{{luggage.serial}}</td><td><button type=button class=\"btn btn-default\" ng-click=mChecksLoadForm.removeLuggage($index)><i class=\"fa fa-times\"></i></button></td></tr><tr ng-show=\"mChecksLoadForm.luggage.length > 0\"><td><strong>TOTAL</strong></td><td>{{mChecksLoadForm.totalToPay}}</td><td colspan=2></td></tr><tr><td><select name=NewLuggageType id=NewLuggageType class=form-control ng-model=mChecksLoadForm.newLuggage.freight ng-options=\"pt as pt.name for pt in mChecksLoadForm.packingTypesList\" ng-change=mChecksLoadForm.resetNewLuggage(mChecksLoadForm.newLuggage.freight)><option value=\"\">Carga</option></select></td><td><input type=text name=NewLuggageRate id=NewLuggageRate class=form-control ng-model=mChecksLoadForm.newLuggage.billableRate disabled></td><td><input type=text name=NewLuggageSerial id=NewLuggageSerial class=form-control ng-model=mChecksLoadForm.newLuggage.serial></td><td><button type=button class=\"btn btn-primary\" ng-click=mChecksLoadForm.addLuggage()>Agregar</button></td></tr><tr><td><input type=text name=NewFreeLuggage id=NewFreeLuggage class=form-control ng-model=mChecksLoadForm.newFreeLuggage.name></td><td><input type=text name=NewFreeLuggageRate id=NewFreeLuggageRate class=form-control ng-model=mChecksLoadForm.newFreeLuggage.billableRate></td><td><input type=text name=NewFreeLuggageSerial id=NewFreeLuggageSerial class=form-control ng-model=mChecksLoadForm.newFreeLuggage.serial></td><td><button type=button class=\"btn btn-primary\" ng-click=mChecksLoadForm.addFreeLuggage()>Agregar</button></td></tr></tbody></table></div><iframe id=printableAreaFrame name=printableAreaFrame style=display:none></iframe></div><div class=row ng-if=\"mChecksLoadForm.totalToPay > 0\"><div class=col-xs-12><div class=row><div class=col-xs-12><h3>Pago</h3></div></div><div class=\"row form-group\"><div class=col-xs-2><strong>Total:</strong></div><div class=\"col-xs-3 text-right\"><input type=text class=\"form-control text-right\" ng-model=mChecksLoadForm.totalToPay disabled></div><div class=col-xs-2><strong>Forma de pago:</strong></div><div class=col-xs-3><select name=paymentTypes id=paymentTypes class=form-control ng-options=\"pt as pt.name for pt in mChecksLoadForm.paymentTypes\" ng-model=mChecksLoadForm.paymentType required><option value=\"\">Forma de Pago</option></select></div></div><div class=\"row form-group\"><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input type=text ng-model=mChecksLoadForm.amount class=\"form-control text-right\" ng-blur=mChecksLoadForm.calcDifference() required></div><div class=col-xs-2 ng-show=\"mChecksLoadForm.paymentType.name == \'Tarjeta\'\"><strong>Autorización:</strong></div><div class=col-xs-3 ng-show=\"mChecksLoadForm.paymentType.name == \'Tarjeta\'\"><input type=text ng-model=mChecksLoadForm.paymentType.cardConfirmation class=form-control ng-required=\"mChecksLoadForm.paymentType.name == \'Tarjeta\'\"></div></div><div class=\"row form-group\" ng-show=mChecksLoadForm.difference><div class=col-xs-2><strong>Vuelto:</strong></div><div class=\"col-xs-3 text-right\"><input type=text ng-model=mChecksLoadForm.difference class=\"form-control text-right\" disabled></div></div></div></div><div class=row ng-show=\"mChecksLoadForm.luggageList.length > 0\"><div class=col-xs-12><h3>Carga Registrada</h3><table class=\"table table-striped\"><thead><tr><th>Carga</th><th>Etiqueta</th></tr></thead><tbody><tr ng-repeat=\"item in mChecksLoadForm.luggageList\"><td>{{item.name}}</td><td>{{item.serial}}</td></tr></tbody></table></div></div></div><div class=modal-footer><button type=button class=\"btn btn-default\" data-dismiss=modal>Cancelar</button> <button type=submit id=save_checks_load ladda=mChecksLoadForm.loading class=\"btn btn-primary\">Imprimir</button></div></form></div></div><div ng-show=false><div class=\"row ticket-print\"><div id=printableArea class=\"col-xs-6 col-xs-offset-3\"><div class=\"row ticket-container\"><div class=\"col-xs-12 text-center\"><h3 class=text-uppercase>{{mChecksLoadForm.registerLuggage.user.terminal.country.companyName}}</h3><p>Ced: Juridica: {{mChecksLoadForm.registerLuggage.user.terminal.contributorNumber}}</p><p>Tel: {{mChecksLoadForm.registerLuggage.user.terminal.phone}}</p><p>{{mChecksLoadForm.registerLuggage.user.terminal.address}}</p></div><div class=\"col-xs-12 text-center\"><hr><h4>Factura de Carga</h4><hr><div class=row><div class=\"col-xs-4 text-left\"><h4>Carga:</h4></div><div class=\"col-xs-8 text-right\"><p>{{mChecksLoadForm.registerLuggage.id}}</p></div></div><div class=row><div class=\"col-xs-4 text-left\"><b>Boleto:</b></div><div class=\"col-xs-8 text-right\"><p>{{mChecksLoadForm.ticket.invoiceNumber}}</p></div></div><div class=row><div class=\"col-xs-4 text-left\"><b>Pasajero:</b></div><div class=\"col-xs-8 text-right\"><p>{{mChecksLoadForm.ticket.client.fullName}}</p></div></div><div class=row><div class=col-xs-12><b>Cargas:</b></div></div><div class=row ng-repeat=\"lagguage in mChecksLoadForm.luggage\"><div class=\"col-xs-6 text-left\"><p>{{lagguage.name}}</p></div><div class=\"col-xs-6 text-right\"><p>{{lagguage.billableRate}}</p></div></div><div class=row><div class=\"col-xs-5 text-left\"><b>Total:</b></div><div class=\"col-xs-7 text-right\"><p>{{mChecksLoadForm.registerLuggage.rate}}</p></div></div><div class=row><div class=\"col-xs-4 text-left\"><b>Cajero:</b></div><div class=\"col-xs-8 text-right\"><p>{{mChecksLoadForm.registerLuggage.user.fullName}}</p></div></div><hr><div class=row><div class=\"col-xs-12 text-center\"><small>{{mChecksLoadForm.registerLuggage.user.terminal.tradeNumber}}</small></div></div><div class=row><div class=\"col-xs-12 text-center\"><small>{{mChecksLoadForm.now | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</small></div></div></div></div></div><iframe id=printableAreaFrame name=printableAreaFrame style=display:none></iframe></div></div></div>");
$templateCache.put("app/pages/reports-bus-drivers-assigned/bus-drivers-assigned.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=busDriversAssigned-overlay><div class=row><div class=col-xs-12><h1>Reporte de Choferes Asignados</h1></div></div><form id=filterForm name=filterForm class=m-top-20 novalidate><div class=row><div class=col-xs-12><h4>Seleccione su viaje</h4></div></div><div class=row><div class=col-xs-3><div class=form-group><label for=Route>Ruta:</label><select name=Route id=Route class=form-control ng-options=\"route as route.name for route in busDriversAssigned.routesList\" ng-model=busDriversAssigned.filter.route required><option value=\"\">Ruta</option></select><div class=error ng-messages=filterForm.Route.$error ng-show=busDriversAssigned.submitAttempt><p ng-message=required>La Ruta es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=OriginDate>Fecha:</label><p class=input-group><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=busDriversAssigned.filter.originDateUI is-open=busDriversAssigned.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=busDriversAssigned.openOriginDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=filterForm.OriginDate.$error ng-show=busDriversAssigned.submitAttempt><p ng-message=required>La Fecha es requerida</p></div></div></div><div class=col-xs-3><div class=form-group><label for=BusType>Tipo de Bus:</label><select name=BusType id=BusType class=form-control ng-options=\"busType as busType.name for busType in busDriversAssigned.busClasses\" ng-model=busDriversAssigned.filter.busType required><option value=\"\">Tipo de Bus</option></select><div class=error ng-messages=filterForm.BusType.$error ng-show=busDriversAssigned.submitAttempt><p ng-message=required>El Tipo de Bus es requerido</p></div></div></div><div class=col-xs-2><button type=button class=\"btn btn-primary m-top-25\" ng-click=busDriversAssigned.loadSchedulesAvailable()>Buscar</button></div></div></form></div><div class=col-xs-12><button type=button class=\"btn btn-primary m-top-25\" ng-click=busDriversAssigned.print() ng-show=\"busDriversAssigned.schedulesAvailable.length > 0\">Imprimir</button><table id=schedules-available class=\"table table-striped\" ng-show=\"busDriversAssigned.schedulesAvailable.length > 0\"><thead><tr><th>Horario</th><th>Tipo de Bus</th><th>Bus</th><th>Chofer</th></tr></thead><tbody><tr ng-repeat=\"scheduleAvailable in busDriversAssigned.schedulesAvailable\"><td>{{scheduleAvailable.schedule.departureTime}}</td><td>{{scheduleAvailable.schedule.routeRate.busClass.name}}</td><td>{{scheduleAvailable.bus.licensePlate || \"No Asignado\"}}</td><td>{{scheduleAvailable.driver.fullName || \"No Asignado\"}}</td></tr></tbody></table><p ng-show=\"!busDriversAssigned.schedulesAvailable.length > 0\">No hay datos para mostrar</p></div><div id=printableArea class=row ng-show=false><div class=col-xs-4>Ruta: {{busDriversAssigned.filter.route.name}}</div><div class=col-xs-4>Fecha: {{busDriversAssigned.filter.originDateUI | amDateFormat:busDriversAssigned.dateFormat}}</div><div class=col-xs-4>Tipo de Bus: {{busDriversAssigned.filter.busType.name}}</div><div class=col-xs-12><table id=schedules-available-clone class=\"table table-striped\" ng-show=\"busDriversAssigned.schedulesAvailable.length > 0\"></table></div></div><iframe id=printableAreaFrame name=printableAreaFrame style=display:none></iframe>");
$templateCache.put("app/pages/reports-cash-registers-balances/cash-registers-balances.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=cashRegistersBalances-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Cierres de Caja</h2></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de cierre de caja</h1></div></div><div class=row><div class=col-xs-12><form class=m-top-20 ng-submit=cashRegistersBalances.searchCashRegistersBalances()><div class=col-xs-3><div class=form-group><label for=terminal>Terminales</label><select name=terminal id=terminal class=form-control ng-options=\"terminal as terminal.name for terminal in cashRegistersBalances.terminalsList\" ng-model=cashRegistersBalances.filter.terminal ng-change=cashRegistersBalances.loadCashRegisters() required><option value=\"\">Terminales</option></select><div class=error ng-messages=filterForm.terminal.$error ng-show=cashRegistersBalances.submitAttempt><p ng-message=required>El terminal es requerido</p></div></div></div><div class=col-xs-3><div class=form-group><label for=cashRegister>Cajas Registradoras</label><select name=cashRegister id=cashRegister class=form-control ng-options=\"cashRegister as cashRegister.name for cashRegister in cashRegistersBalances.cashRegistersList\" ng-model=cashRegistersBalances.filter.cashRegister required><option value=\"\">Cajas Registradoras</option></select><div class=error ng-messages=filterForm.cashRegister.$error ng-show=cashRegistersBalances.submitAttempt><p ng-message=required>La caja registradora es requerida</p></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"cashRegistersBalances.cashRegistersBalancesList.length > 0\"><thead><tr><th>Fecha</th><th>Apertura</th><th>Cierre</th><th>Monto Colones<br><span class=\"text-muted font-light-small\">Esperado / Entregado</span></th><th>Monto Dolares<br><span class=\"text-muted font-light-small\">Esperado / Entregado</span></th><th>Observaciones</th><th>Status</th><th>Acciones</th></tr></thead><tbody><tr ng-repeat=\"balance in cashRegistersBalances.cashRegistersBalancesList\"><td>{{balance.date}}</td><td>{{balance.openedBy.fullName}} - {{balance.openedAt | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{balance.closedBy.fullName}} - {{balance.closedAt | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{balance.totalColonesExpected | currency:\"₡\":0}} /{{balance.totalColonesHandedOver || 0 | currency:\"₡\":0}}</td><td>{{balance.totalDollarsExpected | currency:\"$\":0}} / {{balance.totalDollarsHandedOver || 0 | currency:\"$\":0}}</td><td>{{balance.observations}}</td><td><span ng-if=balance.balanced><i class=\"fa fa-check balance-icon good\"></i> </span><span ng-if=\"!balance.balanced && (balance.totalColonesExpected < balance.totalColonesHandedOver || balance.totalDollarsExpected < balance.totalDollarsHandedOver)\"><i class=\"fa fa-warning balance-icon warning\"></i> </span><span ng-if=\"!balance.balanced && (balance.totalColonesExpected > balance.totalColonesHandedOver || balance.totalDollarsExpected > balance.totalDollarsHandedOver)\"><i class=\"fa fa-times balance-icon error\"></i></span></td><td><button type=button class=\"btn btn-default\" ng-click=cashRegistersBalances.balanceDetail(balance)>Ver Detalle</button></td></tr></tbody></table><p ng-show=\"!cashRegistersBalances.cashRegistersBalancesList.length > 0\">No hay datos para mostrar</p></div></div><div class=row ng-show=\"cashRegistersBalances.cashRegistersBalancesList.length > 0\"><div class=\"col-xs-12 pagination-container\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando {{(cashRegistersBalances.pagination.rangeSelected * (cashRegistersBalances.pagination.pageNum -1))+1}}-{{(cashRegistersBalances.pagination.rangeSelected* (cashRegistersBalances.pagination.pageNum -1))+cashRegistersBalances.pagination.numberOfPageRecords}} de {{cashRegistersBalances.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=cashRegistersBalances.pagination.totalRecords items-per-page=cashRegistersBalances.pagination.rangeSelected ng-change=cashRegistersBalances.goToPage(cashRegistersBalances.pagination.pageNum) ng-model=cashRegistersBalances.pagination.pageNum max-size=cashRegistersBalances.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in cashRegistersBalances.pagination.allowedRanges\"><a class=\"{{cashRegistersBalances.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=cashRegistersBalances.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div><tnsp-modal-cash-register-balance cash-register=cashRegistersBalances.selectedCashRegister terminal=cashRegistersBalances.selectedTerminal balance=cashRegistersBalances.selectedBalance type=cashRegistersBalances.type></tnsp-modal-cash-register-balance>");
$templateCache.put("app/pages/reports-client-tickets/client-tickets.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=clientTickets-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Busqueda de boletos por referencia</h2></div></div></div></div></div><form class=m-top-20 ng-submit=clientTickets.searchClientTickets()><div class=\"row row-minumum-gutter\"><div class=col-xs-2><div class=form-group><label for=Reference>Referencia:</label><input type=text class=form-control id=Reference ng-model=clientTickets.filter.reference></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Buscar</button></div></div></form><div class=row><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"clientTickets.clientTicketsList.length > 0\"><thead><tr><th>Boleto</th><th>Ruta</th><th>Tipo de Pago</th><th>Referencia</th><th>Horario</th><th>Vendido</th></tr></thead><tbody><tr ng-repeat=\"ticket in clientTickets.clientTicketsList\"><td>{{ticket.invoiceNumber}}</td><td>{{ticket.routeName}}</td><td>{{ticket.paymentType}}</td><td>{{ticket.reference}}</td><td>{{ticket.schedule}}</td><td>{{ticket.soldDate | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><!--<td>\n              <button type=\"button\" class=\"btn btn-default\" ng-click=\"clientTickets.printInvoice(clientTicket)\">\n                Imprimir Boleto\n              </button>\n            </td>--></tr></tbody></table><p ng-show=\"!clientTickets.clientTicketsList.length > 0\">No hay datos para mostrar</p></div></div></div><tnsp-modal-print-ticket-invoice invoices-ids=clientTickets.selectedInvoice></tnsp-modal-print-ticket-invoice>");
$templateCache.put("app/pages/reports-consolidated-sales/consolidated-sales.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=consolidatedSales-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Consolidado de Ventas</h2></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Detallado</h1></div></div><div class=row><form role=form name=form class=\"form-inline m-top-20\" ng-submit=consolidatedSales.requestConsolidatedSales(form) novalidate><div class=col-xs-2><div class=form-group><label for=StartDetailed>Fecha Inicial:</label><p class=input-group><input type=text name=StartDetailed id=StartDetailed class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=consolidatedSales.startDetailed is-open=consolidatedSales.showStartCalendarDetailed alt-input-formats=\"[\'DD/MM/YYYY\']\" data-datepicker-options=\"{minMode: \'day\'}\"> <span class=input-group-btn datepicker-options=consolidatedSales.dateConfig><button type=button class=\"btn btn-default\" ng-click=consolidatedSales.openStartDateDetailed()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=formSummary.startDetailed.$error ng-show=consolidatedSales.submitAttemptSummary><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><label for=EndDetailed>Fecha Final:</label><p class=input-group><input type=text name=EndDetailed id=EndDetailed class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=consolidatedSales.endDetailed is-open=consolidatedSales.showEndCalendarDetailed alt-input-formats=\"[\'DD/MM/YYYY\']\" data-datepicker-options=\"{minMode: \'day\'}\"> <span class=input-group-btn datepicker-options=consolidatedSales.dateConfig><button type=button class=\"btn btn-default\" ng-click=consolidatedSales.openEndDateDetailed()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=col-xs-3><div class=\"form-group m-top-25\"><div class=\"radio radio-inline\"><input type=radio id=CR name=reportType value=CR ng-checked=true ng-model=consolidatedSales.type><label for=CR>Santa Cruz</label></div><div class=\"radio radio-inline\"><input type=radio id=NY name=reportType value=NY ng-model=consolidatedSales.type><label for=NY>Nicoya</label></div><div class=\"radio radio-inline\"><input type=radio id=ALL name=reportType value=ALL ng-model=consolidatedSales.type><label for=ALL>Todos</label></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Generar</button></div></form></div><div class=row><div class=col-xs-12><p>El reporte de ventas será enviado el correo electrónico del usuario con que ingresó al sistema.</p></div></div><hr><div class=row><div class=col-xs-12><h1>Resumen</h1></div></div><div class=row><form role=form name=formSummary class=\"form-inline m-top-20\" ng-submit=consolidatedSales.requestConsolidatedSalesSummary(formSummary) novalidate><div class=col-xs-2><div class=form-group><label for=StartSummary>Fecha Inicial:</label><p class=input-group><input type=text name=StartSummary id=StartSummary class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=consolidatedSales.startSummary is-open=consolidatedSales.showStartCalendarSummary alt-input-formats=\"[\'DD/MM/YYYY\']\" data-datepicker-options=\"{minMode: \'day\'}\"> <span class=input-group-btn datepicker-options=consolidatedSales.dateConfig><button type=button class=\"btn btn-default\" ng-click=consolidatedSales.openStartDateSummary()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=formSummary.StartSummary.$error ng-show=consolidatedSales.submitAttemptSummary><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><label for=EndSummary>Fecha Final:</label><p class=input-group><input type=text name=EndSummary id=EndSummary class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=consolidatedSales.endSummary is-open=consolidatedSales.showEndCalendarSummary alt-input-formats=\"[\'DD/MM/YYYY\']\" data-datepicker-options=\"{minMode: \'day\'}\"> <span class=input-group-btn datepicker-options=consolidatedSales.dateConfig><button type=button class=\"btn btn-default\" ng-click=consolidatedSales.openEndDateSummary()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=col-xs-3><div class=\"form-group m-top-25\"><div class=\"radio radio-inline\"><input type=radio id=CR_SUMMARY name=reportTypeSummary value=CR ng-checked=true ng-model=consolidatedSales.typeSummary><label for=CR_SUMMARY>Santa Cruz</label></div><div class=\"radio radio-inline\"><input type=radio id=NY_SUMMARY name=reportTypeSummary value=NY ng-model=consolidatedSales.typeSummary><label for=NY_SUMMARY>Nicoya</label></div><div class=\"radio radio-inline\"><input type=radio id=ALL_SUMMARY name=reportTypeSummary value=ALL ng-model=consolidatedSales.typeSummary><label for=ALL_SUMMARY>Todos</label></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Generar</button></div></form></div><div class=row><div class=col-xs-12><p>El reporte de ventas será enviado el correo electrónico del usuario con que ingresó al sistema.</p></div></div><div class=row><div class=col-xs-12><h1>Egresos por usuario</h1></div></div><div class=row><form role=form name=formOutcome class=\"form-inline m-top-20\" ng-submit=consolidatedSales.requestOutcomeReport(formOutcome) novalidate><div class=col-xs-2><div class=form-group><label for=StartOutcome>Fecha Inicial:</label><p class=input-group><input type=text name=StartOutcome id=StartOutcome class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=consolidatedSales.startOutcome is-open=consolidatedSales.showStartCalendarOutcome alt-input-formats=\"[\'DD/MM/YYYY\']\" data-datepicker-options=\"{minMode: \'day\'}\"> <span class=input-group-btn datepicker-options=consolidatedSales.dateConfig><button type=button class=\"btn btn-default\" ng-click=consolidatedSales.openStartDateOutcome()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=formOutcome.StartOutcome.$error ng-show=consolidatedSales.submitAttemptOutcome><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><label for=EndOutcome>Fecha Final:</label><p class=input-group><input type=text name=EndOutcome id=EndOutcome class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=consolidatedSales.endOutcome is-open=consolidatedSales.showEndCalendarOutcome alt-input-formats=\"[\'DD/MM/YYYY\']\" data-datepicker-options=\"{minMode: \'day\'}\"> <span class=input-group-btn datepicker-options=consolidatedSales.dateConfig><button type=button class=\"btn btn-default\" ng-click=consolidatedSales.openEndDateOutcome()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Generar</button></div></form></div><div class=row><div class=col-xs-12><p>El reporte de egresos será enviado el correo electrónico del usuario con que ingresó al sistema.</p></div></div></div>");
$templateCache.put("app/pages/reports-drivers-payment/reports-drivers-payment.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=drivers-payment-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Viajes Asignados a choferes</h2></div></div></div></div></div><div class=row><form role=form name=form class=\"form-inline m-top-20\" ng-submit=driversPayment.requestReport(form) novalidate><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha Inicial:</label><p class=input-group><input type=text name=StartDate id=StartDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=driversPayment.startDate is-open=driversPayment.showStartCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\"> <span class=input-group-btn datepicker-options=driversPayment.dateConfig><button type=button class=\"btn btn-default\" ng-click=driversPayment.openStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.StartDate.$error ng-show=driversPayment.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=EndDate>Fecha Final:</label><p class=input-group><input type=text name=EndDate id=EndDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=driversPayment.endDate is-open=driversPayment.showEndCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=driversPayment.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=driversPayment.openEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.EndDate.$error ng-show=driversPayment.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-3><div class=\"form-group m-top-25\"><div class=\"radio radio-inline\"><input type=radio id=CR name=reportType value=CR ng-checked=true ng-model=driversPayment.branchName><label for=CR>Santa Cruz</label></div><div class=\"radio radio-inline\"><input type=radio id=NY name=reportType value=NY ng-model=driversPayment.branchName><label for=NY>Nicoya</label></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Generar</button></div></form></div><div class=row><div class=col-xs-12><p>El reporte de viajes asignados a chofer será enviado el correo electrónico del usuario con que ingresó al sistema.</p></div></div></div>");
$templateCache.put("app/pages/reports-edited-tickets/edited-tickets.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=edited-tickets-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Reporte de boletos editados</h2></div></div></div></div></div><div class=row><form role=form name=form class=\"form-inline m-top-20\" ng-submit=editedTickets.submitForm(form) novalidate><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha Inicial:</label><p class=input-group><input type=text name=StartDate id=StartDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=editedTickets.startDate is-open=editedTickets.showStartCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=editedTickets.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=editedTickets.openStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.StartDate.$error ng-show=editedTickets.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=EndDate>Fecha Final:</label><p class=input-group><input type=text name=EndDate id=EndDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=editedTickets.endDate is-open=editedTickets.showEndCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=editedTickets.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=editedTickets.openEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.EndDate.$error ng-show=editedTickets.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Generar</button></div></form></div><div class=row><div class=col-xs-12><p>El reporte de boletos editados será enviado al correo electrónico del usuario con que ingresó al sistema.</p></div></div></div>");
$templateCache.put("app/pages/reports-erp/erp.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=erp-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>ERP (Ventas y Egresos)</h2></div></div></div></div></div><div class=row><form role=form name=form class=\"form-inline m-top-20\" ng-submit=erpReport.requestErpReport(form) novalidate><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha Inicial:</label><p class=input-group><input type=text name=StartDate id=StartDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=erpReport.startDate is-open=erpReport.showStartCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\"> <span class=input-group-btn datepicker-options=erpReport.dateConfig><button type=button class=\"btn btn-default\" ng-click=erpReport.openStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.StartDate.$error ng-show=erpReport.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=EndDate>Fecha Final:</label><p class=input-group><input type=text name=EndDate id=EndDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=erpReport.endDate is-open=erpReport.showEndCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=erpReport.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=erpReport.openEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.EndDate.$error ng-show=erpReport.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-3></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Generar</button></div></form></div><div class=row><div class=col-xs-12><p>El reporte de contabilidad será enviado el correo electrónico del usuario con que ingresó al sistema.</p></div></div></div>");
$templateCache.put("app/pages/reports-insurances/insurances.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=insuranceReport-overlay><div class=row><div class=col-xs-12><h1>Reporte de Seguros</h1></div></div><form id=filterForm name=filterForm class=m-top-20 novalidate><div class=row><div class=col-xs-12><h4>Seleccione su viaje</h4></div></div><div class=row><div class=col-xs-3><div class=form-group><label for=Route>Ruta:</label><select name=Route id=Route class=form-control ng-options=\"route as route.name for route in insuranceReport.routesList\" ng-model=insuranceReport.filter.route required><option value=\"\">Ruta</option></select><div class=error ng-messages=filterForm.Route.$error ng-show=insuranceReport.submitAttempt><p ng-message=required>La Ruta es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=OriginDate>Fecha:</label><p class=input-group><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=insuranceReport.filter.originDateUI is-open=insuranceReport.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=insuranceReport.openOriginDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=filterForm.OriginDate.$error ng-show=insuranceReport.submitAttempt><p ng-message=required>La Fecha es requerida</p></div></div></div><div class=col-xs-3><div class=form-group><label for=BusType>Tipo de Bus:</label><select name=BusType id=BusType class=form-control ng-options=\"busType as busType.name for busType in insuranceReport.busClasses\" ng-change=insuranceReport.loadTips() ng-model=insuranceReport.filter.busType required><option value=\"\">Tipo de Bus</option></select><div class=error ng-messages=filterForm.BusType.$error ng-show=insuranceReport.submitAttempt><p ng-message=required>El Tipo de Bus es requerido</p></div></div></div><div class=col-xs-2><div class=form-group><label for=Horario>Horario:</label><select name=Horario id=Horario class=form-control ng-options=\"tip as tip.schedule.departureTime for tip in insuranceReport.tips\" ng-model=insuranceReport.filter.trip required><option value=\"\">Horario</option></select><div class=error ng-messages=filterForm.Horario.$error ng-show=insuranceReport.submitAttempt><p ng-message=required>El Horario es requerido</p></div></div></div><div class=col-xs-2><button type=button class=\"btn btn-primary m-top-25\" ng-click=insuranceReport.loadInsurances()>Buscar</button></div></div></form></div><div class=col-xs-12><button type=button class=\"btn btn-primary m-top-25\" ng-click=insuranceReport.print() ng-show=\"insuranceReport.insurances.length > 0\">Imprimir</button><table id=insurances class=\"table table-striped\" ng-show=\"insuranceReport.insurances.length > 0\"><thead><tr><th>Nombre</th><th>Identificación</th><th>Género</th><th>Nacionalidad</th><th>Teléfono</th><th>Email</th></tr></thead><tbody><tr ng-repeat=\"insurance in insuranceReport.insurances\"><td>{{insurance.client.fullName}}</td><td>{{insurance.client.identification}}</td><td>{{insurance.client.genre}}</td><td>{{insurance.client.nationality}}</td><td>{{insurance.client.phone}}</td><td>{{insurance.client.email}}</td></tr></tbody></table><p ng-show=\"!insuranceReport.insurances.length > 0\">No hay datos para mostrar</p></div><div id=printableArea class=row ng-show=false><div class=col-xs-6>Ruta: {{insuranceReport.filter.route.name}}</div><div class=col-xs-6>Fecha: {{insuranceReport.filter.originDateUI | amDateFormat:insuranceReport.dateFormat}}</div><div class=col-xs-6>Tipo de Bus: {{insuranceReport.filter.busType.name}}</div><div class=col-xs-6>Viaje: {{insuranceReport.filter.trip.schedule.departureTime}}</div><div class=col-xs-12><table id=insurances-clone class=\"table table-striped\" ng-show=\"insuranceReport.insurances.length > 0\"></table></div></div><iframe id=printableAreaFrame name=printableAreaFrame style=display:none></iframe>");
$templateCache.put("app/pages/reports-occupation-matrix/occupation-matrix.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=occupationMatriz-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Matriz de Ocupacción</h2></div></div></div></div></div><uib-tabset active=active><uib-tab index=0 heading=\"Matrix de Ocupacción\"><div class=row><div class=col-xs-12><h1>Lista de boletos</h1></div></div><div class=row><div class=col-xs-12><form class=\"form-inline m-top-20\" ng-submit=occupationMatrix.searchOccupationMatriz()><div class=col-xs-3><div class=form-group><label for=searchBox>Buscar:</label><br><select name=route id=route class=form-control ng-options=\"route as route.name for route in occupationMatrix.routesList\" ng-model=occupationMatrix.filter.route required><option value=\"\">Rutas</option></select><div class=error ng-messages=occupationMatrix.route.$error ng-show=occupationMatrix.submitAttempt><p ng-message=required>La ruta es requerido</p></div></div></div><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha:</label><p class=input-group><input type=text name=StartDate id=StartDate class=form-control uib-datepicker-popup=\"{{\'MM/yyyy\'}}\" ng-model=occupationMatrix.filter.date is-open=occupationMatrix.showStartCalendar alt-input-formats=\"[\'MM/YYYY\']\" data-datepicker-options=\"{minMode: \'month\'}\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=occupationMatrix.openStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Buscar</button></div></form></div></div><div class=row ng-show=occupationMatrix.visibleHeader><div class=col-xs-3><img src=assets/images/tig-logo.png alt=TIG class=\"img-responsive max-w-200px\"></div><div class=col-xs-6><h4 class=text-center>Matriz de Ocupación</h4></div><div class=\"col-xs-3 text-right\"><button type=button class=\"btn btn-primary\" ng-click=occupationMatrix.print()>Imprimir</button></div></div><div class=\"row overflow-x\"><div class=col-xs-12 id=printableArea><table class=\"table table-striped table-bordered\" id=occupationMatrixPrintable ng-show=\"occupationMatrix.schedulesList.length > 0\"><thead><tr><td>Hora</td><td ng-repeat=\"(index, occupation) in occupationMatrix.occupationMatrizList\">{{index}}</td></tr></thead><tbody><tr ng-repeat=\"schedules in occupationMatrix.schedulesList\"><td>{{schedules}}</td><td ng-repeat=\"occupation in occupationMatrix.occupationMatrizList\" ng-style=\"occupationMatrix.typeOfCell(occupation[schedules].quantity, occupation[schedules].locked)\"><span ng-if=occupation[schedules].locked>Bloq.</span> <span ng-if=!occupation[schedules].locked>{{occupation[schedules].quantity || 0}}/{{occupation[schedules].checkedRegular || 0}}/{{occupation[schedules].checkedElders || 0}}</span></td></tr></tbody></table><p ng-show=\"!occupationMatrix.schedulesList.length > 0\">No hay datos para mostrar</p></div></div></uib-tab><uib-tab index=1 heading=\"Boletos NO utilizados\"><div class=row><div class=col-xs-12><h1>Boletos no utilizados</h1></div></div><div class=row><div class=col-xs-12><form class=\"form-inline m-top-20\" ng-submit=occupationMatrix.searchOccupancy()><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha Inicio:</label><p class=input-group><input type=text name=StartDateOC id=StartDateOC class=form-control uib-datepicker-popup=\"{{\'MM/dd/yyyy\'}}\" ng-model=occupationMatrix.filter.startDate is-open=occupationMatrix.showStartCalendarOC alt-input-formats=\"[\'MM/DD/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=occupationMatrix.openStartDateOC()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha Final:</label><p class=input-group><input type=text name=EndDateOC id=EndDateOC class=form-control uib-datepicker-popup=\"{{\'MM/dd/yyyy\'}}\" ng-model=occupationMatrix.filter.endDate is-open=occupationMatrix.showEndCalendarOC alt-input-formats=\"[\'MM/DD/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=occupationMatrix.openEndDateOC()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Buscar</button></div></form></div><div class=row><div class=col-xs-12><table class=\"table table-striped table-bordered\" ng-show=occupationMatrix.occupancyReport><thead><tr><td><b>RUTA</b></td><td class=text-center><b>Total de boletos</b></td><td class=text-center><b>Boletos Usados</b></td><td class=text-center><b>Boletos No Usados</b></td></tr></thead><tbody><tr ng-if=\"occupationMatrix.occupancyReport[\'CR\']\"><td>SANTA CRUZ</td><td class=text-center>{{occupationMatrix.occupancyReport[\'CR\'].all}}</td><td class=text-center>{{occupationMatrix.occupancyReport[\'CR\'].used}}</td><td class=text-center>{{occupationMatrix.occupancyReport[\'CR\'].notUsed}}</td></tr><tr ng-if=\"occupationMatrix.occupancyReport[\'NY\']\"><td>Nicoya</td><td class=text-center>{{occupationMatrix.occupancyReport[\'NY\'].all}}</td><td class=text-center>{{occupationMatrix.occupancyReport[\'NY\'].used}}</td><td class=text-center>{{occupationMatrix.occupancyReport[\'NY\'].notUsed}}</td></tr></tbody></table><p ng-show=!occupationMatrix.occupancyReport>No hay datos para mostrar</p></div></div></div></uib-tab></uib-tabset></div><tnsp-modal-print-ticket-invoice invoices-ids=occupationMatrix.selectedInvoice></tnsp-modal-print-ticket-invoice><iframe id=printableAreaFrame name=printableAreaFrame style=\"display: none\"></iframe>");
$templateCache.put("app/pages/reports-otp/otp-report.html","<div class=\"container-fluid otp-report relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=otpReport-overlay><div class=row><div class=col-xs-3><h1>Reporte OTP</h1></div><div class=col-xs-9><form id=SearchOtpForm name=SearchOtpForm novalidate class=\"form-inline m-top-20\" ng-submit=otpReport.searchOtpHistory(SearchOtpForm)><div class=form-group><label for=OtpTicketNo>Tiquete:</label><input type=text class=form-control ng-model=otpReport.ticketToSearch name=OtpTicketNo id=OtpTicketNo required> <button type=submit class=\"btn btn-primary\" ng-disabled=!otpReport.ticketToSearch>Buscar</button></div></form></div></div><div class=row><div class=\"col-xs-12 table-responsive m-top-20\" ng-show=\"otpReport.events.length > 0\"><table class=\"table table-striped m-top-20\"><thead class=small-head><tr><th class=otp-toggle-col></th><th class=min-w-75>Sesión</th><th class=min-w-100>Reserva</th><th class=min-w-125>Acción</th><th class=min-w-125>Resultado</th><th class=min-w-150>Fecha/Hora</th><th class=min-w-125>IP</th><th class=min-w-100>Navegador</th><th class=min-w-100>SO</th><th class=min-w-75>Solicitudes</th><th class=min-w-75>Intentos</th><th class=min-w-125>Usuario</th></tr></thead><tbody class=small-body><tr ng-repeat-start=\"row in otpReport.events\" class=otp-row ng-click=otpReport.toggleDetail(row)><td><i class=fa ng-class=\"row.expanded ? \'fa-chevron-down\' : \'fa-chevron-right\'\"></i></td><td>{{row.session.sessionId}}</td><td>{{row.event.reserveNumber || row.session.reserveNumber || \'-\'}}</td><td>{{row.event.action || \'-\'}}</td><td>{{row.event.result || \'-\'}}</td><td>{{row.eventDateText}}</td><td>{{row.event.ipAddress || \'-\'}}</td><td>{{row.event.browser || \'-\'}}</td><td>{{row.event.operatingSystem || \'-\'}}</td><td>{{row.event.pinRequests === null || row.event.pinRequests === undefined ? \'-\' : row.event.pinRequests}}</td><td>{{row.event.pinAttempts === null || row.event.pinAttempts === undefined ? \'-\' : row.event.pinAttempts}}</td><td>{{row.event.internalUsername || \'-\'}}</td></tr><tr ng-repeat-end ng-show=row.expanded class=otp-detail-row><td colspan=12><div class=row><div class=col-xs-6><h4>Detalle del evento</h4><dl class=\"dl-horizontal otp-detail\"><dt>User Agent</dt><dd>{{row.event.userAgent || \'-\'}}</dd><dt>Dispositivo</dt><dd>{{row.event.deviceIdentifier || \'-\'}}</dd><dt>Datos anteriores</dt><dd><pre class=otp-data>{{row.previousTicketDataText}}</pre></dd><dt>Datos nuevos</dt><dd><pre class=otp-data>{{row.newTicketDataText}}</pre></dd></dl></div><div class=col-xs-6><h4>Datos de la sesión <small ng-hide=row.session.sessionDataAvailable>(no disponibles)</small></h4><dl class=\"dl-horizontal otp-detail\"><dt>Canal</dt><dd>{{row.session.channel || \'-\'}}</dd><dt>Destino</dt><dd>{{row.session.targetMask || \'-\'}}</dd><dt>Creación</dt><dd>{{row.sessionDates.created}}</dd><dt>Expira</dt><dd>{{row.sessionDates.otpExpiresAt}}</dd><dt>Usado</dt><dd>{{row.sessionDates.usedAt}}</dd><dt>Invalidado</dt><dd>{{row.sessionDates.invalidatedAt}}</dd><dt>Edición hasta</dt><dd>{{row.sessionDates.editEnabledUntil}}</dd><dt>Bloqueado hasta</dt><dd>{{row.sessionDates.blockedUntil}}</dd><dt>Solicitudes</dt><dd>{{row.session.requestCount === null || row.session.requestCount === undefined ? \'-\' : row.session.requestCount}}</dd><dt>Intentos</dt><dd>{{row.session.attemptCount === null || row.session.attemptCount === undefined ? \'-\' : row.session.attemptCount}}</dd><dt>Último resultado</dt><dd>{{row.session.lastResult || \'-\'}}</dd></dl></div></div></td></tr></tbody></table></div><div class=\"col-xs-12 m-top-20\" ng-show=!otpReport.searched><h3 class=m-top-20>Debe buscar un boleto para ver su registro de OTP</h3></div><div class=\"col-xs-12 m-top-20\" ng-show=\"otpReport.searched && otpReport.events.length === 0\"><h3 class=m-top-20>No se encontraron resultados</h3></div></div><div class=row><div class=\"col-xs-12 pagination-container\" ng-show=\"otpReport.events.length > 0\"><div class=row><div class=\"col-xs-2 text-left\"><p>Mostrando sesiones {{(otpReport.pagination.rangeSelected * (otpReport.pagination.pageNum -1))+1}}-{{(otpReport.pagination.rangeSelected * (otpReport.pagination.pageNum -1))+otpReport.pagination.numberOfPageRecords}} de {{otpReport.pagination.totalRecords}}</p></div><div class=\"col-xs-6 text-center\"><uib-pagination total-items=otpReport.pagination.totalRecords items-per-page=otpReport.pagination.rangeSelected ng-change=otpReport.goToPage(otpReport.pagination.pageNum) ng-model=otpReport.pagination.pageNum max-size=otpReport.pagination.maxPaginationItems class=pagination-sm boundary-links-numbers=true previous-text=\"< Anterior\" next-text=\"Siguiente >\"></uib-pagination></div><div class=\"col-xs-4 text-right clearfix\"><ul class=\"pagination no-last-border pull-right ranges\"><li ng-repeat=\"range in otpReport.pagination.allowedRanges\"><a class=\"{{otpReport.pagination.rangeSelected == range ? \'active\' : \'\'}}\" ng-click=otpReport.setRecordsPerPage(range)>{{range}}</a></li></ul><span class=\"pull-right m-right-20\">Filas por pág:</span></div></div></div></div></div>");
$templateCache.put("app/pages/reports-parent/reports.html","<div class=\"container-fluid page-container\"><div class=\"row max-width-content-extended\"><div class=\"col-xs-12 no-padding\"><div class=animated-view ui-view></div></div></div></div>");
$templateCache.put("app/pages/reports-passengers/passengers.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=passengersReport-overlay><div class=row><div class=col-xs-12><h1>Reporte de Pasajeros</h1></div></div><form id=filterForm name=filterForm class=m-top-20 ng-submit=passengersReport.searchTickets(filterForm) novalidate><div class=row><div class=col-xs-3><div class=form-group><label for=Route>Ruta:</label><select name=Route id=Route class=form-control ng-options=\"route.id as route.name for route in passengersReport.routesList\" ng-model=passengersReport.filter.route ng-change=passengersReport.loadSchedulesAvailable() required><option value=\"\">Ruta</option></select><div class=error ng-messages=filterForm.Route.$error ng-show=passengersReport.submitAttempt><p ng-message=required>La Ruta es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=OriginDate>Fecha:</label><p class=input-group><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=passengersReport.filter.originDateUI is-open=passengersReport.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-change=passengersReport.loadSchedulesAvailable() ng-disabled=\"passengersReport.query.typeOfTrip ==3\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=passengersReport.openOriginDate() ng-disabled=\"passengersReport.query.typeOfTrip == 3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=filterForm.OriginDate.$error ng-show=passengersReport.submitAttempt><p ng-message=required>La Fecha es requerida</p></div></div></div><div class=col-xs-3><div class=form-group><label for=BusType>Tipo de Bus:</label><select name=BusType id=BusType class=form-control ng-options=\"busType.id as busType.name for busType in passengersReport.busClasses\" ng-model=passengersReport.filter.busType ng-change=passengersReport.loadSchedulesAvailable() required><option value=\"\">Tipo de Bus</option></select><div class=error ng-messages=filterForm.BusType.$error ng-show=passengersReport.submitAttempt><p ng-message=required>El Tipo de Bus es requerido</p></div></div></div><div class=col-xs-2><div class=form-group><label for=SchedulesAvailable>Horarios</label><select name=SchedulesAvailable id=SchedulesAvailable class=form-control ng-options=\"trip as trip.schedule.departureTimeUI for trip in passengersReport.schedulesAvailable\" ng-model=passengersReport.filter.selectedTrip required><option value=\"\">Horarios</option></select><div class=error ng-messages=filterForm.SchedulesAvailable.$error ng-show=passengersReport.submitAttempt><p ng-message=required>El horario es requerido</p></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Buscar</button></div></div></form><div class=row><div class=col-xs-12 ng-show=\"passengersReport.report.validTickets.length > 0\"><div class=row><div class=col-xs-3><img src=assets/images/tig-logo.png alt=TIG class=\"img-responsive max-w-200px\"></div><div class=col-xs-6><h3 class=\"text-uppercase text-center\">TIG S.A.</h3><p class=text-center>Tels: 2223-4242 CR 277-2104 Nic. 239-7933 Hon</p><h4 class=text-center>Lista de pasajeros</h4></div><div class=\"col-xs-3 text-right\"><button type=button class=\"btn btn-primary\" ng-click=passengersReport.print()>Imprimir</button></div></div><div class=row><div class=col-xs-3><p><strong>Empresa: </strong>TIG S.A.</p></div><div class=col-xs-3><p><strong>Fecha de Viaje: </strong>{{passengersReport.filter.originDateUI | amDateFormat: dateFormat}}</p></div><div class=col-xs-3><p><strong>Autobus: </strong>{{passengersReport.report.trip.bus.licensePlate}}</p></div><div class=col-xs-3><p><strong>Total de pasajeros: </strong>{{passengersReport.report.validTickets.length}}</p></div></div><div class=row><div class=col-xs-3><p><strong>Ruta: </strong>{{passengersReport.report.route.name}}</p></div><div class=col-xs-3><p><strong>Horario: </strong>{{passengersReport.report.trip.schedule.departureTime}}</p></div><div class=col-xs-3><p><strong>Chofer: </strong>{{passengersReport.report.trip.driver.fullName}}</p></div><div class=col-xs-3></div></div></div><div class=\"col-xs-12 overflow-x\"><table class=\"table table-striped\" id=passengerTable ng-show=\"passengersReport.report.validTickets.length > 0\"><thead><tr><th>1er Apellido</th><th>2do Apellido</th><th>Nombre</th><th>Sexo</th><th>F. Nacimiento</th><th>Tipo ID</th><th>ID</th><th>Nacionalidad</th><th>Estatus Migratorio</th><th>Dirección</th><th>Fecha de ingreso</th><th>Asiento</th><th class=min-w-75>Boleto</th><th>Profesión</th><th>Menor de Edad</th><th>Equipaje</th><th>Abordaje</th><th>Pagado</th></tr></thead><tbody><tr ng-repeat=\"ticket in passengersReport.report.validTickets | filter:{check2:true}\" ng-show=ticket.invoiceNumber><td>{{ticket.client.lastName}}</td><td>{{ticket.client.lastName2}}</td><td>{{ticket.client.firstName}}</td><td>{{ticket.client.genre}}</td><td>{{ticket.client.birthdateUI | amDateFormat: dateFormat}}</td><td>{{ticket.client.identificationType.name}}</td><td>{{ticket.client.identification}}</td><td>{{ticket.client.nationality}}</td><td>{{ticket.client.migratoryStatus}}</td><td>{{ticket.client.address}}</td><td>{{ticket.tripSeat.trip.date | amDateFormat: dateFormat}}</td><td>{{ticket.tripSeat.seatNumber}}</td><td>{{ticket.invoiceNumber}}</td><td>{{ticket.client.profession}}</td><td>{{ticket.underAgeNotes}}</td><td><span ng-repeat=\"luggage in ticket.luggage\">{{luggage.serial}}<span ng-show=!$last>, </span></span></td><td>{{ticket.boarding.name}}</td><td><span ng-if=!ticket.notPayed>Si</span> <span ng-if=ticket.notPayed>No</span></td></tr></tbody></table><p ng-show=\"!passengersReport.tickets.length > 0\">No Hay datos para mostrar</p></div></div></div><div class=row id=printableArea ng-hide=true><div class=col-xs-12 ng-show=\"passengersReport.report.validTickets.length > 0\"><div class=row><div class=col-xs-3><img src=assets/images/logo-tig.png alt=TIG></div><div class=col-xs-6><h3 class=\"text-uppercase text-center\">TIG S.A.</h3><p class=text-center>Tels: 2223-4242 CR 277-2104 Nic. 239-7933 Hon</p><h4 class=text-center>Lista de pasajeros</h4></div><div class=\"col-xs-3 text-right\"></div></div><div class=row><div class=col-xs-3><p><strong>Empresa: </strong>TIG S.A.</p></div><div class=col-xs-3><p><strong>Fecha de Viaje: </strong>{{passengersReport.filter.originDateUI | amDateFormat: dateFormat}}</p></div><div class=col-xs-3><p><strong>Autobus: </strong>{{passengersReport.report.trip.bus.licensePlate}}</p></div><div class=col-xs-3><p><strong>Total de pasajeros: </strong>{{passengersReport.report.validTickets.length}}</p></div></div><div class=row><div class=col-xs-3><p><strong>Ruta: </strong>{{passengersReport.report.route.name}}</p></div><div class=col-xs-3><p><strong>Horario: </strong>{{passengersReport.report.trip.schedule.departureTime}}</p></div><div class=col-xs-3><p><strong>Chofer: </strong>{{passengersReport.report.trip.driver.fullName}}</p></div><div class=col-xs-3></div></div></div><div class=col-xs-12><table id=passengerTable-clone class=\"table table-striped\"></table></div></div><iframe id=printableAreaFrame name=printableAreaFrame style=display:none></iframe>");
$templateCache.put("app/pages/reports-sales/sales-report.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=salesReport-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Ventas</h2></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Reporte de ventas</h1></div></div><div class=row><div class=col-xs-12><div class=\"radio radio-inline\" ng-hide=salesReport.hasOnlyDriverPermission()><input type=radio id=Terminal name=reportType value=terminal ng-checked=true ng-model=salesReport.filter.type><label for=Terminal>Terminal</label></div><div class=\"radio radio-inline\"><input type=radio id=Agencia name=reportType value=reseller ng-model=salesReport.filter.type><label for=Agencia>Agencia</label></div><div class=\"radio radio-inline\"><input type=radio id=Chofer name=reportType value=driver ng-model=salesReport.filter.type><label for=Chofer>Chofer</label></div></div></div><div class=row><div class=col-xs-12><form class=m-top-20 ng-submit=salesReport.searchSalesReport()><div class=col-xs-3 ng-show=\"salesReport.filter.type == \'terminal\'\"><div class=form-group><label for=terminal>Terminales</label><select name=terminal id=terminal class=form-control ng-options=\"terminal as terminal.name for terminal in salesReport.terminalsList\" ng-model=salesReport.filter.terminal ng-required=\"salesReport.filter.type == \'terminal\'\"><option value=\"\">Terminales</option></select><div class=error ng-messages=filterForm.terminal.$error ng-show=salesReport.submitAttempt><p ng-message=required>La terminal es requerida</p></div></div></div><div class=col-xs-3 ng-show=\"salesReport.filter.type == \'reseller\'\"><div class=form-group><label for=reseller>Agencias</label><select name=reseller id=reseller class=form-control ng-options=\"reseller as reseller.name for reseller in salesReport.resellersList\" ng-model=salesReport.filter.reseller ng-required=\"salesReport.filter.type == \'reseller\'\"><option value=\"\">Agencias</option></select><div class=error ng-messages=filterForm.reseller.$error ng-show=salesReport.submitAttempt><p ng-message=required>La agencia es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha Inicial:</label><p class=input-group><input type=text name=StartDate id=StartDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=salesReport.filter.from is-open=salesReport.showStartCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-blur=salesReport.loadBusDrivers()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=salesReport.openStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=col-xs-2><div class=form-group><label for=EndDate>Fecha Final:</label><p class=input-group><input type=text name=EndDate id=EndDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=salesReport.filter.to is-open=salesReport.showEndCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-blur=salesReport.loadBusDrivers()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=salesReport.openEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=col-xs-3 ng-show=\"salesReport.filter.type == \'driver\'\"><div class=form-group><label for=reseller>Choferes</label><select name=soldBy id=soldBy class=form-control ng-options=\"soldBy.username as soldBy.displayName for soldBy in salesReport.busDrivers\" ng-model=salesReport.filter.soldBy><option value=\"\">Choferes</option></select></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Buscar</button></div></form></div></div><div class=row><div class=col-xs-12 ng-show=\"salesReport.salesReportList.detail.length > 0\"><div class=row><div class=col-xs-3><img src=assets/images/tig-logo.png alt=TIG class=\"img-responsive max-w-200px\"></div><div class=col-xs-6><h3 class=\"text-uppercase text-center\">TI Guanacate</h3><p class=text-center></p><h4 class=text-center>Reporte de Ventas</h4></div><div class=\"col-xs-3 text-right\"><button type=button class=\"btn btn-primary hidden-print\" ng-click=salesReport.print()>Imprimir</button></div></div><table class=\"table table-striped\" ng-if=!salesReport.allDrivers><thead><tr><th>Boleto</th><th>Efectivo</th><th>Tarjeta</th><th>SINPE</th><th>Referencia</th><th>Fecha de venta</th><th>Usuario</th></tr></thead><tbody><tr ng-repeat=\"sale in salesReport.salesReportList.detail\"><td>{{sale.invoiceNumber}}</td><td><span>{{sale.cashAmount | currency:\"₡\":2}}</span></td><td><span>{{sale.cardAmount | currency:\"₡\":2}}</span></td><td><span>{{sale.sinpeAmount | currency:\"₡\":2}}</span></td><td>{{sale.cardReference}}</td><td>{{sale.soldDate | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{sale.soldBy}}</td></tr><tr><td><b>Totales</b></td><td>{{salesReport.salesReportList.cashTicketTotalSoldAmount | currency:\"₡\":2}}</td><td>{{salesReport.salesReportList.cardTicketTotalSoldAmount | currency:\"₡\":2}}</td><td>{{salesReport.salesReportList.sinpeTicketTotalSoldAmount | currency:\"₡\":2}}</td><td></td><td></td><td><b>Vendidos en Efectivo:</b> {{salesReport.salesReportList.cashTicketTotalCount}}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en Sinpe Móvil:</b> {{salesReport.salesReportList.sinpeTicketTotalCount}}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en Tarjeta:</b> {{salesReport.salesReportList.cardTicketTotalCount}}</td></tr><tr><td><b>Total: {{salesReport.salesReportList.totalPrice| currency:\"₡\":2}}</b></td><td></td><td></td><td></td><td></td><td></td><td><!-- TODO: Change property when Zapata committee --> <b>Vendidos en Mixto:</b> {{salesReport.salesReportList.mixedTicketTotalCount || 0}}</td></tr></tbody></table><table class=\"table table-striped\" ng-if=salesReport.allDrivers><thead><tr><th>Chofer</th><th>Efectivo</th><th>Tarjeta</th><th>SINPE</th><th>Total</th></tr></thead><tbody><tr ng-repeat=\"sale in salesReport.salesReportList.detail\"><td>{{sale.driverFullName}}</td><td>{{sale.cash | currency:\"₡\":2}}</td><td>{{sale.card | currency:\"₡\":2}}</td><td>{{sale.sinpe | currency:\"₡\":2}}</td><td>{{sale.total | currency:\"₡\":2}}</td></tr><tr><td><b>Totales</b></td><td><b>{{salesReport.salesReportList.cash | currency:\"₡\":2}}</b></td><td><b>{{salesReport.salesReportList.card | currency:\"₡\":2}}</b></td><td><b>{{salesReport.salesReportList.sinpe | currency:\"₡\":2}}</b></td><td><b>{{salesReport.salesReportList.total | currency:\"₡\":2}}</b></td></tr></tbody></table></div><div class=col-xs-12><div class=row><div class=col><p ng-show=\"!salesReport.salesReportList.detail.length > 0\">No hay datos para mostrar</p></div></div></div></div></div><tnsp-modal-cash-register-balance cash-register=salesReport.selectedCashRegister country=salesReport.selectedTerminal balance=salesReport.selectedBalance></tnsp-modal-cash-register-balance>");
$templateCache.put("app/pages/reports-sales-summary/sales-summary.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=sales-summary-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Resumen de Ventas</h2></div></div></div></div></div><div class=row><form role=form name=form class=\"form-inline m-top-20\" ng-submit=salesSummaryReport.submitForm(form) novalidate><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha Inicial:</label><p class=input-group><input type=text name=StartDate id=StartDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=salesSummaryReport.startDate is-open=salesSummaryReport.showStartCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\"> <span class=input-group-btn datepicker-options=salesSummaryReport.dateConfig><button type=button class=\"btn btn-default\" ng-click=salesSummaryReport.openStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.StartDate.$error ng-show=salesSummaryReport.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=EndDate>Fecha Final:</label><p class=input-group><input type=text name=EndDate id=EndDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=salesSummaryReport.endDate is-open=salesSummaryReport.showEndCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=salesSummaryReport.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=salesSummaryReport.openEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.EndDate.$error ng-show=salesSummaryReport.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Generar</button></div></form></div><div class=row ng-if=!!salesSummaryReport.data><div class=\"col-xs-12 mb-3\"><h3>Resumen</h3><uib-tabset active=active><uib-tab index=0 heading=General><div class=\"row text-center\"><div class=col-xs-3><div class=total-separator><h4>Total Vendidos: <b class=total-highlight>{{salesSummaryReport.data.totalCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Adulto: <b class=total-highlight>{{salesSummaryReport.data.noDiscountCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Descuento: <b class=total-highlight>{{salesSummaryReport.data.discountCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Liberados: <b class=total-highlight>{{salesSummaryReport.data.releasedCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Vendidos</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.totalAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-3><div class=total-separator><h4>Total Efectivo</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.onCashAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-2><div class=total-separator><h4>Total Tarjeta</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.onCardAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-2><div class=total-separator><h4>Total SINPE móvil</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.onSinpeAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-2><div class=total-separator><h4>Total Liberados</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.releasedAmount | currency:\"₡\":2}}</b></h5></div></div></div></uib-tab><uib-tab index=1 heading=\"Santa Cruz\"><div class=\"row text-center\"><div class=col-xs-3><div class=total-separator><h4>Total Vendidos: <b class=total-highlight>{{salesSummaryReport.data.CR.totalCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Adulto: <b class=total-highlight>{{salesSummaryReport.data.CR.noDiscountCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Descuento: <b class=total-highlight>{{salesSummaryReport.data.CR.discountCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Liberados: <b class=total-highlight>{{salesSummaryReport.data.CR.releasedCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Vendidos</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.CR.totalAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-3><div class=total-separator><h4>Total Efectivo</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.CR.onCashAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-2><div class=total-separator><h4>Total Tarjeta</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.CR.onCardAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-2><div class=total-separator><h4>Total SINPE móvil</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.CR.onSinpeAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-2><div class=total-separator><h4>Total Liberados</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.CR.releasedAmount | currency:\"₡\":2}}</b></h5></div></div></div></uib-tab><uib-tab index=2 heading=Nicoya><div class=\"row text-center\"><div class=col-xs-3><div class=total-separator><h4>Total Vendidos: <b class=total-highlight>{{salesSummaryReport.data.NY.totalCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Adulto: <b class=total-highlight>{{salesSummaryReport.data.NY.noDiscountCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Descuento: <b class=total-highlight>{{salesSummaryReport.data.NY.discountCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Liberados: <b class=total-highlight>{{salesSummaryReport.data.NY.releasedCount}}</b></h4></div></div><div class=col-xs-3><div class=total-separator><h4>Total Vendidos</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.NY.totalAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-3><div class=total-separator><h4>Total Efectivo</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.NY.onCashAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-2><div class=total-separator><h4>Total Tarjeta</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.NY.onCardAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-2><div class=total-separator><h4>Total SINPE móvil</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.NY.onSinpeAmount | currency:\"₡\":2}}</b></h5></div></div><div class=col-xs-2><div class=total-separator><h4>Total Liberados</h4><h5 class=total-highlight><b>{{salesSummaryReport.data.NY.releasedAmount | currency:\"₡\":2}}</b></h5></div></div></div></uib-tab></uib-tabset></div><div class=col-xs-12><hr class=separator></div><div class=\"col-xs-12 mb-5\"><h3>Online</h3><table class=\"table table-striped\"><thead><tr><th>Caja</th><th class=text-center>Tickets Cierre de Caja</th><th class=text-center>Total Cierre de Caja</th><th class=text-center>Tickets Adulto</th><th class=text-center>Tickets Descuento</th><th class=text-center>Tickets en Efectivo</th><th class=text-center>Tickets en Tarjeta</th><th class=text-center>Tickets en SINPE</th><th class=text-center>TOTAL Vendidos</th><th class=text-center>TOTAL Online</th><th class=text-center>Devolución Adulto</th><th class=text-center>Devolución Descuento</th><th class=text-center>TOTAL Devolución</th></tr></thead><tbody><tr><td>{{salesSummaryReport.data.online.name}}</td><td class=text-center>{{salesSummaryReport.data.online.count}}</td><td class=text-center>{{salesSummaryReport.data.online.soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{salesSummaryReport.data.online.data[3].count}}</td><td class=text-center>{{salesSummaryReport.data.online.data[4].count}}</td><td class=text-center>{{salesSummaryReport.data.online.data[1].count}} => {{salesSummaryReport.data.online.data[1].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{salesSummaryReport.data.online.data[0].count}} => {{salesSummaryReport.data.online.data[0].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{salesSummaryReport.data.online.data[2].count}} => {{salesSummaryReport.data.online.data[2].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{salesSummaryReport.data.online.data[9].count}}</td><td class=text-center>{{salesSummaryReport.data.online.data[9].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{salesSummaryReport.data.online.data[6].count}} => {{salesSummaryReport.data.online.data[6].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{salesSummaryReport.data.online.data[7].count}} => {{salesSummaryReport.data.online.data[7].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{salesSummaryReport.data.online.data[8].count}} => {{salesSummaryReport.data.online.data[8].soldTotal | currency:\"₡\":2}}</td></tr></tbody></table></div><div class=col-xs-12><h3>Cajas</h3><table class=\"table table-striped\"><thead><tr><th>Caja</th><th class=text-center>Tickets Cierre de Caja</th><th class=text-center>Total Cierre de Caja</th><th class=text-center>Tickets Descuento</th><th class=text-center>Tickets Adulto</th><th class=text-center>Tickets en Efectivo</th><th class=text-center>Tickets en Tarjeta</th><th class=text-center>Tickets en SINPE</th><th class=text-center>TOTAL Vendidos</th><th class=text-center>TOTAL en Caja</th><th class=text-center>Devolución Adulto</th><th class=text-center>Devolución Descuento</th><th class=text-center>TOTAL Devolución</th></tr></thead><tbody><tr ng-repeat=\"cashier in salesSummaryReport.data.cashRegisters.data\"><td>{{cashier.name}}</td><td class=text-center>{{cashier.count}}</td><td class=text-center>{{cashier.soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{cashier.data[4].count}}</td><td class=text-center>{{cashier.data[3].count}}</td><td class=text-center>{{cashier.data[1].count}} => {{cashier.data[1].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{cashier.data[0].count}} => {{cashier.data[0].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{cashier.data[2].count}} => {{cashier.data[2].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{cashier.count}}</td><td class=text-center>{{cashier.soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{cashier.data[6].count}} => {{cashier.data[6].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{cashier.data[7].count}} => {{cashier.data[7].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{cashier.data[8].count}} => {{cashier.data[8].soldTotal | currency:\"₡\":2}}</td></tr><tr><td><b>Totales:</b></td><td class=text-center><b>{{salesSummaryReport.data.cashRegisters.count}}</b></td><td class=text-center><b>{{salesSummaryReport.data.cashRegisters.soldTotal | currency:\"₡\":2}}</b></td><td></td><td></td><td></td><td></td><td></td><td class=text-center><b>{{salesSummaryReport.data.cashRegisters.count}}</b></td><td class=text-center><b>{{salesSummaryReport.data.cashRegisters.soldTotal | currency:\"₡\":2}}</b></td><td></td><td></td><td><b>{{salesSummaryReport.data.cashRegisters.releasedCount}} => {{salesSummaryReport.data.cashRegisters.releasedSoldTotal | currency:\"₡\":2}}</b></td></tr></tbody></table></div><div class=col-xs-12><h3>Agencias</h3><table class=\"table table-striped\"><thead><tr><th>Nombre</th><th class=text-center>Tickets Cierre de Caja</th><th class=text-center>Total Cierre de Caja</th><th class=text-center>Tickets Adulto</th><th class=text-center>Tickets Descuento</th><th class=text-center>Tickets en Efectivo</th><th class=text-center>Tickets en Tarjeta</th><th class=text-center>Tickets en SINPE</th><th class=text-center>TOTAL Vendidos</th><th class=text-center>TOTAL en Agencia</th><th class=text-center>Devolución Adulto</th><th class=text-center>Devolución Descuento</th><th class=text-center>TOTAL Devolución</th></tr></thead><tbody><tr ng-repeat=\"reseller in salesSummaryReport.data.resellers.data\"><td>{{reseller.name}}</td><td class=text-center>{{reseller.count}}</td><td class=text-center>{{reseller.soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{reseller.data[3].count}}</td><td class=text-center>{{reseller.data[4].count}}</td><td class=text-center>{{reseller.data[1].count}} => {{reseller.data[1].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{reseller.data[0].count}} => {{reseller.data[0].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{reseller.data[2].count}} => {{reseller.data[2].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{reseller.count}}</td><td class=text-center>{{reseller.soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{reseller.data[6].count}} => {{reseller.data[6].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{reseller.data[7].count}} => {{reseller.data[7].soldTotal | currency:\"₡\":2}}</td><td class=text-center>{{reseller.data[8].count}} => {{reseller.data[8].soldTotal | currency:\"₡\":2}}</td></tr><tr><td><b>Totales:</b></td><td class=text-center><b>{{salesSummaryReport.data.resellers.count }}</b></td><td class=text-center><b>{{salesSummaryReport.data.resellers.soldTotal | currency:\"₡\":2}}</b></td><td></td><td></td><td></td><td></td><td></td><td class=text-center><b>{{salesSummaryReport.data.resellers.count}}</b></td><td class=text-center><b>{{salesSummaryReport.data.resellers.soldTotal | currency:\"₡\":2}}</b></td><td></td><td></td><td><b>{{salesSummaryReport.data.resellers.releasedCount}} => {{salesSummaryReport.data.resellers.releasedSoldTotal | currency:\"₡\":2}}</b></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/pages/reports-tickets-issued/tickets-issued.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=ticketsIssued-overlay><div class=row><div class=col-xs-12><div class=m-top-20><div class=row><div class=col-xs-6><h2>Boletos Emitidos</h2></div></div></div></div></div><div class=row><div class=col-xs-12><h1>Lista de boletos Emitidos</h1></div></div><div class=row><form role=form name=form class=\"form-inline m-top-20\" ng-submit=ticketsIssued.requestTicketsIssued(form) novalidate><div class=col-xs-2><div class=form-group><label for=StartDate>Fecha Inicial:</label><p class=input-group><input type=text name=StartDate id=StartDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=ticketsIssued.startDate is-open=ticketsIssued.showStartCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\"> <span class=input-group-btn datepicker-options=ticketsIssued.dateConfig><button type=button class=\"btn btn-default\" ng-click=ticketsIssued.openStartDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.StartDate.$error ng-show=ticketsIssued.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=EndDate>Fecha Final:</label><p class=input-group><input type=text name=EndDate id=EndDate class=form-control required uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=ticketsIssued.endDate is-open=ticketsIssued.showEndCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" datepicker-options=ticketsIssued.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=ticketsIssued.openEndDate()><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=form.EndDate.$error ng-show=ticketsIssued.submitAttempt><p ng-message=required>Fecha requerida</p></div></div></div><div class=col-xs-3><div class=\"form-group m-top-25\"><div class=\"radio radio-inline\"><input type=radio id=CR name=reportType value=CR ng-checked=true ng-model=ticketsIssued.type><label for=CR>Santa Cruz</label></div><div class=\"radio radio-inline\"><input type=radio id=NY name=reportType value=NY ng-model=ticketsIssued.type><label for=NY>Nicoya</label></div><div class=\"radio radio-inline\"><input type=radio id=TOTALS name=reportType value=TOTALS ng-model=ticketsIssued.type><label for=TOTALS>Total</label></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25\">Generar</button></div></form></div><div class=row><div class=col-xs-12><p>El reporte de boletos emitidos será enviado el correo electrónico del usuario con que ingresó al sistema.</p></div></div></div>");
$templateCache.put("app/pages/reset-password/reset-password.html","<div class=\"container-fluid page-container authentication-form-container\"><div class=\"row max-width-content\"><div class=col-xs-12><h1>Resetear Contraseña</h1><hr><form role=form name=resetForm ng-submit=resetPassword.resetPasswordProcess(resetForm) novalidate><div class=form-group><label for=password>Nueva Contraseña:</label><input type=password id=password name=password placeholder=Contraseña class=form-control ng-model=resetPassword.password ng-pattern=resetPassword.passwordPattern required><div ng-messages=resetForm.password.$error ng-show=resetPassword.submitAttempt><span ng-message=required class=error>Porfavor ingrese una nueva contraseña</span> <span ng-message=pattern class=error>Contraseña Invalida, intentelo de nuevo</span></div></div><div class=form-group><label for=confirmPassword>Confirmar Contraseña:</label><input type=password id=confirmPassword name=confirmPassword placeholder=\"Confirmar Contraseña\" class=form-control ng-model=resetPassword.confirmPassword required><div ng-messages=resetForm.confirmPassword.$error ng-show=resetPassword.submitAttempt><span ng-message=required class=error>Por Favor digite nuevamente su contraseña para verificación</span></div></div><p class=error>{{ resetPassword.message }}</p><p class=error ng-show=!resetPassword.resetToken>Link para resetear contraseña es invalido</p><div class=form-group><button type=submit ladda=resetPassword.loading data-style=zoom-in class=\"btn btn-primary\" ng-disabled=!resetPassword.resetToken ng-class=\"{\'disable\':!resetPassword.resetToken}\">Resetear Contaseña</button></div></form></div></div></div>");
$templateCache.put("app/pages/sales-agency-sales/agency-sales.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=agency-sales-overlay><div class=row><div class=col-xs-12><h1>Reporte de Ventas de Agencia</h1></div></div><form id=filterForm name=filterForm class=m-top-20 novalidate ng-submit=agencySales.getReport(filterForm)><div class=row><div class=col-xs-12><h4>Seleccione las fechas</h4></div></div><div class=row><div class=col-xs-3><div class=form-group><label for=OriginDate>Fecha Inicial:</label><p class=input-group><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=agencySales.filter.originDateUI is-open=agencySales.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"agencySales.showOriginCalendar = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=filterForm.OriginDate.$error ng-show=agencySales.submitAttempt><p ng-message=required>La Fecha Inicial es requerida</p></div></div></div><div class=col-xs-3><div class=form-group><label for=FinalDate>Fecha Final:</label><p class=input-group><input type=text name=FinalDate id=FinalDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=agencySales.filter.finalDateUI is-open=agencySales.showFinalCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"agencySales.showFinalCalendar = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=filterForm.FinalDate.$error ng-show=agencySales.submitAttempt><p ng-message=required>La Fecha Final es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=\"\">&nbsp;</label><p><button class=\"btn btn-primary\" type=submit>Ver</button></p></div></div></div></form><div id=AgencySalesResults ng-show=agencySales.salesReportList.detail.length><div class=row><div class=col-xs-3><img src=assets/images/tig-logo.png alt=TIG class=\"img-responsive max-w-200px\"></div><div class=col-xs-6><h3 class=\"text-uppercase text-center\">TI Guanacate</h3><p class=text-center></p><h4 class=text-center>Boletos Vendidos</h4></div><div class=\"col-xs-3 text-right\"><button type=button class=\"btn btn-primary hidden-print\" ng-click=agencySales.print()>Imprimir</button></div></div><div class=row><div class=col-xs-12><h4>Boletos Vendidos</h4></div></div><div class=row><div class=col-xs-12><table class=\"table table-striped\" id=salesTable><thead><tr><th>Boleto</th><th>Efectivo</th><th>Tarjeta</th><th>SINPE</th><th>Referencia</th><th>Fecha de venta</th><th>Usuario</th></tr></thead><tbody><tr ng-repeat=\"sale in agencySales.salesReportList.detail\"><td>{{sale.invoiceNumber}}</td><td><span ng-if=sale.cash>{{sale.finalPrice | currency:\"₡\":0}}</span></td><td><span ng-if=sale.card>{{sale.finalPrice | currency:\"₡\":0}}</span></td><td><span ng-if=sale.sinpe>{{sale.finalPrice | currency:\"₡\":0}}</span></td><td>{{sale.cardReference}}</td><td>{{sale.soldDate | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{sale.soldBy}}</td></tr><tr><td><b>Totales</b></td><td>{{agencySales.salesReportList.cashTicketTotalSoldAmount | currency:\"₡\":0}}</td><td>{{agencySales.salesReportList.cardTicketTotalSoldAmount | currency:\"₡\":0}}</td><td>{{agencySales.salesReportList.sinpeTicketTotalSoldAmount | currency:\"₡\":0}}</td><td></td><td></td><td><b>Vendidos en Efectivo:</b> {{agencySales.salesReportList.cashTicketTotalCount }}</td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en SINPE:</b> {{agencySales.salesReportList.sinpeTicketTotalCount}}</td></tr><tr><td><b>TOTAL: {{agencySales.salesReportList.totalPrice| currency:\"₡\":0 }}</b></td><td></td><td></td><td></td><td></td><td></td><td><b>Vendidos en Tarjeta:</b> {{agencySales.salesReportList.cardTicketTotalCount}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/sales-cash-movements/cash-movements.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=cash-mov-overlay><div class=row><div class=col-xs-12><h1>Cash Movements</h1></div></div></div>");
$templateCache.put("app/pages/sales-checks/checks.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=checks-overlay><div class=row><div class=col-xs-12><h1>Chequeos</h1></div></div><form id=filterForm name=filterForm class=m-top-20 ng-submit=checks.searchTickets(filterForm) novalidate><div class=row><div class=col-xs-3><div class=form-group><label for=Route>Ruta:</label><select name=Route id=Route class=form-control ng-options=\"route.id as route.name for route in checks.routesList\" ng-model=checks.filter.route ng-change=checks.loadSchedulesAvailable() required><option value=\"\">Ruta</option></select><div class=error ng-messages=filterForm.Route.$error ng-show=checks.submitAttempt><p ng-message=required>La Ruta es requerida</p></div></div></div><div class=col-xs-2><div class=form-group><label for=OriginDate>Fecha:</label><p class=input-group><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=checks.filter.originDateUI is-open=checks.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-change=checks.loadSchedulesAvailable() ng-disabled=\"checks.query.typeOfTrip ==3\" required> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=checks.openOriginDate() ng-disabled=\"checks.query.typeOfTrip == 3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-messages=filterForm.OriginDate.$error ng-show=checks.submitAttempt><p ng-message=required>La Fecha es requerida</p></div></div></div><div class=col-xs-3><div class=form-group><label for=BusType>Tipo de Bus:</label><select name=BusType id=BusType class=form-control ng-options=\"busType.id as busType.name for busType in checks.busClasses\" ng-model=checks.filter.busType ng-change=checks.loadSchedulesAvailable() required><option value=\"\">Tipo de Bus</option></select><div class=error ng-messages=filterForm.BusType.$error ng-show=checks.submitAttempt><p ng-message=required>El Tipo de Bus es requerido</p></div></div></div><div class=col-xs-2><div class=form-group><label for=SchedulesAvailable>Horarios</label><select name=SchedulesAvailable id=SchedulesAvailable class=form-control ng-options=\"trip as trip.schedule.departureTimeUI for trip in checks.schedulesAvailable\" ng-model=checks.filter.selectedTrip required><option value=\"\">Horarios</option></select><div class=error ng-messages=filterForm.SchedulesAvailable.$error ng-show=checks.submitAttempt><p ng-message=required>El horario es requerido</p></div></div></div><div class=col-xs-2><button type=submit class=\"btn btn-primary m-top-25 hidden-print\">Buscar</button> <button type=button ng-show=\"checks.tickets.length > 0\" class=\"btn btn-primary hidden-print m-left-15 m-top-25\" ng-click=checks.print()>Imprimir</button></div></div></form></div><div class=row><div class=\"col-xs-12 text-right hidden-print\" ng-show=\"checks.tickets.length > 0\"><button type=button class=\"btn btn-default\" ng-click=checks.releaseTripTickets(checks.filter.selectedTrip) ng-disabled=\"!hasPermissionsFor(\'RELEASE\')\"><i class=\"fa fa-chain-broken\"></i> Liberar Boletos</button></div><div class=col-xs-12><table class=\"table table-striped\" ng-show=\"checks.tickets.length > 0\"><thead><tr><th>Boleto</th><th>Pagado</th><th>Asiento</th><th>Abordaje</th><th>Hora chequeo</th><th class=text-center>Chequeo 1</th><th class=text-center>Chequeo 2</th><th class=text-center>Chequeo 3</th><th class=hidden-print>Liberar</th></tr></thead><tbody><tr ng-repeat=\"ticket in checks.tickets\" ng-show=ticket.invoiceNumber ng-class=\"{onlinePaymentError: ticket.onlinePaymentError}\"><td>{{ticket.invoiceNumber}}</td><td><span ng-if=!ticket.notPayed>Si</span> <span ng-if=ticket.notPayed>No</span></td><td>{{ticket.tripSeat.seatNumber}}</td><td>{{ticket.boarding.name}}</td><td>{{ticket.checkedTime | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\' }}</td><td class=text-center><input type=checkbox name=check1 id=check1 ng-init=\"checks.check1[ticket.invoiceNumber]=ticket.check1\" ng-model=checks.check1[ticket.invoiceNumber] ng-disabled=\"!ticket.invoiceNumber || checks.check1[ticket.invoiceNumber] || !hasPermissionsFor(\'CHECK_1\')\" ng-change=checks.updateChecks(ticket)></td><td class=text-center><input type=checkbox name=check2 id=check2 ng-init=\"checks.check2[ticket.invoiceNumber]=ticket.check2\" ng-model=checks.check2[ticket.invoiceNumber] ng-disabled=\"!ticket.invoiceNumber || !checks.check1[ticket.invoiceNumber] || checks.check2[ticket.invoiceNumber] || !hasPermissionsFor(\'CHECK_2\')\" ng-change=checks.updateChecks(ticket)></td><td class=text-center><input type=checkbox name=check3 id=check3 ng-init=\"checks.check3[ticket.invoiceNumber]=ticket.check3\" ng-model=checks.check3[ticket.invoiceNumber] ng-disabled=\"!ticket.invoiceNumber || !checks.check1[ticket.invoiceNumber] || !checks.check2[ticket.invoiceNumber] || checks.check3[ticket.invoiceNumber] || !hasPermissionsFor(\'CHECK_3\')\" ng-change=checks.updateChecks(ticket)></td><td class=hidden-print><button type=button class=\"btn btn-default\" ng-click=checks.releaseTicket(ticket) ng-disabled=\"!ticket.invoiceNumber || checks.check3[ticket.invoiceNumber] || !hasPermissionsFor(\'RELEASE\')\"><i class=\"fa fa-chain-broken\"></i> Liberar</button></td></tr></tbody></table><p ng-show=\"!checks.tickets.length > 0\">No Hay datos para mostrar</p></div></div><tnsp-modal-underage-person-form ticket=checks.selectedTicket></tnsp-modal-underage-person-form><tnsp-modal-checks-load-form ticket=checks.selectedTicket></tnsp-modal-checks-load-form><tnsp-modal-client-form client=checks.selectedClient></tnsp-modal-client-form>");
$templateCache.put("app/pages/sales-parent/sales.html","<div class=\"container-fluid page-container\"><div class=\"row max-width-content\"><div class=\"col-xs-12 no-padding cash-menu\"><div class=animated-view ui-view></div></div></div></div>");
$templateCache.put("app/pages/sales-redeem/redeem.html","<div class=\"container-fluid redeem relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=redeem-overlay><div class=row><div class=col-xs-12><h1>Redimir Tickets</h1><form id=SearchTicketForm name=SearchTicketForm novalidate class=form-inline ng-submit=redeem.searchTicket(SearchTicketForm)><div class=form-group><label for=TicketNo>Tiquete:</label><input type=text class=form-control ng-model=redeem.ticketToSearch name=TicketNo id=TicketNo required> <button type=submit class=\"btn btn-primary\" ng-disabled=!redeem.ticketToSearch>Buscar</button></div></form></div></div><div class=row ng-show=redeem.ticket><hr><wizard class=wizard name=redeem-wizard><wz-step wz-title=Disponibilidad><form id=TicketStep1Form name=TicketStep1Form ng-submit=redeem.goToSeats(TicketStep1Form) novalidate><div class=row><div class=col-xs-12><div class=row><div class=col-xs-2><div class=form-group><label for=Ticket>Tiquete:</label><div>{{redeem.ticket.invoiceNumber}}</div></div></div><div class=col-xs-3><div class=form-group><label for=Cliente>Pasajero:</label><div>{{redeem.ticket.client.fullName}}</div></div></div><div class=col-xs-2><div class=form-group><label for=Identification>Identificación:</label><div>{{redeem.ticket.client.identification}}</div></div></div><div class=col-xs-3><div class=form-group><label for=Route>Ruta:</label><div>{{redeem.ticket.routeRate.route.name}}</div></div></div><div class=col-xs-2><div class=form-group><label for=BusType>Tipo de Bus:</label><div>{{redeem.ticket.routeRate.busClass.name}}</div></div></div></div><div class=row><div class=col-xs-2><div class=form-group><label for=OriginDate>Fecha:</label><p class=\"input-group m-bottom-0\"><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=redeem.originDateUI is-open=redeem.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" required ng-blur=redeem.loadSchedulesAvailable() datepicker-options=redeem.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"redeem.showOriginCalendar = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-show=redeem.submitAttemptStep1><p ng-show=TicketStep1Form.OriginDate.$error.required>La fecha es requerida</p></div></div></div><div class=col-xs-3><div class=form-group><label for=SchedulesAvailable>Horarios</label><select name=SchedulesAvailable id=SchedulesAvailable class=form-control ng-options=\"trip as trip.schedule.departureTime for trip in redeem.schedulesAvailable\" ng-model=redeem.selectedTrip ng-change=redeem.generateSeats() required><option value=\"\">Horarios</option></select><div class=error ng-show=redeem.submitAttemptStep1><p ng-show=TicketStep1Form.SchedulesAvailable.$error.required>El horario es requerido</p></div></div></div><div class=col-xs-2><label for=Price>Precio</label><input type=text id=Price name=Price class=\"form-control text-right\" ng-model=redeem.selectedTrip.schedule.routeRate.billingRate disabled></div><div class=col-xs-3><label for=Disponibles>Campos Disponibles</label><input type=text id=Disponibles name=Disponibles class=\"form-control text-right\" ng-model=redeem.selectedTrip.availableSeats disabled></div></div><div class=row><div class=\"col-xs-12 text-right\"><input type=submit value=Siguiente class=\"btn btn-primary\"></div></div></div></div></form></wz-step><wz-step wz-title=Asientos><form id=TicketStep2Form name=TicketStep2Form ng-submit=redeem.goToConfirmation(TicketStep2Form) novalidate><div class=row><div class=col-xs-12><div class=row><div class=col-xs-12><h3>Asientos</h3><p class=m-top-10>Seleccione su asiento</p></div></div><div class=row><div class=col-xs-6><h5><b>{{redeem.ticket.routeRate.route.name}}</b></h5><div ng-repeat=\"seat in redeem.allSeats\" class=seats-container><div ng-if=\"$index % 4 === 0\" ng-init=\"group = redeem.allSeats.slice($index, $index + 4)\" class=seats-group><button type=button class=\"btn btn-clear btn-seat\" ng-repeat=\"seatItem in group\" ng-click=redeem.toggleSeatSelection(seatItem) ng-class=\"{occupied:seatItem.isOccupied, selected:seatItem.selected}\" ng-disabled=\"seatItem.isOccupied || (redeem.selectedSeat.length >= 1 && !seatItem.selected)\">{{seatItem.seatNumber}}</button></div></div></div></div><div class=error ng-show=redeem.submitAttemptStep2><p ng-show=\"redeem.selectedSeat.length !== 1\">Debe seleccionar su asiento</p></div></div></div><div class=row><div class=col-xs-6><input type=button wz-previous value=Anterior class=\"btn btn-primary\"></div><div class=\"col-xs-6 text-right\"><input type=submit value=Siguiente class=\"btn btn-primary\"></div></div></form></wz-step><wz-step wz-title=\"Confirmación y Pago\"><form id=TicketStep3Form name=TicketStep3Form ng-submit=redeem.payTickets(TicketStep3Form) novalidate><div class=row><div class=\"col-xs-10 col-xs-offset-1\"><div class=col-xs-12><div class=row><div class=col-xs-6><h3>Confirmación</h3></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-default\" ng-click=redeem.cancelReservation()><i class=\"fa fa-times\"></i> Cancelar Compra</button></div></div></div><div class=col-xs-12><div class=\"box m-top-20 p-all-10\"><div class=row><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8>{{redeem.ticket.routeRate.route.name}}</div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8><span>{{redeem.selectedTrip.date | amDateFormat: dateFormat}}</span></div></div></div><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{redeem.selectedTrip.schedule.departureTime || \'--\'}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{redeem.selectedTrip.schedule.routeRate.busClass.name}}</div></div></div></div></div></div><div class=\"col-xs-12 m-top-20\"><h3>Pasajeros</h3><table class=\"table table-striped\"><thead><tr><th>Identificación</th><th>Cliente</th><th>Ruta</th><th>Asiento</th><th>Precio</th></tr></thead><tbody><tr><td>{{redeem.ticket.client.identification}}</td><td>{{redeem.ticket.client.fullName}}</td><td>{{redeem.ticket.routeRate.route.name}}</td><td>{{redeem.selectedSeat[0].seatNumber}}</td><td><span>{{redeem.selectedTrip.schedule.routeRate.billingRate}}</span></td></tr><tr><td colspan=4><strong>TOTAL:</strong></td><td>{{redeem.total}}</td></tr></tbody></table></div><div class=\"col-xs-12 m-top-20\" ng-if=!redeem.hasToPay><div class=col-xs-12><div class=text-left><button type=button class=\"btn btn-primary\" ng-show=redeem.ticketsPaid ng-click=redeem.restartTickets()>Reiniciar Compra</button></div><div class=text-right><button type=button class=\"btn btn-secondary\" ng-click=redeem.simpleRedeem() ng-disabled=redeem.ticketsPaid>Redimir</button></div></div></div><div class=\"col-xs-12 m-top-20\" ng-if=redeem.hasToPay><div class=row><div class=col-xs-12><h3>Pago</h3></div></div><div class=\"row form-group\"><div class=col-xs-2><strong>Diferencia a pagar:</strong></div><div class=\"col-xs-3 text-right\"><input type=text class=\"form-control text-right\" ng-model=redeem.total disabled></div><div class=col-xs-2><strong>Forma de pago:</strong></div><div class=col-xs-3><select name=paymentMethod id=paymentMethod class=form-control ng-options=\"pm as pm.name for pm in redeem.paymentMethods\" ng-model=redeem.paymentMethod required><option value=\"\">Forma de Pago</option></select><div class=error ng-show=redeem.submitAttemptStep3><p ng-show=TicketStep3Form.paymentMethod.$error.required>Seleccione metodo de pago</p></div></div></div><div class=\"row form-group\"><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input id=AmountConfirm name=AmountConfirm type=text ng-model=redeem.amount class=\"form-control text-right\" ng-blur=redeem.calcDifference() required><div class=error ng-show=redeem.submitAttemptStep3><p ng-show=TicketStep3Form.AmountConfirm.$error.required>Digite el monto cancelado</p></div></div><div class=col-xs-2 ng-show=\"redeem.paymentMethod.name == \'Tarjeta\'\"><strong>Autorización:</strong></div><div class=col-xs-3 ng-show=\"redeem.paymentMethod.name == \'Tarjeta\'\"><input type=text id=AuthorizationConf name=AuthorizationConf ng-model=redeem.newTicket.cardConfirmation class=form-control ng-required=\"redeem.paymentMethod.name == \'Tarjeta\'\"><div class=error ng-show=redeem.submitAttemptStep3><p ng-show=TicketStep3Form.AuthorizationConf.$error.required>Digite la autorización del Datafono</p></div></div></div><div class=\"row form-group\" ng-show=redeem.difference><div class=col-xs-2><strong>Vuelto:</strong></div><div class=\"col-xs-3 text-right\"><input type=text ng-model=redeem.difference class=\"form-control text-right\" disabled></div></div><div class=row><div class=\"col-xs-12 text-right\"><div class=text-right><button type=submit class=\"btn btn-secondary\" ng-disabled=redeem.ticketsPaid>Pagar</button></div><div class=text-left><button type=button class=\"btn btn-primary\" ng-show=redeem.ticketsPaid ng-click=redeem.restartTickets()>Reiniciar Compra</button></div></div></div></div></div></div></form></wz-step></wizard></div></div><tnsp-modal-print-ticket-invoice invoices-ids=redeem.invoices></tnsp-modal-print-ticket-invoice>");
$templateCache.put("app/pages/sales-ticket-history/ticket-history.html","<div class=\"container-fluid tickets edit-tickets relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=historyTicket-overlay><div class=row><div class=col-xs-3><h1>Historial de Boleto</h1></div><div class=col-xs-9><form id=SearchTicketForm name=SearchTicketForm novalidate class=\"form-inline m-top-20\" ng-submit=ticketHistory.searchTicket(SearchTicketForm)><div class=form-group><label for=TicketNo>Tiquete:</label><input type=text class=form-control ng-model=ticketHistory.ticketToSearch name=TicketNo id=TicketNo required ng-value=\"\"> <button type=submit class=\"btn btn-primary\" ng-disabled=!ticketHistory.ticketToSearch>Buscar</button></div><!--<div ng-show=\"ticketHistory.history.length > 0 && ticketHistory.history[ticketHistory.history.length - 1].status === \'DRAFT\'\" class=\"d-inline-block\">\n          <p class=\"draft-message\">Esta compra no se completó</p>\n        </div>--></form></div></div><div class=row ng-show=\"ticketHistory.history m-top-20\"><div ng-show=\"ticketHistory.history.length > 0\" class=m-top-20><div class=col-xs-2><label>Boleto:</label><input type=text class=form-control ng-model=ticketHistory.history[0].invoiceNumber disabled></div><div class=col-xs-2><label>Vendedor:</label><input type=text class=form-control ng-model=ticketHistory.history[0].createdByName disabled></div><div class=col-xs-2><label>Fecha/Hora de venta:</label><input type=text class=form-control ng-model=\"ticketHistory.history[0].createdAt | amDateFormat: \'DD/MM/YYYY h:mm A\'\" disabled></div><div class=col-xs-2><label>Metodo de pago:</label><input type=text class=form-control ng-model=ticketHistory.history[0].paymentType disabled></div><div class=col-xs-1><label>Precio:</label><input type=text class=form-control ng-model=ticketHistory.history[0].price disabled></div><div class=col-xs-1><label>Descuento:</label><input type=text class=form-control ng-model=ticketHistory.history[0].discount disabled></div><!--<div class=\"col-xs-1\">\n        <label>Precio:</label>\n        <input type=\"text\" class=\"form-control\"\n          ng-model=\"ticketHistory.history[ticketHistory.history.length-1].status === \'DRAFT\' ? \'\' : ticketHistory.history[0].price\" disabled />\n      </div>\n      <div class=\"col-xs-1\">\n        <label>Descuento:</label>\n        <input type=\"text\" class=\"form-control\" ng-model=\"ticketHistory.history[ticketHistory.history.length-1].status === \'DRAFT\' ? \'\' : ticketHistory.history[0].discount\" disabled />\n      </div>--><div class=col-xs-2><label>Referencia:</label><input type=text class=form-control ng-model=ticketHistory.history[0].reference disabled></div></div><div class=\"col-xs-12 table-responsive m-top-20\" ng-show=\"ticketHistory.history.length > 0\"><table class=\"table table-striped m-top-20\"><thead class=small-head><tr><th class=min-w-125>Actualizado por</th><th class=min-w-100>Fecha</th><th class=min-w-200>Ruta</th><th class=min-w-75>Abordaje</th><th class=min-w-100>Destino Final</th><th class=min-w-75>Silla</th><th class=min-w-75>Fecha de viaje</th><th class=min-w-75>Horario</th><th class=min-w-75>Hora de chequeo</th><th class=min-w-75>Unidad Abordada</th><th class=min-w-75>Status</th></tr></thead><tbody class=small-body><tr ng-repeat=\"item in ticketHistory.history\"><td>{{item.updatedByName}}</td><td>{{item.updatedAt | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{item.routeName}}</td><td>{{item.boardingName}}</td><td>{{item.routeDropOffName}}</td><td>{{item.tripSeatNumber}}</td><td>{{item.tripDate | amDateFormat: \'DD/MM/YYYY\'}}</td><td>{{item.tripTime}}</td><td>{{item.checkedTime | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td><td>{{item.licensePlate}}</td><td>{{item.ticketStatus}}</td></tr></tbody></table><p ng-show=\"!ticketHistory.history.length > 0\">No hay datos para mostrar</p></div><div class=\"col-xs-12 m-top-20\" ng-show=\"ticketHistory.history.length === 0\"><h3 class=m-top-20>No se encontraron resultados</h3></div></div></div>");
$templateCache.put("app/pages/sales-tickets/tickets.html","<div class=\"container-fluid tickets relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=ticket-overlay><wizard class=wizard name=ticket-wizard><wz-step wz-title=Ruta><div class=\"row m-top-40\"><div class=\"col-xs-12 text-center\"><div class=text-center><img src=assets/images/tig-logo.png alt=TIG class=\"img-responsive max-w-200px mx-auto\"></div><h2 class=m-top-25>Bienvenido, Elija la ruta en la que desea vender boletos</h2></div></div><div class=\"row m-top-40\"><div class=\"col-xs-6 text-center m-top-40\"><button class=\"btn btn-primary w-25 text-uppercase\" type=button ng-click=\"tickets.selectRoute(\'NY\')\">Nicoya</button></div><div class=\"col-xs-6 text-center m-top-40\"><button type=button class=\"btn btn-primary w-25 text-uppercase\" ng-click=\"tickets.selectRoute(\'CR\')\">Santa Cruz</button></div></div><!-- main row --></wz-step><wz-step wz-title=Disponibilidad><form id=TicketStep1Form name=TicketStep1Form ng-submit=tickets.goToSelectClients(TicketStep1Form) novalidate><div class=row><div class=\"col-xs-10 col-xs-offset-1\"><!--First Way --><div class=box><div class=row><div class=col-xs-4><div class=form-group><label for=Route>Ruta:</label><select name=Route id=Route class=form-control ng-options=\"route as route.name for route in tickets.routesList\" ng-model=tickets.newTicket.route ng-change=tickets.loadSchedulesAvailable() required><option value=\"\">Ruta</option></select><span ng-if=tickets.newTicket.route.transfer>{{tickets.newTicket.route.subRoutes[0].name}}</span><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.Route.$error.required>La ruta es requerida</p></div></div></div><div class=col-xs-4><div class=form-group><label for=OriginDate>Fecha:</label><p class=\"input-group m-bottom-0\"><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=tickets.originDateUI is-open=tickets.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=\"tickets.newticket.typeOfTrip != 3\" ng-blur=tickets.loadSchedulesAvailable() ng-disabled=\"tickets.newticket.typeOfTrip ==3\" datepicker-options=tickets.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=tickets.openOriginDate() ng-disabled=\"tickets.newticket.typeOfTrip == 3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.OriginDate.$error.required>La fecha es requerida</p></div></div></div><div class=col-xs-4><div class=form-group><label for=SchedulesAvailable>Horarios</label><select name=SchedulesAvailable id=SchedulesAvailable class=form-control ng-options=\"trip as trip.schedule.departureTimeUI for trip in tickets.schedulesAvailable\" ng-model=tickets.newTicket.selectedTrip ng-change=tickets.getAvailableSeats() ng-disabled=\"tickets.newticket.typeOfTrip == 3\" ng-required=\"tickets.newticket.typeOfTrip != 3\"><option value=\"\">Horarios</option></select><div class=error ng-show=tickets.submitAttemptStep1><p ng-show=TicketStep1Form.SchedulesAvailable.$error.required>El horario es requerido</p></div></div></div></div><div class=row><div class=col-xs-4><div ng-show=\"tickets.newticket.typeOfTrip != 3\"><label for=Price>Precio</label><input ng-if=!tickets.newTicket.route.transfer type=text id=Price name=Price class=\"form-control text-right\" ng-model=tickets.newTicket.selectedTrip.schedule.routeRate.billingRate disabled> <input ng-if=tickets.newTicket.route.transfer type=text id=Price name=Price class=\"form-control text-right\" ng-model=tickets.newTicket.priceWithTransfer disabled></div><div ng-show=\"tickets.newticket.typeOfTrip == 3\"><label for=PriceOpen>Precio</label><input ng-if=!tickets.newTicket.route.transfer type=text id=PriceOpen name=PriceOpen class=\"form-control text-right\" ng-model=tickets.openRouteRate.billingRate disabled> <input ng-if=tickets.newTicket.route.transfer type=text id=PriceOpen name=PriceOpen class=\"form-control text-right\" ng-model=tickets.newTicket.priceWithTransfer disabled></div></div><div class=col-xs-4><label for=Disponibles>Campos Disponibles</label><input type=text id=Disponibles name=Disponibles class=\"form-control text-right\" ng-model=tickets.newTicket.selectedTrip.availableSeats disabled></div></div></div><div class=\"row m-top-10\"><div class=\"col-xs-12 text-right\"><input type=submit value=Siguiente class=\"btn btn-primary\"></div></div></div><!-- col-10 --></div><!-- main row --></form></wz-step><wz-step wz-title=Asientos wz-disabled=\"{{tickets.newticket.typeOfTrip == 3}}\"><form id=TicketStep3Form name=TicketStep3Form ng-submit=tickets.goToConfirmation(TicketStep3Form) novalidate><div class=\"row m-bottom-20\"><div class=col-xs-12><div class=row><div class=col-xs-12><h3>Asientos</h3><p class=m-top-10>Seleccione hasta {{tickets.newticket.clients.length}} asiento(s) por ruta</p></div></div><h5>Ida <b ng-show=!tickets.newTicket.route.transfer>({{tickets.newTicket.route.name}})</b> <b ng-show=tickets.newTicket.route.transfer>({{tickets.newTicket.route.subRoutes[0].name}})</b></h5><tnsp-bus-layout ng-if=tickets.showBusLayout input-layout-type=tickets.newTicket.selectedTrip.bus.layoutType input-is-trip-locked=tickets.newTicket.selectedTrip.locked input-trip-seats=tickets.occupiedSeats output-selected-seats=tickets.handleSelectedSeats(selectedSeats)></tnsp-bus-layout><div class=error ng-show=tickets.submitAttemptStep3><p ng-show=\"tickets.selectedSeatT.length !== tickets.newticket.clients.length\">Debe seleccionar la misma cantidad de asientos como de clientes en el paso anterior</p><p ng-show=\"(tickets.newticket.typeOfTrip == 2 && tickets.selectedReturnSeatT.length !== tickets.newticket.clients.length)\">Debe seleccionar la misma cantidad de asientos como de clientes en el paso anterior para la ruta de vuelta</p></div></div></div><div class=row><div class=col-xs-6><input type=button wz-previous value=Anterior class=\"btn btn-primary\" ng-click=tickets.goBackToStepOne()></div><div class=\"col-xs-6 text-right\"><input type=submit value=Siguiente class=\"btn btn-primary\" ng-disabled=\"tickets.newTicket.selectedTrip.locked || tickets.selectedSeat.length === 0\"></div></div></form></wz-step><wz-step wz-title=\"Confirmación y Pago\"><form id=TicketStep4Form name=TicketStep4Form ng-submit=tickets.payTickets(TicketStep4Form) novalidate><div class=row><div class=\"col-xs-10 col-xs-offset-1\"><div class=col-xs-12><div class=row><div class=col-xs-2><button type=button class=\"btn btn-primary\" wz-previous ng-click=tickets.goBackToStepThree()><i class=\"fa fa-arrow-circle-left\"></i></button></div><div class=col-xs-4><h3>Confirmación</h3></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-default\" ng-click=tickets.cancelReservation(true)><i class=\"fa fa-times\"></i> Cancelar Compra</button></div></div></div><div class=col-xs-12><div class=\"box m-top-20 p-all-10\"><div class=row><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8>{{tickets.newTicket.route.name}}<p ng-if=tickets.newTicket.route.transfer class=muted>{{tickets.newTicket.route.subRoutes[0].name}}</p></div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8><span ng-show=tickets.newTicket.selectedTrip.date>{{tickets.newTicket.selectedTrip.date | amDateFormat: dateFormat}}</span> <span ng-show=!tickets.newTicket.selectedTrip.date>--</span></div></div></div><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedTrip.schedule.departureTimeUI || \'--\'}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedTrip.schedule.routeRate.busClass.name || tickets.openRouteRate.busClass.name}}</div></div></div></div></div><div class=\"box m-top-20 p-all-10\" ng-if=tickets.newTicket.route.transfer><div class=row><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8>{{tickets.newTicket.route.subRoutes[1].name}}</div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8><span ng-show=tickets.newTicket.selectedTripT.date>{{tickets.newTicket.selectedTripT.date | amDateFormat: dateFormat}}</span> <span ng-show=!tickets.newTicket.selectedTripT.date>--</span></div></div></div><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedTripT.schedule.departureTimeUI || \'--\'}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedTripT.schedule.routeRate.busClass.name || tickets.openRouteRate.busClass.name}}</div></div></div></div></div><div ng-show=\"tickets.newticket.typeOfTrip == 2\" class=\"box m-top-20 p-all-10\"><div class=row><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8>{{tickets.newTicket.returnRoute.name}}<p ng-if=tickets.newTicket.returnRoute.transfer class=muted>{{tickets.newTicket.returnRoute.subRoutes[0].name}}</p></div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedReturnTrip.date | amDateFormat: dateFormat}}</div></div></div><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedReturnTrip.schedule.departureTimeUI}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedReturnTrip.schedule.routeRate.busClass.name}}</div></div></div></div></div><div class=\"box m-top-20 p-all-10\" ng-if=\"tickets.newticket.typeOfTrip == 2 && tickets.newTicket.returnRoute.transfer\"><div class=row><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8>{{tickets.newTicket.returnRoute.subRoutes[1].name}}</div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8><span ng-show=tickets.newTicket.selectedTripT.date>{{tickets.newTicket.selectedReturnTripT.date | amDateFormat: dateFormat}}</span> <span ng-show=!tickets.newTicket.selectedReturnTripT.date>--</span></div></div></div><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedReturnTripT.schedule.departureTimeUI || \'--\'}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{tickets.newTicket.selectedReturnTripT.schedule.routeRate.busClass.name || tickets.openRouteRate.busClass.name}}</div></div></div></div></div></div><div class=\"col-xs-12 m-top-20\"><h3>Pasajeros</h3><table class=\"table table-striped\"><thead><tr><th>Ruta</th><th>Abordaje</th><th>Asiento</th><th>Precio</th><th class=text-center>Adulto mayor</th><th class=text-center>Cédula adulto mayor</th></tr></thead><tbody><tr ng-repeat=\"client in tickets.newticket.clients\"><td>{{tickets.newTicket.route.name}}</td><td><select required name=boarding{{$index}} id=boarding{{$index}} class=\"form-control boarding-selects\" ng-options=\"boarding as boarding.name for boarding in tickets.boardingList\" ng-model=client.boarding ng-change=\"tickets.updateTotal(client.boarding.rate ? client.boarding.rate : tickets.newTicket.selectedTrip.schedule.routeRate.billingRate);\n                        tickets.syncBoardingValues($index, client.boarding)\"><option value=\"\">Abordaje</option></select><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=\"TicketStep4Form.boarding{{$index}}.$error && !client.boarding\">El abordaje es requerido</p></div><div ng-if=\"tickets.dropoffList.length > 0\"><br><b>Destino Final</b><select name=dropoff{{$index}} id=dropoff{{$index}} class=\"form-control boarding-selects\" ng-options=\"dropoff as dropoff.name for dropoff in tickets.dropoffList\" ng-model=client.dropoff ng-change=\"tickets.updateTotal(client.dropoff.rate ? client.dropoff.rate : tickets.newTicket.selectedTrip.schedule.routeRate.billingRate )\"><option value=\"\">Nosara</option></select><!--<div class=\"error\" ng-show=\"tickets.submitAttemptStep4\">\n                          <p ng-show=\"TicketStep4Form.dropoff{{$index}}.$error && !client.dropoff\">Destino Final requerido</p>\n                        </div>--></div></td><td>{{ tickets.getSeatLabel( tickets.newTicket.selectedTrip.bus.layoutType, tickets.selectedSeat[$index].seatNumber) }}</td><td><span ng-show=!client.dropoff>₡{{ (client.hasDiscount ? (client.boarding.rate ? (tickets.roundNearest10(client.boarding.rate - ((client.boarding.rate / 100) * tickets.discountToApply)) ) : (tickets.roundNearest10(tickets.newTicket.selectedTrip.schedule.routeRate.billingRate - ((tickets.newTicket.selectedTrip.schedule.routeRate.billingRate / 100) * tickets.discountToApply)) ) ) : (client.boarding.rate ? client.boarding.rate : tickets.newTicket.selectedTrip.schedule.routeRate.billingRate) ) | number: 0 }}</span> <span ng-show=client.dropoff>₡{{ (client.hasDiscount ? client.dropoff.discountRate : client.dropoff.rate ) | number: 0 }}</span></td><td class=text-center><data ng-init=\"ticketPrice1 = !client.boarding.rate ? tickets.newTicket.selectedTrip.schedule.routeRate.billingRate : client.boarding.rate\"><input type=checkbox ng-model=client.hasDiscount ng-change=tickets.updateTotal()></data></td><td><input type=text id=citizenId{{$index}} name=citizenId{{$index}} class=form-control ng-model=client.citizenId ng-required=client.hasDiscount pattern=^[0-9]*$ minlength=5 ng-disabled=!client.hasDiscount><div class=error ng-show=\"tickets.submitAttemptStep4 && client.hasDiscount\"><p ng-show=\"TicketStep4Form.citizenId{{$index}}.$error.required && !client.citizenId\">La cédula es requerida</p><div ng-show=\"TicketStep4Form.citizenId{{$index}}.$error.pattern && !client.citizenId\">La cédula deber númerica</div><div ng-show=\"TicketStep4Form.citizenId{{$index}}.$error.minlength && !client.citizenId\">La identificación debe tener al menos 5 digitos</div></div></td></tr><tr><td colspan=3><strong>TOTAL:</strong></td><td>₡{{tickets.roundNearest10(tickets.newTicket.total) | number:0}}</td><td></td><td></td></tr></tbody></table></div><div class=col-xs-12><div class=row><div class=col-xs-12><h3>Contacto <small class=text-muted>(opcional)</small></h3></div></div><div class=\"row form-group\"><div class=col-xs-2><strong>Teléfono:</strong></div><div class=col-xs-3><input id=CustomerPhone name=CustomerPhone type=text class=form-control ng-model=tickets.newTicket.customerPhone tnsp-phone-mask maxlength=16 placeholder=\"+506 8859-2161\"><p class=\"text-muted font-light-small\">Incluya el código de país.</p><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.CustomerPhone.$error.phoneFormat>Teléfono debe incluir el código de país, ej. +506 8859-2161</p></div></div><div class=col-xs-2><strong>Correo electrónico:</strong></div><div class=col-xs-3><input id=CustomerEmail name=CustomerEmail type=email class=form-control ng-model=tickets.newTicket.email placeholder=cliente@ejemplo.com><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.CustomerEmail.$error.email>Correo electrónico invalido</p></div></div></div><div class=\"row m-bottom-20\" ng-show=\"!tickets.newTicket.customerPhone && !tickets.newTicket.email\"><div class=col-xs-12><p class=\"text-muted font-light-small\">Sin teléfono ni correo electrónico, el cliente no va a poder editar su boleto por su cuenta después.</p></div></div></div><div class=col-xs-12><div class=row><div class=col-xs-12><h3>Pago</h3></div></div><div class=\"row form-group\"><div class=col-xs-2><strong>Total:</strong></div><div class=\"col-xs-3 text-right\"><input type=text class=\"form-control text-right\" ng-model=tickets.newTicket.total disabled></div><div class=col-xs-2><strong>Forma de pago:</strong></div><div class=col-xs-3><select name=paymentMethod id=paymentMethod class=form-control ng-options=\"pm as pm.name for pm in tickets.paymentMethods\" ng-model=tickets.paymentMethod ng-change=tickets.paymentMethodChange() required><option value=\"\">Forma de Pago</option></select><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.paymentMethod.$error.required>Seleccione metodo de pago</p></div></div><div class=col-xs-2><button type=button class=\"btn btn-primary\" ng-click=tickets.buyDollars()>Comprar dolares</button></div></div><div class=\"row form-group\" ng-if=\"tickets.paymentMethod.name === \'Tarjeta\' || tickets.paymentMethod.name === \'SINPE Movil\' || tickets.paymentMethod.name === \'Efectivo\'\"><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input id=AmountConfirm name=AmountConfirm type=text ng-model=tickets.amount class=\"form-control text-right\" ng-blur=tickets.calcDifference() required><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.AmountConfirm.$error.required>Digite el monto cancelado</p></div></div><div class=col-xs-2 ng-show=\"tickets.paymentMethod.name === \'Tarjeta\' || tickets.paymentMethod.name === \'SINPE Movil\'\"><strong>Autorización:</strong></div><div class=col-xs-3 ng-show=\"tickets.paymentMethod.name === \'Tarjeta\' || tickets.paymentMethod.name === \'SINPE Movil\'\"><input type=text id=AuthorizationConf name=AuthorizationConf ng-model=tickets.newTicket.cardConfirmation class=form-control ng-required=\"tickets.paymentMethod.name === \'Tarjeta\' || tickets.paymentMethod.name === \'SINPE Movil\'\"><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.AuthorizationConf.$error.required>Digite la autorización del Datafono o SINPE Móvil</p></div></div></div><div ng-show=\"tickets.paymentMethod.name === \'Mixto\'\" class=\"row m-bottom-20\"><div class=col-xs-12><hr class=m-bottom-10><strong>Tarjeta</strong></div><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input id=cardAmountConfirm name=cardAmountConfirm type=text ng-model=tickets.cardAmount class=\"form-control text-right\" ng-blur=tickets.calcDifference() ng-required=\"tickets.paymentMethod.name === \'Mixto\' && !tickets.isCoveredTotal()\"><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.cardAmountConfirm.$error.required>Digite el monto cancelado</p></div></div><div class=col-xs-2><strong>Autorización:</strong></div><div class=col-xs-3><input type=text id=cardAuthorizationConf name=cardAuthorizationConf ng-model=tickets.newTicket.cardConfirmation class=form-control ng-required=\"tickets.paymentMethod.name === \'Mixto\' && !tickets.isCoveredTotal() || tickets.cardAmount\"><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.cardAuthorizationConf.$error.required>Digite la autorización del Datafono</p></div></div><div class=col-xs-12><hr class=m-bottom-10><strong>SINPE Móvil</strong></div><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input id=sinpeAmountConfirm name=sinpeAmountConfirm type=text ng-model=tickets.sinpeAmount class=\"form-control text-right\" ng-blur=tickets.calcDifference() ng-required=\"tickets.paymentMethod.name === \'Mixto\' && !tickets.isCoveredTotal()\"><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.sinpeAmountConfirm.$error.required>Digite el monto cancelado</p></div></div><div class=col-xs-2><strong>Autorización:</strong></div><div class=col-xs-3><input type=text id=sinpeAuthorizationConf name=sinpeAuthorizationConf ng-model=tickets.newTicket.sinpeConfirmation class=form-control ng-required=\"tickets.paymentMethod.name === \'Mixto\' && !tickets.isCoveredTotal() || tickets.sinpeAmount\"><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.sinpeAuthorizationConf.$error.required>Digite la autorización del SINPE Móvil</p></div></div><div class=col-xs-12><hr class=m-bottom-10><strong>Efectivo</strong></div><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input id=cashAmountConfirm name=cashAmountConfirm type=text ng-model=tickets.cashAmount class=\"form-control text-right\" ng-blur=tickets.calcDifference() ng-required=\"tickets.paymentMethod.name === \'Mixto\' && !tickets.isCoveredTotal()\"><div class=error ng-show=tickets.submitAttemptStep4><p ng-show=TicketStep4Form.cashAmountConfirm.$error.required>Digite el monto cancelado</p></div></div></div><div class=\"row form-group\" ng-show=tickets.difference ng-if=\"tickets.paymentMethod.name === \'Efectivo\' || tickets.paymentMethod.name === \'Mixto\'\"><div class=col-xs-2><strong>Vuelto:</strong></div><div class=\"col-xs-3 text-right\"><input type=text ng-model=tickets.difference class=\"form-control text-right\" disabled></div></div></div><div class=\"col-xs-12 text-right\"><div class=text-right><button type=submit class=\"btn btn-secondary\" ng-disabled=\"tickets.paymentInProgress || tickets.ticketsPaid\" ladda=tickets.loading>Pagar</button></div><div class=text-left><button type=button class=\"btn btn-primary\" ng-show=tickets.ticketsPaid ng-click=tickets.restartTickets()>Reiniciar Compra</button></div></div></div></div></form></wz-step></wizard></div><tnsp-modal-client-form client=tickets.selectedClient></tnsp-modal-client-form><tnsp-modal-print-ticket-invoice invoices-ids=tickets.invoices show-preview=true payment-method=tickets.paymentMethod></tnsp-modal-print-ticket-invoice><tnsp-modal-buy-dollars-form></tnsp-modal-buy-dollars-form>");
$templateCache.put("app/pages/sales-tickets-edit/edit-tickets.html","<div class=\"container-fluid tickets edit-tickets relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=editTicket-overlay><div class=row><div class=col-xs-3><h1>Modificar Tickets</h1></div><div class=col-xs-9><form id=SearchTicketForm name=SearchTicketForm novalidate class=\"form-inline m-top-20\" ng-submit=editTickets.searchTicket(SearchTicketForm)><div class=form-group><label for=TicketNo>Tiquete:</label><input type=text class=form-control ng-model=editTickets.ticketToSearch name=TicketNo id=TicketNo required> <button type=submit class=\"btn btn-primary\" ng-disabled=!editTickets.ticketToSearch>Buscar</button></div></form></div></div><div class=row ng-show=editTickets.ticket><div class=\"col-xs-10 col-xs-offset-1\" ng-if=\"editTickets.canRemoveChecks && editTickets.ticket.hasChecks\"><p class=text-right><button type=button class=\"btn btn-primary\" ng-click=editTickets.clearChecks(editTickets.invoice)>Limpiar Chequeos</button></p></div><div class=\"col-xs-10 col-xs-offset-1\"><div class=\"box m-top-20 p-all-10 collapse-box\"><div class=row><h1 class=\"col-xs-12 col-md-8\">{{editTickets.originalTicket.invoiceNumber}} <small ng-if=editTickets.originalTicket.mainRoute>Ruta Principal {{editTickets.originalTicket.mainRoute}}</small></h1><div class=\"col-xs-12 col-md-4\"><h2>₡{{editTickets.paidBreakdown.originalRate | number: 0}} <span class=text-muted ng-if=editTickets.paidBreakdown.difference>{{editTickets.paidBreakdown.sign}} ₡{{editTickets.paidBreakdown.difference | number: 0}} = ₡{{editTickets.invoice.finalPrice | number: 0}}</span></h2></div></div><div class=row><div class=col-xs-4><div class=form-group><label>Ruta:</label><p>{{editTickets.originalTicket.routeRate.route.name}}</p></div></div><div class=col-xs-4><div class=form-group><label>Fecha de viaje:</label><p>{{editTickets.originalTicket.tripSeat.trip.date | amDateFormat:editTickets.dateFormat}}</p></div></div><div class=col-xs-4><div class=form-group><label>Horario:</label><p>{{editTickets.originalTicket.tripSeat.trip.schedule.departureTimeUI}}</p></div></div><div class=col-xs-4><div class=form-group><label>Asiento:</label><p>{{editTickets.getSeatLabel( editTickets.originalTicket.tripSeat.trip.bus.layoutType, editTickets.originalTicket.tripSeat.seatNumber)}}</p></div></div><div class=col-xs-4><div class=form-group><label>Abordaje:</label><p>{{editTickets.invoice.boarding}}</p></div></div></div><div class=row><div class=col-xs-4><div class=form-group><label>Tipo de Pago:</label><p>{{editTickets.originalTicket.paymentType}}</p></div></div><div class=col-xs-4><div class=form-group><label>Referencia GP :</label><p>{{editTickets.originalTicket.cardReference}}</p></div></div></div><div class=row ng-if=editTickets.invoice.totalAdjustments><div class=col-xs-12><div class=form-group><label>Ajustes de precio: ₡{{editTickets.invoice.totalAdjustments | number: 0}}</label><table class=\"table table-striped\"><thead><tr><th>Tipo de Pago</th><th>Tarjeta</th><th>Efectivo</th><th>SINPE</th><th>Referencia</th><th>Cobrado por</th><th>Fecha</th></tr></thead><tbody><tr ng-repeat=\"adjustment in editTickets.invoice.priceAdjustments\"><td>{{adjustment.paymentType}}</td><td>₡{{adjustment.cardAmount | number: 0}}</td><td>₡{{adjustment.cashAmount | number: 0}}</td><td>₡{{adjustment.sinpeAmount | number: 0}}</td><td>{{adjustment.cardReference}}</td><td>{{adjustment.soldBy}}</td><td>{{adjustment.created | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</td></tr></tbody></table></div></div></div><div class=row><div class=col-xs-4><div class=form-group><label>Vendido el:</label><p>{{editTickets.originalTicket.created | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</p></div></div><div class=col-xs-4><div class=form-group><label>Vendido por:</label><p>{{editTickets.originalTicket.soldBy}}</p></div></div><div class=col-xs-4></div></div><div class=row><div class=col-xs-12><hr></div></div><div class=row><div class=col-xs-12><h4>Contacto</h4></div></div><div class=row><div class=col-xs-4><div class=form-group><label>Correo electrónico:</label><p>{{editTickets.originalTicket.email || \'--\'}}</p></div></div><div class=col-xs-4><div class=form-group><label>Teléfono:</label><p>{{(editTickets.originalTicket.customerPhone | tnspPhone) || \'--\'}}</p></div></div><div class=col-xs-4 ng-if=editTickets.canEditContact><div class=form-group><label>&nbsp;</label><p><button type=button class=\"btn btn-primary\" ng-click=editTickets.openContactForm()>Editar contacto</button></p></div></div></div></div></div><hr><div class=col-xs-12><wizard class=wizard name=edit-ticket-wizard><wz-step wz-title=Disponibilidad><form id=TicketStep1Form name=TicketStep1Form ng-submit=editTickets.goToSelectClients(TicketStep1Form) novalidate><div class=row><div class=\"col-xs-10 col-xs-offset-1\"><!--First Way --><div class=box><div class=row><div class=col-xs-4><div class=form-group><label for=Route>Ruta:</label><select name=Route id=Route class=form-control ng-options=\"route as route.name for route in editTickets.routesList\" ng-model=editTickets.ticket.route ng-change=editTickets.loadSchedulesAvailable() required><option value=\"\">Ruta</option></select></div></div><div class=col-xs-4><div class=form-group><label for=OriginDate>Fecha:</label><p class=\"input-group m-bottom-0\"><input type=text name=OriginDate id=OriginDate class=form-control uib-datepicker-popup=\"{{\'dd/MM/yyyy\'}}\" ng-model=editTickets.originDateUI is-open=editTickets.showOriginCalendar alt-input-formats=\"[\'DD/MM/YYYY\']\" ng-required=\"editTickets.ticket.typeOfTrip != 3\" ng-blur=editTickets.loadSchedulesAvailable() ng-disabled=\"editTickets.ticket.typeOfTrip ==3\" datepicker-options=editTickets.dateConfig> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=editTickets.openOriginDate() ng-disabled=\"editTickets.ticket.typeOfTrip == 3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=error ng-show=editTickets.submitAttemptStep1><p ng-show=TicketStep1Form.OriginDate.$error.required>La fecha es requerida</p></div></div></div><div class=col-xs-4><div class=form-group><label for=SchedulesAvailable>Horarios</label><select name=SchedulesAvailable id=SchedulesAvailable class=form-control ng-options=\"trip as trip.schedule.departureTimeUI for trip in editTickets.schedulesAvailable\" ng-model=editTickets.ticket.selectedTrip ng-change=editTickets.getAvailableSeats() ng-disabled=\"editTickets.ticket.typeOfTrip == 3\" ng-required=\"editTickets.ticket.typeOfTrip != 3\"><option value=\"\">Horarios</option></select><div class=error ng-show=editTickets.submitAttemptStep1><p ng-show=TicketStep1Form.SchedulesAvailable.$error.required>El horario es requerido</p></div></div></div></div><div class=row><div class=col-xs-4><div ng-show=\"editTickets.ticket.typeOfTrip != 3\"><label for=Price>Precio</label><input type=text id=Price name=Price class=\"form-control text-right\" ng-model=editTickets.ticket.selectedTrip.schedule.routeRate.billingRate disabled></div></div><div class=col-xs-4><label for=Disponibles>Campos Disponibles</label><input type=text id=Disponibles name=Disponibles class=\"form-control text-right\" ng-model=editTickets.ticket.selectedTrip.availableSeats disabled></div></div></div><div class=\"row m-top-10\"><div class=\"col-xs-12 text-right\"><span ng-if=editTickets.ticket.hasChecks class=error>Este Tickete ya tiene chequeos</span> <input type=submit value=Siguiente ng-disabled=editTickets.ticket.hasChecks class=\"btn btn-primary\"></div></div></div><!-- col-10 --></div><!-- main row --></form></wz-step><wz-step wz-title=Asientos wz-disabled=\"{{editTickets.ticket.typeOfTrip == 3}}\"><form id=TicketStep3Form name=TicketStep3Form ng-submit=editTickets.goToConfirmation(TicketStep3Form) novalidate><div class=\"row m-bottom-20\"><div class=col-xs-12><div class=row><div class=col-xs-12><h3>Asientos</h3><p class=m-top-10>Seleccione {{editTickets.ticket.clients.length}} asiento(s) por ruta</p></div></div><tnsp-bus-layout ng-if=editTickets.showBusLayout input-layout-type=editTickets.ticket.selectedTrip.bus.layoutType input-is-trip-locked=editTickets.ticket.selectedTrip.locked input-trip-seats=editTickets.occupiedSeats input-is-edit-ticket=true input-ticket-clients=editTickets.ticket.clients.length output-selected-seats=editTickets.handleSelectedSeats(selectedSeats)></tnsp-bus-layout><div class=error ng-show=editTickets.submitAttemptStep3><p ng-show=\"editTickets.selectedSeat.length !== editTickets.ticket.clients.length\">Debe seleccionar la misma cantidad de asientos como de clientes en el paso anterior</p></div></div></div><div class=row><div class=col-xs-6><input type=button wz-previous value=Anterior class=\"btn btn-primary\" ng-click=editTickets.goBackToStepOne()></div><div class=\"col-xs-6 text-right\"><input type=submit value=Siguiente class=\"btn btn-primary\" ng-disabled=\"editTickets.ticket.selectedTrip.locked || editTickets.selectedSeat.length === 0\"></div></div></form></wz-step><wz-step wz-title=\"Confirmación de edición\"><form id=TicketStep4Form name=TicketStep4Form ng-submit=editTickets.editTicket(TicketStep4Form) novalidate><div class=row><div class=\"col-xs-10 col-xs-offset-1\"><div class=col-xs-12><div class=row><div class=col-xs-2><button type=button class=\"btn btn-primary\" wz-previous ng-click=editTickets.goBackToStepThree()><i class=\"fa fa-arrow-circle-left\"></i></button></div><div class=col-xs-4><h3>Confirmación</h3></div><div class=\"col-xs-6 text-right\"><button type=button class=\"btn btn-default\" ng-click=editTickets.cancelReservation(true)><i class=\"fa fa-times\"></i> Cancelar Edición</button></div></div></div><div class=col-xs-12><div class=\"box m-top-20 p-all-10\"><div class=row><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Ruta:</strong></div><div class=col-xs-8>{{editTickets.ticket.route.name}}<p ng-if=editTickets.ticket.route.transfer class=muted>{{editTickets.ticket.route.subRoutes[0].name}}</p></div></div><div class=row><div class=col-xs-4><strong>Fecha:</strong></div><div class=col-xs-8><span ng-show=editTickets.ticket.selectedTrip.date>{{editTickets.ticket.selectedTrip.date | amDateFormat: dateFormat}}</span> <span ng-show=!editTickets.ticket.selectedTrip.date>--</span></div></div></div><div class=col-xs-6><div class=row><div class=col-xs-4><strong>Horario:</strong></div><div class=col-xs-8>{{editTickets.ticket.selectedTrip.schedule.departureTimeUI || \'--\'}}</div></div><div class=row><div class=col-xs-4><strong>Tipo de Bus:</strong></div><div class=col-xs-8>{{editTickets.ticket.selectedTrip.schedule.routeRate.busClass.name || tickets.openRouteRate.busClass.name}}</div></div></div></div></div></div><div class=\"col-xs-12 m-top-20\"><h3>Pasajeros</h3><table class=\"table table-striped\"><thead><tr><th>Ruta</th><th>Abordaje</th><th>Asiento</th><th>Precio</th><th class=text-center>Adulto Mayor</th></tr></thead><tbody><tr ng-repeat=\"client in editTickets.ticket.clients\"><td>{{editTickets.ticket.route.name}} <span ng-if=editTickets.ticket.route.transfer>/ {{editTickets.ticket.route.subRoutes[0].name}}</span></td><td><select required name=boarding{{$index}} id=boarding{{$index}} class=\"form-control boarding-selects\" ng-options=\"boarding as boarding.name for boarding in editTickets.boardingList\" ng-model=client.boarding><option value=\"\">Abordaje</option></select><div class=error ng-show=editTickets.submitAttemptStep4><p ng-show=\"TicketStep4Form.boarding{{$index}}.$error && !client.boarding\">Abordaje requerido</p></div></td><td>{{ editTickets.getSeatLabel(editTickets.ticket.selectedTrip.bus.layoutType, editTickets.selectedSeat[$index].seatNumber) }}</td><td><div ng-if=!editTickets.ticket.route.transfer><span ng-show=editTickets.ticket.selectedTrip.schedule.routeRate>₡{{ editTickets.ticket.total | number: 0 }}</span></div></td><td class=text-center><input type=checkbox ng-model=editTickets.originalTicket.hasDiscount disabled></td></tr><tr><td colspan=3><strong>TOTAL:</strong></td><td>₡{{editTickets.ticket.total| number: 0}}</td><td></td></tr></tbody></table></div><div class=col-xs-12><div class=row><div class=col-xs-12><h3>Confirmación</h3></div></div><div class=\"row form-group\"><div class=col-xs-2><strong>Total pagado:</strong></div><div class=\"col-xs-3 text-right\"><input type=text ng-model=editTickets.totalPaidAmount class=\"form-control text-right\" disabled></div><div class=col-xs-2><strong>Nuevo precio:</strong></div><div class=\"col-xs-3 text-right\"><input type=text ng-model=editTickets.ticket.total class=\"form-control text-right\" disabled></div></div><div class=\"row form-group\" ng-if=editTickets.hasToPay><div class=col-xs-2><strong>Diferencia a pagar:</strong></div><div class=\"col-xs-3 text-right\"><input type=text ng-model=editTickets.differenceToPay class=\"form-control text-right\" disabled></div></div></div><div class=col-xs-12 ng-if=editTickets.hasToPay><div class=row><div class=col-xs-12><h3>Pago</h3></div></div><div class=\"row form-group\"><div class=col-xs-2><strong>Forma de pago:</strong></div><div class=col-xs-3><select name=paymentMethod id=paymentMethod class=form-control ng-options=\"pm as pm.name for pm in editTickets.paymentMethods\" ng-model=editTickets.paymentMethod ng-change=editTickets.paymentMethodChange() ng-required=editTickets.hasToPay><option value=\"\">Forma de Pago</option></select><div class=error ng-show=editTickets.submitAttemptStep4><p ng-show=TicketStep4Form.paymentMethod.$error.required>Seleccione metodo de pago</p></div></div></div><div class=\"row form-group\" ng-if=\"editTickets.paymentMethod.name === \'Tarjeta\' || editTickets.paymentMethod.name === \'SINPE Movil\' || editTickets.paymentMethod.name === \'Efectivo\'\"><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input id=AmountConfirm name=AmountConfirm type=text ng-model=editTickets.amount class=\"form-control text-right\" ng-blur=editTickets.calcDifference() required><div class=error ng-show=editTickets.submitAttemptStep4><p ng-show=TicketStep4Form.AmountConfirm.$error.required>Digite el monto cancelado</p></div></div><div class=col-xs-2 ng-show=\"editTickets.paymentMethod.name === \'Tarjeta\' || editTickets.paymentMethod.name === \'SINPE Movil\'\"><strong>Autorización:</strong></div><div class=col-xs-3 ng-show=\"editTickets.paymentMethod.name === \'Tarjeta\' || editTickets.paymentMethod.name === \'SINPE Movil\'\"><input type=text id=AuthorizationConf name=AuthorizationConf ng-model=editTickets.cardConfirmation class=form-control ng-required=\"editTickets.paymentMethod.name === \'Tarjeta\' || editTickets.paymentMethod.name === \'SINPE Movil\'\"><div class=error ng-show=editTickets.submitAttemptStep4><p ng-show=TicketStep4Form.AuthorizationConf.$error.required>Digite la autorización del Datafono o SINPE Móvil</p></div></div></div><div ng-show=\"editTickets.paymentMethod.name === \'Mixto\'\" class=\"row m-bottom-20\"><div class=col-xs-12><hr class=m-bottom-10><strong>Tarjeta</strong></div><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input id=cardAmountConfirm name=cardAmountConfirm type=text ng-model=editTickets.cardAmount class=\"form-control text-right\" ng-blur=editTickets.calcDifference() ng-required=\"editTickets.paymentMethod.name === \'Mixto\' && !editTickets.isCoveredTotal()\"><div class=error ng-show=editTickets.submitAttemptStep4><p ng-show=TicketStep4Form.cardAmountConfirm.$error.required>Digite el monto cancelado</p></div></div><div class=col-xs-2><strong>Autorización:</strong></div><div class=col-xs-3><input type=text id=cardAuthorizationConf name=cardAuthorizationConf ng-model=editTickets.cardConfirmation class=form-control ng-required=\"editTickets.paymentMethod.name === \'Mixto\' && !editTickets.isCoveredTotal() || editTickets.cardAmount\"><div class=error ng-show=editTickets.submitAttemptStep4><p ng-show=TicketStep4Form.cardAuthorizationConf.$error.required>Digite la autorización del Datafono</p></div></div><div class=col-xs-12><hr class=m-bottom-10><strong>SINPE Móvil</strong></div><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input id=sinpeAmountConfirm name=sinpeAmountConfirm type=text ng-model=editTickets.sinpeAmount class=\"form-control text-right\" ng-blur=editTickets.calcDifference() ng-required=\"editTickets.paymentMethod.name === \'Mixto\' && !editTickets.isCoveredTotal()\"><div class=error ng-show=editTickets.submitAttemptStep4><p ng-show=TicketStep4Form.sinpeAmountConfirm.$error.required>Digite el monto cancelado</p></div></div><div class=col-xs-2><strong>Autorización:</strong></div><div class=col-xs-3><input type=text id=sinpeAuthorizationConf name=sinpeAuthorizationConf ng-model=editTickets.sinpeConfirmation class=form-control ng-required=\"editTickets.paymentMethod.name === \'Mixto\' && !editTickets.isCoveredTotal() || editTickets.sinpeAmount\"><div class=error ng-show=editTickets.submitAttemptStep4><p ng-show=TicketStep4Form.sinpeAuthorizationConf.$error.required>Digite la autorización del SINPE Móvil</p></div></div><div class=col-xs-12><hr class=m-bottom-10><strong>Efectivo</strong></div><div class=col-xs-2><strong>Monto:</strong></div><div class=\"col-xs-3 text-right\"><input id=cashAmountConfirm name=cashAmountConfirm type=text ng-model=editTickets.cashAmount class=\"form-control text-right\" ng-blur=editTickets.calcDifference() ng-required=\"editTickets.paymentMethod.name === \'Mixto\' && !editTickets.isCoveredTotal()\"><div class=error ng-show=editTickets.submitAttemptStep4><p ng-show=TicketStep4Form.cashAmountConfirm.$error.required>Digite el monto cancelado</p></div></div></div><div class=\"row form-group\" ng-show=editTickets.difference ng-if=\"editTickets.paymentMethod.name === \'Efectivo\' || editTickets.paymentMethod.name === \'Mixto\'\"><div class=col-xs-2><strong>Vuelto:</strong></div><div class=\"col-xs-3 text-right\"><input type=text ng-model=editTickets.difference class=\"form-control text-right\" disabled></div></div></div><div class=\"col-xs-12 text-right\"><div class=text-right><button type=submit class=\"btn btn-secondary\" ladda=editTickets.loading>Editar</button></div><div class=text-left><button type=button class=\"btn btn-primary\" ng-click=editTickets.restartTickets()>Reiniciar Edición</button></div></div></div></div></form></wz-step></wizard></div></div></div><tnsp-modal-client-form client=editTickets.selectedClient></tnsp-modal-client-form><tnsp-modal-print-ticket-invoice invoices-ids=editTickets.invoices show-preview=true payment-method=editTickets.paymentMethod edit-info=editTickets.editInvoiceInfo></tnsp-modal-print-ticket-invoice><tnsp-modal-ticket-contact-form ticket=editTickets.originalTicket></tnsp-modal-ticket-contact-form>");
$templateCache.put("app/pages/sales-tickets-edit-boarding/edit-tickets-boarding.html","<div class=\"container-fluid tickets edit-tickets relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=editTicket-overlay><div class=row><div class=col-xs-12><h1>Cambiar Abordajes</h1><form id=SearchTicketForm name=SearchTicketForm novalidate class=form-inline ng-submit=editTicketsBoarding.searchTicket(SearchTicketForm)><div class=form-group><label for=TicketNo>Tiquete:</label><input type=text class=form-control ng-model=editTicketsBoarding.ticketToSearch name=TicketNo id=TicketNo required> <button type=submit class=\"btn btn-primary\" ng-disabled=!editTicketsBoarding.ticketToSearch>Buscar</button></div></form></div></div><form role=form name=ChangeBoardingForm ng-submit=editTicketsBoarding.changeBoarding(ChangeBoardingForm) novalidate><div ng-show=editTicketsBoarding.ticket class=ticket-details><h1>{{editTicketsBoarding.ticket.invoiceNumber}} <small ng-if=editTicketsBoarding.ticket.mainRoute>Ruta Principal {{editTicketsBoarding.ticket.mainRoute}}</small></h1><div class=row><div class=col-xs-4><div class=form-group><label>Ruta:</label><p>{{editTicketsBoarding.ticket.route}}</p></div></div><div class=col-xs-4><div class=form-group><label>Fecha:</label><p>{{editTicketsBoarding.ticket.date | amDateFormat:editTicketsBoarding.dateFormat}}</p></div></div><div class=col-xs-4><div class=form-group><label>Horario:</label><p>{{editTicketsBoarding.ticket.timeUI}}</p></div></div><div class=col-xs-4><div class=form-group><label>Asiento:</label><p>{{editTicketsBoarding.ticket.seatNumber > (editTicketsBoarding.ticket.seatCount - 10) ? \'DP\'+(editTicketsBoarding.ticket.seatNumber - (editTicketsBoarding.ticket.seatCount - 10)) : editTicketsBoarding.ticket.seatNumber}}</p></div></div><div class=col-xs-4><div class=form-group><label>Precio:</label><p>₡{{editTicketsBoarding.ticket.finalPrice}}</p></div></div></div><hr><h3>Abordaje</h3><div class=\"row m-bottom-20\"><div class=col-xs-4><label for=boarding>Abordaje</label><select name=boarding id=boarding class=\"form-control boarding-selects\" ng-options=\"boarding as boarding.name for boarding in editTicketsBoarding.boardingList\" ng-model=editTicketsBoarding.newBoarding required><option value=\"\">Abordaje</option></select><div class=error ng-messages=ChangeBoardingForm.boarding.$error ng-show=editTicketsBoarding.submitAttempt><p ng-message=required>Abordaje Requerido</p></div><button type=submit ladda=editTicketsBoarding.loading data-style=zoom-in class=\"btn btn-primary m-top-20\">Cambiar Abordaje</button></div></div></div></form></div>");
$templateCache.put("app/pages/sales-tickets-search/search-tickets.html","<div class=\"container-fluid tickets edit-tickets relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=editTicket-overlay><div class=row><div class=col-xs-3><h1>Buscar Boleto</h1></div><div class=col-xs-9><form id=SearchTicketForm name=SearchTicketForm novalidate class=\"form-inline m-top-20\" ng-submit=searchTickets.searchTicket(SearchTicketForm)><div class=form-group><label for=TicketNo>Tiquete:</label><input type=text class=form-control ng-model=searchTickets.ticketToSearch name=TicketNo id=TicketNo required> <button type=submit class=\"btn btn-primary\" ng-disabled=!searchTickets.ticketToSearch>Buscar</button></div></form></div></div><div class=row ng-show=searchTickets.ticket><div class=\"col-xs-10 col-xs-offset-1\"><p class=text-right><button ng-if=searchTickets.canPutOnHold() ng-disabled=searchTickets.disableOnHold type=button class=\"btn btn-primary d-inline-block\" ng-click=searchTickets.putOnHold(searchTickets.invoice)>{{searchTickets.originalTicket.status === \'ACTIVE\' ? \"Poner en revisión\" : \"Anular revisión\"}}</button> <button ng-if=searchTickets.canRemoveChecks type=button class=\"btn btn-primary d-inline-block\" ng-click=searchTickets.clearChecks(searchTickets.invoice)>Limpiar Chequeos</button></p></div><div class=\"col-xs-10 col-xs-offset-1\"><div class=\"box m-top-20 p-all-10 collapse-box\"><div class=row><h1 class=\"col-xs-12 col-md-8\">{{searchTickets.originalTicket.invoiceNumber}} <small ng-if=searchTickets.originalTicket.mainRoute>Ruta Principal {{searchTickets.originalTicket.mainRoute}}</small></h1><h2 class=\"col-xs-12 col-md-4\">₡{{searchTickets.invoice.finalPrice}}</h2></div><div class=row><div class=col-xs-4><div class=form-group><label>Ruta:</label><p>{{searchTickets.originalTicket.routeRate.route.name}}</p></div></div><div class=col-xs-4><div class=form-group><label>Fecha de viaje:</label><p>{{searchTickets.originalTicket.tripSeat.trip.date | amDateFormat:searchTickets.dateFormat}}</p></div></div><div class=col-xs-4><div class=form-group><label>Horario:</label><p>{{searchTickets.originalTicket.tripSeat.trip.schedule.departureTimeUI}}</p></div></div><div class=col-xs-4><div class=form-group><label>Asiento:</label><p>{{searchTickets.originalTicket.tripSeat.seatNumber > (searchTickets.originalTicket.seatCount - 10) ? \'DP\'+(searchTickets.originalTicket.tripSeat.seatNumber - (searchTickets.originalTicket.seatCount - 10)) : searchTickets.originalTicket.tripSeat.seatNumber}}</p></div></div><div class=col-xs-4><div class=form-group><label>Abordaje:</label><p>{{searchTickets.invoice.boarding}}</p></div></div></div><div class=row><div class=col-xs-4><div class=form-group><label>Tipo de Pago:</label><p>{{searchTickets.originalTicket.paymentType}}</p></div></div><div class=col-xs-4><div class=form-group><label>Referencia GP :</label><p>{{searchTickets.originalTicket.cardReference}}</p></div></div></div><div class=row><div class=col-xs-4><div class=form-group><label>Vendido el:</label><p>{{searchTickets.originalTicket.created | amUtc | amLocal | amDateFormat: \'DD/MM/YYYY h:mm A\'}}</p></div></div><div class=col-xs-4><div class=form-group><label>Vendido por:</label><p>{{searchTickets.originalTicket.soldBy}}</p></div></div><div class=col-xs-4><div class=form-group><button type=button class=\"btn btn-primary\" ng-click=searchTickets.printInvoice(searchTickets.invoice)>Imprimir Boleto</button></div></div></div></div></div></div></div><tnsp-modal-client-form client=searchTickets.selectedClient></tnsp-modal-client-form><tnsp-modal-print-ticket-invoice invoices-ids=searchTickets.selectedInvoice show-preview=true></tnsp-modal-print-ticket-invoice>");
$templateCache.put("app/pages/sales-till/till.html","<div class=\"container-fluid relative-pos\" bs-loading-overlay bs-loading-overlay-reference-id=till-overlay><div class=row><div class=col-xs-12><h1>Cajas</h1></div></div><div class=row><div class=\"col-xs-4 text-center\"><a ng-class=\"till.userInfo.openCash ? \'disabled menu-item\' : \'menu-item\'\" ng-click=till.openCashRegister()><i class=\"fa fa-check-circle fa-4x\"></i><h4>Abrir Caja</h4></a></div><div class=\"col-xs-4 text-center\"><a ng-class=\"till.userInfo.openCash ? \'menu-item\' : \'disabled menu-item\'\" ng-click=till.closeCashRegister()><i class=\"fa fa-times-circle fa-4x\"></i><h4>Cerrar Caja</h4></a></div><div class=\"col-xs-4 text-center\"><a ng-class=\"till.userInfo.openCash ? \'menu-item\' : \'disabled menu-item\'\" ng-click=till.addMovement()><i class=\"fa fa-plus-circle fa-4x\"></i><h4>Agregar movimiento</h4></a></div></div><div class=row><!--<div class=\"col-xs-4 text-center\">\n      <a class=\"menu-item\" ng-click=\"till.ticketRegistration()\">\n        <i class=\"fa fa-download fa-4x\"></i>\n        <h4>Registro de boleto físico</h4>\n      </a>\n    </div>--><!-- <div class=\"col-xs-4 text-center\">\n      <a class=\"menu-item\" ng-click=\"till.addCancellation()\">\n        <i class=\"fa fa-minus-circle fa-4x\"></i>\n        <h4>Anulaciones</h4>\n      </a>\n    </div>--><div class=\"col-xs-4 text-center\"><a ng-class=\"till.userInfo.openCash ? \'menu-item\' : \'disabled menu-item\'\" ng-click=till.showMovement()><i class=\"fa fa-exchange fa-4x\"></i><h4>Movimientos de caja abierta</h4></a></div><div class=\"col-xs-4 text-center\"><a ng-class=\"till.userInfo.openCash ? \'menu-item\' : \'disabled menu-item\'\" ng-click=till.buyDollars()><i class=\"fa fa-money fa-4x\"></i><h4>Compra de dolares</h4></a></div></div></div><tnsp-modal-close-cash-register-form></tnsp-modal-close-cash-register-form><tnsp-modal-open-cash-register-form></tnsp-modal-open-cash-register-form><tnsp-modal-add-movement-form></tnsp-modal-add-movement-form><tnsp-modal-ticket-registration-form></tnsp-modal-ticket-registration-form><tnsp-modal-add-cancellation-form></tnsp-modal-add-cancellation-form><tnsp-modal-cash-register-balance current=true></tnsp-modal-cash-register-balance><tnsp-modal-buy-dollars-form></tnsp-modal-buy-dollars-form>");}]);